import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Record of credentials associated with the MCP server installation */
  AuthFieldsObject: { input: any; output: any };
  /** Map of arg and its values */
  ConfigProperties: { input: any; output: any };
  /** Map of tool names to their configurations */
  ConfigTools: { input: any; output: any };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any };
  /** Map of environment variable names to values */
  EnvVarsMap: { input: any; output: any };
  /** Map of Feature switch and its value for the org. */
  FeatureSwitchOverride: { input: any; output: any };
  /** Map of resolved feature switch values (org overrides merged with server defaults). */
  FeatureSwitches: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
  /** A field whose value conforms with the standard mongodb object ID as described here: https://docs.mongodb.com/manual/reference/method/ObjectId/#ObjectId. Example: 5e5677d71bdc2ae76344968c */
  ObjectID: { input: any; output: any };
  /** Map of credential name to credential value and whether it is secret */
  ServerInstallationCredsMap: { input: any; output: any };
  /** Custom scalar for string and array of strings */
  StringOrArray: { input: any; output: any };
};

/** General entity that manages an aspect of access to an MCP server */
export type AccessControl = AccessControlPolicy | AccessControlRateLimit;

/** Shared fields for an access control entity */
export type AccessControlInterface = {
  /** Unique identifier for entity */
  _id: Scalars['ObjectID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** User-friendly display name */
  name: Scalars['String']['output'];
  status: AccessControlStatus;
  /** The entity type, typically mongoose model */
  type: AccessControlType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Slim representation of a policy */
export type AccessControlPolicy = AccessControlInterface & {
  __typename?: 'AccessControlPolicy';
  /** Unique identifier for entity */
  _id: Scalars['ObjectID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** User-friendly display name */
  name: Scalars['String']['output'];
  policy: McpAccessPolicy;
  status: AccessControlStatus;
  /** The entity type, typically mongoose model */
  type: AccessControlType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Slim representation of a rate limit */
export type AccessControlRateLimit = AccessControlInterface & {
  __typename?: 'AccessControlRateLimit';
  /** Unique identifier for entity */
  _id: Scalars['ObjectID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** User-friendly display name */
  name: Scalars['String']['output'];
  rateLimit: RateLimit;
  status: AccessControlStatus;
  /** The entity type, typically mongoose model */
  type: AccessControlType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Sorting mechanism for access control */
export enum AccessControlSort {
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

/** Status of the access control */
export enum AccessControlStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

/** Sorting mechanism for access control */
export enum AccessControlType {
  Policy = 'POLICY',
  RateLimit = 'RATE_LIMIT'
}

export type AccessPolicyPrincipal = Agent | Group | User;

export type AccessPolicyPrincipalsResponse = {
  __typename?: 'AccessPolicyPrincipalsResponse';
  principals: Array<AccessPolicyPrincipal>;
};

/** Sorting mechanism for access policies */
export enum AccessPolicySort {
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

/** Input for filtering by actor with type information */
export type ActorFilterInput = {
  /** The unique identifier of the actor (user or agent) */
  id: Scalars['ObjectID']['input'];
  /** The type of actor (USER or AGENT) */
  type: AuditActorType;
};

/** Valid actor types */
export enum ActorType {
  Agent = 'AGENT',
  User = 'USER'
}

/** An agent that can access managed connections through CLIENT_CREDENTIALS authentication */
export type Agent = {
  __typename?: 'Agent';
  _id: Scalars['ID']['output'];
  /** Connection names (first 3, sorted by last used) for display purposes */
  connections: Array<Scalars['String']['output']>;
  /** Total number of connections linked to this agent */
  connectionsCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  displayName: Scalars['String']['output'];
  /** Timestamp of the most recent activity by this agent */
  lastActive?: Maybe<Scalars['DateTime']['output']>;
  org: Org;
  owner: User;
  updatedAt: Scalars['DateTime']['output'];
};

/** A recent tool call made by an AI agent via an MCP server */
export type AgentToolCall = {
  __typename?: 'AgentToolCall';
  _id: Scalars['ID']['output'];
  calledAt: Scalars['DateTime']['output'];
  client: Scalars['String']['output'];
  deviceId?: Maybe<Scalars['String']['output']>;
  gitBranch?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  resultStatus?: Maybe<Scalars['String']['output']>;
  serverName: Scalars['String']['output'];
  sessionId?: Maybe<Scalars['String']['output']>;
  toolArguments?: Maybe<Scalars['JSON']['output']>;
  toolName: Scalars['String']['output'];
};

export type ApiSpecSource = {
  __typename?: 'ApiSpecSource';
  sourceType: McpServerSourceType;
};

/** Basic information about an app (stored on serverInfo or customServerInfo), used populating our app catalog */
export type AppInfo = {
  __typename?: 'AppInfo';
  /** Whether this app is a Natoma-hosted server or a BYO server */
  appType: AppType;
  /** Human-readable name of the app (serverInfo.name) */
  name: Scalars['String']['output'];
  /** Unique slug identifier for the app (serverInfo.slug) */
  slug: Scalars['String']['output'];
};

/** Enum to specify whether an app is a Natoma-hosted server or a BYO server */
export enum AppType {
  All = 'ALL',
  Custom = 'CUSTOM',
  Natoma = 'NATOMA'
}

export type AuditActorResource = Agent | User;

export enum AuditActorType {
  Agent = 'AGENT',
  User = 'USER'
}

export enum AuditEvent {
  AlertAccepted = 'ALERT_ACCEPTED',
  AlertCreated = 'ALERT_CREATED',
  AlertDismissed = 'ALERT_DISMISSED',
  AlertResolved = 'ALERT_RESOLVED',
  AlertSnoozed = 'ALERT_SNOOZED',
  IdentityClassificationChanged = 'IDENTITY_CLASSIFICATION_CHANGED',
  IdentityOwnerChanged = 'IDENTITY_OWNER_CHANGED',
  IntegrationAdded = 'INTEGRATION_ADDED',
  IntegrationRemoved = 'INTEGRATION_REMOVED',
  IntegrationUpdated = 'INTEGRATION_UPDATED',
  ManagedConnectionCreated = 'MANAGED_CONNECTION_CREATED',
  ManagedConnectionDeleted = 'MANAGED_CONNECTION_DELETED',
  McpToolCall = 'MCP_TOOL_CALL',
  PersonalConnectionsDisabled = 'PERSONAL_CONNECTIONS_DISABLED',
  PersonalConnectionsEnabled = 'PERSONAL_CONNECTIONS_ENABLED',
  PersonalConnectionCreated = 'PERSONAL_CONNECTION_CREATED',
  PersonalConnectionDeleted = 'PERSONAL_CONNECTION_DELETED',
  SsoConfigured = 'SSO_CONFIGURED',
  SsoRemoved = 'SSO_REMOVED',
  TicketCreated = 'TICKET_CREATED',
  UserCreatedViaSamlJitAccess = 'USER_CREATED_VIA_SAML_JIT_ACCESS',
  UserInvited = 'USER_INVITED',
  UserRoleChanged = 'USER_ROLE_CHANGED',
  UserSuspended = 'USER_SUSPENDED'
}

export type AuditLog = {
  __typename?: 'AuditLog';
  _id: Scalars['ObjectID']['output'];
  actor: AuditLogActor;
  event: AuditEvent;
  metadata?: Maybe<Scalars['JSON']['output']>;
  org: Org;
  targets?: Maybe<Array<AuditLogTarget>>;
  timestamp: Scalars['DateTime']['output'];
};

export type AuditLogActor = {
  details?: Maybe<AuditActorResource>;
  type: AuditActorType;
};

export type AuditLogActorDetails = AuditLogActor & {
  __typename?: 'AuditLogActorDetails';
  details?: Maybe<AuditActorResource>;
  type: AuditActorType;
};

export type AuditLogAggregatedResponse = {
  __typename?: 'AuditLogAggregatedResponse';
  /** Grouped audit log results */
  groups: Array<AuditLogAggregatedResult>;
  /** Total count of audit logs matching the criteria (before grouping) */
  totalCount: Scalars['Int']['output'];
};

export type AuditLogAggregatedResult = {
  __typename?: 'AuditLogAggregatedResult';
  /** Number of audit logs in this group */
  count: Scalars['Int']['output'];
  /** Timestamp of the earliest audit log in this group */
  earliestTimestamp: Scalars['DateTime']['output'];
  /** Individual audit log events in this group */
  events: Array<AuditLog>;
  /** The key by which the audit logs are grouped */
  groupKey: Scalars['JSON']['output'];
  /** Timestamp of the most recent audit log in this group */
  latestTimestamp: Scalars['DateTime']['output'];
};

export enum AuditLogGroupBy {
  Actor = 'ACTOR',
  Day = 'DAY',
  Event = 'EVENT',
  Hour = 'HOUR',
  None = 'NONE',
  SessionId = 'SESSION_ID'
}

/** Different fields to sort audit logs by */
export enum AuditLogSort {
  TimestampAsc = 'TIMESTAMP_ASC',
  TimestampDesc = 'TIMESTAMP_DESC'
}

export type AuditLogTarget = {
  details?: Maybe<AuditTargetResource>;
  ref?: Maybe<Scalars['ObjectID']['output']>;
  type: AuditTargetType;
};

export type AuditLogTargetDetails = AuditLogTarget & {
  __typename?: 'AuditLogTargetDetails';
  details?: Maybe<AuditTargetResource>;
  ref?: Maybe<Scalars['ObjectID']['output']>;
  type: AuditTargetType;
};

export type AuditTargetResource = Agent | McpServer | McpServerInstall | User;

export enum AuditTargetType {
  Agent = 'AGENT',
  McpserverInstall = 'MCPSERVER_INSTALL',
  McpServer = 'MCP_SERVER',
  User = 'USER'
}

/** Auxiliary Service metadata if the ServiceType is AUXILIARY */
export type Auxiliary = {
  __typename?: 'Auxiliary';
  integrationId?: Maybe<IntegrationId>;
};

/** A billing feature for an org */
export type BillingFeature = {
  __typename?: 'BillingFeature';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

/** A feature is included in a product to determine what an org has access to. */
export enum BillingFeatureId {
  AccessPolicies = 'ACCESS_POLICIES',
  AgentIdentity = 'AGENT_IDENTITY',
  AiActivityMonitoring = 'AI_ACTIVITY_MONITORING',
  AiIdentity = 'AI_IDENTITY',
  Aws = 'AWS',
  AzureKeyvault = 'AZURE_KEYVAULT',
  Crowdstrike = 'CROWDSTRIKE',
  CustomAuthServers = 'CUSTOM_AUTH_SERVERS',
  CustomOrgSlug = 'CUSTOM_ORG_SLUG',
  Datadog = 'DATADOG',
  DesktopApp = 'DESKTOP_APP',
  DiscoverAi = 'DISCOVER_AI',
  Entra = 'ENTRA',
  Github = 'GITHUB',
  GoogleWorkspace = 'GOOGLE_WORKSPACE',
  Jamf = 'JAMF',
  Jira = 'JIRA',
  LiveChat = 'LIVE_CHAT',
  McpServerGeneration = 'MCP_SERVER_GENERATION',
  NonHumanIdentity = 'NON_HUMAN_IDENTITY',
  Okta = 'OKTA',
  OnPremiseServers = 'ON_PREMISE_SERVERS',
  OpenTelemetry = 'OPEN_TELEMETRY',
  PlatformAuditLogs = 'PLATFORM_AUDIT_LOGS',
  Profiles = 'PROFILES',
  Salesforce = 'SALESFORCE',
  Sentinelone = 'SENTINELONE',
  Servicenow = 'SERVICENOW',
  Slack = 'SLACK',
  Snowflake = 'SNOWFLAKE',
  Splunk = 'SPLUNK',
  Sso = 'SSO'
}

/** A list of billing items for an org */
export type BillingItems = {
  __typename?: 'BillingItems';
  features: Array<BillingFeature>;
  products: Array<BillingProduct>;
};

/** A billing product for an org */
export type BillingProduct = {
  __typename?: 'BillingProduct';
  description: Scalars['String']['output'];
  features: Array<BillingFeatureId>;
  id: Scalars['String']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

/** Higher level billing product (includes a set of features). */
export enum BillingProductId {
  AgentAccessBase = 'AGENT_ACCESS_BASE',
  AgentAccessFreeTrial = 'AGENT_ACCESS_FREE_TRIAL',
  AgentAccessPrivatePreview = 'AGENT_ACCESS_PRIVATE_PREVIEW',
  NonHumanIdentity = 'NON_HUMAN_IDENTITY'
}

export type ByoTemplateSourceInput = {
  /** Authentication type for the MCP server */
  authenticationType: McpServerAuthenticationType;
  /** A brief description of the MCP server */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the MCP server */
  name: Scalars['String']['input'];
  /** Remote URL source configuration (required for REMOTE_URL type) */
  remoteUrlSource?: InputMaybe<RemoteUrlSourceInput>;
  /** The source type of the MCP server */
  sourceType: McpServerSourceType;
  /** The name for the static credential for STATIC_CREDS auth type BYO MCP servers */
  staticCredentialName?: InputMaybe<Scalars['String']['input']>;
};

/** A Cedar entity UID */
export type CedarEntityUid = {
  __typename?: 'CedarEntityUid';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ChangeUserRoleInput = {
  /** The new role to assign to the user. */
  newRole: UserRole;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

/** Configuration schema for an MCP server template */
export type ConfigSchema = {
  __typename?: 'ConfigSchema';
  /** List of tools that can be configured for this MCP server template */
  availableTools?: Maybe<Array<McpServerTool>>;
  /** Specifies the properties of required fields and their characteristics */
  properties: Scalars['ConfigProperties']['output'];
  /** Required fields for configuring an MCP server via a template */
  required?: Maybe<Array<Scalars['String']['output']>>;
};

/** Property definition in a config schema */
export type ConfigSchemaProperty = {
  __typename?: 'ConfigSchemaProperty';
  default?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isUrlParameter?: Maybe<Scalars['Boolean']['output']>;
  sensitive?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
};

/** The type of content being validated */
export enum ContentType {
  Arguments = 'ARGUMENTS',
  Response = 'RESPONSE'
}

/** A rule for content validation */
export type ContentValidationRule = {
  __typename?: 'ContentValidationRule';
  /**
   * Pattern matching is always case-insensitive.
   * @deprecated This field is ignored. All pattern matching is case-insensitive by default.
   */
  caseSensitive: Scalars['Boolean']['output'];
  /** Whether this rule applies to arguments or responses */
  contentType: ContentType;
  /** Human-readable description of this rule */
  description?: Maybe<Scalars['String']['output']>;
  /** The pattern to match in content (e.g., "neo", "password") */
  pattern: Scalars['String']['output'];
};

/** Input for a content validation rule */
export type ContentValidationRuleInput = {
  /** Pattern matching is always case-insensitive. */
  caseSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this rule applies to arguments or responses */
  contentType: ContentType;
  /** Human-readable description of this rule */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The pattern to match in content (e.g., "neo", "password") */
  pattern: Scalars['String']['input'];
};

/** Successful core client response, including created credential and deployment */
export type CoreDeploymentResponse = {
  __typename?: 'CoreDeploymentResponse';
  clientId: Scalars['String']['output'];
  credential: CredentialCreatedResponse;
  deployment: Deployment;
  name: Scalars['String']['output'];
};

/** Policy data required by MCP core */
export type CorePolicyData = {
  __typename?: 'CorePolicyData';
  /** If true, disable the universal permit policy (deny-by-default) */
  disableAllowAllPolicy?: Maybe<Scalars['Boolean']['output']>;
  entities?: Maybe<Array<Maybe<PolicyEntity>>>;
  policies?: Maybe<Array<Maybe<PolicyInfo>>>;
  schema?: Maybe<Scalars['String']['output']>;
};

/** List of servers for which we need to scan */
export type CoreScanRemoteServerRequests = {
  __typename?: 'CoreScanRemoteServerRequests';
  servers?: Maybe<Array<Maybe<ToolScan>>>;
};

/** Input for creating a new agent */
export type CreateAgentInput = {
  /** Display name for the agent */
  displayName: Scalars['String']['input'];
  /** User ID of the agent owner */
  ownerId: Scalars['String']['input'];
};

/** Input for creating a credential with specified type */
export type CreateCredentialInput = {
  /** Optional agent ID to create the credential for. If not provided, creates for current user. */
  agentId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Optional display name for the credential */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Type of the credential to create */
  type: CredentialTypes;
};

export type CreateDesktopAppReleasesInputObject = {
  channel: DesktopAppChannel;
  platforms: Array<DesktopPlatform>;
  status: DesktopAppReleaseStatus;
  version: Scalars['String']['input'];
};

/** Required information to create an ingest job */
export type CreateIngestJobInput = {
  context?: InputMaybe<Scalars['ObjectID']['input']>;
  contextType?: InputMaybe<JobContextType>;
  dependsOn?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  type: JobType;
};

export type CreateIntegrationInput = {
  activeAuthType: IntegrationAuthTypes;
  authFields: Scalars['JSON']['input'];
  authorizedScopes: Array<Scalars['String']['input']>;
  instanceName?: InputMaybe<Scalars['String']['input']>;
  integrationId: IntegrationId;
};

/** Required information to create a job chain */
export type CreateJobChainInput = {
  context: Scalars['ObjectID']['input'];
  contextType: JobContextType;
  jobChainType: JobChainType;
  params?: InputMaybe<JobChainParams>;
};

/** Input to create an install for an OAuth mcp server. */
export type CreateOAuthMcpServerInstallInput = {
  /** ID of actor that owns the oauth connection */
  actorId: Scalars['ObjectID']['input'];
  /** Client information from registration */
  clientInformation: OAuthClientInformationInput;
  /** Install display name */
  displayName: Scalars['String']['input'];
  /** ID of the server to which the install belongs */
  serverId: Scalars['ObjectID']['input'];
};

/** Input object for creating or updating an MCP access policy */
export type CreateOrUpdateAccessPolicyInput = {
  /** The ID of the policy to update (if updating existing policy) */
  _id?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The type of action this policy controls (invoke or validate_content) */
  actionType?: InputMaybe<PolicyActionType>;
  /** Content validation rules (only applicable for validate_content policies) */
  contentValidationRules?: InputMaybe<
    Array<InputMaybe<ContentValidationRuleInput>>
  >;
  /** Context conditions for policy enforcement (IP address ranges, user agent patterns, etc.) */
  contextConditions?: InputMaybe<Scalars['JSON']['input']>;
  /** Policy effect: must be "permit" */
  effect?: InputMaybe<PolicyEffectType>;
  /** The name of the access policy */
  name: Scalars['String']['input'];
  /** The nested conditional principals this policy applies to */
  principalTree?: InputMaybe<Scalars['JSON']['input']>;
  /** The status of the access policy */
  status?: InputMaybe<McpAccessPolicyStatus>;
  /** The target configurations this policy applies to */
  targetConfigs?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type CreateShadowMcpServersInput = {
  servers: Array<ShadowMcpServerInput>;
};

/** Successful tunnel creation response */
export type CreateTunnelResponse = {
  __typename?: 'CreateTunnelResponse';
  _id: Scalars['ObjectID']['output'];
  connectionStatus: TunnelConnectionStatus;
  displayName: Scalars['String']['output'];
  metadata: TunnelMetadata;
  status: TunnelStatus;
  tunnelKey: CredentialCreatedResponse;
};

/** An authn/authz mechanism used to access resources or services within the organization in natoma. */
export type Credential = {
  __typename?: 'Credential';
  _id: Scalars['ObjectID']['output'];
  createdAt: Scalars['DateTime']['output'];
  credentialId: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  lastUsed?: Maybe<Scalars['DateTime']['output']>;
  org: Org;
  ownedBy: CredentialOwner;
  preview: Scalars['String']['output'];
  status: CredentialStatus;
  type: CredentialTypes;
  updatedAt: Scalars['DateTime']['output'];
};

/** Response object for credential creation, for which we show unencrypted secret */
export type CredentialCreatedResponse = {
  __typename?: 'CredentialCreatedResponse';
  _id: Scalars['ObjectID']['output'];
  createdAt: Scalars['DateTime']['output'];
  credentialId: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  lastUsed?: Maybe<Scalars['DateTime']['output']>;
  preview: Scalars['String']['output'];
  /** The unencrypted secret value of the credential */
  secret: Scalars['String']['output'];
  status: CredentialStatus;
  type: CredentialTypes;
};

export type CredentialOwner = Agent | User;

/** The status of a credential */
export enum CredentialStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Deleted = 'DELETED'
}

/** The available credential types */
export enum CredentialTypes {
  ApiKey = 'API_KEY',
  ClientCredentials = 'CLIENT_CREDENTIALS',
  ScimProvisioningKey = 'SCIM_PROVISIONING_KEY',
  TunnelKey = 'TUNNEL_KEY'
}

/** CrowdStrike Intergration details */
export type CrowdStrikeIntegration = Integration & {
  __typename?: 'CrowdStrikeIntegration';
  activeAuthType: IntegrationAuthTypes;
  authFields: Scalars['JSON']['output'];
  authorizedScopes: Array<Scalars['String']['output']>;
  currentScopes?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  integrationId: IntegrationId;
  status: IntegrationStatus;
  uniqueId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Dynamic remote URL source for custom MCP server info provided by a customer */
export type CustomDynamicRemoteUrlSource = {
  __typename?: 'CustomDynamicRemoteUrlSource';
  /** The deployment associated with the custom dynamic remote URL source */
  deployment?: Maybe<Deployment>;
  /** Reference to the deployment associated with the custom dynamic remote URL source */
  deploymentRef?: Maybe<Scalars['ObjectID']['output']>;
  /** Indicates whether the remote URL is for an on-premises server */
  isOnPrem?: Maybe<Scalars['Boolean']['output']>;
  /** The URL of the MCP server */
  mcpServerUrl: Scalars['String']['output'];
  /** The type of source for the MCP server info. In this case, it will always be DYNAMIC_REMOTE_URL */
  sourceType: McpServerSourceType;
  /** The transport method used for the MCP server */
  transport?: Maybe<McpServerTransport>;
  /** Indicates whether a custom authentication server is used */
  useCustomAuthServer?: Maybe<Scalars['Boolean']['output']>;
};

/** MCP server info for custom servers configured by users. */
export type CustomMcpServerInfo = {
  __typename?: 'CustomMCPServerInfo';
  /** The authentication type for the MCP server */
  authenticationType?: Maybe<McpServerAuthenticationType>;
  /** A brief description of the MCP server */
  description?: Maybe<Scalars['String']['output']>;
  /** Configuration schema for the MCP server installations */
  installConfig?: Maybe<McpServerInfoConfigSchema>;
  /** The display name of the MCP server */
  name: Scalars['String']['output'];
  /** A unique identifier for the MCP server */
  slug: Scalars['String']['output'];
  /** The source information for the custom MCP server configured by the user */
  source: CustomServerInfoSource;
};

/** Remote URL source for custom MCP server info provided by a customer */
export type CustomRemoteUrlSource = {
  __typename?: 'CustomRemoteUrlSource';
  /** The deployment associated with the custom remote URL source */
  deployment?: Maybe<Deployment>;
  /** Reference to the deployment associated with the custom remote URL source */
  deploymentRef?: Maybe<Scalars['ObjectID']['output']>;
  /** Indicates whether the remote URL is for an on-premises server */
  isOnPrem?: Maybe<Scalars['Boolean']['output']>;
  /** The URL of the MCP server */
  mcpServerUrl: Scalars['String']['output'];
  /** The type of source for the MCP server info. In this case, it will always be REMOTE_URL */
  sourceType: McpServerSourceType;
  /** The transport method used for the MCP server */
  transport?: Maybe<McpServerTransport>;
  /** Indicates whether a custom authentication server is used */
  useCustomAuthServer?: Maybe<Scalars['Boolean']['output']>;
};

/** Union type for the source field of the MCP server info provided by a customer. */
export type CustomServerInfoSource =
  | CustomDynamicRemoteUrlSource
  | CustomRemoteUrlSource;

/** Custom-only fields for editMCPServer */
export type CustomServerPatchInput = {
  /** Authentication type used by the BYO server */
  authenticationType?: InputMaybe<McpServerAuthenticationType>;
  /** Human-readable description of the BYO server */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Remote URL source configuration — only valid for REMOTE_URL servers */
  remoteUrlSource?: InputMaybe<RemoteUrlSourceInput>;
  /** Name of the static credential to use — only valid for STATIC_CREDS servers */
  staticCredentialName?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardInstallationsByMcpServer = {
  __typename?: 'DashboardInstallationsByMCPServer';
  /** Number of managed connections installed */
  managedConnections: Scalars['Int']['output'];
  /** Number of personal connections installed */
  personalConnections: Scalars['Int']['output'];
  /** Name of the MCP server */
  serverName: Scalars['String']['output'];
  /** Number of shadow connections discovered */
  shadowConnections: Scalars['Int']['output'];
};

/** Dashboard top MCP servers by tool calls */
export type DashboardMcpServersByToolCalls = {
  __typename?: 'DashboardMCPServersByToolCalls';
  /** Name of the MCP server */
  serverName: Scalars['String']['output'];
  /** Total number of tool calls made for this MCP server. */
  toolCallCount: Scalars['Int']['output'];
};

export type DashboardToolCallsOverTime = {
  __typename?: 'DashboardToolCallsOverTime';
  /** Number of failed calls, this could be errors or rejected calls */
  failedCalls: Scalars['Int']['output'];
  /** Number of successful calls */
  successfulCalls: Scalars['Int']['output'];
  /** Total number of calls */
  totalCalls: Scalars['Int']['output'];
  /** End of the week */
  weekEnd: Scalars['DateTime']['output'];
  /** Start of the week */
  weekStart: Scalars['DateTime']['output'];
};

/** Dashboard top users by tool calls */
export type DashboardUsersByToolCalls = {
  __typename?: 'DashboardUsersByToolCalls';
  /** Total number of tool calls made by this user. */
  toolCallCount: Scalars['Int']['output'];
  /** The user object related to this tool call count */
  user: User;
};

/** Datadog OTLP (SIEM export) integration details */
export type DatadogOtlpIntegration = Integration & {
  __typename?: 'DatadogOtlpIntegration';
  activeAuthType: IntegrationAuthTypes;
  authFields: Scalars['JSON']['output'];
  authorizedScopes: Array<Scalars['String']['output']>;
  currentScopes?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  integrationId: IntegrationId;
  status: IntegrationStatus;
  uniqueId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Input object for deleting an MCP access policy */
export type DeleteAccessPolicyInput = {
  /** The ID of the access policy to delete */
  _id: Scalars['ObjectID']['input'];
};

export enum DeleteNhiDataPhase {
  Purge = 'PURGE',
  Tombstone = 'TOMBSTONE'
}

export type DeleteNhiDataResult = {
  __typename?: 'DeleteNhiDataResult';
  orgId: Scalars['ObjectID']['output'];
  phase: DeleteNhiDataPhase;
  pubsubMessageId: Scalars['String']['output'];
};

/** A simple type to confirm the deletion of a particular object */
export type DeleteResult = {
  __typename?: 'DeleteResult';
  _id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** A deployment definition */
export type Deployment = {
  __typename?: 'Deployment';
  /** ObjectId of the DeploymentDocument */
  _id: Scalars['ObjectID']['output'];
  /** Deployment creation datetime */
  createdAt: Scalars['DateTime']['output'];
  /** The admin user who created this deployment */
  createdBy: User;
  /** List of active credentials associated with this deployment */
  credentials: Array<Credential>;
  /** User-friendly name for deployment */
  displayName: Scalars['String']['output'];
  /** Health of this deployment connection to on-prem agents */
  health: Scalars['String']['output'];
  /** Origin for the deployment */
  origin: Scalars['String']['output'];
  /** Last time on-prem agent deployment polled natoma server */
  polledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Status of the deployment */
  status: DeploymentStatus;
  /** Deployment last update datetime */
  updatedAt: Scalars['DateTime']['output'];
  /** The admin user who last updated this deployment */
  updatedBy: User;
};

/** The status of a deployment */
export enum DeploymentStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Deleted = 'DELETED'
}

export enum DesktopAppChannel {
  Alpha = 'ALPHA',
  Beta = 'BETA',
  Stable = 'STABLE',
  Test = 'TEST'
}

export type DesktopAppRelease = {
  __typename?: 'DesktopAppRelease';
  _id: Scalars['ObjectID']['output'];
  channel: DesktopAppChannel;
  createdAt: Scalars['DateTime']['output'];
  platform: DesktopPlatform;
  status: DesktopAppReleaseStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version: Scalars['String']['output'];
  versionCode: Scalars['Float']['output'];
};

export type DesktopAppReleaseFilterInput = {
  channel?: InputMaybe<DesktopAppChannel>;
  platform?: InputMaybe<DesktopPlatform>;
  version: Scalars['String']['input'];
};

export enum DesktopAppReleaseStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE'
}

export type DesktopAppReleaseUpdatePatchInput = {
  status?: InputMaybe<DesktopAppReleaseStatus>;
};

export type DesktopAppReleasesGroupedByVersion = {
  __typename?: 'DesktopAppReleasesGroupedByVersion';
  releases: Array<DesktopAppRelease>;
  version: Scalars['String']['output'];
};

export enum DesktopPlatform {
  Linux = 'LINUX',
  Mac = 'MAC',
  Windows = 'WINDOWS'
}

/** Discovered AI clients grouped by configFileType — one row per client type across all integrations */
export type DiscoveredAiClient = {
  __typename?: 'DiscoveredAIClient';
  configFileType: Scalars['String']['output'];
  firstSeenAt: Scalars['DateTime']['output'];
  /** Integration IDs of EDR/MDM services that detected this client type. */
  integrationIds: Array<IntegrationId>;
  /** Whether this client type has any detections from Natoma Desktop */
  isDetectedByDesktopApp: Scalars['Boolean']['output'];
  lastSeenAt: Scalars['DateTime']['output'];
  users: Array<ShadowDeviceInfo>;
  usersCount: Scalars['Int']['output'];
};

/** A distinct user/device that has a specific AI client installed */
export type DiscoveredAiClientUserEntry = {
  __typename?: 'DiscoveredAIClientUserEntry';
  device?: Maybe<Scalars['String']['output']>;
  firstDetectedAt: Scalars['DateTime']['output'];
  /** Integration IDs of EDR/MDM services that detected this user. */
  integrationIds: Array<IntegrationId>;
  /** Whether this user was detected by Natoma Desktop */
  isDetectedByDesktopApp: Scalars['Boolean']['output'];
  lastSeenAt: Scalars['DateTime']['output'];
  user?: Maybe<Scalars['String']['output']>;
};

/** Paginated users for a specific AI client type across all integrations */
export type DiscoveredAiClientUsersResult = {
  __typename?: 'DiscoveredAIClientUsersResult';
  firstDetectedAt?: Maybe<Scalars['DateTime']['output']>;
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  /** Total count of distinct users for this client type (unfiltered by search) */
  totalCount: Scalars['Int']['output'];
  users: Array<DiscoveredAiClientUserEntry>;
};

/** An AI client type with its unique device installations */
export type DiscoveredClientByDevices = {
  __typename?: 'DiscoveredClientByDevices';
  configFileType: Scalars['String']['output'];
  deviceCount: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
};

/** Sort options for discovered AI clients */
export enum DiscoveredClientSortBy {
  ClientNameAsc = 'CLIENT_NAME_ASC',
  ClientNameDesc = 'CLIENT_NAME_DESC',
  FirstDetectedAsc = 'FIRST_DETECTED_ASC',
  FirstDetectedDesc = 'FIRST_DETECTED_DESC',
  LastSeenAsc = 'LAST_SEEN_ASC',
  LastSeenDesc = 'LAST_SEEN_DESC',
  UsersAsc = 'USERS_ASC',
  UsersDesc = 'USERS_DESC'
}

/** A discovered MCP server ranked by installation count */
export type DiscoveredMcpServerByInstallations = {
  __typename?: 'DiscoveredMCPServerByInstallations';
  installationCount: Scalars['Int']['output'];
  normalizedServerName: Scalars['String']['output'];
};

/** A device user with the number of distinct MCP servers detected for them */
export type DiscoveredUserByServers = {
  __typename?: 'DiscoveredUserByServers';
  hostname?: Maybe<Scalars['String']['output']>;
  primaryUserEmail?: Maybe<Scalars['String']['output']>;
  serverCount: Scalars['Int']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

/** Configuration for dynamically configured remotely hosted MCP servers */
export type DynamicRemoteUrlSource = {
  __typename?: 'DynamicRemoteUrlSource';
  deployment?: Maybe<Deployment>;
  /** Flag if set to true, this is an on-prem server */
  isOnPrem?: Maybe<Scalars['Boolean']['output']>;
  /** The URL template with placeholders for parameters (e.g., https://{subdomain}.example.com) */
  mcpServerUrl: Scalars['String']['output'];
  sourceType: McpServerSourceType;
  /** Flag if set to true, use specified authorization server to introspect a passed token */
  useCustomAuthServer?: Maybe<Scalars['Boolean']['output']>;
};

export type EditMcpServerInput = {
  _id: Scalars['ObjectID']['input'];
  patch: EditMcpServerPatch;
};

export type EditMcpServerPatch = {
  /** Pass true to enable personal connections, false to disable them */
  allowPersonalConnections?: InputMaybe<Scalars['Boolean']['input']>;
  /** Server-level config (key-value pairs), e.g. URL-parameter values like a GitLab instance host. Persisted to MCPServer.config and used to build the server URL. */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** BYO-only patch fields — invalid for NATOMA-origin servers */
  customServerPatch?: InputMaybe<CustomServerPatchInput>;
  /** New display name for the server */
  name?: InputMaybe<Scalars['String']['input']>;
  /** OAuth client credentials to store on the server */
  oauthCredentials?: InputMaybe<OAuthCredentialsInput>;
};

/** Elasticsearch OTLP (SIEM export) integration details */
export type ElasticsearchOtlpIntegration = Integration & {
  __typename?: 'ElasticsearchOtlpIntegration';
  activeAuthType: IntegrationAuthTypes;
  authFields: Scalars['JSON']['output'];
  authorizedScopes: Array<Scalars['String']['output']>;
  currentScopes?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  integrationId: IntegrationId;
  status: IntegrationStatus;
  uniqueId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EnableMcpServerInput = {
  /** Whether personal connections are allowed for this server */
  allowPersonalConnections?: InputMaybe<Scalars['Boolean']['input']>;
  /** Server-level config (key-value pairs), e.g. URL-parameter values like a GitLab instance host. Persisted to MCPServer.config and used to build the server URL. */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** BYO server to enable (mutually exclusive with serverId) */
  customSource?: InputMaybe<ByoTemplateSourceInput>;
  /** Optional OAuth credentials for this server */
  oauthCredentials?: InputMaybe<OAuthCredentialsInput>;
  /** NATOMA-origin server to enable (mutually exclusive with byoSource) */
  serverId?: InputMaybe<McpServerId>;
};

/** A general error object */
export type Error = {
  __typename?: 'Error';
  message: Scalars['String']['output'];
};

/** Input body to query for a single MCP server, reusable for any query */
export type GetByIdMcpServerInput = {
  /** The ID of the MCP server to update */
  _id: Scalars['ObjectID']['input'];
};

/** Input body to query for a single MCP server install, reusable for any query */
export type GetByIdMcpServerInstallInput = {
  /** The ID of the MCP server install to update */
  _id: Scalars['ObjectID']['input'];
};

/** Different sorts for the orgs query */
export enum GetOrgsSort {
  DisplaynameAsc = 'DISPLAYNAME_ASC',
  DisplaynameDesc = 'DISPLAYNAME_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC'
}

/** Returns the short-lived access token for the scoped service account */
export type GetStorageBucketServiceAccountCredentialResponse = {
  __typename?: 'GetStorageBucketServiceAccountCredentialResponse';
  accessToken: Scalars['String']['output'];
  expiration: Scalars['DateTime']['output'];
};

export type GetUsersResponse = {
  __typename?: 'GetUsersResponse';
  total: Scalars['Int']['output'];
  users?: Maybe<Array<User>>;
};

/** Different sorts for the users query */
export enum GetUsersSort {
  DisplayNameAsc = 'DISPLAY_NAME_ASC',
  DisplayNameDesc = 'DISPLAY_NAME_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC'
}

/** A group of users */
export type Group = {
  __typename?: 'Group';
  _id: Scalars['ObjectID']['output'];
  displayName: Scalars['String']['output'];
};

/** Health and error metadata for an MCP server installation */
export type HealthStatus = {
  __typename?: 'HealthStatus';
  healthy: Scalars['Boolean']['output'];
  lastCheckedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Inferred = {
  __typename?: 'Inferred';
  integrationId?: Maybe<InferredIntegrationId>;
  integrationLookupId?: Maybe<Scalars['String']['output']>;
};

/** Set of available integration IDs for inferred integrations */
export enum InferredIntegrationId {
  Crowdstrike = 'CROWDSTRIKE',
  DatadogOtlp = 'DATADOG_OTLP',
  ElasticsearchOtlp = 'ELASTICSEARCH_OTLP',
  Jamf = 'JAMF',
  Natoma = 'NATOMA',
  NatomaBot = 'NATOMA_BOT',
  NewRelicOtlp = 'NEW_RELIC_OTLP',
  ObserveOtlp = 'OBSERVE_OTLP',
  OpenTelemetry = 'OPEN_TELEMETRY',
  Sentinelone = 'SENTINELONE',
  SplunkHec = 'SPLUNK_HEC'
}

/** The processing metadata of an ingest job */
export type IngestJobProcessingMetadata = {
  __typename?: 'IngestJobProcessingMetadata';
  expectedIdentities?: Maybe<Scalars['Int']['output']>;
  processedIdentities?: Maybe<Scalars['Int']['output']>;
};

/** Action to add or remove an actor from the MCP server installation */
export enum InstallationAction {
  Add = 'ADD',
  Remove = 'REMOVE'
}

/** Configuration for a single MCP server installation in a profile */
export type InstallationConfig = {
  __typename?: 'InstallationConfig';
  /** Whether or not all tools are enabled for this server in this profile */
  allToolsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** List of enabled tool names (without server prefix) */
  enabledTools: Array<Scalars['String']['output']>;
  /** Whether this is a managed or personal installation */
  installType: McpServerInstallAccessInstallType;
  /** Optional reference to a specific managed installation (null for personal installs) */
  installation?: Maybe<McpServerInstall>;
  /** The MCP server for this installation */
  server: McpServer;
};

/** Configuration for a single MCP server installation in a profile */
export type InstallationConfigInput = {
  /** Whether or not all tools are enabled for this server in this profile */
  allToolsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of enabled tool names (without server prefix) */
  enabledTools?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether this is a MANAGED or PERSONAL installation */
  installType: McpServerInstallAccessInstallType;
  /** Reference to MCPServerInstall (null if not connected yet for PERSONAL installs) */
  installation?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Reference to the MCPServer */
  server: Scalars['ObjectID']['input'];
};

/** Properties needed to configure an MCP server installation */
export type InstallationConfigProperties = {
  __typename?: 'InstallationConfigProperties';
  /** Schema defining the configuration fields required for installing this MCP server */
  configSchema: McpServerInfoConfigSchema;
  /** Object ID of the MCP server we are fetching installation configuration properties for */
  server?: Maybe<McpServer>;
  /** ID of the MCP server info for which we are fetching installation configuration properties */
  serverId?: Maybe<McpServerId>;
};

/** The scope of installations a policy target applies to */
export enum InstallationScope {
  All = 'ALL',
  Managed = 'MANAGED',
  Personal = 'PERSONAL',
  PersonalWithSpecificManaged = 'PERSONAL_WITH_SPECIFIC_MANAGED',
  Specific = 'SPECIFIC'
}

export enum InstalledForActorType {
  Agent = 'AGENT',
  User = 'USER'
}

export type Integration = {
  activeAuthType: IntegrationAuthTypes;
  authFields: Scalars['JSON']['output'];
  authorizedScopes: Array<Scalars['String']['output']>;
  currentScopes?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  integrationId: IntegrationId;
  status: IntegrationStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** The available authentication types for an integration */
export enum IntegrationAuthTypes {
  ApiKey = 'API_KEY',
  AsyncConfiguration = 'ASYNC_CONFIGURATION',
  AsyncConfigurationBulk = 'ASYNC_CONFIGURATION_BULK',
  ClientCredentials = 'CLIENT_CREDENTIALS',
  Install = 'INSTALL',
  Oauth = 'OAUTH',
  ServiceAccount = 'SERVICE_ACCOUNT'
}

/** A sum of configured services for a given integrationId */
export type IntegrationCount = {
  __typename?: 'IntegrationCount';
  count: Scalars['Int']['output'];
  integrationId: IntegrationId;
};

/** Set of available integration IDs */
export enum IntegrationId {
  Crowdstrike = 'CROWDSTRIKE',
  DatadogOtlp = 'DATADOG_OTLP',
  ElasticsearchOtlp = 'ELASTICSEARCH_OTLP',
  Jamf = 'JAMF',
  NewRelicOtlp = 'NEW_RELIC_OTLP',
  ObserveOtlp = 'OBSERVE_OTLP',
  OpenTelemetry = 'OPEN_TELEMETRY',
  Sentinelone = 'SENTINELONE',
  SplunkHec = 'SPLUNK_HEC'
}

/** The status of an integration connection */
export enum IntegrationStatus {
  Active = 'ACTIVE',
  Disconnected = 'DISCONNECTED'
}

/** Input for inviting a user to the current organization. */
export type InviteUserInput = {
  /** The email address of the user to invite. */
  email: Scalars['String']['input'];
  /** The role of the user to invite. */
  role?: UserRole;
};

/** Jamf Intergration details */
export type JamfIntegration = Integration & {
  __typename?: 'JamfIntegration';
  activeAuthType: IntegrationAuthTypes;
  authFields: Scalars['JSON']['output'];
  authorizedScopes: Array<Scalars['String']['output']>;
  currentScopes?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  integrationId: IntegrationId;
  status: IntegrationStatus;
  uniqueId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** A record for a identity ingest job */
export type Job = {
  __typename?: 'Job';
  _id: Scalars['ObjectID']['output'];
  adminInitiated?: Maybe<Scalars['Boolean']['output']>;
  areDependenciesCompleted?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  context?: Maybe<JobContext>;
  dependsOn?: Maybe<Array<Maybe<Scalars['ObjectID']['output']>>>;
  error?: Maybe<Scalars['String']['output']>;
  missingScopes?: Maybe<Array<Scalars['String']['output']>>;
  org: Org;
  processingMetadata?: Maybe<IngestJobProcessingMetadata>;
  queuedAt: Scalars['DateTime']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: JobStatus;
  triggeredBy?: Maybe<User>;
  type: JobType;
};

/** A chain of jobs */
export type JobChain = {
  __typename?: 'JobChain';
  _id: Scalars['ObjectID']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  context?: Maybe<JobContext>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The error surfaced to the end user */
  error?: Maybe<Scalars['String']['output']>;
  missingScopes?: Maybe<Array<Scalars['String']['output']>>;
  org: Org;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: JobStatus;
  type: JobChainType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Parameters for a job chain */
export type JobChainParams = {
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The type of job chain */
export enum JobChainType {
  Ingest = 'INGEST'
}

/** The context of an job */
export type JobContext = {
  __typename?: 'JobContext';
  ref?: Maybe<Scalars['ObjectID']['output']>;
  service?: Maybe<Service>;
  type?: Maybe<JobContextType>;
};

/** The type of document to which the context ref refers */
export enum JobContextType {
  Org = 'Org',
  Service = 'Service',
  ServiceIdentity = 'ServiceIdentity'
}

/** The status of a job */
export enum JobStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Queued = 'QUEUED'
}

/** The type of this job */
export enum JobType {
  OrgLevel = 'ORG_LEVEL',
  UserDetail = 'USER_DETAIL'
}

/** Configuration for locally running MCP servers managed by the desktop application */
export type LocalPackageSource = {
  __typename?: 'LocalPackageSource';
  commandFunction: Scalars['String']['output'];
  sourceType: McpServerSourceType;
  transport: McpServerTransport;
};

/** Configuration for locally running servers that use HTTP transport */
export type LocalUrlSource = {
  __typename?: 'LocalUrlSource';
  sourceType: McpServerSourceType;
  transport: McpServerTransport;
  url?: Maybe<Scalars['String']['output']>;
};

export type LoginInfo = {
  __typename?: 'LoginInfo';
  _id?: Maybe<Scalars['ObjectID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  ssoOrg?: Maybe<Scalars['ObjectID']['output']>;
};

/** An access policy to control MCP usage */
export type McpAccessPolicy = {
  __typename?: 'MCPAccessPolicy';
  _id: Scalars['ObjectID']['output'];
  /** The type of action this policy controls */
  actionType: PolicyActionType;
  /** Content validation rules (only applicable for validate_content policies) */
  contentValidationRules?: Maybe<Array<Maybe<ContentValidationRule>>>;
  /** Context conditions for policy enforcement (stored for UI editing) */
  contextConditions?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Policy effect: must be forbid (all actions permitted by default) */
  effect?: Maybe<PolicyEffectType>;
  /** Whether this policy uses deprecated features (forbid effect, or any targetConfig with non-ALL installationScope) */
  isDeprecated: Scalars['Boolean']['output'];
  isTombstoned?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  org: Org;
  /** The Cedar policy string synthesized from this policy document */
  policy: Scalars['String']['output'];
  /** Nested principal conditions for this policy */
  principalTree?: Maybe<McpAccessPolicyPrincipalTreeNode>;
  status: McpAccessPolicyStatus;
  /** All target configs relevant for this policy */
  targetConfigs: Array<McpAccessPolicyTarget>;
  updatedAt: Scalars['DateTime']['output'];
};

/** The op node type of an op principal */
export enum McpAccessPolicyPrincipalOp {
  And = 'AND',
  Or = 'OR'
}

/** A single profile attribute definition on a node */
export type McpAccessPolicyPrincipalProfile = {
  __typename?: 'MCPAccessPolicyPrincipalProfile';
  key?: Maybe<Scalars['String']['output']>;
  matcher?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

/** The op node type of an op principal */
export enum McpAccessPolicyPrincipalRootType {
  Actorsids = 'ACTORSIDS',
  Advanced = 'ADVANCED',
  Conditions = 'CONDITIONS',
  Userids = 'USERIDS'
}

/** A node in the principal tree for nested ANY/ALL (OR/AND) conditions in access policies */
export type McpAccessPolicyPrincipalTreeNode = {
  __typename?: 'MCPAccessPolicyPrincipalTreeNode';
  agentId?: Maybe<Scalars['ObjectID']['output']>;
  groupId?: Maybe<Scalars['ObjectID']['output']>;
  matcher?: Maybe<Scalars['String']['output']>;
  nodes?: Maybe<Array<Maybe<McpAccessPolicyPrincipalTreeNode>>>;
  op?: Maybe<McpAccessPolicyPrincipalOp>;
  profile?: Maybe<McpAccessPolicyPrincipalProfile>;
  role?: Maybe<UserRole>;
  rootType?: Maybe<McpAccessPolicyPrincipalRootType>;
  type?: Maybe<McpAccessPolicyPrincipalType>;
  userId?: Maybe<Scalars['ObjectID']['output']>;
};

/** Principal type on a policy */
export enum McpAccessPolicyPrincipalType {
  AgentId = 'AGENT_ID',
  GroupMembership = 'GROUP_MEMBERSHIP',
  UserId = 'USER_ID',
  UserProfileAttribute = 'USER_PROFILE_ATTRIBUTE',
  UserRole = 'USER_ROLE'
}

/** The status of the MCP server */
export enum McpAccessPolicyStatus {
  Deleted = 'DELETED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

/** The access policy target, or a server and its installs to which the policy applies */
export type McpAccessPolicyTarget = {
  __typename?: 'MCPAccessPolicyTarget';
  /** Whether or not all tools should be a target config */
  allTools: Scalars['Boolean']['output'];
  /** The scope of installations this policy applies to */
  installationScope: InstallationScope;
  server: McpServer;
  serverInstalls: Array<McpServerInstall>;
  /** List of tools for this server that policy applies */
  tools: Array<Scalars['String']['output']>;
  /** Total number of installs on this server target */
  totalInstalls: Scalars['Int']['output'];
};

/** Type of client used to connect to the MCP server */
export enum McpClientType {
  Chatgpt = 'CHATGPT',
  Claude = 'CLAUDE',
  ClaudeCode = 'CLAUDE_CODE',
  ClaudeWeb = 'CLAUDE_WEB',
  Cline = 'CLINE',
  Codex = 'CODEX',
  CortexCode = 'CORTEX_CODE',
  Cursor = 'CURSOR',
  Gemini = 'GEMINI',
  Kiro = 'KIRO',
  Langchain = 'LANGCHAIN',
  MsftCopilot = 'MSFT_COPILOT',
  OaiPlayground = 'OAI_PLAYGROUND',
  Openclaw = 'OPENCLAW',
  Opencode = 'OPENCODE',
  QDeveloper = 'Q_DEVELOPER',
  Subconscious = 'SUBCONSCIOUS',
  Vscode = 'VSCODE',
  Windsurf = 'WINDSURF'
}

/** User profile containing MCP server configurations */
export type McpProfile = {
  __typename?: 'MCPProfile';
  _id: Scalars['ObjectID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** List of MCP server installation configurations */
  installationConfigs: Array<ProfileInstallationConfig>;
  /** Indicates if this profile is the system default */
  isSystemDefault?: Maybe<Scalars['Boolean']['output']>;
  /** The path to the MCP profile */
  mcpUrl: Scalars['String']['output'];
  /** Optional display name for the profile */
  name?: Maybe<Scalars['String']['output']>;
  org: Org;
  /** The user who owns this profile */
  owner: User;
  /** Optional URL-friendly slug for the profile */
  slug?: Maybe<Scalars['String']['output']>;
  /** Reference to template (only for MANAGED profiles) */
  templateRef?: Maybe<McpProfileTemplate>;
  /** Profile type - MANAGED or PERSONAL */
  type: McpProfileType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Admin-defined template containing a collection of MCP server configurations */
export type McpProfileTemplate = {
  __typename?: 'MCPProfileTemplate';
  _id: Scalars['ObjectID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Human-readable name for this template */
  displayName: Scalars['String']['output'];
  /** List of MCP server installation configurations (can have multiple servers) */
  installationConfigs: Array<InstallationConfig>;
  /** The organization that owns this template */
  org: Org;
  updatedAt: Scalars['DateTime']['output'];
};

/** Type of MCP profile - MANAGED (from template) or PERSONAL (custom) */
export enum McpProfileType {
  Managed = 'MANAGED',
  Personal = 'PERSONAL'
}

/** An MCP (Model Context Protocol) server */
export type McpServer = {
  __typename?: 'MCPServer';
  _id: Scalars['ObjectID']['output'];
  accessConfig: McpServerAccessConfig;
  /** List of MCP server installs for this server */
  availableInstalls: Array<McpServerInstall>;
  /** List of tools available on this MCP server */
  availableTools: Array<McpServerTool>;
  /** Whether the current user has permission to view/use this server */
  canConnect: Scalars['Boolean']['output'];
  /** Server-level configuration (e.g., URL parameters for DYNAMIC_REMOTE_URL servers) */
  config?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Whether this server has an OAuth client secret configured */
  hasOauthClientSecret?: Maybe<Scalars['Boolean']['output']>;
  /** This value is true if a BYO on-prem server has been scanned */
  isRemoteServerScanned?: Maybe<Scalars['Boolean']['output']>;
  /** List of managed installs on this MCP server */
  managedInstalls: Array<McpServerToInstallObject>;
  name: Scalars['String']['output'];
  /** Optional OAuth client ID configured for this server */
  oauthClientId?: Maybe<Scalars['String']['output']>;
  /** Optional OAuth scopes configured for this server */
  oauthScopes?: Maybe<Scalars['String']['output']>;
  org: Org;
  originType: McpServerOrigin;
  /** The server info for this MCP server. For Natoma catalog servers, this is a TypeScript-defined object. For BYO servers, this is based on the custom server info configured by the user. */
  serverInfo: ServerInfo;
  status: McpServerStatus;
  template?: Maybe<McpServerTemplate>;
  /** Slug identifying the server template, used for stable URL generation */
  templateSlug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** Count of distinct users who have installs on the server */
  usersCount: Scalars['Int']['output'];
};

/** An MCP (Model Context Protocol) server */
export type McpServerAvailableInstallsArgs = {
  agentId?: InputMaybe<Scalars['ObjectID']['input']>;
  showInstalls?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Who can create connections to this MCP server */
export enum McpServerAccessAvailableFor {
  Managed = 'MANAGED',
  Personal = 'PERSONAL'
}

/** The access configuration for the MCP server */
export type McpServerAccessConfig = {
  __typename?: 'MCPServerAccessConfig';
  availableFor: Array<McpServerAccessAvailableFor>;
  /** Whether personal connections are enabled for this MCP server */
  isPersonalConnectionEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Authentication type for the MCP server */
export enum McpServerAuthenticationType {
  ClientCredentials = 'CLIENT_CREDENTIALS',
  None = 'NONE',
  Oauth = 'OAUTH',
  StaticCreds = 'STATIC_CREDS'
}

/** The source type of the MCP server */
export enum McpServerDetectionMethod {
  Ai = 'AI',
  Regex = 'REGEX'
}

/** The ID of the MCP server (for built-in servers) */
export enum McpServerId {
  Airtable = 'AIRTABLE',
  AirweaveSearch = 'AIRWEAVE_SEARCH',
  Amplitude = 'AMPLITUDE',
  Apiiro = 'APIIRO',
  Asana = 'ASANA',
  Ashby = 'ASHBY',
  AshbyNatoma = 'ASHBY_NATOMA',
  Atlassian = 'ATLASSIAN',
  AtlassianRemote = 'ATLASSIAN_REMOTE',
  AvalaraDevDocumentation = 'AVALARA_DEV_DOCUMENTATION',
  AvalaraTaxContent = 'AVALARA_TAX_CONTENT',
  Avatax = 'AVATAX',
  AwsCloudwatch = 'AWS_CLOUDWATCH',
  AwsCostExplorer = 'AWS_COST_EXPLORER',
  AwsDocumentation = 'AWS_DOCUMENTATION',
  AwsIam = 'AWS_IAM',
  AzureDevops = 'AZURE_DEVOPS',
  BigqueryRemote = 'BIGQUERY_REMOTE',
  Box = 'BOX',
  Brave = 'BRAVE',
  Braze = 'BRAZE',
  Buildkite = 'BUILDKITE',
  BullhornCrm = 'BULLHORN_CRM',
  Checkmarx = 'CHECKMARX',
  Chembl = 'CHEMBL',
  ChromeDevtools = 'CHROME_DEVTOOLS',
  Circleci = 'CIRCLECI',
  Clickup = 'CLICKUP',
  Clojure = 'CLOJURE',
  CloudflareAuditLogs = 'CLOUDFLARE_AUDIT_LOGS',
  CloudflareWorkersObservability = 'CLOUDFLARE_WORKERS_OBSERVABILITY',
  Cloudzero = 'CLOUDZERO',
  CnaGwreDeveloperAssistant = 'CNA_GWRE_DEVELOPER_ASSISTANT',
  CnaJutroDeveloperAssistant = 'CNA_JUTRO_DEVELOPER_ASSISTANT',
  Context7 = 'CONTEXT7',
  Context7Oauth = 'CONTEXT7_OAUTH',
  Crowdstrike = 'CROWDSTRIKE',
  CustomApiServer = 'CUSTOM_API_SERVER',
  CyeraDataport = 'CYERA_DATAPORT',
  Dailymed = 'DAILYMED',
  Databricks = 'DATABRICKS',
  DatadogCommunity = 'DATADOG_COMMUNITY',
  Dataforseo = 'DATAFORSEO',
  Datahub = 'DATAHUB',
  Dovetail = 'DOVETAIL',
  Drawio = 'DRAWIO',
  Dropbox = 'DROPBOX',
  Excalidraw = 'EXCALIDRAW',
  Fetch = 'FETCH',
  Figma = 'FIGMA',
  FigmaDesktop = 'FIGMA_DESKTOP',
  Filesystem = 'FILESYSTEM',
  Firecrawl = 'FIRECRAWL',
  Fireflies = 'FIREFLIES',
  Freshservice = 'FRESHSERVICE',
  FullstoryLexicon = 'FULLSTORY_LEXICON',
  GenaiToolbox = 'GENAI_TOOLBOX',
  GenaiToolboxBigquery = 'GENAI_TOOLBOX_BIGQUERY',
  GenaiToolboxLooker = 'GENAI_TOOLBOX_LOOKER',
  GenaiToolboxOracledb = 'GENAI_TOOLBOX_ORACLEDB',
  GenaiToolboxPostgres = 'GENAI_TOOLBOX_POSTGRES',
  Github = 'GITHUB',
  GithubOauth = 'GITHUB_OAUTH',
  GithubStdio = 'GITHUB_STDIO',
  Gitlab = 'GITLAB',
  GitlabRemote = 'GITLAB_REMOTE',
  Glean = 'GLEAN',
  Gong = 'GONG',
  GongCommunity = 'GONG_COMMUNITY',
  GoogleCalendar = 'GOOGLE_CALENDAR',
  GoogleCalendarOfficial = 'GOOGLE_CALENDAR_OFFICIAL',
  GoogleChat = 'GOOGLE_CHAT',
  GoogleDocs = 'GOOGLE_DOCS',
  GoogleDrive = 'GOOGLE_DRIVE',
  GoogleDriveOfficial = 'GOOGLE_DRIVE_OFFICIAL',
  GoogleForms = 'GOOGLE_FORMS',
  GoogleGmail = 'GOOGLE_GMAIL',
  GoogleGmailOfficial = 'GOOGLE_GMAIL_OFFICIAL',
  GooglePeople = 'GOOGLE_PEOPLE',
  GoogleSheets = 'GOOGLE_SHEETS',
  GoogleSlides = 'GOOGLE_SLIDES',
  GoogleWorkspace = 'GOOGLE_WORKSPACE',
  Grafana = 'GRAFANA',
  Graphiti = 'GRAPHITI',
  Greenhouse = 'GREENHOUSE',
  Harness = 'HARNESS',
  Heroku = 'HEROKU',
  Honeycomb = 'HONEYCOMB',
  Hubspot = 'HUBSPOT',
  Incidentio = 'INCIDENTIO',
  Intercom = 'INTERCOM',
  Invideo = 'INVIDEO',
  Iterable = 'ITERABLE',
  Jenkins = 'JENKINS',
  Jfrog = 'JFROG',
  Kubernetes = 'KUBERNETES',
  Launchdarkly = 'LAUNCHDARKLY',
  LaunchdarklyOfficial = 'LAUNCHDARKLY_OFFICIAL',
  Linear = 'LINEAR',
  Linx = 'LINX',
  Lucid = 'LUCID',
  Mdapi = 'MDAPI',
  Microsoft365 = 'MICROSOFT365',
  MicrosoftGraphAndArm = 'MICROSOFT_GRAPH_AND_ARM',
  Miro = 'MIRO',
  MiroOfficial = 'MIRO_OFFICIAL',
  Mixpanel = 'MIXPANEL',
  MockServer = 'MOCK_SERVER',
  Mongodb = 'MONGODB',
  Motherduck = 'MOTHERDUCK',
  Neon = 'NEON',
  Netsuite = 'NETSUITE',
  NewRelic = 'NEW_RELIC',
  Notebooklm = 'NOTEBOOKLM',
  Notion = 'NOTION',
  OktaCommunity = 'OKTA_COMMUNITY',
  OktaNatoma = 'OKTA_NATOMA',
  Pagerduty = 'PAGERDUTY',
  Paypal = 'PAYPAL',
  PerplexityAsk = 'PERPLEXITY_ASK',
  Pinecone = 'PINECONE',
  Plaid = 'PLAID',
  Playwright = 'PLAYWRIGHT',
  PlaywrightLocal = 'PLAYWRIGHT_LOCAL',
  PowerBi = 'POWER_BI',
  Prisma = 'PRISMA',
  Prometheus = 'PROMETHEUS',
  Pubchem = 'PUBCHEM',
  Pubmed = 'PUBMED',
  Redis = 'REDIS',
  Resend = 'RESEND',
  Sailpoint = 'SAILPOINT',
  Salesforce = 'SALESFORCE',
  SalesforceRemote = 'SALESFORCE_REMOTE',
  Scalr = 'SCALR',
  SelectStar = 'SELECT_STAR',
  Semgrep = 'SEMGREP',
  Sentinelone = 'SENTINELONE',
  Sentry = 'SENTRY',
  Sequentialthinking = 'SEQUENTIALTHINKING',
  Servicenow = 'SERVICENOW',
  ServicenowRemote = 'SERVICENOW_REMOTE',
  SlackBeta = 'SLACK_BETA',
  SlackCommunity = 'SLACK_COMMUNITY',
  SlackRemote = 'SLACK_REMOTE',
  Smartbear = 'SMARTBEAR',
  Snowflake = 'SNOWFLAKE',
  Sonarqube = 'SONARQUBE',
  Sourcebot = 'SOURCEBOT',
  Spacelift = 'SPACELIFT',
  Spinach = 'SPINACH',
  Splunk = 'SPLUNK',
  Square = 'SQUARE',
  StarWars = 'STAR_WARS',
  Statsig = 'STATSIG',
  Stripe = 'STRIPE',
  Supabase = 'SUPABASE',
  Supernova = 'SUPERNOVA',
  Tableau = 'TABLEAU',
  Teradata = 'TERADATA',
  Time = 'TIME',
  Torii = 'TORII',
  Upwind = 'UPWIND',
  UsPto = 'US_PTO',
  Vega = 'VEGA',
  Webflow = 'WEBFLOW',
  Wiz = 'WIZ',
  Workato = 'WORKATO',
  Wrike = 'WRIKE',
  Zapier = 'ZAPIER',
  Zoom = 'ZOOM',
  Zoominfo = 'ZOOMINFO',
  ZoomRemote = 'ZOOM_REMOTE'
}

/** MCP server info for servers that are available as part of Natoma's MCP Server Catalog. */
export type McpServerInfo = {
  __typename?: 'MCPServerInfo';
  /** Optional annotations describing how to treat this catalog server */
  annotations?: Maybe<McpServerInfoAnnotations>;
  /** authConfig for an MCP server info, contains scopes */
  authConfig?: Maybe<McpServerInfoAuthConfig>;
  /** The authentication type for the MCP server */
  authenticationType?: Maybe<McpServerAuthenticationType>;
  /** A brief description of the MCP server */
  description?: Maybe<Scalars['String']['output']>;
  /** Configuration schema for the MCP server installations */
  installConfig?: Maybe<McpServerInfoConfigSchema>;
  /** Setup instructions for the MCP server. Used for loclal development and testing MCP servers that require manual setup steps that are not handled by automated installation scripts. */
  instructions?: Maybe<McpServerInfoInstructions>;
  /** The display name of the MCP server */
  name: Scalars['String']['output'];
  /** Configuration schema for the MCP server */
  serverConfig: McpServerInfoConfigSchema;
  /** The unique identifier for the MCP server */
  serverId: McpServerId;
  /** A unique identifier for the MCP server */
  slug: Scalars['String']['output'];
  /** The source information for the MCP server hosted by Natoma. */
  source: ServerInfoSource;
};

/** Optional annotations describing how to treat a catalog server */
export type McpServerInfoAnnotations = {
  __typename?: 'MCPServerInfoAnnotations';
  /** When true, customers provide a pre-registered OAuth client for this server */
  hintPreRegistered?: Maybe<Scalars['Boolean']['output']>;
};

/** authConfig for a single MCP server info */
export type McpServerInfoAuthConfig = {
  __typename?: 'MCPServerInfoAuthConfig';
  /** If set to true, then this server has a default client available */
  hasDefaultClient?: Maybe<Scalars['Boolean']['output']>;
  /** List of supported scopes that are optional */
  requiredScopes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  scopeDelimiter?: Maybe<Scalars['String']['output']>;
  /** List of supported scopes that are optional */
  supportedScopes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Configuration schema for the MCP server */
export type McpServerInfoConfigSchema = {
  __typename?: 'MCPServerInfoConfigSchema';
  /** Map of property names to their definitions */
  properties: Scalars['JSON']['output'];
  /** List of required property keys */
  required: Array<Scalars['String']['output']>;
};

/** Setup instructions for the MCP Server */
export type McpServerInfoInstructions = {
  __typename?: 'MCPServerInfoInstructions';
  /** Instructions for configuring the MCP server installation */
  installSetupInstructions?: Maybe<Scalars['String']['output']>;
  /** Instructions for configuring the MCP server */
  serverSetupInstructions?: Maybe<Scalars['String']['output']>;
};

/** An MCP server template that admins can enable for their orgs */
export type McpServerInstall = {
  __typename?: 'MCPServerInstall';
  _id: Scalars['ObjectID']['output'];
  accessConfig: McpServerInstallAccessConfig;
  /** All the credentials stored on the MCP server installation */
  authFields?: Maybe<Scalars['AuthFieldsObject']['output']>;
  /** All tools available from the MCP server (discovered during connection test) */
  availableTools: Array<McpServerTool>;
  /** Whether the current user has permission to use this connection */
  canConnect: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  healthStatus?: Maybe<HealthStatus>;
  /** Whether this MCP server install is connected by the current user or agent */
  installed: Scalars['Boolean']['output'];
  /** How many users have this install in their profile */
  installedForCount: Scalars['Int']['output'];
  /** The path to the MCP installation */
  mcpUrl: Scalars['String']['output'];
  /** The owner of this installation (user or agent) */
  ownedBy?: Maybe<OwnedBy>;
  /** The MCP server that this install is associated with */
  server: McpServer;
  status: McpServerInstallStatus;
  /** Number of tools installed on this MCP server */
  tools: Array<McpServerTool>;
  updatedAt: Scalars['DateTime']['output'];
};

/** An MCP server template that admins can enable for their orgs */
export type McpServerInstallInstalledArgs = {
  agentId?: InputMaybe<Scalars['ObjectID']['input']>;
};

/** An MCP server template that admins can enable for their orgs */
export type McpServerInstallMcpUrlArgs = {
  agentId?: InputMaybe<Scalars['ObjectID']['input']>;
};

/** An MCP server template that admins can enable for their orgs */
export type McpServerInstallToolsArgs = {
  agentId?: InputMaybe<Scalars['ObjectID']['input']>;
  profileId?: InputMaybe<Scalars['ObjectID']['input']>;
};

/** The access configuration for the MCP server installation */
export type McpServerInstallAccessConfig = {
  __typename?: 'MCPServerInstallAccessConfig';
  installType: McpServerInstallAccessInstallType;
};

/** The install type of the MCP Server installation */
export enum McpServerInstallAccessInstallType {
  Managed = 'MANAGED',
  Personal = 'PERSONAL'
}

/** The status of the MCP server installation */
export enum McpServerInstallStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

/** The origin type of the MCP server */
export enum McpServerOrigin {
  Byo = 'BYO',
  Natoma = 'NATOMA'
}

/** The source type of the MCP server */
export enum McpServerSourceType {
  ApiSpec = 'API_SPEC',
  DynamicRemoteUrl = 'DYNAMIC_REMOTE_URL',
  LocalPackage = 'LOCAL_PACKAGE',
  LocalUrl = 'LOCAL_URL',
  RemoteUrl = 'REMOTE_URL',
  Repository = 'REPOSITORY',
  Tunneled = 'TUNNELED'
}

/** The status of the MCP server */
export enum McpServerStatus {
  Active = 'ACTIVE',
  Deploying = 'DEPLOYING',
  Error = 'ERROR',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

/** An MCP server template that admins can enable for their orgs */
export type McpServerTemplate = {
  __typename?: 'MCPServerTemplate';
  _id: Scalars['ObjectID']['output'];
  authenticationType: McpServerAuthenticationType;
  /** Configuration schema for the server template */
  configSchema: ConfigSchema;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  instructions?: Maybe<McpServerTemplateInstructions>;
  mcpServerUrl: Scalars['String']['output'];
  metadata?: Maybe<McpServerTemplateMetadata>;
  name: Scalars['String']['output'];
  repoUrl: Scalars['String']['output'];
  serverId?: Maybe<McpServerId>;
  slug?: Maybe<Scalars['String']['output']>;
  /** MCP Server Source configuration */
  source: ServerSource;
  status: McpServerTemplateStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** Setup instructions for the MCP Server */
export type McpServerTemplateInstructions = {
  __typename?: 'MCPServerTemplateInstructions';
  installSetupInstructions?: Maybe<Scalars['String']['output']>;
  serverSetupInstructions?: Maybe<Scalars['String']['output']>;
};

/** Metadata about the MCP server template */
export type McpServerTemplateMetadata = {
  __typename?: 'MCPServerTemplateMetadata';
  type?: Maybe<McpServerTemplateType>;
  version?: Maybe<Scalars['String']['output']>;
};

/** The status of the MCP server template */
export enum McpServerTemplateStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** The type of the MCP server template */
export enum McpServerTemplateType {
  Community = 'COMMUNITY',
  Natoma = 'NATOMA',
  Official = 'OFFICIAL'
}

/** A single MCP server install object, used by server to list all managed connections to server */
export type McpServerToInstallObject = {
  __typename?: 'MCPServerToInstallObject';
  /** List of tools available on this MCP server */
  availableTools: Array<McpServerTool>;
  canEdit: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
};

/** Native structure for a tool that can be configured for an MCP server */
export type McpServerTool = {
  __typename?: 'MCPServerTool';
  /** A description of the tool */
  description?: Maybe<Scalars['String']['output']>;
  /** The input schema for the tool, defining its configuration options */
  inputSchema?: Maybe<Scalars['JSON']['output']>;
  /** The name of the tool */
  name: Scalars['String']['output'];
};

/** The transport supported by the MCP server */
export enum McpServerTransport {
  Sse = 'SSE',
  Stdio = 'STDIO',
  StreamableHttp = 'STREAMABLE_HTTP'
}

/** Configuration for a tool available on the MCP server */
export type McpToolConfig = {
  __typename?: 'MCPToolConfig';
  /** The name of the tool */
  name: Scalars['String']['output'];
  /** Whether the client needs to request verification to use this tool */
  requireVerification: Scalars['Boolean']['output'];
};

export type MeResponse = {
  __typename?: 'MeResponse';
  /** The current logged in org. */
  currentOrg?: Maybe<Org>;
  /** The logged-in current user. */
  currentUser?: Maybe<User>;
  /** The login info for the current user. */
  loginInfo?: Maybe<LoginInfo>;
};

export type Mutation = {
  __typename?: 'Mutation';
  changeUserRole: User;
  /** Copy any profile (typically MANAGED) to create a customizable PERSONAL profile */
  copyMCPProfileToPersonal: McpProfile;
  /** Create a new agent that can access managed connections */
  createAgent?: Maybe<Agent>;
  /** Creates a new core client */
  createCoreDeployment: CoreDeploymentResponse;
  /** Creates a new credential of the specified type. Can create for current user or specified agent. */
  createCredential: CredentialCreatedResponse;
  /** Create DesktopAppReleases for each platform by version and channel. The document is updated if it already exists. */
  createDesktopAppReleases: Array<DesktopAppRelease>;
  createIngestJob: Job;
  createJobChain: Array<Job>;
  /** Create a new PERSONAL profile with custom tool configurations (max 5 per user) */
  createMCPProfile: McpProfile;
  createMCPProfileTemplate: McpProfileTemplate;
  /** Creates an install on an on-prem server with OAuth */
  createOAuthMcpServerInstall: McpServerInstall;
  /** Creates a new MCP access policy or updates an existing one if it exists */
  createOrUpdateAccessPolicy: McpAccessPolicy;
  /** Mutation that upserts an MCPServerInstall and optionally creates its associated MCPServer */
  createOrUpdateServerInstall: McpServerInstall;
  createService: Service;
  createServiceFromIntegration: Service;
  createShadowMCPServers: Array<ShadowMcpServer>;
  /** Creates a new tunnel */
  createTunnel: CreateTunnelResponse;
  /** Deletes a single MCP access policy by ID */
  deleteAccessPolicy?: Maybe<McpAccessPolicy>;
  /** Hard delete an agent by setting isTombstoned to true */
  deleteAgent?: Maybe<Agent>;
  /** Delete a PERSONAL profile (soft delete via tombstone). MANAGED profiles cannot be deleted. */
  deleteMCPProfile: Scalars['Boolean']['output'];
  deleteMCPProfileTemplate: Scalars['Boolean']['output'];
  /** Removes a single MCP server install */
  deleteMCPServerInstall: McpServerInstall;
  deleteOrg?: Maybe<DeleteResult>;
  deleteOrgNhiData?: Maybe<DeleteNhiDataResult>;
  /** Deletes a single rate limit by ID */
  deleteRateLimit?: Maybe<RateLimit>;
  deleteServiceIntegration?: Maybe<DeleteResult>;
  /** Deletes an existing tunnel */
  deleteTunnel: Tunnel;
  deleteUser: User;
  /** Edit a single MCP server */
  editMcpServer: McpServer;
  /** Enable an MCP server for an org */
  enableMcpServer: McpServer;
  /** Sets the flag to request a scan for a BYO MCP server. For on-prem, the scan includes fresh list of available tools. */
  flagScanForServer: McpServer;
  inviteUser: User;
  markUserConfigSeen: User;
  obliterateOrg?: Maybe<ObliterateOrgResult>;
  /** Promote an ACTIVE release from sourceChannel to the next targetChannel for a platform and version. Enforces adjacency (alpha→beta, beta→stable). */
  promoteDesktopAppRelease: DesktopAppRelease;
  /** Record a rate usage */
  recordUsage?: Maybe<RateUsage>;
  register: MeResponse;
  /** Removes a single MCP server and all its installs */
  removeMCPServer: McpServer;
  /** Remove the selected MCP profile for the current user */
  removeSelectedMCPProfileForUser: Scalars['Boolean']['output'];
  requestMCPServerTemplate?: Maybe<Notification>;
  /** Sends the scan results of a remote MCP server from the on-prem agent. */
  sendRemoteServerScanResults?: Maybe<McpServer>;
  /** Set the selected MCP profile for the current user */
  setSelectedMCPProfileForUser: Scalars['Boolean']['output'];
  /** Modifies the status of the provided tunnel */
  setTunnelStatus: Tunnel;
  /** Updates a single MCP access policy */
  updateAccessPolicy: McpAccessPolicy;
  /** Update an agent's display name and/or owner */
  updateAgent?: Maybe<Agent>;
  /** Sets the status of a credential to a new value */
  updateCredentialStatus: Credential;
  /** Updates deployment fields to provided new value */
  updateDeployment: Deployment;
  /** Update DesktopAppReleases, based on given ids or filter. Doesn't create any new documents */
  updateDesktopAppReleases: Array<DesktopAppRelease>;
  /** Update name or tool configurations of a PERSONAL profile (MANAGED profiles are read-only) */
  updateMCPProfile: McpProfile;
  updateMCPProfileTemplate: McpProfileTemplate;
  /** Update a single MCP server by adding or removing an actor (user/agent) from the installation */
  updateMCPServerInstall: McpServerInstall;
  /** Updates the available tools on an MCP server install (and the corresonding server) after a tools/list response. Used by the desktop app when it services a tools/list request. */
  updateMcpServerInstallTools?: Maybe<McpServerInstall>;
  /** Updates an install on an on-prem server with OAuth for creds */
  updateOAuthMcpServerInstall: McpServerInstall;
  updateOrg: Org;
  updateOrgBillingFeatures: Org;
  /** Adds or removes products to an organization. */
  updateOrgBillingProducts: Org;
  updateOrgFeatureSwitch: Org;
  updateOrgNotificationsSettings: Org;
  updateOrgSamlConfig: OrgSamlConfig;
  updateOrgScimConfig: OrgScimConfig;
  updateOrgSettings: Org;
  updateService: Service;
  /** Update shadow MCP servers matching the filter criteria. Returns the number of servers updated. */
  updateShadowMCPServers: Scalars['Int']['output'];
  /** Upsert a rate limit document */
  upsertRateLimit?: Maybe<RateLimit>;
};

export type MutationChangeUserRoleArgs = {
  input: ChangeUserRoleInput;
};

export type MutationCopyMcpProfileToPersonalArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['ObjectID']['input'];
  setSelectedProfile?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateAgentArgs = {
  input: CreateAgentInput;
};

export type MutationCreateCoreDeploymentArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['String']['input'];
};

export type MutationCreateCredentialArgs = {
  input: CreateCredentialInput;
};

export type MutationCreateDesktopAppReleasesArgs = {
  input: CreateDesktopAppReleasesInputObject;
};

export type MutationCreateIngestJobArgs = {
  input: CreateIngestJobInput;
};

export type MutationCreateJobChainArgs = {
  input: CreateJobChainInput;
};

export type MutationCreateMcpProfileArgs = {
  installationConfigs: Array<InstallationConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  setSelectedProfile?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreateMcpProfileTemplateArgs = {
  displayName: Scalars['String']['input'];
  installationConfigs: Array<TemplateInstallationConfigInput>;
};

export type MutationCreateOAuthMcpServerInstallArgs = {
  input: CreateOAuthMcpServerInstallInput;
};

export type MutationCreateOrUpdateAccessPolicyArgs = {
  input: CreateOrUpdateAccessPolicyInput;
};

export type MutationCreateOrUpdateServerInstallArgs = {
  actorType?: InputMaybe<InstalledForActorType>;
  authCredentials?: InputMaybe<Scalars['ServerInstallationCredsMap']['input']>;
  displayName: Scalars['String']['input'];
  installType: McpServerInstallAccessInstallType;
  mcpServerId?: InputMaybe<Scalars['ObjectID']['input']>;
  mcpServerInstallId?: InputMaybe<Scalars['ObjectID']['input']>;
  ownerId?: InputMaybe<Scalars['ObjectID']['input']>;
  serverId?: InputMaybe<McpServerId>;
  shouldEnable?: InputMaybe<Scalars['Boolean']['input']>;
  templateId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type MutationCreateServiceArgs = {
  input: ServiceCreateBody;
};

export type MutationCreateServiceFromIntegrationArgs = {
  input: CreateIntegrationInput;
};

export type MutationCreateShadowMcpServersArgs = {
  input: CreateShadowMcpServersInput;
};

export type MutationCreateTunnelArgs = {
  displayName: Scalars['String']['input'];
};

export type MutationDeleteAccessPolicyArgs = {
  input: DeleteAccessPolicyInput;
};

export type MutationDeleteAgentArgs = {
  id: Scalars['ObjectID']['input'];
};

export type MutationDeleteMcpProfileArgs = {
  profileId: Scalars['ObjectID']['input'];
};

export type MutationDeleteMcpProfileTemplateArgs = {
  templateId: Scalars['ObjectID']['input'];
};

export type MutationDeleteMcpServerInstallArgs = {
  input: GetByIdMcpServerInstallInput;
};

export type MutationDeleteOrgNhiDataArgs = {
  orgId: Scalars['ObjectID']['input'];
  phase: DeleteNhiDataPhase;
};

export type MutationDeleteRateLimitArgs = {
  _id: Scalars['ObjectID']['input'];
};

export type MutationDeleteServiceIntegrationArgs = {
  _id?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type MutationDeleteTunnelArgs = {
  tunnelId: Scalars['ObjectID']['input'];
};

export type MutationDeleteUserArgs = {
  _id?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type MutationEditMcpServerArgs = {
  input: EditMcpServerInput;
};

export type MutationEnableMcpServerArgs = {
  input: EnableMcpServerInput;
};

export type MutationFlagScanForServerArgs = {
  input: GetByIdMcpServerInput;
};

export type MutationInviteUserArgs = {
  input: InviteUserInput;
};

export type MutationObliterateOrgArgs = {
  orgId: Scalars['ObjectID']['input'];
};

export type MutationPromoteDesktopAppReleaseArgs = {
  input: PromoteDesktopAppReleaseInput;
};

export type MutationRecordUsageArgs = {
  input: RecordRateUsageInput;
};

export type MutationRegisterArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  orgDisplayName?: InputMaybe<Scalars['String']['input']>;
  registrationCode?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRemoveMcpServerArgs = {
  input: GetByIdMcpServerInput;
};

export type MutationRequestMcpServerTemplateArgs = {
  additionalContext?: InputMaybe<Scalars['String']['input']>;
  appName: Scalars['String']['input'];
};

export type MutationSendRemoteServerScanResultsArgs = {
  input: SendRemoteServerScanResultsInput;
};

export type MutationSetSelectedMcpProfileForUserArgs = {
  profileId: Scalars['ObjectID']['input'];
};

export type MutationSetTunnelStatusArgs = {
  status: TunnelStatus;
  tunnelId: Scalars['ObjectID']['input'];
};

export type MutationUpdateAccessPolicyArgs = {
  input: UpdateAccessPolicyInput;
};

export type MutationUpdateAgentArgs = {
  input: UpdateAgentInput;
};

export type MutationUpdateCredentialStatusArgs = {
  input: UpdateCredentialStatusInput;
};

export type MutationUpdateDeploymentArgs = {
  input: UpdateDeploymentInput;
};

export type MutationUpdateDesktopAppReleasesArgs = {
  input: UpdateDesktopAppReleasesInput;
};

export type MutationUpdateMcpProfileArgs = {
  installationConfigs?: InputMaybe<Array<InstallationConfigInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['ObjectID']['input'];
};

export type MutationUpdateMcpProfileTemplateArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  installationConfigs?: InputMaybe<Array<TemplateInstallationConfigInput>>;
  templateId: Scalars['ObjectID']['input'];
};

export type MutationUpdateMcpServerInstallArgs = {
  input: UpdateMcpServerInstallInput;
};

export type MutationUpdateMcpServerInstallToolsArgs = {
  input: UpdateMcpServerInstallToolsInput;
};

export type MutationUpdateOAuthMcpServerInstallArgs = {
  input: UpdateOAuthMcpServerInstallInput;
};

export type MutationUpdateOrgArgs = {
  input: OrgUpdateBody;
};

export type MutationUpdateOrgBillingFeaturesArgs = {
  input: OrgBillingFeatureBody;
};

export type MutationUpdateOrgBillingProductsArgs = {
  input: OrgBillingProductBody;
};

export type MutationUpdateOrgFeatureSwitchArgs = {
  input: OrgFeatureSwitchBody;
};

export type MutationUpdateOrgNotificationsSettingsArgs = {
  input?: InputMaybe<OrgNotificationsSettingsBody>;
};

export type MutationUpdateOrgSamlConfigArgs = {
  input: OrgUpdateSamlConfigInput;
};

export type MutationUpdateOrgScimConfigArgs = {
  input: OrgUpdateScimConfigInput;
};

export type MutationUpdateOrgSettingsArgs = {
  input: OrgSettingsInput;
};

export type MutationUpdateServiceArgs = {
  input: ServiceUpdateBody;
};

export type MutationUpdateShadowMcpServersArgs = {
  input: UpdateShadowMcpServersInput;
};

export type MutationUpsertRateLimitArgs = {
  input: UpsertRateLimitInput;
};

/** Dynamic remote URL source for MCP server info provided by Natoma */
export type NatomaDynamicRemoteUrlSource = {
  __typename?: 'NatomaDynamicRemoteUrlSource';
  /** The URL of the MCP server */
  mcpServerUrl: Scalars['String']['output'];
  /** The type of source for the MCP server info. In this case, it will always be DYNAMIC_REMOTE_URL */
  sourceType: McpServerSourceType;
  /** The transport method used for the MCP server */
  transport?: Maybe<McpServerTransport>;
};

/** Local package source for MCP server info provided by Natoma (only used for local development and testing) */
export type NatomaLocalPackageSource = {
  __typename?: 'NatomaLocalPackageSource';
  /** The command function for the MCP server info */
  commandFunction: Scalars['String']['output'];
  /** The type of source for the MCP server info. In this case, it will always be LOCAL_PACKAGE */
  sourceType: McpServerSourceType;
  /** The transport method for the MCP server info. Will always be STDIO for local package sources */
  transport: McpServerTransport;
};

/** Local URL source for MCP server info provided by Natoma (only used for local development and testing) */
export type NatomaLocalUrlSource = {
  __typename?: 'NatomaLocalUrlSource';
  /** The type of source for the MCP server info. In this case, it will always be LOCAL_URL */
  sourceType: McpServerSourceType;
  /** The transport method for the MCP server info */
  transport: McpServerTransport;
  /** The URL for the MCP server info */
  url?: Maybe<Scalars['String']['output']>;
};

/** Remote URL source for MCP server info provided by Natoma */
export type NatomaRemoteUrlSource = {
  __typename?: 'NatomaRemoteUrlSource';
  /** The URL of the MCP server */
  mcpServerUrl: Scalars['String']['output'];
  /** The type of source for the MCP server info. In this case, it will always be REMOTE_URL */
  sourceType: McpServerSourceType;
  /** The transport method used for the MCP server */
  transport?: Maybe<McpServerTransport>;
};

/** Repository source for MCP server info provided by Natoma */
export type NatomaRepositorySource = {
  __typename?: 'NatomaRepositorySource';
  /** The name of the branch in the repository */
  branchName?: Maybe<Scalars['String']['output']>;
  /** The SHA of the commit in the repository */
  commitSha?: Maybe<Scalars['String']['output']>;
  envVars?: Maybe<Scalars['EnvVarsMap']['output']>;
  /** The name of the package in the repository */
  packageName: Scalars['String']['output'];
  /** The package type of the repository. (e.g. npm, pip, docker, etc.) */
  packageType: RepositoryPackageType;
  /** The URL of the repository containing the MCP server source code */
  repositoryUrl: Scalars['String']['output'];
  /** The type of source for the MCP server info. In this case, it will always be REPOSITORY */
  sourceType: McpServerSourceType;
  /** The type of repository. (OFFICIAL | COMMUNITY) */
  type: McpServerTemplateType;
  /** The working directory within the repository. This cannot have ../ in the path for security reasons. */
  workingDirectory?: Maybe<Scalars['String']['output']>;
};

/** New Relic OTLP (SIEM export) integration details */
export type NewRelicOtlpIntegration = Integration & {
  __typename?: 'NewRelicOtlpIntegration';
  activeAuthType: IntegrationAuthTypes;
  authFields: Scalars['JSON']['output'];
  authorizedScopes: Array<Scalars['String']['output']>;
  currentScopes?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  integrationId: IntegrationId;
  status: IntegrationStatus;
  uniqueId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  /** The ID of the notification. */
  _id?: Maybe<Scalars['ObjectID']['output']>;
  /** The status of the notification. */
  status?: Maybe<NotificationStatus>;
};

export enum NotificationStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

/** Client information from registration */
export type OAuthClientInformationInput = {
  clientId: Scalars['String']['input'];
  clientIdIssuedAt?: InputMaybe<Scalars['Float']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  clientSecretExpiresAt?: InputMaybe<Scalars['Float']['input']>;
};

/** Optional OAuth client credentials for an MCP server */
export type OAuthCredentialsInput = {
  /** OAuth client ID */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** OAuth client secret */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /** Space-separated OAuth scopes */
  scopes?: InputMaybe<Scalars['String']['input']>;
  /** If true, then use first-party client */
  useDefaultClient?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Tokens from oauth flow */
export type OAuthTokensInput = {
  accessToken: Scalars['String']['input'];
  expiresIn?: InputMaybe<Scalars['Float']['input']>;
  idToken?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  tokenType: Scalars['String']['input'];
};

export type ObliterateOrgResult = {
  __typename?: 'ObliterateOrgResult';
  orgId: Scalars['ObjectID']['output'];
  pubsubMessageId: Scalars['String']['output'];
};

/** Observe OTLP (SIEM export) integration details */
export type ObserveOtlpIntegration = Integration & {
  __typename?: 'ObserveOtlpIntegration';
  activeAuthType: IntegrationAuthTypes;
  authFields: Scalars['JSON']['output'];
  authorizedScopes: Array<Scalars['String']['output']>;
  currentScopes?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  integrationId: IntegrationId;
  status: IntegrationStatus;
  uniqueId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** A single server metadata object */
export type OnPremServerMetadata = {
  __typename?: 'OnPremServerMetadata';
  /** Client ID for the server if configured with auth server */
  clientId?: Maybe<Scalars['String']['output']>;
  /** Client secret for the server if configured with auth server */
  clientSecret?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  installations: Array<Maybe<Scalars['String']['output']>>;
  mcpServerInstalls: Array<McpServerInstall>;
  mcpServerUrl: Scalars['String']['output'];
  useCustomAuthServer: Scalars['Boolean']['output'];
};

/** List of servers and their pertinent metadata */
export type OnPremServerMetadataPoll = {
  __typename?: 'OnPremServerMetadataPoll';
  servers: Array<OnPremServerMetadata>;
};

/** An object to metadata about an Organization’s onboarding process. */
export type Onboarding = {
  __typename?: 'Onboarding';
  connectedIDP: Scalars['Boolean']['output'];
};

/** OpenTelemetry (SIEM export) integration details */
export type OpenTelemetryIntegration = Integration & {
  __typename?: 'OpenTelemetryIntegration';
  activeAuthType: IntegrationAuthTypes;
  authFields: Scalars['JSON']['output'];
  authorizedScopes: Array<Scalars['String']['output']>;
  currentScopes?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  integrationId: IntegrationId;
  status: IntegrationStatus;
  uniqueId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** A singular tenant in Natoma. */
export type Org = {
  __typename?: 'Org';
  _id: Scalars['ObjectID']['output'];
  authServer?: Maybe<OrgAuthServer>;
  desktopAppChannel: DesktopAppChannel;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Billing features for the org */
  enabledFeatures?: Maybe<Array<BillingFeatureId>>;
  /** MCP clients available to the org based on its billing products */
  enabledMcpClients?: Maybe<Array<McpClientType>>;
  /** Feature switch overrides for the org */
  featureSwitchOverrides: Scalars['FeatureSwitchOverride']['output'];
  /** Fully resolved feature switch values (org override merged with server defaults) */
  featureSwitches: Scalars['FeatureSwitches']['output'];
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  notifications?: Maybe<OrgNotifications>;
  /** Onboarding progress for an Organization. */
  onboarding?: Maybe<Onboarding>;
  samlConfig?: Maybe<OrgSamlConfig>;
  settings?: Maybe<OrgSettings>;
  slug: Scalars['String']['output'];
  status: OrgStatus;
  /** When the Org was tombstoned */
  tombstonedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Details for connecting to a custom auth server for the org. */
export type OrgAuthServer = {
  __typename?: 'OrgAuthServer';
  /** Accepted audience values — token validation succeeds if the aud claim matches any entry */
  audiences?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the custom auth server is enabled for the org */
  enabled: Scalars['Boolean']['output'];
  /** The OAuth Auth Server URL */
  url?: Maybe<Scalars['String']['output']>;
};

export type OrgAuthServerBody = {
  audiences?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled: Scalars['Boolean']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

/** The action to perform on the feature switch */
export enum OrgBillingFeatureAction {
  Add = 'add',
  Remove = 'remove'
}

export type OrgBillingFeatureBody = {
  operations: Array<OrgBillingFeatureOperation>;
};

export type OrgBillingFeatureOperation = {
  action: OrgBillingFeatureAction;
  billingFeature: BillingFeatureId;
};

/** The action to perform on the billing product */
export enum OrgBillingProductAction {
  Add = 'add',
  Remove = 'remove'
}

export type OrgBillingProductBody = {
  operations: Array<OrgBillingProductOperation>;
};

export type OrgBillingProductOperation = {
  action: OrgBillingProductAction;
  billingProduct: BillingProductId;
};

export type OrgFeatureSwitchBody = {
  featureSwitchOverrides: Scalars['FeatureSwitchOverride']['input'];
};

/** Object containing notification settings for an org */
export type OrgNotifications = {
  __typename?: 'OrgNotifications';
  sender: Scalars['String']['output'];
  smtpHost: Scalars['String']['output'];
  smtpPort: SmtpPort;
};

export type OrgNotificationsSettingsBody = {
  password?: InputMaybe<Scalars['String']['input']>;
  sender: Scalars['String']['input'];
  smtpHost: Scalars['String']['input'];
  smtpPort?: SmtpPort;
};

/** The SAML authorize url for an org */
export type OrgSamlAuthorizeUrl = {
  __typename?: 'OrgSamlAuthorizeUrl';
  authorizeUrl?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** The SAML authorize url for an org */
export type OrgSamlAuthorizeUrlInput = {
  idpSigningCertificate?: InputMaybe<Scalars['String']['input']>;
  metadataUrl?: InputMaybe<Scalars['String']['input']>;
  ssoUrl?: InputMaybe<Scalars['String']['input']>;
  wantAssertionsSigned?: InputMaybe<Scalars['Boolean']['input']>;
  wantAuthnResponseSigned?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The SAML config for an org */
export type OrgSamlConfig = {
  __typename?: 'OrgSamlConfig';
  /** Whether SAML is enabled for the org */
  enabled: Scalars['Boolean']['output'];
  /** The IdP metadata for the org */
  idpMetadata?: Maybe<OrgSamlConfigIdpMetadata>;
  /** The SP metadata for the org */
  spMetadata?: Maybe<OrgSamlConfigSpMetadata>;
};

/** The IdP metadata fields for SAML configuration */
export type OrgSamlConfigIdpMetadata = {
  __typename?: 'OrgSamlConfigIdpMetadata';
  /** The unique identifier of the IdP */
  entityId?: Maybe<Scalars['String']['output']>;
  /** Signing certificate issued by the IdP; used to sign SAML assertions and responses from the IdP */
  idpSigningCertificate?: Maybe<Scalars['String']['output']>;
  /** The IdP metadata URL for the org. If this is provided, the other fields will be ignored. */
  metadataUrl?: Maybe<Scalars['String']['output']>;
  /** The SSO entry point URL for the org */
  ssoUrl?: Maybe<Scalars['String']['output']>;
};

/** The IdP metadata for the org to be updated */
export type OrgSamlConfigIdpMetadataInput = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  idpSigningCertificate?: InputMaybe<Scalars['String']['input']>;
  metadataUrl?: InputMaybe<Scalars['String']['input']>;
  ssoUrl?: InputMaybe<Scalars['String']['input']>;
};

/** The SP metadata fields for SAML configuration */
export type OrgSamlConfigSpMetadata = {
  __typename?: 'OrgSamlConfigSpMetadata';
  /** The ACS URL of the SP */
  acsUrl: Scalars['String']['output'];
  /** The unique identifier of the SP */
  entityId: Scalars['String']['output'];
  /** Whether the SP wants the assertions to be signed */
  wantAssertionsSigned: Scalars['Boolean']['output'];
  /** Whether the SP wants the authn response to be signed */
  wantAuthnResponseSigned: Scalars['Boolean']['output'];
};

/** The SP metadata for the org to be updated */
export type OrgSamlConfigSpMetadataInput = {
  wantAssertionsSigned?: InputMaybe<Scalars['Boolean']['input']>;
  wantAuthnResponseSigned?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The SCIM config for an org */
export type OrgScimConfig = {
  __typename?: 'OrgScimConfig';
  /** The base URL for the SCIM config */
  baseURL: Scalars['String']['output'];
  /** Whether SCIM is enabled for the org */
  enabled: Scalars['Boolean']['output'];
  /** The SCIM provisioning token for the org */
  scimProvisioningToken?: Maybe<ScimProvisioningToken>;
};

/** The SCIM config for an org */
export type OrgScimConfigScimProvisioningTokenArgs = {
  includeUnencryptedSecret?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Object containing settings for an org */
export type OrgSettings = {
  __typename?: 'OrgSettings';
  /** Whether the universal allow-all policy is disabled for the org (deny-by-default) */
  disableAllowAllPolicy: Scalars['Boolean']['output'];
  /** Whether API key usage is disabled for the org */
  disableApiKeyUsage: Scalars['Boolean']['output'];
  /** If set to true, then allow x-slug-* headers to be accepted as passthrough within on-prem agents */
  enableAgentHeaderWhitelist?: Maybe<Scalars['Boolean']['output']>;
  /** If true, tool call inputs will not be stored in audit logs for on-prem agent MCP tool calls */
  hideToolArgumentsAgent?: Maybe<Scalars['Boolean']['output']>;
  /** If true, tool call inputs will not be stored in audit logs for cloud (hosted) MCP tool calls */
  hideToolArgumentsCloud?: Maybe<Scalars['Boolean']['output']>;
  /** If true, tool call inputs will not be stored in audit logs for desktop MCP tool calls */
  hideToolArgumentsDesktop?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for updating org settings */
export type OrgSettingsInput = {
  disableAllowAllPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  disableApiKeyUsage?: InputMaybe<Scalars['Boolean']['input']>;
  hideToolArgumentsAgent?: InputMaybe<Scalars['Boolean']['input']>;
  hideToolArgumentsCloud?: InputMaybe<Scalars['Boolean']['input']>;
  hideToolArgumentsDesktop?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The status of an organization */
export enum OrgStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

/** Input body for updating an Identity object. */
export type OrgUpdateBody = {
  authServer?: InputMaybe<OrgAuthServerBody>;
  desktopAppChannel?: InputMaybe<DesktopAppChannel>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrgStatus>;
};

/** The SAML config for an org to be updated */
export type OrgUpdateSamlConfigInput = {
  /** Whether SAML is enabled for the org */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The IdP metadata for the org */
  idpMetadata?: InputMaybe<OrgSamlConfigIdpMetadataInput>;
  /** The SP metadata for the org */
  spMetadata?: InputMaybe<OrgSamlConfigSpMetadataInput>;
};

/** The SCIM config for an org to be updated */
export type OrgUpdateScimConfigInput = {
  /** Whether SCIM is enabled for the org */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to generate a new SCIM provisioning token */
  generateNewScimProvisioningToken?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OwnedBy = {
  __typename?: 'OwnedBy';
  ref?: Maybe<OwnerActor>;
  type: InstalledForActorType;
};

/** User or Agent reference (e.g. install owner) */
export type OwnerActor = Agent | User;

/** Status of personal connection availability for MCP servers and templates */
export enum PersonalConnectionStatus {
  All = 'ALL',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

/** The type of action this policy controls */
export enum PolicyActionType {
  Invoke = 'INVOKE',
  ValidateContent = 'VALIDATE_CONTENT'
}

/** The effect of the policy: permit or forbid */
export enum PolicyEffectType {
  Forbid = 'FORBID',
  Permit = 'PERMIT'
}

/** An entity used in policy evaluations */
export type PolicyEntity = {
  __typename?: 'PolicyEntity';
  attrs: Scalars['JSON']['output'];
  parents?: Maybe<Array<Maybe<CedarEntityUid>>>;
  uid: CedarEntityUid;
};

/** Policy object consisting of ObjectId and policy string */
export type PolicyInfo = {
  __typename?: 'PolicyInfo';
  id: Scalars['String']['output'];
  policy: Scalars['String']['output'];
};

/** Configuration for a single MCP server installation in a user profile */
export type ProfileInstallationConfig = {
  __typename?: 'ProfileInstallationConfig';
  /** Whether or not all tools are enabled for this server in this profile */
  allToolsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** List of enabled tool names (without server prefix) */
  enabledTools: Array<Scalars['String']['output']>;
  /** Whether this is a managed or personal installation */
  installType: McpServerInstallAccessInstallType;
  /** Optional reference to a specific installation (null if not connected yet) */
  installation?: Maybe<McpServerInstall>;
  /** The MCP server for this installation */
  server: McpServer;
};

export type PromoteDesktopAppReleaseInput = {
  platform: DesktopPlatform;
  sourceChannel: DesktopAppChannel;
  targetChannel: DesktopAppChannel;
  version: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  accessControls: Array<AccessControlInterface>;
  accessPolicies: Array<McpAccessPolicy>;
  accessPolicy: McpAccessPolicy;
  accessPolicyPrincipals: AccessPolicyPrincipalsResponse;
  /** Fetches all the information we want to display to admins in our app catalog. Admins will be able to see all natoma hosted servers and all active byo servers in their org. */
  adminAppCatalog: Array<AppInfo>;
  /** Get a single agent by ID */
  agent?: Maybe<Agent>;
  /** Get an agent's MCP Server Installs */
  agentMcpServerInstalls: Array<McpServerInstall>;
  /** Get all agents for an organization with optional search and pagination */
  agents: Array<Agent>;
  /** Get aggregated audit logs grouped by specified field with total count */
  aggregatedAuditLogs: AuditLogAggregatedResponse;
  allOrgs: Array<Org>;
  /** Get count of audit logs grouped by specified field */
  auditLogCounts: Array<Scalars['JSON']['output']>;
  /** Get total count of audit logs matching the criteria */
  auditLogTotalCount: Scalars['Int']['output'];
  /** Get a paginated list of audit logs with optional aggregation */
  auditLogs: Array<AuditLog>;
  /** A list of all available billing products and features */
  billingItems: BillingItems;
  corePolicyData: CorePolicyData;
  /** Get a list of credentials by type within for a specific user in an org. */
  credentials: Array<Credential>;
  /** Query a single Deployment */
  deployment: Deployment;
  /** Query for list of Deployments */
  deployments: Array<Deployment>;
  /** Get releases grouped by version; optionally filter by versions, platform and status */
  desktopAppReleasesGroupedByVersion: Array<DesktopAppReleasesGroupedByVersion>;
  /** Get distinct users/devices that have a specific AI client installed across all integrations */
  discoveredAIClientUsers: DiscoveredAiClientUsersResult;
  /** Discovered AI clients grouped by configFileType — one row per client type across all integrations. Each row includes integrationIds of all EDR/MDM services that detected this client type, plus isDetectedByDesktopApp if Natoma Desktop also detected it. */
  discoveredAIClientsGroupedByType: Array<DiscoveredAiClient>;
  /** Discovered AI clients ranked by unique device installations count - returns complete distribution, since limited Client types */
  discoveredClientsByDevices: Array<DiscoveredClientByDevices>;
  /** Top MCP servers in an org ranked by the number of installations */
  discoveredMCPServersByInstallations: Array<DiscoveredMcpServerByInstallations>;
  /** Top users ranked by the number of distinct MCP servers detected on their devices. Defaults to top 5. */
  discoveredUsersByServers: Array<DiscoveredUserByServers>;
  doesByoServerExist: Scalars['Boolean']['output'];
  enabledApps: Array<McpServer>;
  /** Fetches the number of installations per MCP server, categorized personal, managed, and shadow connections */
  getDashboardInstallationsByMCPServer: Array<DashboardInstallationsByMcpServer>;
  /** Top 10 MCP servers by tool calls made in the last 30 days */
  getDashboardMCPServersByToolCalls: Array<DashboardMcpServersByToolCalls>;
  /** Number of MCP tool calls per week (success vs failure breakdown) */
  getDashboardToolCallsOverTime: Array<DashboardToolCallsOverTime>;
  /** Top 10 users by tool calls made in the last 30 days */
  getDashboardUsersByToolCalls: Array<DashboardUsersByToolCalls>;
  getIngestJob: Job;
  /** Fetches the number of integrated applications by their integrationId */
  getIntegrationCounts: Array<IntegrationCount>;
  /** Fetch a short-lived access token for uploading batched audit log data for processing */
  getStorageBucketServiceAccountCredential: GetStorageBucketServiceAccountCredentialResponse;
  getUsers?: Maybe<GetUsersResponse>;
  group: Group;
  groups: Array<Group>;
  /** Get a list of ingestion jobs within the current org. */
  ingestjobs: Array<Job>;
  /** Fetches the configuration fields required to configure an installation, based on the server info or template slug */
  installationConfigProperties: InstallationConfigProperties;
  /** Get latest ACTIVE release for a platform+channel (admin-only) */
  latestDesktopAppRelease?: Maybe<DesktopAppRelease>;
  /** Get the latest job chain for a given service within the current org */
  latestJobChain?: Maybe<JobChain>;
  mcpProfile?: Maybe<McpProfile>;
  mcpProfileTemplate?: Maybe<McpProfileTemplate>;
  mcpProfiles: Array<McpProfile>;
  mcpServer?: Maybe<McpServer>;
  /** Fetch all server info (metadata) for Natoma registry MCP servers. */
  mcpServerInfos: Array<McpServerInfo>;
  /** Get a single MCP Server Install */
  mcpServerInstall?: Maybe<McpServerInstall>;
  /** Get all MCP server installs */
  mcpServerInstalls: Array<McpServerInstall>;
  /** Get all MCP server templates */
  mcpServerTemplates: Array<McpServerTemplate>;
  mcpServers: Array<McpServer>;
  me: MeResponse;
  /** Get current user's MCP Server Installs */
  myMcpServerInstalls: Array<McpServerInstall>;
  myOrgSamlAuthorizeUrl?: Maybe<OrgSamlAuthorizeUrl>;
  myOrgSamlConfig: OrgSamlConfig;
  myOrgScimConfig: OrgScimConfig;
  myOrgs: Array<Org>;
  /** Check if Shadow AI setup is needed (no EDR integrations and no desktop app installs) */
  needsShadowAISetup: Scalars['Boolean']['output'];
  /** Get a list of all on-prem MCP servers and their metadata */
  onPremServerMetadata: OnPremServerMetadataPoll;
  rateLimit: RateLimit;
  rateLimits: Array<RateLimit>;
  /** Get a list of all on-prem MCP servers that need to be scanned */
  scanRemoteServerRequests: CoreScanRemoteServerRequests;
  /** Gets details about an individual service. */
  serviceDetails?: Maybe<Service>;
  /** Retrieves a list of service instance names mapped by their instance IDs for each integrationId */
  serviceInstances: Scalars['JSON']['output'];
  services?: Maybe<Array<Service>>;
  /** Get MCP tool call audit logs grouped by session ID with filtering and pagination */
  sessionAuditLogs: SessionAuditLogResponse;
  /** List of unique users or hostnames for the Owner filter */
  shadowMCPServerOwners: Array<ShadowServerOwnerOption>;
  /** Get individual Shadow MCP servers for a specific normalized server name and EDR service with statistics */
  shadowMCPServersForNormalizedServerName: ShadowMcpServerDetails;
  /** Get Shadow MCP servers grouped by normalizedServerName and integrationId of sourceEDRService */
  shadowMCPServersGroupedByNormalizedServerName: Array<ShadowMcpServerNormalizedGroup>;
  /** Simulates a policy check for a tool call */
  simulatePolicyToolCall?: Maybe<Scalars['JSON']['output']>;
  /** Test an MCP server connection with provided credentials or existing install */
  testMCPConnection: TestMcpConnectionResult;
  /** Get all created tunnels */
  tunnels: Array<Tunnel>;
  user: User;
  /** Validates a Cedar policy without saving it */
  validateCedarPolicy?: Maybe<Scalars['JSON']['output']>;
};

export type QueryAccessControlsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AccessControlSort>;
  types?: InputMaybe<Array<AccessControlType>>;
};

export type QueryAccessPoliciesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AccessPolicySort>;
};

export type QueryAccessPolicyArgs = {
  id: Scalars['ObjectID']['input'];
};

export type QueryAccessPolicyPrincipalsArgs = {
  ids?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  requiredIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  types: Array<McpAccessPolicyPrincipalType>;
};

export type QueryAdminAppCatalogArgs = {
  appType?: InputMaybe<AppType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAgentArgs = {
  id: Scalars['ObjectID']['input'];
};

export type QueryAgentMcpServerInstallsArgs = {
  agentId: Scalars['ObjectID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  server?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type QueryAgentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  myAgentsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAggregatedAuditLogsArgs = {
  actorType?: InputMaybe<AuditActorType>;
  eventType?: InputMaybe<AuditEvent>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<AuditLogGroupBy>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AuditLogSort>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAllOrgsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GetOrgsSort>;
};

export type QueryAuditLogCountsArgs = {
  actorType?: InputMaybe<AuditActorType>;
  eventType?: InputMaybe<AuditEvent>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<AuditLogGroupBy>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAuditLogTotalCountArgs = {
  actorType?: InputMaybe<AuditActorType>;
  eventType?: InputMaybe<AuditEvent>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAuditLogsArgs = {
  actorType?: InputMaybe<AuditActorType>;
  eventTypes?: InputMaybe<Array<AuditEvent>>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<AuditLogGroupBy>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AuditLogSort>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type QueryBillingItemsArgs = {
  orgId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type QueryCorePolicyDataArgs = {
  isUserScoped?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCredentialsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type: CredentialTypes;
};

export type QueryDeploymentArgs = {
  _id: Scalars['ObjectID']['input'];
};

export type QueryDeploymentsArgs = {
  includeDeletedDeployments?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryDesktopAppReleasesGroupedByVersionArgs = {
  platform?: InputMaybe<DesktopPlatform>;
  status?: InputMaybe<DesktopAppReleaseStatus>;
  versions: Array<Scalars['String']['input']>;
};

export type QueryDiscoveredAiClientUsersArgs = {
  configFileType: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDiscoveredAiClientsGroupedByTypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  owners?: InputMaybe<Array<ShadowServerOwnerInput>>;
  q?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<DiscoveredClientSortBy>;
  status?: InputMaybe<ShadowMcpServerStatus>;
};

export type QueryDiscoveredMcpServersByInstallationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryDiscoveredUsersByServersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryEnabledAppsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  personalConnectionStatus: PersonalConnectionStatus;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetIngestJobArgs = {
  _id?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type QueryGetIntegrationCountsArgs = {
  integrationId?: InputMaybe<IntegrationId>;
};

export type QueryGetUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ObjectID']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Array<UserRole>>;
  sort?: InputMaybe<GetUsersSort>;
  status?: InputMaybe<Array<UserStatus>>;
};

export type QueryGroupArgs = {
  id: Scalars['ObjectID']['input'];
};

export type QueryGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type QueryIngestjobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  serviceId?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  type?: InputMaybe<JobType>;
};

export type QueryInstallationConfigPropertiesArgs = {
  templateOrServerInfoSlug: Scalars['String']['input'];
};

export type QueryLatestDesktopAppReleaseArgs = {
  channel: DesktopAppChannel;
  platform: DesktopPlatform;
};

export type QueryLatestJobChainArgs = {
  serviceId: Scalars['ObjectID']['input'];
  type: JobChainType;
};

export type QueryMcpProfileArgs = {
  profileId: Scalars['ObjectID']['input'];
};

export type QueryMcpProfilesArgs = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMcpServerArgs = {
  id: Scalars['ObjectID']['input'];
};

export type QueryMcpServerInfosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMcpServerInstallArgs = {
  id: Scalars['ObjectID']['input'];
};

export type QueryMcpServerInstallsArgs = {
  includeOrgManagedInstalls?: InputMaybe<Scalars['Boolean']['input']>;
  installTypes?: InputMaybe<Array<McpServerInstallAccessInstallType>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  owners?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  servers?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type QueryMcpServerTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMcpServersArgs = {
  agentId?: InputMaybe<Scalars['ObjectID']['input']>;
  availableForTypes?: InputMaybe<Array<McpServerAccessAvailableFor>>;
  isAvailableQuery?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  showUnusedByoOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryMyMcpServerInstallsArgs = {
  installTypes?: InputMaybe<Array<McpServerInstallAccessInstallType>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  server?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type QueryMyOrgSamlAuthorizeUrlArgs = {
  input: OrgSamlAuthorizeUrlInput;
};

export type QueryRateLimitArgs = {
  id: Scalars['ObjectID']['input'];
};

export type QueryRateLimitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<RateLimitStatus>>;
};

export type QueryServiceDetailsArgs = {
  _id: Scalars['ObjectID']['input'];
};

export type QueryServicesArgs = {
  identityId?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  integrationId?: InputMaybe<Array<IntegrationId>>;
  isIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ServiceStatus>>;
};

export type QuerySessionAuditLogsArgs = {
  actors?: InputMaybe<Array<ActorFilterInput>>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AuditLogSort>;
  status?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  toolName?: InputMaybe<Scalars['String']['input']>;
};

export type QueryShadowMcpServerOwnersArgs = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type QueryShadowMcpServersForNormalizedServerNameArgs = {
  integrationId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  normalizedServerName: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type QueryShadowMcpServersGroupedByNormalizedServerNameArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  owners?: InputMaybe<Array<ShadowServerOwnerInput>>;
  q?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ShadowServerSortBy>;
  statuses?: InputMaybe<Array<ShadowMcpServerStatus>>;
};

export type QuerySimulatePolicyToolCallArgs = {
  input: SimulatePolicyToolCallInput;
};

export type QueryTestMcpConnectionArgs = {
  agentId?: InputMaybe<Scalars['ObjectID']['input']>;
  authCredentials?: InputMaybe<Scalars['ServerInstallationCredsMap']['input']>;
  mcpServerId?: InputMaybe<Scalars['ObjectID']['input']>;
  mcpServerInstallId?: InputMaybe<Scalars['ObjectID']['input']>;
  templateId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type QueryTunnelsArgs = {
  connectionStatus?: InputMaybe<TunnelConnectionStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<TunnelStatus>>;
};

export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type QueryValidateCedarPolicyArgs = {
  input: ValidateCedarPolicyInput;
};

/** A single rate limit definition */
export type RateLimit = {
  __typename?: 'RateLimit';
  _id: Scalars['ObjectID']['output'];
  action: RateLimitAction;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  lastUpdatedBy: User;
  name: Scalars['String']['output'];
  status: RateLimitStatus;
  target: RateLimitTarget;
  updatedAt: Scalars['DateTime']['output'];
  /** @deprecated Usage is now enforced per-actor; this per-app field is a compatibility stub that always returns a zeroed value and will be removed once all agents upgrade. */
  usageData: RateLimitUsageData;
  window: RateLimitWindow;
};

/** The action to which this rate limit applies */
export enum RateLimitAction {
  ToolCall = 'TOOL_CALL'
}

/** Input object for the actor definition */
export type RateLimitActorInput = {
  ref: Scalars['ObjectID']['input'];
  type: ActorType;
};

/** The status of a rate limit */
export enum RateLimitStatus {
  Deleted = 'DELETED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

/** The target of this rate limit */
export type RateLimitTarget = {
  __typename?: 'RateLimitTarget';
  details?: Maybe<RateLimitTargetDetails>;
  type: RateLimitTargetType;
};

/** Resolver for rate limit target */
export type RateLimitTargetDetails = McpServer;

/** Input specification for a rate limit target */
export type RateLimitTargetInput = {
  ref: Scalars['ObjectID']['input'];
  type: RateLimitTargetType;
};

/** The target type to which this rate limit applies */
export enum RateLimitTargetType {
  McpServer = 'MCP_SERVER'
}

/** Data that returns if the rate limit has been reached by the rate limit */
export type RateLimitUsageData = {
  __typename?: 'RateLimitUsageData';
  hasReachedLimit: Scalars['Boolean']['output'];
  usage: Scalars['Int']['output'];
};

/** Sliding window configuration for a rate limit */
export type RateLimitWindow = {
  __typename?: 'RateLimitWindow';
  amount: Scalars['Int']['output'];
  unit: RateLimitWindowUnit;
};

/** Input specification for a rate limit window */
export type RateLimitWindowInput = {
  amount: Scalars['Int']['input'];
  unit: RateLimitWindowUnit;
};

/** The unit for a sliding rate limit window */
export enum RateLimitWindowUnit {
  Hour = 'HOUR',
  Hour_24 = 'HOUR_24',
  Minute = 'MINUTE',
  Minute_5 = 'MINUTE_5',
  Minute_15 = 'MINUTE_15',
  Minute_30 = 'MINUTE_30'
}

/** Rate usage object type */
export type RateUsage = {
  __typename?: 'RateUsage';
  meta: RateUsageMeta;
  timestamp: Scalars['DateTime']['output'];
  usage: Scalars['Int']['output'];
};

/** The meta field on rate usage */
export type RateUsageMeta = {
  __typename?: 'RateUsageMeta';
  action: RateLimitAction;
  target: RateLimitTarget;
};

/** Input object to record a rate usage */
export type RecordRateUsageInput = {
  meta: RecordRateUsageMetaInput;
  timestamp: Scalars['DateTime']['input'];
  usage: Scalars['Int']['input'];
};

/** Input object for the meta */
export type RecordRateUsageMetaInput = {
  action: RateLimitAction;
  actor?: InputMaybe<RateLimitActorInput>;
  target: RateLimitTargetInput;
};

/** Configuration for remotely hosted MCP servers */
export type RemoteUrlSource = {
  __typename?: 'RemoteUrlSource';
  deployment?: Maybe<Deployment>;
  /** Flag if set to true, this is an on-prem server */
  isOnPrem?: Maybe<Scalars['Boolean']['output']>;
  /** The URL of the hosted streamable-http or sse MCP server */
  mcpServerUrl: Scalars['String']['output'];
  sourceType: McpServerSourceType;
  /** Flag if set to true, use specified authorization server to introspect a passed token */
  useCustomAuthServer?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoteUrlSourceInput = {
  /** Deployment objectId for onprem */
  deploymentRef?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Flag if set to true, this is an on-prem server */
  isOnPrem?: InputMaybe<Scalars['Boolean']['input']>;
  /** The URL of the hosted streamable-http or sse MCP server */
  mcpServerUrl: Scalars['String']['input'];
  /** Flag if set to true, use specified authorization server to introspect a passed token */
  useCustomAuthServer?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The package type of the repository. (e.g. npm, pip, docker, etc.) */
export enum RepositoryPackageType {
  Docker = 'docker',
  Npm = 'npm',
  Pip = 'pip'
}

/** Configuration for repository-based MCP servers */
export type RepositorySource = {
  __typename?: 'RepositorySource';
  /** The branch name of the MCP server repository */
  branchName?: Maybe<Scalars['String']['output']>;
  /** The commit SHA of the MCP server repository */
  commitSha?: Maybe<Scalars['String']['output']>;
  /** The URL of the MCP server repository */
  repositoryUrl: Scalars['String']['output'];
  sourceType: McpServerSourceType;
  /** Working directory for build steps (defaults to root if not specified) */
  workingDirectory?: Maybe<Scalars['String']['output']>;
};

/** Supported SMTP Server Ports */
export enum SmtpPort {
  Standard = 'STANDARD',
  Starttls = 'STARTTLS',
  Tls = 'TLS'
}

/** A sample tool that can be displayed to users as an example of what the MCP server can do */
export type SampleTool = {
  __typename?: 'SampleTool';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** The SCIM provisioning token for an org */
export type ScimProvisioningToken = Credential | CredentialCreatedResponse;

/** Input body to send the scan results of a remote MCP server from the on-prem agent. */
export type SendRemoteServerScanResultsInput = {
  /** The ID of the MCP server */
  id: Scalars['ObjectID']['input'];
  /** The ID of the alert */
  tools: Array<ToolConfigInput>;
};

/** SentinelOne Intergration details */
export type SentinelOneIntegration = Integration & {
  __typename?: 'SentinelOneIntegration';
  activeAuthType: IntegrationAuthTypes;
  authFields: Scalars['JSON']['output'];
  authorizedScopes: Array<Scalars['String']['output']>;
  currentScopes?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  integrationId: IntegrationId;
  status: IntegrationStatus;
  uniqueId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Union type for MCP server info that can be either from Natoma's catalog or custom configured by users. */
export type ServerInfo = CustomMcpServerInfo | McpServerInfo;

/** Union type for the source field of the MCP server info provided by Natoma. */
export type ServerInfoSource =
  | NatomaDynamicRemoteUrlSource
  | NatomaLocalPackageSource
  | NatomaLocalUrlSource
  | NatomaRemoteUrlSource
  | NatomaRepositorySource;

export type ServerSource =
  | ApiSpecSource
  | DynamicRemoteUrlSource
  | LocalPackageSource
  | LocalUrlSource
  | RemoteUrlSource
  | RepositorySource
  | TunneledSource;

/** The representation of a third party app to which service identities and resources belong */
export type Service = {
  __typename?: 'Service';
  _id: Scalars['ObjectID']['output'];
  auxiliary?: Maybe<Auxiliary>;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  inferred?: Maybe<Inferred>;
  instanceName?: Maybe<Scalars['String']['output']>;
  integration?: Maybe<Integration>;
  lastActivityIngest?: Maybe<Scalars['DateTime']['output']>;
  org: Org;
  owner?: Maybe<User>;
  status: ServiceStatus;
  type?: Maybe<ServiceType>;
};

/** Input body for creating a Service object */
export type ServiceCreateBody = {
  /** The display name for this service */
  displayName: Scalars['String']['input'];
};

/** A map of serviceId to instanceName for a given integrationId */
export type ServiceInstanceMap = {
  __typename?: 'ServiceInstanceMap';
  instanceName?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['String']['output']>;
};

/** The type of owner for a service */
export enum ServiceOwnerType {
  User = 'USER'
}

/** The status of a service within the system */
export enum ServiceStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Pending = 'PENDING'
}

/** The type of the service */
export enum ServiceType {
  Auxiliary = 'AUXILIARY',
  Inferred = 'INFERRED',
  Integrated = 'INTEGRATED'
}

/** Input body for updating a Service object */
export type ServiceUpdateBody = {
  /** ID of the service to update the type. */
  _id: Scalars['String']['input'];
  patch: ServiceUpdatePatch;
};

/** Patch object for updating an service */
export type ServiceUpdatePatch = {
  newScopes?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type SessionAuditLogMetadata = {
  __typename?: 'SessionAuditLogMetadata';
  /** Number of unique actors in this session */
  actorCount?: Maybe<Scalars['Int']['output']>;
  /** Unique statuses encountered in this session */
  statuses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Unique targets affected in this session (now includes MCP Server Installs directly) */
  targets?: Maybe<Array<Maybe<AuditLogTarget>>>;
  /** Unique tool names used in this session */
  toolNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SessionAuditLogResponse = {
  __typename?: 'SessionAuditLogResponse';
  /** Session-grouped audit log results */
  sessions: Array<SessionAuditLogResult>;
  /** Total count of unique sessions matching the criteria */
  totalCount: Scalars['Int']['output'];
};

export type SessionAuditLogResult = {
  __typename?: 'SessionAuditLogResult';
  /** Number of audit logs in this session */
  count: Scalars['Int']['output'];
  /** Timestamp of the earliest audit log in this session */
  earliestTimestamp: Scalars['DateTime']['output'];
  /** Individual audit log events in this session */
  events: Array<AuditLog>;
  /** Timestamp of the most recent audit log in this session */
  latestTimestamp: Scalars['DateTime']['output'];
  /** Additional metadata about this session */
  metadata?: Maybe<SessionAuditLogMetadata>;
  /** The session ID grouping key */
  sessionId: Scalars['String']['output'];
};

export type ShadowDeviceInfo = {
  __typename?: 'ShadowDeviceInfo';
  deviceId?: Maybe<Scalars['String']['output']>;
  hostname: Scalars['String']['output'];
  primaryUserEmail?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type ShadowDeviceInput = {
  hostname: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

/** A detected shadow MCP server on a device */
export type ShadowMcpServer = {
  __typename?: 'ShadowMCPServer';
  _id: Scalars['ID']['output'];
  configFilePath?: Maybe<Scalars['String']['output']>;
  configFileType?: Maybe<McpClientType>;
  createdAt: Scalars['DateTime']['output'];
  device?: Maybe<ShadowDeviceInfo>;
  firstDetectedAt: Scalars['DateTime']['output'];
  lastSeenAt: Scalars['DateTime']['output'];
  mcpServerDetectionMethod?: Maybe<McpServerDetectionMethod>;
  normalizedServerName?: Maybe<Scalars['String']['output']>;
  serverAddress?: Maybe<Scalars['String']['output']>;
  serverName?: Maybe<Scalars['String']['output']>;
  status: ShadowMcpServerStatus;
  /** Last N tool calls for this specific server installation */
  toolCalls: Array<AgentToolCall>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

/** A detected shadow MCP server on a device */
export type ShadowMcpServerToolCallsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Response containing shadow MCP servers and statistics */
export type ShadowMcpServerDetails = {
  __typename?: 'ShadowMCPServerDetails';
  /** Earliest lastSeenAt date across all servers for this normalized name - first detected timestamp */
  firstDetectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Most recent lastSeenAt date across all servers for this normalized name */
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  /** Paginated list of shadow MCP servers */
  servers: Array<ShadowMcpServer>;
  /** Total count of servers for this normalized name (unfiltered by search) */
  totalCount: Scalars['Int']['output'];
};

/** Filter input for selecting shadow MCP servers to update */
export type ShadowMcpServerFilterInput = {
  /** Filter by integration ID to scope to a specific integration. If not provided, filters desktop app detections. */
  integrationId?: InputMaybe<IntegrationId>;
  /** Filter by normalized server name (identifies the group) */
  normalizedServerName?: InputMaybe<Scalars['String']['input']>;
};

export type ShadowMcpServerInput = {
  configFilePath?: InputMaybe<Scalars['String']['input']>;
  configFileType?: InputMaybe<McpClientType>;
  device?: InputMaybe<ShadowDeviceInput>;
  serverAddress?: InputMaybe<Scalars['String']['input']>;
  serverName?: InputMaybe<Scalars['String']['input']>;
};

/** A group of shadow MCP server installations aggregated by normalized server name and integration (corresponds to one row in Shadow AI Details page) */
export type ShadowMcpServerNormalizedGroup = {
  __typename?: 'ShadowMCPServerNormalizedGroup';
  /** First createdAt date for this normalized group */
  firstDetectedAt: Scalars['DateTime']['output'];
  /** Integration ID of the EDR/MDM service that detected this server, or null for Natoma Desktop. */
  integrationId?: Maybe<IntegrationId>;
  /** Most recent lastSeenAt date for this normalized group */
  lastSeenAt: Scalars['DateTime']['output'];
  normalizedServerName: Scalars['String']['output'];
  users: Array<ShadowDeviceInfo>;
};

/** Status of the shadow MCP server */
export enum ShadowMcpServerStatus {
  Active = 'ACTIVE',
  Dismissed = 'DISMISSED'
}

/** Patch object for updating shadow MCP servers */
export type ShadowMcpServerUpdatePatchInput = {
  /** The new status to set */
  status?: InputMaybe<ShadowMcpServerStatus>;
};

export type ShadowServerOwnerInput = {
  hostname?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ShadowServerOwnerOption = {
  __typename?: 'ShadowServerOwnerOption';
  hostname?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Sort options for shadow MCP servers */
export enum ShadowServerSortBy {
  FirstDetectedAsc = 'FIRST_DETECTED_ASC',
  FirstDetectedDesc = 'FIRST_DETECTED_DESC',
  InstallationsAsc = 'INSTALLATIONS_ASC',
  InstallationsDesc = 'INSTALLATIONS_DESC',
  IntegrationAsc = 'INTEGRATION_ASC',
  IntegrationDesc = 'INTEGRATION_DESC',
  LastSeenAsc = 'LAST_SEEN_ASC',
  LastSeenDesc = 'LAST_SEEN_DESC',
  ServerNameAsc = 'SERVER_NAME_ASC',
  ServerNameDesc = 'SERVER_NAME_DESC'
}

/** Input object for simulating a policy tool call */
export type SimulatePolicyToolCallInput = {
  /** The actor ID to simulate (optional, requires actorType if provided, defaults to current user) */
  actorId?: InputMaybe<Scalars['String']['input']>;
  /** The type of actor to simulate (optional, requires actorId if provided) */
  actorType?: InputMaybe<InstalledForActorType>;
  /** The MCP server installation ID */
  installationId: Scalars['String']['input'];
  /** The name of the tool to simulate */
  toolName: Scalars['String']['input'];
};

/** Splunk HEC (SIEM export) integration details */
export type SplunkHecIntegration = Integration & {
  __typename?: 'SplunkHecIntegration';
  activeAuthType: IntegrationAuthTypes;
  authFields: Scalars['JSON']['output'];
  authorizedScopes: Array<Scalars['String']['output']>;
  currentScopes?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  integrationId: IntegrationId;
  status: IntegrationStatus;
  uniqueId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Configuration for a single MCP server installation in a profile template */
export type TemplateInstallationConfigInput = {
  /** Whether or not all tools are enabled for this server in this profile */
  allToolsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of enabled tool names (without server prefix) */
  enabledTools?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Installation type (typically MANAGED for templates) */
  installType: McpServerInstallAccessInstallType;
  /** Reference to MCPServerInstall for MANAGED installations */
  installation?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Reference to the MCPServer */
  server: Scalars['ObjectID']['input'];
};

/** Result of testing an MCP server connection */
export type TestMcpConnectionResult = {
  __typename?: 'TestMCPConnectionResult';
  /** Error message if the connection test failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether the connection test was successful */
  success: Scalars['Boolean']['output'];
  /** Number of tools available from the MCP server */
  toolCount?: Maybe<Scalars['Int']['output']>;
  /** Names of available tools from the MCP server */
  toolNames?: Maybe<Array<Scalars['String']['output']>>;
};

/** Tool config input for a MCP server */
export type ToolConfigInput = {
  /** Specialized metadata for the tool that describe tool behavior */
  annotations?: InputMaybe<Scalars['JSON']['input']>;
  /** Human-readable description of functionality */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Input schema for this tool */
  inputSchema?: InputMaybe<Scalars['JSON']['input']>;
  /** The name of the tool */
  name: Scalars['String']['input'];
  /** Output schema for this tool */
  outputSchema?: InputMaybe<Scalars['JSON']['input']>;
  /** Human-readable name of the tool for display purposes */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Specification for a single MCP server that needs to receive tools/list */
export type ToolScan = {
  __typename?: 'ToolScan';
  id: Scalars['ObjectID']['output'];
  mcpServerUrl: Scalars['String']['output'];
};

/** Individual tunnel configurations */
export type Tunnel = {
  __typename?: 'Tunnel';
  _id: Scalars['ObjectID']['output'];
  connectionStatus: TunnelConnectionStatus;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  displayName: Scalars['String']['output'];
  metadata: TunnelMetadata;
  org: Org;
  status: TunnelStatus;
  tunnelKey: Credential;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** Tunnel authentication strategies */
export enum TunnelAuthStrategy {
  Keyauth = 'KEYAUTH',
  Noauth = 'NOAUTH'
}

/** Tunnel connection statuses */
export enum TunnelConnectionStatus {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED'
}

/** Tunnel connection metadata */
export type TunnelMetadata = {
  __typename?: 'TunnelMetadata';
  lastHeartbeatAt?: Maybe<Scalars['DateTime']['output']>;
  tunnelAuthStrategy?: Maybe<TunnelAuthStrategy>;
  tunnelVersion?: Maybe<Scalars['String']['output']>;
};

/** Tunnel statuses */
export enum TunnelStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Disabled = 'DISABLED'
}

export type TunneledSource = {
  __typename?: 'TunneledSource';
  sourceType: McpServerSourceType;
};

/** Input body for updating a single MCP server */
export type UpdateAccessPolicyInput = {
  /** The ID of the MCP server to update */
  _id: Scalars['ObjectID']['input'];
  /** The patch object to apply to the MCP server */
  patch: UpdateAccessPolicyPatch;
};

/** Patch object for updating an MCP server */
export type UpdateAccessPolicyPatch = {
  /** The status of the MCP server */
  status?: InputMaybe<McpAccessPolicyStatus>;
};

/** Input for updating an existing agent */
export type UpdateAgentInput = {
  /** The ID of the agent to update */
  _id: Scalars['ID']['input'];
  /** New display name for the agent */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** New owner user ID for the agent */
  ownerId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a credential status */
export type UpdateCredentialStatusInput = {
  /** Credential ObjectId to update */
  _id: Scalars['ObjectID']['input'];
  /** Status of the credential to update to */
  status: CredentialStatus;
};

/** Input for updating a deployment */
export type UpdateDeploymentInput = {
  /** Deployment ObjectId to update */
  _id: Scalars['ObjectID']['input'];
  /** displayName of the deployment to update to */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Origin of the deployment to update to */
  origin?: InputMaybe<Scalars['String']['input']>;
  /** Status of the deployment to update to */
  status?: InputMaybe<DeploymentStatus>;
};

export type UpdateDesktopAppReleasesInput = {
  filter?: InputMaybe<DesktopAppReleaseFilterInput>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  patch: DesktopAppReleaseUpdatePatchInput;
};

/** Input body for updating a single MCP server installation */
export type UpdateMcpServerInstallInput = {
  /** The ID of the MCP server installation to update */
  _id: Scalars['ObjectID']['input'];
  /** Agent ID to add/remove from the installation instead of current user */
  agentId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Action to add or remove a user from the MCP server installation */
  installationAction?: InputMaybe<InstallationAction>;
};

/** Input to update available tools on an MCP server install (and its server) after a tools/list response, e.g. from the desktop app. */
export type UpdateMcpServerInstallToolsInput = {
  /** If set to true, do not use context.currentActor to retrieve install (e.g. on-prem agents updating) */
  disableActorLookup?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the MCPServerInstall to update */
  installationId: Scalars['ObjectID']['input'];
  /** The list of tools returned by the MCP server */
  tools: Array<ToolConfigInput>;
};

/** Input to update an install for an OAuth mcp server. */
export type UpdateOAuthMcpServerInstallInput = {
  /** Client information from registration */
  clientInformation?: InputMaybe<OAuthClientInformationInput>;
  /** Code verifier for the authorization */
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  /** Install display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the MCPServerInstall to update */
  installationId: Scalars['ObjectID']['input'];
  /** OAuth tokens from the authorization flow */
  tokens?: InputMaybe<OAuthTokensInput>;
};

/** Input for updating shadow MCP servers */
export type UpdateShadowMcpServersInput = {
  /** Filter criteria for selecting servers to update */
  filter?: InputMaybe<ShadowMcpServerFilterInput>;
  /** Fields to update */
  patch: ShadowMcpServerUpdatePatchInput;
};

/** Input object to upsert a rate limit object */
export type UpsertRateLimitInput = {
  /** ID of rate limit to update, if updating existing access control */
  _id?: InputMaybe<Scalars['ObjectID']['input']>;
  action?: InputMaybe<RateLimitAction>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RateLimitStatus>;
  target?: InputMaybe<RateLimitTargetInput>;
  window?: InputMaybe<RateLimitWindowInput>;
};

/** A human user who is able to log in and act within Natoma. */
export type User = {
  __typename?: 'User';
  _id: Scalars['ObjectID']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  loginType: UserLoginType;
  org: Org;
  role: UserRole;
  /** The MCP profile selected by the user. */
  selectedProfile?: Maybe<McpProfile>;
  /** True if the user be informed that their MCP config has changed. */
  shouldPingMcpConfig?: Maybe<Scalars['Boolean']['output']>;
  status: UserStatus;
};

/** The type of login method used by a user */
export enum UserLoginType {
  Disallowed = 'DISALLOWED',
  Local = 'LOCAL',
  Sso = 'SSO'
}

/** The role of a user */
export enum UserRole {
  Admin = 'ADMIN',
  AppAdmin = 'APP_ADMIN',
  Member = 'MEMBER'
}

/** The status of an organization */
export enum UserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Invited = 'INVITED'
}

/** Input object for validating a Cedar policy */
export type ValidateCedarPolicyInput = {
  /** The policy string to validate */
  policy: Scalars['String']['input'];
};

export type NewAccessPolicyFragment = {
  __typename: 'MCPAccessPolicy';
  _id: any;
  name: string;
  status: McpAccessPolicyStatus;
  isDeprecated: boolean;
  targetConfigs: Array<{
    __typename?: 'MCPAccessPolicyTarget';
    allTools: boolean;
    tools: Array<string>;
    totalInstalls: number;
    installationScope: InstallationScope;
  }>;
};

export type NewAccessControlPolicyFragment = {
  __typename: 'AccessControlPolicy';
  _id: any;
  name: string;
  status: AccessControlStatus;
  type: AccessControlType;
  updatedAt: any;
  createdAt: any;
  policy: {
    __typename?: 'MCPAccessPolicy';
    effect?: PolicyEffectType | null;
    isDeprecated: boolean;
    targetConfigs: Array<{
      __typename?: 'MCPAccessPolicyTarget';
      allTools: boolean;
      totalInstalls: number;
      tools: Array<string>;
      installationScope: InstallationScope;
    }>;
  };
};

export type GetEnabledMcpServersQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  availableForTypes?: InputMaybe<Array<McpServerAccessAvailableFor>>;
}>;

export type GetEnabledMcpServersQuery = {
  __typename?: 'Query';
  mcpServers: Array<{
    __typename?: 'MCPServer';
    _id: any;
    name: string;
    description?: string | null;
    originType: McpServerOrigin;
    isRemoteServerScanned?: boolean | null;
    status: McpServerStatus;
    config?: any | null;
    oauthClientId?: string | null;
    hasOauthClientSecret?: boolean | null;
    oauthScopes?: string | null;
    createdAt: any;
    updatedAt: any;
    accessConfig: {
      __typename?: 'MCPServerAccessConfig';
      availableFor: Array<McpServerAccessAvailableFor>;
      isPersonalConnectionEnabled?: boolean | null;
    };
    availableTools: Array<{
      __typename?: 'MCPServerTool';
      name: string;
      description?: string | null;
    }>;
    managedInstalls: Array<{
      __typename?: 'MCPServerToInstallObject';
      id: any;
      displayName: string;
      canEdit: boolean;
      availableTools: Array<{
        __typename?: 'MCPServerTool';
        name: string;
        description?: string | null;
      }>;
    }>;
  }>;
};

export type RemoteUrlAppFormEnableMcpServerMutationVariables = Exact<{
  input: EnableMcpServerInput;
}>;

export type RemoteUrlAppFormEnableMcpServerMutation = {
  __typename?: 'Mutation';
  enableMcpServer: { __typename?: 'MCPServer'; _id: any };
};

export type ApiKeyFieldCreateCredentialMutationVariables = Exact<{
  input: CreateCredentialInput;
}>;

export type ApiKeyFieldCreateCredentialMutation = {
  __typename?: 'Mutation';
  createCredential: {
    __typename?: 'CredentialCreatedResponse';
    _id: any;
    secret: string;
  };
};

export type GetServerConnectionsForUserQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type GetServerConnectionsForUserQuery = {
  __typename?: 'Query';
  mcpServer?: {
    __typename?: 'MCPServer';
    _id: any;
    availableInstalls: Array<{
      __typename?: 'MCPServerInstall';
      _id: any;
      displayName: string;
      installed: boolean;
      accessConfig: {
        __typename?: 'MCPServerInstallAccessConfig';
        installType: McpServerInstallAccessInstallType;
      };
    }>;
  } | null;
};

export type GetServerConnectionsForAgentQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
  agentId: Scalars['ObjectID']['input'];
}>;

export type GetServerConnectionsForAgentQuery = {
  __typename?: 'Query';
  mcpServer?: {
    __typename?: 'MCPServer';
    _id: any;
    availableInstalls: Array<{
      __typename?: 'MCPServerInstall';
      _id: any;
      displayName: string;
      installed: boolean;
      accessConfig: {
        __typename?: 'MCPServerInstallAccessConfig';
        installType: McpServerInstallAccessInstallType;
      };
    }>;
  } | null;
};

export type ConnectionConfigViewGetInstallsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ConnectionConfigViewGetInstallsQuery = {
  __typename?: 'Query';
  myMcpServerInstalls: Array<{
    __typename?: 'MCPServerInstall';
    _id: any;
    displayName: string;
    status: McpServerInstallStatus;
    mcpUrl: string;
    server: { __typename?: 'MCPServer'; _id: any; name: string };
  }>;
};

export type GetMyConnectionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetMyConnectionsQuery = {
  __typename?: 'Query';
  myMcpServerInstalls: Array<{
    __typename?: 'MCPServerInstall';
    _id: any;
    displayName: string;
    status: McpServerInstallStatus;
    server: {
      __typename?: 'MCPServer';
      _id: any;
      name: string;
      accessConfig: {
        __typename?: 'MCPServerAccessConfig';
        availableFor: Array<McpServerAccessAvailableFor>;
      };
      serverInfo:
        | {
            __typename: 'CustomMCPServerInfo';
            source:
              | {
                  __typename: 'CustomDynamicRemoteUrlSource';
                  isOnPrem?: boolean | null;
                }
              | {
                  __typename: 'CustomRemoteUrlSource';
                  isOnPrem?: boolean | null;
                };
          }
        | {
            __typename: 'MCPServerInfo';
            source:
              | { __typename: 'NatomaDynamicRemoteUrlSource' }
              | { __typename: 'NatomaLocalPackageSource' }
              | { __typename: 'NatomaLocalUrlSource' }
              | { __typename: 'NatomaRemoteUrlSource' }
              | { __typename: 'NatomaRepositorySource' };
          };
    };
    healthStatus?: { __typename?: 'HealthStatus'; healthy: boolean } | null;
    accessConfig: {
      __typename?: 'MCPServerInstallAccessConfig';
      installType: McpServerInstallAccessInstallType;
    };
  }>;
};

export type GetEnabledServersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetEnabledServersQuery = {
  __typename?: 'Query';
  mcpServers: Array<{
    __typename?: 'MCPServer';
    _id: any;
    name: string;
    canConnect: boolean;
    accessConfig: {
      __typename?: 'MCPServerAccessConfig';
      availableFor: Array<McpServerAccessAvailableFor>;
    };
    managedInstalls: Array<{
      __typename?: 'MCPServerToInstallObject';
      id: any;
    }>;
  }>;
};

export type NewDeploymentFragment = {
  __typename: 'Deployment';
  _id: any;
  status: DeploymentStatus;
  displayName: string;
  origin: string;
  createdAt: any;
  updatedAt: any;
  polledAt?: any | null;
  health: string;
  credentials: Array<{
    __typename?: 'Credential';
    _id: any;
    status: CredentialStatus;
    credentialId: string;
  }>;
  createdBy: {
    __typename?: 'User';
    _id: any;
    displayName?: string | null;
    email: string;
  };
  updatedBy: {
    __typename?: 'User';
    _id: any;
    displayName?: string | null;
    email: string;
  };
};

export type GetShadowMcpServersForNormalizedServerNameQueryVariables = Exact<{
  normalizedServerName: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
  q?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;

export type GetShadowMcpServersForNormalizedServerNameQuery = {
  __typename?: 'Query';
  shadowMCPServersForNormalizedServerName: {
    __typename?: 'ShadowMCPServerDetails';
    totalCount: number;
    lastSeenAt?: any | null;
    firstDetectedAt?: any | null;
    servers: Array<{
      __typename?: 'ShadowMCPServer';
      _id: string;
      serverName?: string | null;
      serverAddress?: string | null;
      normalizedServerName?: string | null;
      configFileType?: McpClientType | null;
      configFilePath?: string | null;
      lastSeenAt: any;
      firstDetectedAt: any;
      createdAt: any;
      device?: {
        __typename?: 'ShadowDeviceInfo';
        hostname: string;
        primaryUserEmail?: string | null;
        username?: string | null;
      } | null;
      user?: { __typename?: 'User'; displayName?: string | null } | null;
      toolCalls: Array<{
        __typename?: 'AgentToolCall';
        _id: string;
        toolName: string;
        calledAt: any;
        resultStatus?: string | null;
        model?: string | null;
        gitBranch?: string | null;
        toolArguments?: any | null;
      }>;
    }>;
  };
};

export type GetDiscoveredAiClientsGroupedByTypeQueryVariables = Exact<{
  status?: InputMaybe<ShadowMcpServerStatus>;
  q?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<DiscoveredClientSortBy>;
  owners?: InputMaybe<Array<ShadowServerOwnerInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetDiscoveredAiClientsGroupedByTypeQuery = {
  __typename?: 'Query';
  discoveredAIClientsGroupedByType: Array<{
    __typename?: 'DiscoveredAIClient';
    configFileType: string;
    usersCount: number;
    integrationIds: Array<IntegrationId>;
    isDetectedByDesktopApp: boolean;
    firstSeenAt: any;
    lastSeenAt: any;
    users: Array<{
      __typename?: 'ShadowDeviceInfo';
      userId?: string | null;
      hostname: string;
      primaryUserEmail?: string | null;
    }>;
  }>;
};

export type GetDiscoveredAiClientUsersQueryVariables = Exact<{
  configFileType: Scalars['String']['input'];
  q?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetDiscoveredAiClientUsersQuery = {
  __typename?: 'Query';
  discoveredAIClientUsers: {
    __typename?: 'DiscoveredAIClientUsersResult';
    totalCount: number;
    lastSeenAt?: any | null;
    firstDetectedAt?: any | null;
    users: Array<{
      __typename?: 'DiscoveredAIClientUserEntry';
      user?: string | null;
      device?: string | null;
      isDetectedByDesktopApp: boolean;
      integrationIds: Array<IntegrationId>;
      firstDetectedAt: any;
      lastSeenAt: any;
    }>;
  };
};

export type ActorAutocompleteQueryVariables = Exact<{
  types: Array<McpAccessPolicyPrincipalType>;
  q?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ActorAutocompleteQuery = {
  __typename?: 'Query';
  accessPolicyPrincipals: {
    __typename?: 'AccessPolicyPrincipalsResponse';
    principals: Array<
      | {
          __typename: 'Agent';
          agentId: string;
          agentDisplayName: string;
          owner: { __typename?: 'User'; _id: any; displayName?: string | null };
        }
      | { __typename: 'Group' }
      | {
          __typename: 'User';
          email: string;
          userId: any;
          userDisplayName?: string | null;
        }
    >;
  };
};

export type NewAgentFragment = {
  __typename: 'Agent';
  _id: string;
  displayName: string;
  createdAt: any;
  updatedAt: any;
  connections: Array<string>;
  connectionsCount: number;
  owner: {
    __typename?: 'User';
    _id: any;
    email: string;
    displayName?: string | null;
  };
  createdBy: {
    __typename?: 'User';
    _id: any;
    email: string;
    displayName?: string | null;
  };
};

export type UpdatedAgentFragment = {
  __typename?: 'Agent';
  _id: string;
  displayName: string;
  updatedAt: any;
  owner: {
    __typename?: 'User';
    _id: any;
    email: string;
    displayName?: string | null;
  };
};

export type GetAvailableMcpServersQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  availableForTypes?: InputMaybe<Array<McpServerAccessAvailableFor>>;
  agentId?: InputMaybe<Scalars['ObjectID']['input']>;
}>;

export type GetAvailableMcpServersQuery = {
  __typename?: 'Query';
  mcpServers: Array<{
    __typename?: 'MCPServer';
    _id: any;
    name: string;
    canConnect: boolean;
    accessConfig: {
      __typename?: 'MCPServerAccessConfig';
      availableFor: Array<McpServerAccessAvailableFor>;
      isPersonalConnectionEnabled?: boolean | null;
    };
    availableInstalls: Array<{
      __typename?: 'MCPServerInstall';
      _id: any;
      displayName: string;
      installed: boolean;
      accessConfig: {
        __typename?: 'MCPServerInstallAccessConfig';
        installType: McpServerInstallAccessInstallType;
      };
    }>;
  }>;
};

export type GetAgentMcpServerInstallsQueryVariables = Exact<{
  agentId: Scalars['ObjectID']['input'];
  server?: InputMaybe<Scalars['ObjectID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetAgentMcpServerInstallsQuery = {
  __typename?: 'Query';
  agentMcpServerInstalls: Array<{
    __typename?: 'MCPServerInstall';
    _id: any;
    displayName: string;
    status: McpServerInstallStatus;
    mcpUrl: string;
    canEdit: boolean;
    createdAt: any;
    updatedAt: any;
    server: {
      __typename?: 'MCPServer';
      _id: any;
      name: string;
      status: McpServerStatus;
      serverInfo:
        | {
            __typename: 'CustomMCPServerInfo';
            source:
              | {
                  __typename: 'CustomDynamicRemoteUrlSource';
                  isOnPrem?: boolean | null;
                }
              | {
                  __typename: 'CustomRemoteUrlSource';
                  isOnPrem?: boolean | null;
                };
          }
        | {
            __typename: 'MCPServerInfo';
            source:
              | { __typename: 'NatomaDynamicRemoteUrlSource' }
              | { __typename: 'NatomaLocalPackageSource' }
              | { __typename: 'NatomaLocalUrlSource' }
              | { __typename: 'NatomaRemoteUrlSource' }
              | { __typename: 'NatomaRepositorySource' };
          };
      accessConfig: {
        __typename?: 'MCPServerAccessConfig';
        availableFor: Array<McpServerAccessAvailableFor>;
        isPersonalConnectionEnabled?: boolean | null;
      };
      availableInstalls: Array<{
        __typename?: 'MCPServerInstall';
        _id: any;
        displayName: string;
        installed: boolean;
        accessConfig: {
          __typename?: 'MCPServerInstallAccessConfig';
          installType: McpServerInstallAccessInstallType;
        };
      }>;
    };
    accessConfig: {
      __typename?: 'MCPServerInstallAccessConfig';
      installType: McpServerInstallAccessInstallType;
    };
    tools: Array<{
      __typename?: 'MCPServerTool';
      name: string;
      description?: string | null;
    }>;
  }>;
};

export type GetAdminAppCatalogQueryVariables = Exact<{
  appType?: InputMaybe<AppType>;
  q?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetAdminAppCatalogQuery = {
  __typename?: 'Query';
  adminAppCatalog: Array<{
    __typename?: 'AppInfo';
    name: string;
    slug: string;
    appType: AppType;
  }>;
};

export type AppsCardViewEnableMcpServerMutationVariables = Exact<{
  input: EnableMcpServerInput;
}>;

export type AppsCardViewEnableMcpServerMutation = {
  __typename?: 'Mutation';
  enableMcpServer: { __typename?: 'MCPServer'; _id: any };
};

export type AppsCardViewEditMcpServerMutationVariables = Exact<{
  input: EditMcpServerInput;
}>;

export type AppsCardViewEditMcpServerMutation = {
  __typename?: 'Mutation';
  editMcpServer: {
    __typename?: 'MCPServer';
    _id: any;
    config?: any | null;
    accessConfig: {
      __typename?: 'MCPServerAccessConfig';
      availableFor: Array<McpServerAccessAvailableFor>;
      isPersonalConnectionEnabled?: boolean | null;
    };
  };
};

export type AppsCardViewMcpServerInfosQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AppsCardViewMcpServerInfosQuery = {
  __typename?: 'Query';
  mcpServerInfos: Array<{
    __typename?: 'MCPServerInfo';
    serverId: McpServerId;
    slug: string;
    name: string;
    authenticationType?: McpServerAuthenticationType | null;
    installConfig?: {
      __typename?: 'MCPServerInfoConfigSchema';
      required: Array<string>;
      properties: any;
    } | null;
    serverConfig: {
      __typename?: 'MCPServerInfoConfigSchema';
      required: Array<string>;
      properties: any;
    };
    source:
      | {
          __typename: 'NatomaDynamicRemoteUrlSource';
          sourceType: McpServerSourceType;
        }
      | {
          __typename: 'NatomaLocalPackageSource';
          sourceType: McpServerSourceType;
        }
      | { __typename: 'NatomaLocalUrlSource'; sourceType: McpServerSourceType }
      | { __typename: 'NatomaRemoteUrlSource'; sourceType: McpServerSourceType }
      | {
          __typename: 'NatomaRepositorySource';
          sourceType: McpServerSourceType;
          type: McpServerTemplateType;
        };
    authConfig?: {
      __typename?: 'MCPServerInfoAuthConfig';
      supportedScopes?: Array<string | null> | null;
      requiredScopes?: Array<string | null> | null;
      scopeDelimiter?: string | null;
      hasDefaultClient?: boolean | null;
    } | null;
    annotations?: {
      __typename?: 'MCPServerInfoAnnotations';
      hintPreRegistered?: boolean | null;
    } | null;
  }>;
};

export type GetEnabledServersAppsViewQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  availableForTypes?: InputMaybe<Array<McpServerAccessAvailableFor>>;
}>;

export type GetEnabledServersAppsViewQuery = {
  __typename?: 'Query';
  mcpServers: Array<{
    __typename?: 'MCPServer';
    _id: any;
    name: string;
    description?: string | null;
    originType: McpServerOrigin;
    isRemoteServerScanned?: boolean | null;
    status: McpServerStatus;
    config?: any | null;
    oauthClientId?: string | null;
    hasOauthClientSecret?: boolean | null;
    oauthScopes?: string | null;
    accessConfig: {
      __typename?: 'MCPServerAccessConfig';
      availableFor: Array<McpServerAccessAvailableFor>;
    };
    serverInfo:
      | {
          __typename: 'CustomMCPServerInfo';
          name: string;
          authenticationType?: McpServerAuthenticationType | null;
          installConfig?: {
            __typename?: 'MCPServerInfoConfigSchema';
            required: Array<string>;
            properties: any;
          } | null;
          source:
            | {
                __typename: 'CustomDynamicRemoteUrlSource';
                isOnPrem?: boolean | null;
                mcpServerUrl: string;
                useCustomAuthServer?: boolean | null;
                deployment?: {
                  __typename?: 'Deployment';
                  _id: any;
                  displayName: string;
                  origin: string;
                } | null;
              }
            | {
                __typename: 'CustomRemoteUrlSource';
                isOnPrem?: boolean | null;
                mcpServerUrl: string;
                useCustomAuthServer?: boolean | null;
                deployment?: {
                  __typename?: 'Deployment';
                  _id: any;
                  displayName: string;
                  origin: string;
                } | null;
              };
        }
      | {
          __typename: 'MCPServerInfo';
          serverId: McpServerId;
          name: string;
          authenticationType?: McpServerAuthenticationType | null;
          installConfig?: {
            __typename?: 'MCPServerInfoConfigSchema';
            required: Array<string>;
            properties: any;
          } | null;
          serverConfig: {
            __typename?: 'MCPServerInfoConfigSchema';
            required: Array<string>;
            properties: any;
          };
          source:
            | { __typename: 'NatomaDynamicRemoteUrlSource' }
            | { __typename: 'NatomaLocalPackageSource' }
            | { __typename: 'NatomaLocalUrlSource' }
            | { __typename: 'NatomaRemoteUrlSource' }
            | {
                __typename: 'NatomaRepositorySource';
                type: McpServerTemplateType;
              };
          annotations?: {
            __typename?: 'MCPServerInfoAnnotations';
            hintPreRegistered?: boolean | null;
          } | null;
        };
    managedInstalls: Array<{
      __typename?: 'MCPServerToInstallObject';
      id: any;
      displayName: string;
      canEdit: boolean;
    }>;
  }>;
};

export type AppsCardViewFlagScanForServerMutationVariables = Exact<{
  input: GetByIdMcpServerInput;
}>;

export type AppsCardViewFlagScanForServerMutation = {
  __typename?: 'Mutation';
  flagScanForServer: { __typename?: 'MCPServer'; _id: any };
};

export type AppsCardViewMcpServerPollingQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type AppsCardViewMcpServerPollingQuery = {
  __typename?: 'Query';
  mcpServer?: {
    __typename?: 'MCPServer';
    _id: any;
    status: McpServerStatus;
  } | null;
};

export type GetDoesByoServerExistQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetDoesByoServerExistQuery = {
  __typename?: 'Query';
  doesByoServerExist: boolean;
};

export type GetMcpServerInstallQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type GetMcpServerInstallQuery = {
  __typename?: 'Query';
  mcpServerInstall?: {
    __typename?: 'MCPServerInstall';
    _id: any;
    displayName: string;
    canEdit: boolean;
    server: {
      __typename?: 'MCPServer';
      _id: any;
      serverInfo:
        | { __typename: 'CustomMCPServerInfo'; slug: string }
        | { __typename: 'MCPServerInfo'; slug: string };
    };
    accessConfig: {
      __typename?: 'MCPServerInstallAccessConfig';
      installType: McpServerInstallAccessInstallType;
    };
  } | null;
};

export type GetByoMcpServersQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  showUnusedByoOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetByoMcpServersQuery = {
  __typename?: 'Query';
  mcpServers: Array<{
    __typename?: 'MCPServer';
    _id: any;
    name: string;
    description?: string | null;
    originType: McpServerOrigin;
    isRemoteServerScanned?: boolean | null;
    status: McpServerStatus;
    oauthScopes?: string | null;
    accessConfig: {
      __typename?: 'MCPServerAccessConfig';
      availableFor: Array<McpServerAccessAvailableFor>;
    };
    serverInfo:
      | {
          __typename: 'CustomMCPServerInfo';
          name: string;
          authenticationType?: McpServerAuthenticationType | null;
          installConfig?: {
            __typename?: 'MCPServerInfoConfigSchema';
            required: Array<string>;
            properties: any;
          } | null;
          source:
            | { __typename: 'CustomDynamicRemoteUrlSource' }
            | {
                __typename: 'CustomRemoteUrlSource';
                isOnPrem?: boolean | null;
                mcpServerUrl: string;
                useCustomAuthServer?: boolean | null;
                deployment?: {
                  __typename?: 'Deployment';
                  _id: any;
                  displayName: string;
                  origin: string;
                } | null;
              };
        }
      | { __typename: 'MCPServerInfo' };
    managedInstalls: Array<{
      __typename?: 'MCPServerToInstallObject';
      id: any;
      displayName: string;
    }>;
  }>;
};

export type AppPersonalDisableMutationVariables = Exact<{
  input: EditMcpServerInput;
}>;

export type AppPersonalDisableMutation = {
  __typename?: 'Mutation';
  editMcpServer: {
    __typename?: 'MCPServer';
    _id: any;
    config?: any | null;
    accessConfig: {
      __typename?: 'MCPServerAccessConfig';
      availableFor: Array<McpServerAccessAvailableFor>;
      isPersonalConnectionEnabled?: boolean | null;
    };
  };
};

export type ByoServerRemoveMcpServerMutationVariables = Exact<{
  input: GetByIdMcpServerInput;
}>;

export type ByoServerRemoveMcpServerMutation = {
  __typename?: 'Mutation';
  removeMCPServer: { __typename?: 'MCPServer'; _id: any };
};

export type GetMcpServersQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  availableForTypes?: InputMaybe<Array<McpServerAccessAvailableFor>>;
}>;

export type GetMcpServersQuery = {
  __typename?: 'Query';
  mcpServers: Array<{
    __typename?: 'MCPServer';
    _id: any;
    name: string;
    status: McpServerStatus;
    createdAt: any;
    updatedAt: any;
    org: {
      __typename?: 'Org';
      _id: any;
      slug: string;
      featureSwitchOverrides: any;
      status: OrgStatus;
    };
    accessConfig: {
      __typename?: 'MCPServerAccessConfig';
      availableFor: Array<McpServerAccessAvailableFor>;
      isPersonalConnectionEnabled?: boolean | null;
    };
  }>;
};

export type GroupAutocompleteQueryVariables = Exact<{
  types: Array<McpAccessPolicyPrincipalType>;
  q?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GroupAutocompleteQuery = {
  __typename?: 'Query';
  accessPolicyPrincipals: {
    __typename?: 'AccessPolicyPrincipalsResponse';
    principals: Array<
      | { __typename: 'Agent' }
      | { __typename: 'Group'; _id: any; displayName: string }
      | { __typename: 'User' }
    >;
  };
};

export type ByoEditDrawerMutationVariables = Exact<{
  input: EditMcpServerInput;
}>;

export type ByoEditDrawerMutation = {
  __typename?: 'Mutation';
  editMcpServer: {
    __typename?: 'MCPServer';
    _id: any;
    name: string;
    description?: string | null;
    status: McpServerStatus;
    config?: any | null;
    accessConfig: {
      __typename?: 'MCPServerAccessConfig';
      availableFor: Array<McpServerAccessAvailableFor>;
      isPersonalConnectionEnabled?: boolean | null;
    };
  };
};

export type ByoStandardAppFormEnableMcpServerMutationVariables = Exact<{
  input: EnableMcpServerInput;
}>;

export type ByoStandardAppFormEnableMcpServerMutation = {
  __typename?: 'Mutation';
  enableMcpServer: {
    __typename?: 'MCPServer';
    _id: any;
    name: string;
    status: McpServerStatus;
    accessConfig: {
      __typename?: 'MCPServerAccessConfig';
      availableFor: Array<McpServerAccessAvailableFor>;
      isPersonalConnectionEnabled?: boolean | null;
    };
  };
};

export type NewManagedServerFragment = {
  __typename: 'MCPServerInstall';
  _id: any;
  displayName: string;
  installed: boolean;
  accessConfig: {
    __typename: 'MCPServerInstallAccessConfig';
    installType: McpServerInstallAccessInstallType;
  };
};

export type PersonalConfigDrawerEnableMcpServerMutationVariables = Exact<{
  input: EnableMcpServerInput;
}>;

export type PersonalConfigDrawerEnableMcpServerMutation = {
  __typename?: 'Mutation';
  enableMcpServer: { __typename?: 'MCPServer'; _id: any };
};

export type PersonalConfigDrawerEditMcpServerMutationVariables = Exact<{
  input: EditMcpServerInput;
}>;

export type PersonalConfigDrawerEditMcpServerMutation = {
  __typename?: 'Mutation';
  editMcpServer: { __typename?: 'MCPServer'; _id: any };
};

export type GetPersonalCreateDrawerMcpServerQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type GetPersonalCreateDrawerMcpServerQuery = {
  __typename?: 'Query';
  mcpServer?: {
    __typename?: 'MCPServer';
    _id: any;
    name: string;
    serverInfo:
      | {
          __typename: 'CustomMCPServerInfo';
          authenticationType?: McpServerAuthenticationType | null;
          installConfig?: {
            __typename?: 'MCPServerInfoConfigSchema';
            required: Array<string>;
            properties: any;
          } | null;
          source:
            | { __typename: 'CustomDynamicRemoteUrlSource' }
            | {
                __typename: 'CustomRemoteUrlSource';
                sourceType: McpServerSourceType;
                mcpServerUrl: string;
                isOnPrem?: boolean | null;
                deployment?: {
                  __typename?: 'Deployment';
                  origin: string;
                } | null;
              };
        }
      | {
          __typename: 'MCPServerInfo';
          authenticationType?: McpServerAuthenticationType | null;
          serverId: McpServerId;
          instructions?: {
            __typename?: 'MCPServerInfoInstructions';
            installSetupInstructions?: string | null;
          } | null;
          installConfig?: {
            __typename?: 'MCPServerInfoConfigSchema';
            required: Array<string>;
            properties: any;
          } | null;
          source:
            | { __typename: 'NatomaDynamicRemoteUrlSource' }
            | {
                __typename: 'NatomaLocalPackageSource';
                sourceType: McpServerSourceType;
              }
            | {
                __typename: 'NatomaLocalUrlSource';
                sourceType: McpServerSourceType;
              }
            | {
                __typename: 'NatomaRemoteUrlSource';
                sourceType: McpServerSourceType;
              }
            | {
                __typename: 'NatomaRepositorySource';
                sourceType: McpServerSourceType;
              };
        };
  } | null;
};

export type GetPersonalCreateDrawerMcpServerInstallQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type GetPersonalCreateDrawerMcpServerInstallQuery = {
  __typename?: 'Query';
  mcpServerInstall?: {
    __typename?: 'MCPServerInstall';
    _id: any;
    displayName: string;
    server: {
      __typename?: 'MCPServer';
      _id: any;
      name: string;
      serverInfo:
        | {
            __typename: 'CustomMCPServerInfo';
            authenticationType?: McpServerAuthenticationType | null;
            installConfig?: {
              __typename?: 'MCPServerInfoConfigSchema';
              required: Array<string>;
              properties: any;
            } | null;
            source:
              | { __typename: 'CustomDynamicRemoteUrlSource' }
              | {
                  __typename: 'CustomRemoteUrlSource';
                  sourceType: McpServerSourceType;
                  mcpServerUrl: string;
                  isOnPrem?: boolean | null;
                  deployment?: {
                    __typename?: 'Deployment';
                    origin: string;
                  } | null;
                };
          }
        | {
            __typename: 'MCPServerInfo';
            authenticationType?: McpServerAuthenticationType | null;
            serverId: McpServerId;
            instructions?: {
              __typename?: 'MCPServerInfoInstructions';
              installSetupInstructions?: string | null;
            } | null;
            installConfig?: {
              __typename?: 'MCPServerInfoConfigSchema';
              required: Array<string>;
              properties: any;
            } | null;
            source:
              | { __typename: 'NatomaDynamicRemoteUrlSource' }
              | {
                  __typename: 'NatomaLocalPackageSource';
                  sourceType: McpServerSourceType;
                }
              | {
                  __typename: 'NatomaLocalUrlSource';
                  sourceType: McpServerSourceType;
                }
              | {
                  __typename: 'NatomaRemoteUrlSource';
                  sourceType: McpServerSourceType;
                }
              | {
                  __typename: 'NatomaRepositorySource';
                  sourceType: McpServerSourceType;
                };
          };
    };
    accessConfig: {
      __typename?: 'MCPServerInstallAccessConfig';
      installType: McpServerInstallAccessInstallType;
    };
  } | null;
};

export type NewApiKeyFragment = {
  __typename: 'Credential';
  _id: any;
  displayName?: string | null;
  lastUsed?: any | null;
  createdAt: any;
  credentialId: string;
  preview: string;
  status: CredentialStatus;
};

export type GetMcpServersForProfileQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetMcpServersForProfileQuery = {
  __typename?: 'Query';
  mcpServers: Array<{
    __typename?: 'MCPServer';
    _id: any;
    name: string;
    accessConfig: {
      __typename?: 'MCPServerAccessConfig';
      availableFor: Array<McpServerAccessAvailableFor>;
      isPersonalConnectionEnabled?: boolean | null;
    };
    availableTools: Array<{
      __typename?: 'MCPServerTool';
      name: string;
      description?: string | null;
    }>;
    managedInstalls: Array<{
      __typename?: 'MCPServerToInstallObject';
      id: any;
      displayName: string;
      availableTools: Array<{
        __typename?: 'MCPServerTool';
        name: string;
        description?: string | null;
      }>;
    }>;
  }>;
};

export type NewAccessControlRateLimitFragment = {
  __typename: 'AccessControlRateLimit';
  _id: any;
  name: string;
  status: AccessControlStatus;
  type: AccessControlType;
  updatedAt: any;
  createdAt: any;
  rateLimit: {
    __typename: 'RateLimit';
    _id: any;
    name: string;
    status: RateLimitStatus;
    target: {
      __typename?: 'RateLimitTarget';
      type: RateLimitTargetType;
      details?: { __typename?: 'MCPServer'; _id: any; name: string } | null;
    };
    window: {
      __typename?: 'RateLimitWindow';
      unit: RateLimitWindowUnit;
      amount: number;
    };
  };
};

export type NewTunnelFragment = {
  __typename: 'Tunnel';
  _id: any;
  displayName: string;
  status: TunnelStatus;
  connectionStatus: TunnelConnectionStatus;
  url?: string | null;
  metadata: {
    __typename: 'TunnelMetadata';
    lastHeartbeatAt?: any | null;
    tunnelVersion?: string | null;
    tunnelAuthStrategy?: TunnelAuthStrategy | null;
  };
};

export type ChangeUserRoleMutationVariables = Exact<{
  userId: Scalars['ObjectID']['input'];
  role: UserRole;
}>;

export type ChangeUserRoleMutation = {
  __typename?: 'Mutation';
  changeUserRole: {
    __typename?: 'User';
    _id: any;
    displayName?: string | null;
    email: string;
    status: UserStatus;
    role: UserRole;
    org: { __typename?: 'Org'; _id: any };
  };
};

export type CopyMcpProfileToPersonalMutationVariables = Exact<{
  profileId: Scalars['ObjectID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  setSelectedProfile?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CopyMcpProfileToPersonalMutation = {
  __typename?: 'Mutation';
  copyMCPProfileToPersonal: {
    __typename?: 'MCPProfile';
    _id: any;
    name?: string | null;
    type: McpProfileType;
  };
};

export type CreateAgentMutationVariables = Exact<{
  input: CreateAgentInput;
}>;

export type CreateAgentMutation = {
  __typename?: 'Mutation';
  createAgent?: {
    __typename?: 'Agent';
    _id: string;
    displayName: string;
    createdAt: any;
    updatedAt: any;
    owner: {
      __typename?: 'User';
      _id: any;
      email: string;
      displayName?: string | null;
    };
    createdBy: {
      __typename?: 'User';
      _id: any;
      email: string;
      displayName?: string | null;
    };
  } | null;
};

export type CreateCoreDeploymentMutationVariables = Exact<{
  origin: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateCoreDeploymentMutation = {
  __typename?: 'Mutation';
  createCoreDeployment: {
    __typename?: 'CoreDeploymentResponse';
    credential: {
      __typename?: 'CredentialCreatedResponse';
      _id: any;
      status: CredentialStatus;
      secret: string;
      credentialId: string;
    };
    deployment: {
      __typename?: 'Deployment';
      _id: any;
      status: DeploymentStatus;
      displayName: string;
      origin: string;
      createdAt: any;
      updatedAt: any;
      polledAt?: any | null;
      health: string;
      createdBy: {
        __typename?: 'User';
        _id: any;
        displayName?: string | null;
        email: string;
      };
      updatedBy: {
        __typename?: 'User';
        _id: any;
        displayName?: string | null;
        email: string;
      };
    };
  };
};

export type CreateCredentialMutationVariables = Exact<{
  input: CreateCredentialInput;
}>;

export type CreateCredentialMutation = {
  __typename?: 'Mutation';
  createCredential: {
    __typename?: 'CredentialCreatedResponse';
    _id: any;
    type: CredentialTypes;
    preview: string;
    credentialId: string;
    secret: string;
    displayName?: string | null;
    createdAt: any;
    status: CredentialStatus;
    lastUsed?: any | null;
  };
};

export type CreateIngestJobMutationVariables = Exact<{
  input: CreateIngestJobInput;
}>;

export type CreateIngestJobMutation = {
  __typename?: 'Mutation';
  createIngestJob: {
    __typename?: 'Job';
    _id: any;
    completedAt?: any | null;
    queuedAt: any;
    startedAt?: any | null;
    status: JobStatus;
    type: JobType;
    triggeredBy?: { __typename?: 'User'; _id: any } | null;
  };
};

export type CreateJobChainMutationVariables = Exact<{
  input: CreateJobChainInput;
}>;

export type CreateJobChainMutation = {
  __typename?: 'Mutation';
  createJobChain: Array<{
    __typename?: 'Job';
    _id: any;
    completedAt?: any | null;
    queuedAt: any;
    startedAt?: any | null;
    status: JobStatus;
    type: JobType;
    triggeredBy?: { __typename?: 'User'; _id: any } | null;
  }>;
};

export type CreateMcpProfileMutationVariables = Exact<{
  name: Scalars['String']['input'];
  installationConfigs: Array<InstallationConfigInput>;
  setSelectedProfile?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CreateMcpProfileMutation = {
  __typename?: 'Mutation';
  createMCPProfile: {
    __typename?: 'MCPProfile';
    _id: any;
    name?: string | null;
    type: McpProfileType;
  };
};

export type CreateMcpProfileTemplateMutationVariables = Exact<{
  displayName: Scalars['String']['input'];
  installationConfigs: Array<TemplateInstallationConfigInput>;
}>;

export type CreateMcpProfileTemplateMutation = {
  __typename?: 'Mutation';
  createMCPProfileTemplate: {
    __typename?: 'MCPProfileTemplate';
    _id: any;
    displayName: string;
    installationConfigs: Array<{
      __typename?: 'InstallationConfig';
      enabledTools: Array<string>;
      installType: McpServerInstallAccessInstallType;
      server: { __typename?: 'MCPServer'; _id: any; name: string };
      installation?: {
        __typename?: 'MCPServerInstall';
        _id: any;
        displayName: string;
      } | null;
    }>;
  };
};

export type CreateOAuthMcpServerInstallMutationVariables = Exact<{
  input: CreateOAuthMcpServerInstallInput;
}>;

export type CreateOAuthMcpServerInstallMutation = {
  __typename?: 'Mutation';
  createOAuthMcpServerInstall: { __typename?: 'MCPServerInstall'; _id: any };
};

export type CreateOrUpdateAccessPolicyMutationVariables = Exact<{
  input: CreateOrUpdateAccessPolicyInput;
}>;

export type CreateOrUpdateAccessPolicyMutation = {
  __typename?: 'Mutation';
  createOrUpdateAccessPolicy: {
    __typename?: 'MCPAccessPolicy';
    _id: any;
    name: string;
    status: McpAccessPolicyStatus;
    actionType: PolicyActionType;
    effect?: PolicyEffectType | null;
    updatedAt: any;
    createdAt: any;
    isDeprecated: boolean;
    targetConfigs: Array<{
      __typename?: 'MCPAccessPolicyTarget';
      tools: Array<string>;
      allTools: boolean;
      totalInstalls: number;
      installationScope: InstallationScope;
      server: {
        __typename?: 'MCPServer';
        _id: any;
        name: string;
        availableTools: Array<{
          __typename?: 'MCPServerTool';
          name: string;
          description?: string | null;
        }>;
      };
    }>;
  };
};

export type CreateOrUpdateMcpServerInstallMutationVariables = Exact<{
  mcpServerId?: InputMaybe<Scalars['ObjectID']['input']>;
  serverId?: InputMaybe<McpServerId>;
  displayName: Scalars['String']['input'];
  installType: McpServerInstallAccessInstallType;
  authCredentials?: InputMaybe<Scalars['ServerInstallationCredsMap']['input']>;
  mcpServerInstallId?: InputMaybe<Scalars['ObjectID']['input']>;
  ownerId?: InputMaybe<Scalars['ObjectID']['input']>;
  actorType?: InputMaybe<InstalledForActorType>;
  shouldEnable?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CreateOrUpdateMcpServerInstallMutation = {
  __typename?: 'Mutation';
  createOrUpdateServerInstall: {
    __typename?: 'MCPServerInstall';
    _id: any;
    displayName: string;
    server: { __typename?: 'MCPServer'; _id: any; name: string };
    accessConfig: {
      __typename?: 'MCPServerInstallAccessConfig';
      installType: McpServerInstallAccessInstallType;
    };
  };
};

export type CreateServiceFromIntegrationMutationVariables = Exact<{
  input: CreateIntegrationInput;
}>;

export type CreateServiceFromIntegrationMutation = {
  __typename?: 'Mutation';
  createServiceFromIntegration: {
    __typename?: 'Service';
    _id: any;
    status: ServiceStatus;
    integration?:
      | { __typename: 'CrowdStrikeIntegration'; status: IntegrationStatus }
      | { __typename: 'DatadogOtlpIntegration'; status: IntegrationStatus }
      | {
          __typename: 'ElasticsearchOtlpIntegration';
          status: IntegrationStatus;
        }
      | { __typename: 'JamfIntegration'; status: IntegrationStatus }
      | { __typename: 'NewRelicOtlpIntegration'; status: IntegrationStatus }
      | { __typename: 'ObserveOtlpIntegration'; status: IntegrationStatus }
      | { __typename: 'OpenTelemetryIntegration'; status: IntegrationStatus }
      | { __typename: 'SentinelOneIntegration'; status: IntegrationStatus }
      | { __typename: 'SplunkHecIntegration'; status: IntegrationStatus }
      | null;
  };
};

export type CreateTunnelMutationVariables = Exact<{
  displayName: Scalars['String']['input'];
}>;

export type CreateTunnelMutation = {
  __typename?: 'Mutation';
  createTunnel: {
    __typename?: 'CreateTunnelResponse';
    _id: any;
    displayName: string;
    status: TunnelStatus;
    connectionStatus: TunnelConnectionStatus;
    tunnelKey: {
      __typename?: 'CredentialCreatedResponse';
      _id: any;
      secret: string;
    };
    metadata: {
      __typename?: 'TunnelMetadata';
      lastHeartbeatAt?: any | null;
      tunnelVersion?: string | null;
      tunnelAuthStrategy?: TunnelAuthStrategy | null;
    };
  };
};

export type DeleteAccessPolicyMutationVariables = Exact<{
  input: DeleteAccessPolicyInput;
}>;

export type DeleteAccessPolicyMutation = {
  __typename?: 'Mutation';
  deleteAccessPolicy?: { __typename?: 'MCPAccessPolicy'; _id: any } | null;
};

export type DeleteAgentMutationVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type DeleteAgentMutation = {
  __typename?: 'Mutation';
  deleteAgent?: {
    __typename?: 'Agent';
    _id: string;
    displayName: string;
  } | null;
};

export type DeleteServiceIntegrationMutationVariables = Exact<{
  _id: Scalars['ObjectID']['input'];
}>;

export type DeleteServiceIntegrationMutation = {
  __typename?: 'Mutation';
  deleteServiceIntegration?: {
    __typename?: 'DeleteResult';
    _id?: string | null;
    type?: string | null;
  } | null;
};

export type DeleteMcpProfileMutationVariables = Exact<{
  profileId: Scalars['ObjectID']['input'];
}>;

export type DeleteMcpProfileMutation = {
  __typename?: 'Mutation';
  deleteMCPProfile: boolean;
};

export type DeleteRateLimitMutationVariables = Exact<{
  _id: Scalars['ObjectID']['input'];
}>;

export type DeleteRateLimitMutation = {
  __typename?: 'Mutation';
  deleteRateLimit?: { __typename?: 'RateLimit'; _id: any } | null;
};

export type DeleteTunnelMutationVariables = Exact<{
  tunnelId: Scalars['ObjectID']['input'];
}>;

export type DeleteTunnelMutation = {
  __typename?: 'Mutation';
  deleteTunnel: { __typename?: 'Tunnel'; _id: any; status: TunnelStatus };
};

export type DeleteUserMutationVariables = Exact<{
  _id: Scalars['ObjectID']['input'];
}>;

export type DeleteUserMutation = {
  __typename?: 'Mutation';
  deleteUser: {
    __typename?: 'User';
    _id: any;
    displayName?: string | null;
    email: string;
    status: UserStatus;
    role: UserRole;
    org: { __typename?: 'Org'; _id: any };
  };
};

export type OrgRegistrationFieldsFragment = {
  __typename?: 'Org';
  _id: any;
  displayName?: string | null;
  slug: string;
  status: OrgStatus;
};

export type UserRegistrationFieldsFragment = {
  __typename?: 'User';
  _id: any;
  email: string;
  displayName?: string | null;
  status: UserStatus;
  org: { __typename?: 'Org'; _id: any };
};

export type InviteUserMutationVariables = Exact<{
  input: InviteUserInput;
}>;

export type InviteUserMutation = {
  __typename?: 'Mutation';
  inviteUser: {
    __typename?: 'User';
    _id: any;
    email: string;
    displayName?: string | null;
    status: UserStatus;
    role: UserRole;
    org: { __typename?: 'Org'; _id: any };
  };
};

export type MarkUserConfigSeenMutationVariables = Exact<{
  [key: string]: never;
}>;

export type MarkUserConfigSeenMutation = {
  __typename?: 'Mutation';
  markUserConfigSeen: {
    __typename?: 'User';
    _id: any;
    shouldPingMcpConfig?: boolean | null;
  };
};

export type RegisterMutationVariables = Exact<{
  displayName?: InputMaybe<Scalars['String']['input']>;
  orgDisplayName?: InputMaybe<Scalars['String']['input']>;
  registrationCode?: InputMaybe<Scalars['String']['input']>;
}>;

export type RegisterMutation = {
  __typename?: 'Mutation';
  register: {
    __typename?: 'MeResponse';
    currentOrg?: {
      __typename?: 'Org';
      _id: any;
      displayName?: string | null;
      slug: string;
      status: OrgStatus;
    } | null;
    currentUser?: {
      __typename?: 'User';
      _id: any;
      email: string;
      displayName?: string | null;
      status: UserStatus;
      org: { __typename?: 'Org'; _id: any };
    } | null;
  };
};

export type DeleteMcpServerInstallMutationVariables = Exact<{
  input: GetByIdMcpServerInstallInput;
}>;

export type DeleteMcpServerInstallMutation = {
  __typename?: 'Mutation';
  deleteMCPServerInstall: {
    __typename?: 'MCPServerInstall';
    _id: any;
    accessConfig: {
      __typename?: 'MCPServerInstallAccessConfig';
      installType: McpServerInstallAccessInstallType;
    };
  };
};

export type RemoveSelectedMcpProfileForUserMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RemoveSelectedMcpProfileForUserMutation = {
  __typename?: 'Mutation';
  removeSelectedMCPProfileForUser: boolean;
};

export type RequestMcpServerTemplateMutationVariables = Exact<{
  appName: Scalars['String']['input'];
  additionalContext?: InputMaybe<Scalars['String']['input']>;
}>;

export type RequestMcpServerTemplateMutation = {
  __typename?: 'Mutation';
  requestMCPServerTemplate?: {
    __typename?: 'Notification';
    _id?: any | null;
    status?: NotificationStatus | null;
  } | null;
};

export type SetSelectedMcpProfileForUserMutationVariables = Exact<{
  profileId: Scalars['ObjectID']['input'];
}>;

export type SetSelectedMcpProfileForUserMutation = {
  __typename?: 'Mutation';
  setSelectedMCPProfileForUser: boolean;
};

export type UpdateAccessPolicyMutationVariables = Exact<{
  input: UpdateAccessPolicyInput;
}>;

export type UpdateAccessPolicyMutation = {
  __typename?: 'Mutation';
  updateAccessPolicy: {
    __typename?: 'MCPAccessPolicy';
    _id: any;
    status: McpAccessPolicyStatus;
  };
};

export type UpdateAgentMutationVariables = Exact<{
  input: UpdateAgentInput;
}>;

export type UpdateAgentMutation = {
  __typename?: 'Mutation';
  updateAgent?: {
    __typename?: 'Agent';
    _id: string;
    displayName: string;
    createdAt: any;
    updatedAt: any;
    owner: {
      __typename?: 'User';
      _id: any;
      email: string;
      displayName?: string | null;
    };
    createdBy: {
      __typename?: 'User';
      _id: any;
      email: string;
      displayName?: string | null;
    };
  } | null;
};

export type UpdateCredentialStatusMutationVariables = Exact<{
  input: UpdateCredentialStatusInput;
}>;

export type UpdateCredentialStatusMutation = {
  __typename?: 'Mutation';
  updateCredentialStatus: {
    __typename?: 'Credential';
    _id: any;
    status: CredentialStatus;
  };
};

export type UpdateDeploymentMutationVariables = Exact<{
  input: UpdateDeploymentInput;
}>;

export type UpdateDeploymentMutation = {
  __typename?: 'Mutation';
  updateDeployment: {
    __typename?: 'Deployment';
    _id: any;
    status: DeploymentStatus;
    displayName: string;
    origin: string;
    updatedAt: any;
    updatedBy: {
      __typename?: 'User';
      _id: any;
      displayName?: string | null;
      email: string;
    };
  };
};

export type UpdateMcpProfileTemplateMutationVariables = Exact<{
  templateId: Scalars['ObjectID']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  installationConfigs?: InputMaybe<Array<TemplateInstallationConfigInput>>;
}>;

export type UpdateMcpProfileTemplateMutation = {
  __typename?: 'Mutation';
  updateMCPProfileTemplate: {
    __typename?: 'MCPProfileTemplate';
    _id: any;
    displayName: string;
    installationConfigs: Array<{
      __typename?: 'InstallationConfig';
      enabledTools: Array<string>;
      installType: McpServerInstallAccessInstallType;
      allToolsEnabled?: boolean | null;
      server: { __typename?: 'MCPServer'; _id: any; name: string };
      installation?: {
        __typename?: 'MCPServerInstall';
        _id: any;
        displayName: string;
      } | null;
    }>;
  };
};

export type UpdateMcpServerInstallMutationVariables = Exact<{
  input: UpdateMcpServerInstallInput;
}>;

export type UpdateMcpServerInstallMutation = {
  __typename?: 'Mutation';
  updateMCPServerInstall: {
    __typename?: 'MCPServerInstall';
    _id: any;
    displayName: string;
  };
};

export type UpdateOAuthMcpServerInstallMutationVariables = Exact<{
  input: UpdateOAuthMcpServerInstallInput;
}>;

export type UpdateOAuthMcpServerInstallMutation = {
  __typename?: 'Mutation';
  updateOAuthMcpServerInstall: { __typename?: 'MCPServerInstall'; _id: any };
};

export type UpdateOrgMutationVariables = Exact<{
  input: OrgUpdateBody;
}>;

export type UpdateOrgMutation = {
  __typename?: 'Mutation';
  updateOrg: {
    __typename?: 'Org';
    _id: any;
    displayName?: string | null;
    slug: string;
    status: OrgStatus;
    onboarding?: { __typename?: 'Onboarding'; connectedIDP: boolean } | null;
    authServer?: {
      __typename?: 'OrgAuthServer';
      enabled: boolean;
      url?: string | null;
      audiences?: Array<string> | null;
    } | null;
  };
};

export type UpdateOrgNotificationsSettingsMutationVariables = Exact<{
  input?: InputMaybe<OrgNotificationsSettingsBody>;
}>;

export type UpdateOrgNotificationsSettingsMutation = {
  __typename?: 'Mutation';
  updateOrgNotificationsSettings: {
    __typename?: 'Org';
    _id: any;
    notifications?: {
      __typename?: 'OrgNotifications';
      sender: string;
      smtpHost: string;
      smtpPort: SmtpPort;
    } | null;
  };
};

export type UpdateOrgSamlConfigMutationVariables = Exact<{
  input: OrgUpdateSamlConfigInput;
}>;

export type UpdateOrgSamlConfigMutation = {
  __typename?: 'Mutation';
  updateOrgSamlConfig: {
    __typename?: 'OrgSamlConfig';
    enabled: boolean;
    idpMetadata?: {
      __typename?: 'OrgSamlConfigIdpMetadata';
      metadataUrl?: string | null;
      entityId?: string | null;
      ssoUrl?: string | null;
      idpSigningCertificate?: string | null;
    } | null;
    spMetadata?: {
      __typename?: 'OrgSamlConfigSpMetadata';
      entityId: string;
      acsUrl: string;
      wantAssertionsSigned: boolean;
      wantAuthnResponseSigned: boolean;
    } | null;
  };
};

export type UpdateOrgScimConfigMutationVariables = Exact<{
  input: OrgUpdateScimConfigInput;
}>;

export type UpdateOrgScimConfigMutation = {
  __typename?: 'Mutation';
  updateOrgScimConfig: {
    __typename?: 'OrgScimConfig';
    enabled: boolean;
    scimProvisioningToken?:
      | { __typename?: 'Credential' }
      | {
          __typename?: 'CredentialCreatedResponse';
          preview: string;
          secret: string;
          status: CredentialStatus;
          type: CredentialTypes;
        }
      | null;
  };
};

export type UpdateOrgSettingsMutationVariables = Exact<{
  input: OrgSettingsInput;
}>;

export type UpdateOrgSettingsMutation = {
  __typename?: 'Mutation';
  updateOrgSettings: {
    __typename?: 'Org';
    _id: any;
    slug: string;
    displayName?: string | null;
    settings?: {
      __typename?: 'OrgSettings';
      disableApiKeyUsage: boolean;
      disableAllowAllPolicy: boolean;
    } | null;
  };
};

export type UpdateShadowMcpServersMutationVariables = Exact<{
  input: UpdateShadowMcpServersInput;
}>;

export type UpdateShadowMcpServersMutation = {
  __typename?: 'Mutation';
  updateShadowMCPServers: number;
};

export type UpdateTunnelStatusMutationVariables = Exact<{
  tunnelId: Scalars['ObjectID']['input'];
  status: TunnelStatus;
}>;

export type UpdateTunnelStatusMutation = {
  __typename?: 'Mutation';
  setTunnelStatus: { __typename?: 'Tunnel'; _id: any; status: TunnelStatus };
};

export type UpsertRateLimitMutationVariables = Exact<{
  input: UpsertRateLimitInput;
}>;

export type UpsertRateLimitMutation = {
  __typename?: 'Mutation';
  upsertRateLimit?: {
    __typename?: 'RateLimit';
    _id: any;
    name: string;
    status: RateLimitStatus;
    action: RateLimitAction;
    updatedAt: any;
    createdAt: any;
    target: {
      __typename?: 'RateLimitTarget';
      type: RateLimitTargetType;
      details?: { __typename?: 'MCPServer'; _id: any; name: string } | null;
    };
    window: {
      __typename?: 'RateLimitWindow';
      unit: RateLimitWindowUnit;
      amount: number;
    };
  } | null;
};

export type CurrentOrgFieldsFragment = {
  __typename?: 'Org';
  _id: any;
  slug: string;
  displayName?: string | null;
  status: OrgStatus;
  featureSwitchOverrides: any;
  enabledFeatures?: Array<BillingFeatureId> | null;
  enabledMcpClients?: Array<McpClientType> | null;
  onboarding?: { __typename?: 'Onboarding'; connectedIDP: boolean } | null;
  settings?: {
    __typename?: 'OrgSettings';
    disableApiKeyUsage: boolean;
    disableAllowAllPolicy: boolean;
  } | null;
  notifications?: {
    __typename?: 'OrgNotifications';
    sender: string;
    smtpHost: string;
    smtpPort: SmtpPort;
  } | null;
  authServer?: {
    __typename?: 'OrgAuthServer';
    enabled: boolean;
    url?: string | null;
    audiences?: Array<string> | null;
  } | null;
};

export type CurrentUserFieldsFragment = {
  __typename?: 'User';
  _id: any;
  email: string;
  displayName?: string | null;
  status: UserStatus;
  role: UserRole;
  shouldPingMcpConfig?: boolean | null;
  selectedProfile?: {
    __typename?: 'MCPProfile';
    _id: any;
    name?: string | null;
    slug?: string | null;
    isSystemDefault?: boolean | null;
    mcpUrl: string;
    type: McpProfileType;
    installationConfigs: Array<{
      __typename?: 'ProfileInstallationConfig';
      enabledTools: Array<string>;
      server: {
        __typename?: 'MCPServer';
        _id: any;
        name: string;
        templateSlug?: string | null;
      };
    }>;
  } | null;
};

export type IngestJobFieldsFragment = {
  __typename?: 'Job';
  _id: any;
  completedAt?: any | null;
  queuedAt: any;
  startedAt?: any | null;
  status: JobStatus;
  type: JobType;
  error?: string | null;
  missingScopes?: Array<string> | null;
  triggeredBy?: { __typename?: 'User'; _id: any } | null;
  org: { __typename?: 'Org'; _id: any };
  context?: {
    __typename?: 'JobContext';
    type?: JobContextType | null;
    ref?: any | null;
    service?: {
      __typename?: 'Service';
      _id: any;
      displayName: string;
      integration?:
        | {
            __typename?: 'CrowdStrikeIntegration';
            integrationId: IntegrationId;
            description?: string | null;
          }
        | {
            __typename?: 'DatadogOtlpIntegration';
            integrationId: IntegrationId;
            description?: string | null;
          }
        | {
            __typename?: 'ElasticsearchOtlpIntegration';
            integrationId: IntegrationId;
            description?: string | null;
          }
        | {
            __typename?: 'JamfIntegration';
            integrationId: IntegrationId;
            description?: string | null;
          }
        | {
            __typename?: 'NewRelicOtlpIntegration';
            integrationId: IntegrationId;
            description?: string | null;
          }
        | {
            __typename?: 'ObserveOtlpIntegration';
            integrationId: IntegrationId;
            description?: string | null;
          }
        | {
            __typename?: 'OpenTelemetryIntegration';
            integrationId: IntegrationId;
            description?: string | null;
          }
        | {
            __typename?: 'SentinelOneIntegration';
            integrationId: IntegrationId;
            description?: string | null;
          }
        | {
            __typename?: 'SplunkHecIntegration';
            integrationId: IntegrationId;
            description?: string | null;
          }
        | null;
    } | null;
  } | null;
  processingMetadata?: {
    __typename?: 'IngestJobProcessingMetadata';
    processedIdentities?: number | null;
    expectedIdentities?: number | null;
  } | null;
};

export type PrincipalTreeFieldsL1Fragment = {
  __typename?: 'MCPAccessPolicyPrincipalTreeNode';
  op?: McpAccessPolicyPrincipalOp | null;
  rootType?: McpAccessPolicyPrincipalRootType | null;
  nodes?: Array<{
    __typename?: 'MCPAccessPolicyPrincipalTreeNode';
    op?: McpAccessPolicyPrincipalOp | null;
    type?: McpAccessPolicyPrincipalType | null;
    userId?: any | null;
    agentId?: any | null;
    role?: UserRole | null;
    groupId?: any | null;
    profile?: {
      __typename?: 'MCPAccessPolicyPrincipalProfile';
      key?: string | null;
      matcher?: string | null;
      value?: any | null;
    } | null;
    nodes?: Array<{
      __typename?: 'MCPAccessPolicyPrincipalTreeNode';
      op?: McpAccessPolicyPrincipalOp | null;
      type?: McpAccessPolicyPrincipalType | null;
      userId?: any | null;
      agentId?: any | null;
      role?: UserRole | null;
      groupId?: any | null;
      profile?: {
        __typename?: 'MCPAccessPolicyPrincipalProfile';
        key?: string | null;
        matcher?: string | null;
        value?: any | null;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type PrincipalTreeFieldsL2Fragment = {
  __typename?: 'MCPAccessPolicyPrincipalTreeNode';
  op?: McpAccessPolicyPrincipalOp | null;
  type?: McpAccessPolicyPrincipalType | null;
  userId?: any | null;
  agentId?: any | null;
  role?: UserRole | null;
  groupId?: any | null;
  profile?: {
    __typename?: 'MCPAccessPolicyPrincipalProfile';
    key?: string | null;
    matcher?: string | null;
    value?: any | null;
  } | null;
  nodes?: Array<{
    __typename?: 'MCPAccessPolicyPrincipalTreeNode';
    op?: McpAccessPolicyPrincipalOp | null;
    type?: McpAccessPolicyPrincipalType | null;
    userId?: any | null;
    agentId?: any | null;
    role?: UserRole | null;
    groupId?: any | null;
    profile?: {
      __typename?: 'MCPAccessPolicyPrincipalProfile';
      key?: string | null;
      matcher?: string | null;
      value?: any | null;
    } | null;
  } | null> | null;
};

export type PrincipalTreeFieldsLeafFragment = {
  __typename?: 'MCPAccessPolicyPrincipalTreeNode';
  op?: McpAccessPolicyPrincipalOp | null;
  type?: McpAccessPolicyPrincipalType | null;
  userId?: any | null;
  agentId?: any | null;
  role?: UserRole | null;
  groupId?: any | null;
  profile?: {
    __typename?: 'MCPAccessPolicyPrincipalProfile';
    key?: string | null;
    matcher?: string | null;
    value?: any | null;
  } | null;
};

export type GetAccessControlsQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<AccessControlType>>;
  sort?: InputMaybe<AccessControlSort>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetAccessControlsQuery = {
  __typename?: 'Query';
  accessControls: Array<
    | {
        __typename?: 'AccessControlPolicy';
        _id: any;
        type: AccessControlType;
        name: string;
        status: AccessControlStatus;
        updatedAt: any;
        createdAt: any;
        policy: {
          __typename?: 'MCPAccessPolicy';
          effect?: PolicyEffectType | null;
          isDeprecated: boolean;
          targetConfigs: Array<{
            __typename?: 'MCPAccessPolicyTarget';
            allTools: boolean;
            installationScope: InstallationScope;
            totalInstalls: number;
            tools: Array<string>;
          }>;
        };
      }
    | {
        __typename?: 'AccessControlRateLimit';
        _id: any;
        type: AccessControlType;
        name: string;
        status: AccessControlStatus;
        updatedAt: any;
        createdAt: any;
        rateLimit: {
          __typename?: 'RateLimit';
          target: {
            __typename?: 'RateLimitTarget';
            type: RateLimitTargetType;
            details?: {
              __typename?: 'MCPServer';
              _id: any;
              name: string;
            } | null;
          };
          window: {
            __typename?: 'RateLimitWindow';
            unit: RateLimitWindowUnit;
            amount: number;
          };
        };
      }
  >;
};

export type GetAccessPoliciesQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AccessPolicySort>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetAccessPoliciesQuery = {
  __typename?: 'Query';
  accessPolicies: Array<{
    __typename?: 'MCPAccessPolicy';
    _id: any;
    name: string;
    status: McpAccessPolicyStatus;
    actionType: PolicyActionType;
    effect?: PolicyEffectType | null;
    isDeprecated: boolean;
    targetConfigs: Array<{
      __typename?: 'MCPAccessPolicyTarget';
      allTools: boolean;
      tools: Array<string>;
      totalInstalls: number;
      installationScope: InstallationScope;
    }>;
  }>;
};

export type GetAccessPolicyQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type GetAccessPolicyQuery = {
  __typename?: 'Query';
  accessPolicy: {
    __typename?: 'MCPAccessPolicy';
    _id: any;
    name: string;
    policy: string;
    status: McpAccessPolicyStatus;
    actionType: PolicyActionType;
    effect?: PolicyEffectType | null;
    isDeprecated: boolean;
    contextConditions?: any | null;
    contentValidationRules?: Array<{
      __typename?: 'ContentValidationRule';
      pattern: string;
      contentType: ContentType;
      caseSensitive: boolean;
      description?: string | null;
    } | null> | null;
    principalTree?: {
      __typename?: 'MCPAccessPolicyPrincipalTreeNode';
      op?: McpAccessPolicyPrincipalOp | null;
      rootType?: McpAccessPolicyPrincipalRootType | null;
      nodes?: Array<{
        __typename?: 'MCPAccessPolicyPrincipalTreeNode';
        op?: McpAccessPolicyPrincipalOp | null;
        type?: McpAccessPolicyPrincipalType | null;
        userId?: any | null;
        agentId?: any | null;
        role?: UserRole | null;
        groupId?: any | null;
        profile?: {
          __typename?: 'MCPAccessPolicyPrincipalProfile';
          key?: string | null;
          matcher?: string | null;
          value?: any | null;
        } | null;
        nodes?: Array<{
          __typename?: 'MCPAccessPolicyPrincipalTreeNode';
          op?: McpAccessPolicyPrincipalOp | null;
          type?: McpAccessPolicyPrincipalType | null;
          userId?: any | null;
          agentId?: any | null;
          role?: UserRole | null;
          groupId?: any | null;
          profile?: {
            __typename?: 'MCPAccessPolicyPrincipalProfile';
            key?: string | null;
            matcher?: string | null;
            value?: any | null;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null;
    targetConfigs: Array<{
      __typename?: 'MCPAccessPolicyTarget';
      allTools: boolean;
      tools: Array<string>;
      installationScope: InstallationScope;
      totalInstalls: number;
      server: {
        __typename?: 'MCPServer';
        _id: any;
        name: string;
        availableTools: Array<{
          __typename?: 'MCPServerTool';
          name: string;
          description?: string | null;
        }>;
      };
      serverInstalls: Array<{ __typename?: 'MCPServerInstall'; _id: any }>;
    }>;
  };
};

export type GetAgentQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type GetAgentQuery = {
  __typename?: 'Query';
  agent?: {
    __typename?: 'Agent';
    _id: string;
    displayName: string;
    createdAt: any;
    updatedAt: any;
    connections: Array<string>;
    connectionsCount: number;
    owner: {
      __typename?: 'User';
      _id: any;
      email: string;
      displayName?: string | null;
    };
    createdBy: {
      __typename?: 'User';
      _id: any;
      email: string;
      displayName?: string | null;
    };
  } | null;
};

export type GetAgentsQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  myAgentsOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetAgentsQuery = {
  __typename?: 'Query';
  agents: Array<{
    __typename?: 'Agent';
    _id: string;
    displayName: string;
    createdAt: any;
    connections: Array<string>;
    connectionsCount: number;
    lastActive?: any | null;
    owner: {
      __typename?: 'User';
      _id: any;
      email: string;
      displayName?: string | null;
    };
  }>;
};

export type GetAuditLogsQueryVariables = Exact<{
  eventTypes?: InputMaybe<Array<AuditEvent>>;
  actorType?: InputMaybe<AuditActorType>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<AuditLogGroupBy>;
  sort?: InputMaybe<AuditLogSort>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetAuditLogsQuery = {
  __typename?: 'Query';
  auditLogs: Array<{
    __typename?: 'AuditLog';
    _id: any;
    timestamp: any;
    event: AuditEvent;
    metadata?: any | null;
    actor: {
      __typename?: 'AuditLogActorDetails';
      type: AuditActorType;
      details?:
        | { __typename: 'Agent'; _id: string; agentDisplayName: string }
        | { __typename: 'User'; email: string; userDisplayName?: string | null }
        | null;
    };
    targets?: Array<{
      __typename?: 'AuditLogTargetDetails';
      type: AuditTargetType;
      ref?: any | null;
      details?:
        | { __typename?: 'Agent'; displayName: string; agentId: string }
        | { __typename?: 'MCPServer'; _id: any; name: string }
        | {
            __typename?: 'MCPServerInstall';
            displayName: string;
            _id: any;
            accessConfig: {
              __typename?: 'MCPServerInstallAccessConfig';
              installType: McpServerInstallAccessInstallType;
            };
          }
        | {
            __typename?: 'User';
            email: string;
            userDisplayName?: string | null;
          }
        | null;
    }> | null;
  }>;
};

export type GetByoRemoteUrlServerQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type GetByoRemoteUrlServerQuery = {
  __typename?: 'Query';
  mcpServer?: {
    __typename?: 'MCPServer';
    _id: any;
    name: string;
    serverInfo:
      | {
          __typename?: 'CustomMCPServerInfo';
          name: string;
          description?: string | null;
          authenticationType?: McpServerAuthenticationType | null;
          source:
            | { __typename?: 'CustomDynamicRemoteUrlSource' }
            | {
                __typename?: 'CustomRemoteUrlSource';
                mcpServerUrl: string;
                isOnPrem?: boolean | null;
                useCustomAuthServer?: boolean | null;
                deployment?: {
                  __typename?: 'Deployment';
                  _id: any;
                  displayName: string;
                } | null;
              };
        }
      | { __typename?: 'MCPServerInfo' };
  } | null;
};

export type GetCredentialsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  type: CredentialTypes;
}>;

export type GetCredentialsQuery = {
  __typename?: 'Query';
  credentials: Array<{
    __typename?: 'Credential';
    _id: any;
    displayName?: string | null;
    lastUsed?: any | null;
    createdAt: any;
    preview: string;
    credentialId: string;
    status: CredentialStatus;
  }>;
};

export type GetDashboardInstallationsByMcpServerQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetDashboardInstallationsByMcpServerQuery = {
  __typename?: 'Query';
  getDashboardInstallationsByMCPServer: Array<{
    __typename?: 'DashboardInstallationsByMCPServer';
    serverName: string;
    personalConnections: number;
    managedConnections: number;
    shadowConnections: number;
  }>;
};

export type GetDashboardMcpServersByToolCallsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetDashboardMcpServersByToolCallsQuery = {
  __typename?: 'Query';
  getDashboardMCPServersByToolCalls: Array<{
    __typename?: 'DashboardMCPServersByToolCalls';
    serverName: string;
    toolCallCount: number;
  }>;
};

export type GetDashboardToolCallsOverTimeQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetDashboardToolCallsOverTimeQuery = {
  __typename?: 'Query';
  getDashboardToolCallsOverTime: Array<{
    __typename?: 'DashboardToolCallsOverTime';
    weekStart: any;
    weekEnd: any;
    successfulCalls: number;
    failedCalls: number;
    totalCalls: number;
  }>;
};

export type GetDashboardUsersByToolCallsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetDashboardUsersByToolCallsQuery = {
  __typename?: 'Query';
  getDashboardUsersByToolCalls: Array<{
    __typename?: 'DashboardUsersByToolCalls';
    toolCallCount: number;
    user: { __typename?: 'User'; displayName?: string | null; email: string };
  }>;
};

export type GetDeploymentsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetDeploymentsQuery = {
  __typename?: 'Query';
  deployments: Array<{
    __typename?: 'Deployment';
    _id: any;
    status: DeploymentStatus;
    displayName: string;
    origin: string;
    createdAt: any;
    updatedAt: any;
    polledAt?: any | null;
    health: string;
    credentials: Array<{
      __typename?: 'Credential';
      _id: any;
      status: CredentialStatus;
      credentialId: string;
    }>;
    createdBy: {
      __typename?: 'User';
      _id: any;
      displayName?: string | null;
      email: string;
    };
    updatedBy: {
      __typename?: 'User';
      _id: any;
      displayName?: string | null;
      email: string;
    };
  }>;
};

export type GetDeploymentsForSelectQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetDeploymentsForSelectQuery = {
  __typename?: 'Query';
  deployments: Array<{
    __typename?: 'Deployment';
    _id: any;
    displayName: string;
    origin: string;
  }>;
};

export type GetEnabledAppsQueryVariables = Exact<{
  personalConnectionStatus: PersonalConnectionStatus;
  q?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetEnabledAppsQuery = {
  __typename?: 'Query';
  enabledApps: Array<{
    __typename?: 'MCPServer';
    _id: any;
    name: string;
    accessConfig: {
      __typename?: 'MCPServerAccessConfig';
      availableFor: Array<McpServerAccessAvailableFor>;
      isPersonalConnectionEnabled?: boolean | null;
    };
  }>;
};

export type GetEnabledInstallsForServerQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  installTypes?: InputMaybe<Array<McpServerInstallAccessInstallType>>;
  server?: InputMaybe<Scalars['ObjectID']['input']>;
}>;

export type GetEnabledInstallsForServerQuery = {
  __typename?: 'Query';
  myMcpServerInstalls: Array<{
    __typename?: 'MCPServerInstall';
    _id: any;
    displayName: string;
    accessConfig: {
      __typename?: 'MCPServerInstallAccessConfig';
      installType: McpServerInstallAccessInstallType;
    };
  }>;
};

export type GetEnabledMcpServersForSelectQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  availableForTypes?: InputMaybe<Array<McpServerAccessAvailableFor>>;
}>;

export type GetEnabledMcpServersForSelectQuery = {
  __typename?: 'Query';
  mcpServers: Array<{ __typename?: 'MCPServer'; _id: any; name: string }>;
};

export type GetGroupQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type GetGroupQuery = {
  __typename?: 'Query';
  group: { __typename?: 'Group'; _id: any; displayName: string };
};

export type GetGroupsQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetGroupsQuery = {
  __typename?: 'Query';
  groups: Array<{ __typename?: 'Group'; _id: any; displayName: string }>;
};

export type GetIdNameMcpServerInstallsQueryVariables = Exact<{
  servers?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  installTypes?: InputMaybe<Array<McpServerInstallAccessInstallType>>;
  q?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
}>;

export type GetIdNameMcpServerInstallsQuery = {
  __typename?: 'Query';
  mcpServerInstalls: Array<{
    __typename?: 'MCPServerInstall';
    _id: any;
    displayName: string;
    server: { __typename?: 'MCPServer'; _id: any };
  }>;
};

export type GetInstallationConfigPropertiesQueryVariables = Exact<{
  templateOrServerInfoSlug: Scalars['String']['input'];
}>;

export type GetInstallationConfigPropertiesQuery = {
  __typename?: 'Query';
  installationConfigProperties: {
    __typename?: 'InstallationConfigProperties';
    serverId?: McpServerId | null;
    server?: { __typename?: 'MCPServer'; _id: any } | null;
    configSchema: {
      __typename?: 'MCPServerInfoConfigSchema';
      required: Array<string>;
      properties: any;
    };
  };
};

export type GetIntegrationCountsQueryVariables = Exact<{
  integrationId?: InputMaybe<IntegrationId>;
}>;

export type GetIntegrationCountsQuery = {
  __typename?: 'Query';
  getIntegrationCounts: Array<{
    __typename?: 'IntegrationCount';
    integrationId: IntegrationId;
    count: number;
  }>;
};

export type LatestJobChainQueryVariables = Exact<{
  serviceId: Scalars['ObjectID']['input'];
  type: JobChainType;
}>;

export type LatestJobChainQuery = {
  __typename?: 'Query';
  latestJobChain?: {
    __typename?: 'JobChain';
    _id: any;
    startedAt?: any | null;
    completedAt?: any | null;
    status: JobStatus;
    error?: string | null;
    missingScopes?: Array<string> | null;
  } | null;
};

export type GetMcpProfilesQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetMcpProfilesQuery = {
  __typename?: 'Query';
  mcpProfiles: Array<{
    __typename?: 'MCPProfile';
    _id: any;
    type: McpProfileType;
    name?: string | null;
    isSystemDefault?: boolean | null;
  }>;
};

export type GetMcpProfileQueryVariables = Exact<{
  profileId: Scalars['ObjectID']['input'];
}>;

export type GetMcpProfileQuery = {
  __typename?: 'Query';
  mcpProfile?: {
    __typename?: 'MCPProfile';
    _id: any;
    type: McpProfileType;
    name?: string | null;
    installationConfigs: Array<{
      __typename?: 'ProfileInstallationConfig';
      enabledTools: Array<string>;
      installType: McpServerInstallAccessInstallType;
      server: { __typename?: 'MCPServer'; _id: any; name: string };
      installation?: {
        __typename?: 'MCPServerInstall';
        _id: any;
        displayName: string;
        tools: Array<{
          __typename?: 'MCPServerTool';
          name: string;
          description?: string | null;
        }>;
      } | null;
    }>;
  } | null;
};

export type GetMcpProfileTemplateQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetMcpProfileTemplateQuery = {
  __typename?: 'Query';
  mcpProfileTemplate?: {
    __typename?: 'MCPProfileTemplate';
    _id: any;
    displayName: string;
    createdAt: any;
    updatedAt: any;
    installationConfigs: Array<{
      __typename?: 'InstallationConfig';
      enabledTools: Array<string>;
      installType: McpServerInstallAccessInstallType;
      allToolsEnabled?: boolean | null;
      server: { __typename?: 'MCPServer'; _id: any; name: string };
      installation?: {
        __typename?: 'MCPServerInstall';
        _id: any;
        displayName: string;
      } | null;
    }>;
  } | null;
};

export type GetMcpServerInstallsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  installTypes?: InputMaybe<Array<McpServerInstallAccessInstallType>>;
  q?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  includeOrgManagedInstalls?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetMcpServerInstallsQuery = {
  __typename?: 'Query';
  mcpServerInstalls: Array<{
    __typename?: 'MCPServerInstall';
    _id: any;
    displayName: string;
    status: McpServerInstallStatus;
    availableTools: Array<{ __typename?: 'MCPServerTool'; name: string }>;
    server: {
      __typename?: 'MCPServer';
      _id: any;
      name: string;
      status: McpServerStatus;
    };
    ownedBy?: {
      __typename?: 'OwnedBy';
      type: InstalledForActorType;
      ref?:
        | { __typename?: 'Agent'; agentId: string; agentDisplayName: string }
        | { __typename?: 'User'; userId: any; userDisplayName?: string | null }
        | null;
    } | null;
    accessConfig: {
      __typename?: 'MCPServerInstallAccessConfig';
      installType: McpServerInstallAccessInstallType;
    };
  }>;
};

export type GetMeQueryVariables = Exact<{ [key: string]: never }>;

export type GetMeQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'MeResponse';
    currentOrg?: {
      __typename?: 'Org';
      _id: any;
      slug: string;
      displayName?: string | null;
      status: OrgStatus;
      featureSwitchOverrides: any;
      enabledFeatures?: Array<BillingFeatureId> | null;
      enabledMcpClients?: Array<McpClientType> | null;
      onboarding?: { __typename?: 'Onboarding'; connectedIDP: boolean } | null;
      settings?: {
        __typename?: 'OrgSettings';
        disableApiKeyUsage: boolean;
        disableAllowAllPolicy: boolean;
      } | null;
      notifications?: {
        __typename?: 'OrgNotifications';
        sender: string;
        smtpHost: string;
        smtpPort: SmtpPort;
      } | null;
      authServer?: {
        __typename?: 'OrgAuthServer';
        enabled: boolean;
        url?: string | null;
        audiences?: Array<string> | null;
      } | null;
    } | null;
    currentUser?: {
      __typename?: 'User';
      _id: any;
      email: string;
      displayName?: string | null;
      status: UserStatus;
      role: UserRole;
      shouldPingMcpConfig?: boolean | null;
      selectedProfile?: {
        __typename?: 'MCPProfile';
        _id: any;
        name?: string | null;
        slug?: string | null;
        isSystemDefault?: boolean | null;
        mcpUrl: string;
        type: McpProfileType;
        installationConfigs: Array<{
          __typename?: 'ProfileInstallationConfig';
          enabledTools: Array<string>;
          server: {
            __typename?: 'MCPServer';
            _id: any;
            name: string;
            templateSlug?: string | null;
          };
        }>;
      } | null;
    } | null;
  };
};

export type GetMyOrgSamlAuthorizeUrlQueryVariables = Exact<{
  input: OrgSamlAuthorizeUrlInput;
}>;

export type GetMyOrgSamlAuthorizeUrlQuery = {
  __typename?: 'Query';
  myOrgSamlAuthorizeUrl?: {
    __typename?: 'OrgSamlAuthorizeUrl';
    authorizeUrl?: string | null;
    success?: boolean | null;
  } | null;
};

export type GetMyOrgSamlConfigQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyOrgSamlConfigQuery = {
  __typename?: 'Query';
  myOrgSamlConfig: {
    __typename?: 'OrgSamlConfig';
    enabled: boolean;
    idpMetadata?: {
      __typename?: 'OrgSamlConfigIdpMetadata';
      metadataUrl?: string | null;
      entityId?: string | null;
      ssoUrl?: string | null;
      idpSigningCertificate?: string | null;
    } | null;
    spMetadata?: {
      __typename?: 'OrgSamlConfigSpMetadata';
      entityId: string;
      acsUrl: string;
      wantAssertionsSigned: boolean;
      wantAuthnResponseSigned: boolean;
    } | null;
  };
};

export type GetMyOrgScimConfigQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyOrgScimConfigQuery = {
  __typename?: 'Query';
  myOrgScimConfig: {
    __typename?: 'OrgScimConfig';
    enabled: boolean;
    baseURL: string;
    scimProvisioningToken?:
      | {
          __typename?: 'Credential';
          preview: string;
          status: CredentialStatus;
          type: CredentialTypes;
        }
      | { __typename?: 'CredentialCreatedResponse' }
      | null;
  };
};

export type GetMyOrgsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyOrgsQuery = {
  __typename?: 'Query';
  myOrgs: Array<{
    __typename?: 'Org';
    _id: any;
    slug: string;
    displayName?: string | null;
    status: OrgStatus;
    featureSwitchOverrides: any;
    enabledFeatures?: Array<BillingFeatureId> | null;
    enabledMcpClients?: Array<McpClientType> | null;
    onboarding?: { __typename?: 'Onboarding'; connectedIDP: boolean } | null;
    settings?: {
      __typename?: 'OrgSettings';
      disableApiKeyUsage: boolean;
      disableAllowAllPolicy: boolean;
    } | null;
    notifications?: {
      __typename?: 'OrgNotifications';
      sender: string;
      smtpHost: string;
      smtpPort: SmtpPort;
    } | null;
    authServer?: {
      __typename?: 'OrgAuthServer';
      enabled: boolean;
      url?: string | null;
      audiences?: Array<string> | null;
    } | null;
  }>;
};

export type GetNeedsShadowAiSetupQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetNeedsShadowAiSetupQuery = {
  __typename?: 'Query';
  needsShadowAISetup: boolean;
};

export type GetRateLimitQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type GetRateLimitQuery = {
  __typename?: 'Query';
  rateLimit: {
    __typename?: 'RateLimit';
    _id: any;
    name: string;
    target: {
      __typename?: 'RateLimitTarget';
      details?: { __typename?: 'MCPServer'; _id: any; name: string } | null;
    };
    window: {
      __typename?: 'RateLimitWindow';
      unit: RateLimitWindowUnit;
      amount: number;
    };
  };
};

export type GetServiceInstancesQueryVariables = Exact<{ [key: string]: never }>;

export type GetServiceInstancesQuery = {
  __typename?: 'Query';
  serviceInstances: any;
};

export type GetServicesQueryVariables = Exact<{
  identityId?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  integrationId?: InputMaybe<Array<IntegrationId>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  isIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<ServiceStatus>>;
}>;

export type GetServicesQuery = {
  __typename?: 'Query';
  services?: Array<{
    __typename?: 'Service';
    _id: any;
    displayName: string;
    instanceName?: string | null;
    status: ServiceStatus;
    integration?:
      | {
          __typename?: 'CrowdStrikeIntegration';
          integrationId: IntegrationId;
          description?: string | null;
          activeAuthType: IntegrationAuthTypes;
          authFields: any;
        }
      | {
          __typename?: 'DatadogOtlpIntegration';
          integrationId: IntegrationId;
          description?: string | null;
          activeAuthType: IntegrationAuthTypes;
          authFields: any;
        }
      | {
          __typename?: 'ElasticsearchOtlpIntegration';
          integrationId: IntegrationId;
          description?: string | null;
          activeAuthType: IntegrationAuthTypes;
          authFields: any;
        }
      | {
          __typename?: 'JamfIntegration';
          integrationId: IntegrationId;
          description?: string | null;
          activeAuthType: IntegrationAuthTypes;
          authFields: any;
        }
      | {
          __typename?: 'NewRelicOtlpIntegration';
          integrationId: IntegrationId;
          description?: string | null;
          activeAuthType: IntegrationAuthTypes;
          authFields: any;
        }
      | {
          __typename?: 'ObserveOtlpIntegration';
          integrationId: IntegrationId;
          description?: string | null;
          activeAuthType: IntegrationAuthTypes;
          authFields: any;
        }
      | {
          __typename?: 'OpenTelemetryIntegration';
          integrationId: IntegrationId;
          description?: string | null;
          activeAuthType: IntegrationAuthTypes;
          authFields: any;
        }
      | {
          __typename?: 'SentinelOneIntegration';
          integrationId: IntegrationId;
          description?: string | null;
          activeAuthType: IntegrationAuthTypes;
          authFields: any;
        }
      | {
          __typename?: 'SplunkHecIntegration';
          integrationId: IntegrationId;
          description?: string | null;
          activeAuthType: IntegrationAuthTypes;
          authFields: any;
        }
      | null;
  }> | null;
};

export type GetSessionAuditLogsQueryVariables = Exact<{
  actors?: InputMaybe<Array<ActorFilterInput>>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  toolName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AuditLogSort>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetSessionAuditLogsQuery = {
  __typename?: 'Query';
  sessionAuditLogs: {
    __typename?: 'SessionAuditLogResponse';
    totalCount: number;
    sessions: Array<{
      __typename?: 'SessionAuditLogResult';
      sessionId: string;
      count: number;
      latestTimestamp: any;
      earliestTimestamp: any;
      events: Array<{
        __typename?: 'AuditLog';
        _id: any;
        timestamp: any;
        event: AuditEvent;
        metadata?: any | null;
        actor: {
          __typename?: 'AuditLogActorDetails';
          type: AuditActorType;
          details?:
            | { __typename: 'Agent'; _id: string; agentDisplayName: string }
            | {
                __typename: 'User';
                email: string;
                userDisplayName?: string | null;
              }
            | null;
        };
        targets?: Array<{
          __typename?: 'AuditLogTargetDetails';
          type: AuditTargetType;
          details?:
            | { __typename: 'Agent' }
            | { __typename: 'MCPServer' }
            | {
                __typename: 'MCPServerInstall';
                displayName: string;
                _id: any;
                accessConfig: {
                  __typename?: 'MCPServerInstallAccessConfig';
                  installType: McpServerInstallAccessInstallType;
                };
                server: { __typename?: 'MCPServer'; name: string };
              }
            | { __typename: 'User' }
            | null;
        }> | null;
      }>;
      metadata?: {
        __typename?: 'SessionAuditLogMetadata';
        toolNames?: Array<string | null> | null;
        statuses?: Array<string | null> | null;
        actorCount?: number | null;
      } | null;
    }>;
  };
};

export type GetShadowMcpServerOwnerOptionsQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetShadowMcpServerOwnerOptionsQuery = {
  __typename?: 'Query';
  shadowMCPServerOwners: Array<{
    __typename?: 'ShadowServerOwnerOption';
    hostname?: string | null;
    user?: {
      __typename?: 'User';
      _id: any;
      displayName?: string | null;
      email: string;
    } | null;
  }>;
};

export type GetShadowMcpServersGroupedByNormalizedServerNameQueryVariables =
  Exact<{
    q?: InputMaybe<Scalars['String']['input']>;
    offset: Scalars['Int']['input'];
    limit: Scalars['Int']['input'];
    owners?: InputMaybe<Array<ShadowServerOwnerInput>>;
    sortBy?: InputMaybe<ShadowServerSortBy>;
    statuses?: InputMaybe<Array<ShadowMcpServerStatus>>;
  }>;

export type GetShadowMcpServersGroupedByNormalizedServerNameQuery = {
  __typename?: 'Query';
  shadowMCPServersGroupedByNormalizedServerName: Array<{
    __typename?: 'ShadowMCPServerNormalizedGroup';
    normalizedServerName: string;
    lastSeenAt: any;
    firstDetectedAt: any;
    integrationId?: IntegrationId | null;
    users: Array<{
      __typename?: 'ShadowDeviceInfo';
      deviceId?: string | null;
      hostname: string;
      primaryUserEmail?: string | null;
      userId?: string | null;
    }>;
  }>;
};

export type GetTunnelsQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<TunnelStatus>>;
  connectionStatus?: InputMaybe<TunnelConnectionStatus>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetTunnelsQuery = {
  __typename?: 'Query';
  tunnels: Array<{
    __typename?: 'Tunnel';
    _id: any;
    displayName: string;
    status: TunnelStatus;
    connectionStatus: TunnelConnectionStatus;
    url?: string | null;
    metadata: {
      __typename?: 'TunnelMetadata';
      lastHeartbeatAt?: any | null;
      tunnelVersion?: string | null;
      tunnelAuthStrategy?: TunnelAuthStrategy | null;
    };
  }>;
};

export type GetUsersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<GetUsersSort>;
  status?: InputMaybe<Array<UserStatus>>;
  role?: InputMaybe<Array<UserRole>>;
}>;

export type GetUsersQuery = {
  __typename?: 'Query';
  getUsers?: {
    __typename?: 'GetUsersResponse';
    total: number;
    users?: Array<{
      __typename?: 'User';
      _id: any;
      displayName?: string | null;
      email: string;
      status: UserStatus;
      role: UserRole;
      org: { __typename?: 'Org'; _id: any };
    }> | null;
  } | null;
};

export type GetUsersCountOnMcpServersQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type GetUsersCountOnMcpServersQuery = {
  __typename?: 'Query';
  mcpServer?: { __typename?: 'MCPServer'; _id: any; usersCount: number } | null;
};

export type SimulatePolicyToolCallQueryVariables = Exact<{
  input: SimulatePolicyToolCallInput;
}>;

export type SimulatePolicyToolCallQuery = {
  __typename?: 'Query';
  simulatePolicyToolCall?: any | null;
};

export type TestMcpConnectionQueryVariables = Exact<{
  authCredentials?: InputMaybe<Scalars['ServerInstallationCredsMap']['input']>;
  mcpServerId?: InputMaybe<Scalars['ObjectID']['input']>;
  mcpServerInstallId?: InputMaybe<Scalars['ObjectID']['input']>;
  agentId?: InputMaybe<Scalars['ObjectID']['input']>;
}>;

export type TestMcpConnectionQuery = {
  __typename?: 'Query';
  testMCPConnection: {
    __typename?: 'TestMCPConnectionResult';
    success: boolean;
    error?: string | null;
    toolCount?: number | null;
    toolNames?: Array<string> | null;
  };
};

export const NewAccessPolicyFragmentDoc = gql`
  fragment NewAccessPolicy on MCPAccessPolicy {
    __typename
    _id
    name
    status
    isDeprecated
    targetConfigs {
      allTools
      tools
      totalInstalls
      installationScope
    }
  }
`;
export const NewAccessControlPolicyFragmentDoc = gql`
  fragment NewAccessControlPolicy on AccessControlPolicy {
    __typename
    _id
    name
    status
    type
    updatedAt
    createdAt
    policy {
      effect
      isDeprecated
      targetConfigs {
        allTools
        totalInstalls
        tools
        installationScope
      }
    }
  }
`;
export const NewDeploymentFragmentDoc = gql`
  fragment NewDeployment on Deployment {
    __typename
    _id
    status
    displayName
    origin
    credentials {
      _id
      status
      credentialId
    }
    createdBy {
      _id
      displayName
      email
    }
    updatedBy {
      _id
      displayName
      email
    }
    createdAt
    updatedAt
    polledAt
    health
  }
`;
export const NewAgentFragmentDoc = gql`
  fragment NewAgent on Agent {
    __typename
    _id
    displayName
    owner {
      _id
      email
      displayName
    }
    createdBy {
      _id
      email
      displayName
    }
    createdAt
    updatedAt
    connections
    connectionsCount
  }
`;
export const UpdatedAgentFragmentDoc = gql`
  fragment UpdatedAgent on Agent {
    _id
    displayName
    owner {
      _id
      email
      displayName
    }
    updatedAt
  }
`;
export const NewManagedServerFragmentDoc = gql`
  fragment NewManagedServer on MCPServerInstall {
    __typename
    _id
    displayName
    accessConfig {
      __typename
      installType
    }
    installed
  }
`;
export const NewApiKeyFragmentDoc = gql`
  fragment NewApiKey on Credential {
    __typename
    _id
    displayName
    lastUsed
    createdAt
    credentialId
    preview
    status
  }
`;
export const NewAccessControlRateLimitFragmentDoc = gql`
  fragment NewAccessControlRateLimit on AccessControlRateLimit {
    __typename
    _id
    name
    status
    type
    updatedAt
    createdAt
    rateLimit {
      __typename
      _id
      name
      status
      target {
        type
        details {
          ... on MCPServer {
            _id
            name
          }
        }
      }
      window {
        unit
        amount
      }
    }
  }
`;
export const NewTunnelFragmentDoc = gql`
  fragment NewTunnel on Tunnel {
    __typename
    _id
    displayName
    status
    connectionStatus
    url
    metadata {
      __typename
      lastHeartbeatAt
      tunnelVersion
      tunnelAuthStrategy
    }
  }
`;
export const OrgRegistrationFieldsFragmentDoc = gql`
  fragment OrgRegistrationFields on Org {
    _id
    displayName
    slug
    status
  }
`;
export const UserRegistrationFieldsFragmentDoc = gql`
  fragment UserRegistrationFields on User {
    _id
    org {
      _id
    }
    email
    displayName
    status
  }
`;
export const CurrentOrgFieldsFragmentDoc = gql`
  fragment CurrentOrgFields on Org {
    _id
    slug
    displayName
    status
    onboarding {
      connectedIDP
    }
    featureSwitchOverrides
    settings {
      disableApiKeyUsage
      disableAllowAllPolicy
    }
    enabledFeatures
    enabledMcpClients
    notifications {
      sender
      smtpHost
      smtpPort
    }
    authServer {
      enabled
      url
      audiences
    }
  }
`;
export const CurrentUserFieldsFragmentDoc = gql`
  fragment CurrentUserFields on User {
    _id
    email
    displayName
    status
    role
    selectedProfile {
      _id
      name
      slug
      isSystemDefault
      mcpUrl
      type
      installationConfigs {
        server {
          _id
          name
          templateSlug
        }
        enabledTools
      }
    }
    shouldPingMcpConfig
  }
`;
export const IngestJobFieldsFragmentDoc = gql`
  fragment IngestJobFields on Job {
    _id
    completedAt
    queuedAt
    startedAt
    status
    triggeredBy {
      _id
    }
    type
    org {
      _id
    }
    context {
      type
      ref
      service {
        _id
        displayName
        integration {
          integrationId
          description
        }
      }
    }
    processingMetadata {
      processedIdentities
      expectedIdentities
    }
    error
    missingScopes
  }
`;
export const PrincipalTreeFieldsLeafFragmentDoc = gql`
  fragment PrincipalTreeFieldsLeaf on MCPAccessPolicyPrincipalTreeNode {
    op
    type
    userId
    agentId
    role
    groupId
    profile {
      key
      matcher
      value
    }
  }
`;
export const PrincipalTreeFieldsL2FragmentDoc = gql`
  fragment PrincipalTreeFieldsL2 on MCPAccessPolicyPrincipalTreeNode {
    op
    type
    userId
    agentId
    role
    groupId
    profile {
      key
      matcher
      value
    }
    nodes {
      ...PrincipalTreeFieldsLeaf
    }
  }
  ${PrincipalTreeFieldsLeafFragmentDoc}
`;
export const PrincipalTreeFieldsL1FragmentDoc = gql`
  fragment PrincipalTreeFieldsL1 on MCPAccessPolicyPrincipalTreeNode {
    op
    rootType
    nodes {
      ...PrincipalTreeFieldsL2
    }
  }
  ${PrincipalTreeFieldsL2FragmentDoc}
`;
export const GetEnabledMcpServersDocument = gql`
  query getEnabledMcpServers(
    $q: String
    $offset: Int
    $limit: Int
    $availableForTypes: [MCPServerAccessAvailableFor!]
  ) {
    mcpServers(
      q: $q
      offset: $offset
      limit: $limit
      availableForTypes: $availableForTypes
    ) {
      _id
      accessConfig {
        availableFor
        isPersonalConnectionEnabled
      }
      availableTools {
        name
        description
      }
      managedInstalls {
        id
        displayName
        availableTools {
          name
          description
        }
        canEdit
      }
      name
      description
      originType
      isRemoteServerScanned
      status
      config
      oauthClientId
      hasOauthClientSecret
      oauthScopes
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useGetEnabledMcpServersQuery__
 *
 * To run a query within a React component, call `useGetEnabledMcpServersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnabledMcpServersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnabledMcpServersQuery({
 *   variables: {
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      availableForTypes: // value for 'availableForTypes'
 *   },
 * });
 */
export function useGetEnabledMcpServersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEnabledMcpServersQuery,
    GetEnabledMcpServersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEnabledMcpServersQuery,
    GetEnabledMcpServersQueryVariables
  >(GetEnabledMcpServersDocument, options);
}
export function useGetEnabledMcpServersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEnabledMcpServersQuery,
    GetEnabledMcpServersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEnabledMcpServersQuery,
    GetEnabledMcpServersQueryVariables
  >(GetEnabledMcpServersDocument, options);
}
// @ts-ignore
export function useGetEnabledMcpServersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEnabledMcpServersQuery,
    GetEnabledMcpServersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetEnabledMcpServersQuery,
  GetEnabledMcpServersQueryVariables
>;
export function useGetEnabledMcpServersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEnabledMcpServersQuery,
        GetEnabledMcpServersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetEnabledMcpServersQuery | undefined,
  GetEnabledMcpServersQueryVariables
>;
export function useGetEnabledMcpServersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEnabledMcpServersQuery,
        GetEnabledMcpServersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEnabledMcpServersQuery,
    GetEnabledMcpServersQueryVariables
  >(GetEnabledMcpServersDocument, options);
}
export type GetEnabledMcpServersQueryHookResult = ReturnType<
  typeof useGetEnabledMcpServersQuery
>;
export type GetEnabledMcpServersLazyQueryHookResult = ReturnType<
  typeof useGetEnabledMcpServersLazyQuery
>;
export type GetEnabledMcpServersSuspenseQueryHookResult = ReturnType<
  typeof useGetEnabledMcpServersSuspenseQuery
>;
export type GetEnabledMcpServersQueryResult = Apollo.QueryResult<
  GetEnabledMcpServersQuery,
  GetEnabledMcpServersQueryVariables
>;
export const RemoteUrlAppFormEnableMcpServerDocument = gql`
  mutation RemoteUrlAppFormEnableMcpServer($input: EnableMcpServerInput!) {
    enableMcpServer(input: $input) {
      _id
    }
  }
`;
export type RemoteUrlAppFormEnableMcpServerMutationFn = Apollo.MutationFunction<
  RemoteUrlAppFormEnableMcpServerMutation,
  RemoteUrlAppFormEnableMcpServerMutationVariables
>;

/**
 * __useRemoteUrlAppFormEnableMcpServerMutation__
 *
 * To run a mutation, you first call `useRemoteUrlAppFormEnableMcpServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoteUrlAppFormEnableMcpServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [remoteUrlAppFormEnableMcpServerMutation, { data, loading, error }] = useRemoteUrlAppFormEnableMcpServerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoteUrlAppFormEnableMcpServerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoteUrlAppFormEnableMcpServerMutation,
    RemoteUrlAppFormEnableMcpServerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoteUrlAppFormEnableMcpServerMutation,
    RemoteUrlAppFormEnableMcpServerMutationVariables
  >(RemoteUrlAppFormEnableMcpServerDocument, options);
}
export type RemoteUrlAppFormEnableMcpServerMutationHookResult = ReturnType<
  typeof useRemoteUrlAppFormEnableMcpServerMutation
>;
export type RemoteUrlAppFormEnableMcpServerMutationResult =
  Apollo.MutationResult<RemoteUrlAppFormEnableMcpServerMutation>;
export type RemoteUrlAppFormEnableMcpServerMutationOptions =
  Apollo.BaseMutationOptions<
    RemoteUrlAppFormEnableMcpServerMutation,
    RemoteUrlAppFormEnableMcpServerMutationVariables
  >;
export const ApiKeyFieldCreateCredentialDocument = gql`
  mutation ApiKeyFieldCreateCredential($input: CreateCredentialInput!) {
    createCredential(input: $input) {
      _id
      secret
    }
  }
`;
export type ApiKeyFieldCreateCredentialMutationFn = Apollo.MutationFunction<
  ApiKeyFieldCreateCredentialMutation,
  ApiKeyFieldCreateCredentialMutationVariables
>;

/**
 * __useApiKeyFieldCreateCredentialMutation__
 *
 * To run a mutation, you first call `useApiKeyFieldCreateCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiKeyFieldCreateCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiKeyFieldCreateCredentialMutation, { data, loading, error }] = useApiKeyFieldCreateCredentialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApiKeyFieldCreateCredentialMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApiKeyFieldCreateCredentialMutation,
    ApiKeyFieldCreateCredentialMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApiKeyFieldCreateCredentialMutation,
    ApiKeyFieldCreateCredentialMutationVariables
  >(ApiKeyFieldCreateCredentialDocument, options);
}
export type ApiKeyFieldCreateCredentialMutationHookResult = ReturnType<
  typeof useApiKeyFieldCreateCredentialMutation
>;
export type ApiKeyFieldCreateCredentialMutationResult =
  Apollo.MutationResult<ApiKeyFieldCreateCredentialMutation>;
export type ApiKeyFieldCreateCredentialMutationOptions =
  Apollo.BaseMutationOptions<
    ApiKeyFieldCreateCredentialMutation,
    ApiKeyFieldCreateCredentialMutationVariables
  >;
export const GetServerConnectionsForUserDocument = gql`
  query getServerConnectionsForUser($id: ObjectID!) {
    mcpServer(id: $id) {
      _id
      availableInstalls(showInstalls: true) {
        _id
        displayName
        installed
        accessConfig {
          installType
        }
      }
    }
  }
`;

/**
 * __useGetServerConnectionsForUserQuery__
 *
 * To run a query within a React component, call `useGetServerConnectionsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServerConnectionsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServerConnectionsForUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServerConnectionsForUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetServerConnectionsForUserQuery,
    GetServerConnectionsForUserQueryVariables
  > &
    (
      | { variables: GetServerConnectionsForUserQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetServerConnectionsForUserQuery,
    GetServerConnectionsForUserQueryVariables
  >(GetServerConnectionsForUserDocument, options);
}
export function useGetServerConnectionsForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetServerConnectionsForUserQuery,
    GetServerConnectionsForUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetServerConnectionsForUserQuery,
    GetServerConnectionsForUserQueryVariables
  >(GetServerConnectionsForUserDocument, options);
}
// @ts-ignore
export function useGetServerConnectionsForUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetServerConnectionsForUserQuery,
    GetServerConnectionsForUserQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetServerConnectionsForUserQuery,
  GetServerConnectionsForUserQueryVariables
>;
export function useGetServerConnectionsForUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetServerConnectionsForUserQuery,
        GetServerConnectionsForUserQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetServerConnectionsForUserQuery | undefined,
  GetServerConnectionsForUserQueryVariables
>;
export function useGetServerConnectionsForUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetServerConnectionsForUserQuery,
        GetServerConnectionsForUserQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetServerConnectionsForUserQuery,
    GetServerConnectionsForUserQueryVariables
  >(GetServerConnectionsForUserDocument, options);
}
export type GetServerConnectionsForUserQueryHookResult = ReturnType<
  typeof useGetServerConnectionsForUserQuery
>;
export type GetServerConnectionsForUserLazyQueryHookResult = ReturnType<
  typeof useGetServerConnectionsForUserLazyQuery
>;
export type GetServerConnectionsForUserSuspenseQueryHookResult = ReturnType<
  typeof useGetServerConnectionsForUserSuspenseQuery
>;
export type GetServerConnectionsForUserQueryResult = Apollo.QueryResult<
  GetServerConnectionsForUserQuery,
  GetServerConnectionsForUserQueryVariables
>;
export const GetServerConnectionsForAgentDocument = gql`
  query getServerConnectionsForAgent($id: ObjectID!, $agentId: ObjectID!) {
    mcpServer(id: $id) {
      _id
      availableInstalls(showInstalls: true, agentId: $agentId) {
        _id
        displayName
        installed(agentId: $agentId)
        accessConfig {
          installType
        }
      }
    }
  }
`;

/**
 * __useGetServerConnectionsForAgentQuery__
 *
 * To run a query within a React component, call `useGetServerConnectionsForAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServerConnectionsForAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServerConnectionsForAgentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useGetServerConnectionsForAgentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetServerConnectionsForAgentQuery,
    GetServerConnectionsForAgentQueryVariables
  > &
    (
      | {
          variables: GetServerConnectionsForAgentQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetServerConnectionsForAgentQuery,
    GetServerConnectionsForAgentQueryVariables
  >(GetServerConnectionsForAgentDocument, options);
}
export function useGetServerConnectionsForAgentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetServerConnectionsForAgentQuery,
    GetServerConnectionsForAgentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetServerConnectionsForAgentQuery,
    GetServerConnectionsForAgentQueryVariables
  >(GetServerConnectionsForAgentDocument, options);
}
// @ts-ignore
export function useGetServerConnectionsForAgentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetServerConnectionsForAgentQuery,
    GetServerConnectionsForAgentQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetServerConnectionsForAgentQuery,
  GetServerConnectionsForAgentQueryVariables
>;
export function useGetServerConnectionsForAgentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetServerConnectionsForAgentQuery,
        GetServerConnectionsForAgentQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetServerConnectionsForAgentQuery | undefined,
  GetServerConnectionsForAgentQueryVariables
>;
export function useGetServerConnectionsForAgentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetServerConnectionsForAgentQuery,
        GetServerConnectionsForAgentQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetServerConnectionsForAgentQuery,
    GetServerConnectionsForAgentQueryVariables
  >(GetServerConnectionsForAgentDocument, options);
}
export type GetServerConnectionsForAgentQueryHookResult = ReturnType<
  typeof useGetServerConnectionsForAgentQuery
>;
export type GetServerConnectionsForAgentLazyQueryHookResult = ReturnType<
  typeof useGetServerConnectionsForAgentLazyQuery
>;
export type GetServerConnectionsForAgentSuspenseQueryHookResult = ReturnType<
  typeof useGetServerConnectionsForAgentSuspenseQuery
>;
export type GetServerConnectionsForAgentQueryResult = Apollo.QueryResult<
  GetServerConnectionsForAgentQuery,
  GetServerConnectionsForAgentQueryVariables
>;
export const ConnectionConfigViewGetInstallsDocument = gql`
  query ConnectionConfigViewGetInstalls($limit: Int) {
    myMcpServerInstalls(limit: $limit) {
      _id
      displayName
      status
      mcpUrl
      server {
        _id
        name
      }
    }
  }
`;

/**
 * __useConnectionConfigViewGetInstallsQuery__
 *
 * To run a query within a React component, call `useConnectionConfigViewGetInstallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionConfigViewGetInstallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionConfigViewGetInstallsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useConnectionConfigViewGetInstallsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConnectionConfigViewGetInstallsQuery,
    ConnectionConfigViewGetInstallsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConnectionConfigViewGetInstallsQuery,
    ConnectionConfigViewGetInstallsQueryVariables
  >(ConnectionConfigViewGetInstallsDocument, options);
}
export function useConnectionConfigViewGetInstallsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConnectionConfigViewGetInstallsQuery,
    ConnectionConfigViewGetInstallsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConnectionConfigViewGetInstallsQuery,
    ConnectionConfigViewGetInstallsQueryVariables
  >(ConnectionConfigViewGetInstallsDocument, options);
}
// @ts-ignore
export function useConnectionConfigViewGetInstallsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ConnectionConfigViewGetInstallsQuery,
    ConnectionConfigViewGetInstallsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ConnectionConfigViewGetInstallsQuery,
  ConnectionConfigViewGetInstallsQueryVariables
>;
export function useConnectionConfigViewGetInstallsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConnectionConfigViewGetInstallsQuery,
        ConnectionConfigViewGetInstallsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ConnectionConfigViewGetInstallsQuery | undefined,
  ConnectionConfigViewGetInstallsQueryVariables
>;
export function useConnectionConfigViewGetInstallsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConnectionConfigViewGetInstallsQuery,
        ConnectionConfigViewGetInstallsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ConnectionConfigViewGetInstallsQuery,
    ConnectionConfigViewGetInstallsQueryVariables
  >(ConnectionConfigViewGetInstallsDocument, options);
}
export type ConnectionConfigViewGetInstallsQueryHookResult = ReturnType<
  typeof useConnectionConfigViewGetInstallsQuery
>;
export type ConnectionConfigViewGetInstallsLazyQueryHookResult = ReturnType<
  typeof useConnectionConfigViewGetInstallsLazyQuery
>;
export type ConnectionConfigViewGetInstallsSuspenseQueryHookResult = ReturnType<
  typeof useConnectionConfigViewGetInstallsSuspenseQuery
>;
export type ConnectionConfigViewGetInstallsQueryResult = Apollo.QueryResult<
  ConnectionConfigViewGetInstallsQuery,
  ConnectionConfigViewGetInstallsQueryVariables
>;
export const GetMyConnectionsDocument = gql`
  query getMyConnections($limit: Int) {
    myMcpServerInstalls(limit: $limit) {
      _id
      displayName
      status
      server {
        _id
        name
        accessConfig {
          availableFor
        }
        serverInfo {
          __typename
          ... on MCPServerInfo {
            source {
              __typename
            }
          }
          ... on CustomMCPServerInfo {
            source {
              __typename
              ... on CustomRemoteUrlSource {
                isOnPrem
              }
              ... on CustomDynamicRemoteUrlSource {
                isOnPrem
              }
            }
          }
        }
      }
      healthStatus {
        healthy
      }
      accessConfig {
        installType
      }
    }
  }
`;

/**
 * __useGetMyConnectionsQuery__
 *
 * To run a query within a React component, call `useGetMyConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyConnectionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMyConnectionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMyConnectionsQuery,
    GetMyConnectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMyConnectionsQuery, GetMyConnectionsQueryVariables>(
    GetMyConnectionsDocument,
    options
  );
}
export function useGetMyConnectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyConnectionsQuery,
    GetMyConnectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMyConnectionsQuery,
    GetMyConnectionsQueryVariables
  >(GetMyConnectionsDocument, options);
}
// @ts-ignore
export function useGetMyConnectionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMyConnectionsQuery,
    GetMyConnectionsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetMyConnectionsQuery,
  GetMyConnectionsQueryVariables
>;
export function useGetMyConnectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMyConnectionsQuery,
        GetMyConnectionsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetMyConnectionsQuery | undefined,
  GetMyConnectionsQueryVariables
>;
export function useGetMyConnectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMyConnectionsQuery,
        GetMyConnectionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMyConnectionsQuery,
    GetMyConnectionsQueryVariables
  >(GetMyConnectionsDocument, options);
}
export type GetMyConnectionsQueryHookResult = ReturnType<
  typeof useGetMyConnectionsQuery
>;
export type GetMyConnectionsLazyQueryHookResult = ReturnType<
  typeof useGetMyConnectionsLazyQuery
>;
export type GetMyConnectionsSuspenseQueryHookResult = ReturnType<
  typeof useGetMyConnectionsSuspenseQuery
>;
export type GetMyConnectionsQueryResult = Apollo.QueryResult<
  GetMyConnectionsQuery,
  GetMyConnectionsQueryVariables
>;
export const GetEnabledServersDocument = gql`
  query getEnabledServers($limit: Int) {
    mcpServers(limit: $limit, isAvailableQuery: true) {
      _id
      name
      accessConfig {
        availableFor
      }
      canConnect
      managedInstalls {
        id
      }
    }
  }
`;

/**
 * __useGetEnabledServersQuery__
 *
 * To run a query within a React component, call `useGetEnabledServersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnabledServersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnabledServersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetEnabledServersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEnabledServersQuery,
    GetEnabledServersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEnabledServersQuery,
    GetEnabledServersQueryVariables
  >(GetEnabledServersDocument, options);
}
export function useGetEnabledServersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEnabledServersQuery,
    GetEnabledServersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEnabledServersQuery,
    GetEnabledServersQueryVariables
  >(GetEnabledServersDocument, options);
}
// @ts-ignore
export function useGetEnabledServersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEnabledServersQuery,
    GetEnabledServersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetEnabledServersQuery,
  GetEnabledServersQueryVariables
>;
export function useGetEnabledServersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEnabledServersQuery,
        GetEnabledServersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetEnabledServersQuery | undefined,
  GetEnabledServersQueryVariables
>;
export function useGetEnabledServersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEnabledServersQuery,
        GetEnabledServersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEnabledServersQuery,
    GetEnabledServersQueryVariables
  >(GetEnabledServersDocument, options);
}
export type GetEnabledServersQueryHookResult = ReturnType<
  typeof useGetEnabledServersQuery
>;
export type GetEnabledServersLazyQueryHookResult = ReturnType<
  typeof useGetEnabledServersLazyQuery
>;
export type GetEnabledServersSuspenseQueryHookResult = ReturnType<
  typeof useGetEnabledServersSuspenseQuery
>;
export type GetEnabledServersQueryResult = Apollo.QueryResult<
  GetEnabledServersQuery,
  GetEnabledServersQueryVariables
>;
export const GetShadowMcpServersForNormalizedServerNameDocument = gql`
  query getShadowMCPServersForNormalizedServerName(
    $normalizedServerName: String!
    $integrationId: String!
    $q: String
    $offset: Int!
    $limit: Int!
  ) {
    shadowMCPServersForNormalizedServerName(
      normalizedServerName: $normalizedServerName
      integrationId: $integrationId
      q: $q
      offset: $offset
      limit: $limit
    ) {
      totalCount
      lastSeenAt
      firstDetectedAt
      servers {
        _id
        serverName
        serverAddress
        normalizedServerName
        configFileType
        configFilePath
        lastSeenAt
        firstDetectedAt
        device {
          hostname
          primaryUserEmail
          username
        }
        user {
          displayName
        }
        createdAt
        toolCalls {
          _id
          toolName
          calledAt
          resultStatus
          model
          gitBranch
          toolArguments
        }
      }
    }
  }
`;

/**
 * __useGetShadowMcpServersForNormalizedServerNameQuery__
 *
 * To run a query within a React component, call `useGetShadowMcpServersForNormalizedServerNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShadowMcpServersForNormalizedServerNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShadowMcpServersForNormalizedServerNameQuery({
 *   variables: {
 *      normalizedServerName: // value for 'normalizedServerName'
 *      integrationId: // value for 'integrationId'
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetShadowMcpServersForNormalizedServerNameQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetShadowMcpServersForNormalizedServerNameQuery,
    GetShadowMcpServersForNormalizedServerNameQueryVariables
  > &
    (
      | {
          variables: GetShadowMcpServersForNormalizedServerNameQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetShadowMcpServersForNormalizedServerNameQuery,
    GetShadowMcpServersForNormalizedServerNameQueryVariables
  >(GetShadowMcpServersForNormalizedServerNameDocument, options);
}
export function useGetShadowMcpServersForNormalizedServerNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetShadowMcpServersForNormalizedServerNameQuery,
    GetShadowMcpServersForNormalizedServerNameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetShadowMcpServersForNormalizedServerNameQuery,
    GetShadowMcpServersForNormalizedServerNameQueryVariables
  >(GetShadowMcpServersForNormalizedServerNameDocument, options);
}
// @ts-ignore
export function useGetShadowMcpServersForNormalizedServerNameSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetShadowMcpServersForNormalizedServerNameQuery,
    GetShadowMcpServersForNormalizedServerNameQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetShadowMcpServersForNormalizedServerNameQuery,
  GetShadowMcpServersForNormalizedServerNameQueryVariables
>;
export function useGetShadowMcpServersForNormalizedServerNameSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetShadowMcpServersForNormalizedServerNameQuery,
        GetShadowMcpServersForNormalizedServerNameQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetShadowMcpServersForNormalizedServerNameQuery | undefined,
  GetShadowMcpServersForNormalizedServerNameQueryVariables
>;
export function useGetShadowMcpServersForNormalizedServerNameSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetShadowMcpServersForNormalizedServerNameQuery,
        GetShadowMcpServersForNormalizedServerNameQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetShadowMcpServersForNormalizedServerNameQuery,
    GetShadowMcpServersForNormalizedServerNameQueryVariables
  >(GetShadowMcpServersForNormalizedServerNameDocument, options);
}
export type GetShadowMcpServersForNormalizedServerNameQueryHookResult =
  ReturnType<typeof useGetShadowMcpServersForNormalizedServerNameQuery>;
export type GetShadowMcpServersForNormalizedServerNameLazyQueryHookResult =
  ReturnType<typeof useGetShadowMcpServersForNormalizedServerNameLazyQuery>;
export type GetShadowMcpServersForNormalizedServerNameSuspenseQueryHookResult =
  ReturnType<typeof useGetShadowMcpServersForNormalizedServerNameSuspenseQuery>;
export type GetShadowMcpServersForNormalizedServerNameQueryResult =
  Apollo.QueryResult<
    GetShadowMcpServersForNormalizedServerNameQuery,
    GetShadowMcpServersForNormalizedServerNameQueryVariables
  >;
export const GetDiscoveredAiClientsGroupedByTypeDocument = gql`
  query getDiscoveredAIClientsGroupedByType(
    $status: ShadowMCPServerStatus
    $q: String
    $sortBy: DiscoveredClientSortBy
    $owners: [ShadowServerOwnerInput!]
    $limit: Int
    $offset: Int
  ) {
    discoveredAIClientsGroupedByType(
      status: $status
      q: $q
      sortBy: $sortBy
      owners: $owners
      limit: $limit
      offset: $offset
    ) {
      configFileType
      usersCount
      integrationIds
      isDetectedByDesktopApp
      users {
        userId
        hostname
        primaryUserEmail
      }
      firstSeenAt
      lastSeenAt
    }
  }
`;

/**
 * __useGetDiscoveredAiClientsGroupedByTypeQuery__
 *
 * To run a query within a React component, call `useGetDiscoveredAiClientsGroupedByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscoveredAiClientsGroupedByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscoveredAiClientsGroupedByTypeQuery({
 *   variables: {
 *      status: // value for 'status'
 *      q: // value for 'q'
 *      sortBy: // value for 'sortBy'
 *      owners: // value for 'owners'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetDiscoveredAiClientsGroupedByTypeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDiscoveredAiClientsGroupedByTypeQuery,
    GetDiscoveredAiClientsGroupedByTypeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDiscoveredAiClientsGroupedByTypeQuery,
    GetDiscoveredAiClientsGroupedByTypeQueryVariables
  >(GetDiscoveredAiClientsGroupedByTypeDocument, options);
}
export function useGetDiscoveredAiClientsGroupedByTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDiscoveredAiClientsGroupedByTypeQuery,
    GetDiscoveredAiClientsGroupedByTypeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDiscoveredAiClientsGroupedByTypeQuery,
    GetDiscoveredAiClientsGroupedByTypeQueryVariables
  >(GetDiscoveredAiClientsGroupedByTypeDocument, options);
}
// @ts-ignore
export function useGetDiscoveredAiClientsGroupedByTypeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDiscoveredAiClientsGroupedByTypeQuery,
    GetDiscoveredAiClientsGroupedByTypeQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetDiscoveredAiClientsGroupedByTypeQuery,
  GetDiscoveredAiClientsGroupedByTypeQueryVariables
>;
export function useGetDiscoveredAiClientsGroupedByTypeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDiscoveredAiClientsGroupedByTypeQuery,
        GetDiscoveredAiClientsGroupedByTypeQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetDiscoveredAiClientsGroupedByTypeQuery | undefined,
  GetDiscoveredAiClientsGroupedByTypeQueryVariables
>;
export function useGetDiscoveredAiClientsGroupedByTypeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDiscoveredAiClientsGroupedByTypeQuery,
        GetDiscoveredAiClientsGroupedByTypeQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDiscoveredAiClientsGroupedByTypeQuery,
    GetDiscoveredAiClientsGroupedByTypeQueryVariables
  >(GetDiscoveredAiClientsGroupedByTypeDocument, options);
}
export type GetDiscoveredAiClientsGroupedByTypeQueryHookResult = ReturnType<
  typeof useGetDiscoveredAiClientsGroupedByTypeQuery
>;
export type GetDiscoveredAiClientsGroupedByTypeLazyQueryHookResult = ReturnType<
  typeof useGetDiscoveredAiClientsGroupedByTypeLazyQuery
>;
export type GetDiscoveredAiClientsGroupedByTypeSuspenseQueryHookResult =
  ReturnType<typeof useGetDiscoveredAiClientsGroupedByTypeSuspenseQuery>;
export type GetDiscoveredAiClientsGroupedByTypeQueryResult = Apollo.QueryResult<
  GetDiscoveredAiClientsGroupedByTypeQuery,
  GetDiscoveredAiClientsGroupedByTypeQueryVariables
>;
export const GetDiscoveredAiClientUsersDocument = gql`
  query getDiscoveredAIClientUsers(
    $configFileType: String!
    $q: String
    $limit: Int
    $offset: Int
  ) {
    discoveredAIClientUsers(
      configFileType: $configFileType
      q: $q
      limit: $limit
      offset: $offset
    ) {
      users {
        user
        device
        isDetectedByDesktopApp
        integrationIds
        firstDetectedAt
        lastSeenAt
      }
      totalCount
      lastSeenAt
      firstDetectedAt
    }
  }
`;

/**
 * __useGetDiscoveredAiClientUsersQuery__
 *
 * To run a query within a React component, call `useGetDiscoveredAiClientUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscoveredAiClientUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscoveredAiClientUsersQuery({
 *   variables: {
 *      configFileType: // value for 'configFileType'
 *      q: // value for 'q'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetDiscoveredAiClientUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDiscoveredAiClientUsersQuery,
    GetDiscoveredAiClientUsersQueryVariables
  > &
    (
      | { variables: GetDiscoveredAiClientUsersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDiscoveredAiClientUsersQuery,
    GetDiscoveredAiClientUsersQueryVariables
  >(GetDiscoveredAiClientUsersDocument, options);
}
export function useGetDiscoveredAiClientUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDiscoveredAiClientUsersQuery,
    GetDiscoveredAiClientUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDiscoveredAiClientUsersQuery,
    GetDiscoveredAiClientUsersQueryVariables
  >(GetDiscoveredAiClientUsersDocument, options);
}
// @ts-ignore
export function useGetDiscoveredAiClientUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDiscoveredAiClientUsersQuery,
    GetDiscoveredAiClientUsersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetDiscoveredAiClientUsersQuery,
  GetDiscoveredAiClientUsersQueryVariables
>;
export function useGetDiscoveredAiClientUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDiscoveredAiClientUsersQuery,
        GetDiscoveredAiClientUsersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetDiscoveredAiClientUsersQuery | undefined,
  GetDiscoveredAiClientUsersQueryVariables
>;
export function useGetDiscoveredAiClientUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDiscoveredAiClientUsersQuery,
        GetDiscoveredAiClientUsersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDiscoveredAiClientUsersQuery,
    GetDiscoveredAiClientUsersQueryVariables
  >(GetDiscoveredAiClientUsersDocument, options);
}
export type GetDiscoveredAiClientUsersQueryHookResult = ReturnType<
  typeof useGetDiscoveredAiClientUsersQuery
>;
export type GetDiscoveredAiClientUsersLazyQueryHookResult = ReturnType<
  typeof useGetDiscoveredAiClientUsersLazyQuery
>;
export type GetDiscoveredAiClientUsersSuspenseQueryHookResult = ReturnType<
  typeof useGetDiscoveredAiClientUsersSuspenseQuery
>;
export type GetDiscoveredAiClientUsersQueryResult = Apollo.QueryResult<
  GetDiscoveredAiClientUsersQuery,
  GetDiscoveredAiClientUsersQueryVariables
>;
export const ActorAutocompleteDocument = gql`
  query actorAutocomplete(
    $types: [MCPAccessPolicyPrincipalType!]!
    $q: String
    $ids: [ObjectID!]
    $limit: Int
    $offset: Int
  ) {
    accessPolicyPrincipals(
      types: $types
      q: $q
      ids: $ids
      limit: $limit
      offset: $offset
    ) {
      principals {
        __typename
        ... on User {
          userId: _id
          userDisplayName: displayName
          email
        }
        ... on Agent {
          agentId: _id
          agentDisplayName: displayName
          owner {
            _id
            displayName
          }
        }
      }
    }
  }
`;

/**
 * __useActorAutocompleteQuery__
 *
 * To run a query within a React component, call `useActorAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useActorAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActorAutocompleteQuery({
 *   variables: {
 *      types: // value for 'types'
 *      q: // value for 'q'
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useActorAutocompleteQuery(
  baseOptions: Apollo.QueryHookOptions<
    ActorAutocompleteQuery,
    ActorAutocompleteQueryVariables
  > &
    (
      | { variables: ActorAutocompleteQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ActorAutocompleteQuery,
    ActorAutocompleteQueryVariables
  >(ActorAutocompleteDocument, options);
}
export function useActorAutocompleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActorAutocompleteQuery,
    ActorAutocompleteQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ActorAutocompleteQuery,
    ActorAutocompleteQueryVariables
  >(ActorAutocompleteDocument, options);
}
// @ts-ignore
export function useActorAutocompleteSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ActorAutocompleteQuery,
    ActorAutocompleteQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ActorAutocompleteQuery,
  ActorAutocompleteQueryVariables
>;
export function useActorAutocompleteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActorAutocompleteQuery,
        ActorAutocompleteQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ActorAutocompleteQuery | undefined,
  ActorAutocompleteQueryVariables
>;
export function useActorAutocompleteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActorAutocompleteQuery,
        ActorAutocompleteQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ActorAutocompleteQuery,
    ActorAutocompleteQueryVariables
  >(ActorAutocompleteDocument, options);
}
export type ActorAutocompleteQueryHookResult = ReturnType<
  typeof useActorAutocompleteQuery
>;
export type ActorAutocompleteLazyQueryHookResult = ReturnType<
  typeof useActorAutocompleteLazyQuery
>;
export type ActorAutocompleteSuspenseQueryHookResult = ReturnType<
  typeof useActorAutocompleteSuspenseQuery
>;
export type ActorAutocompleteQueryResult = Apollo.QueryResult<
  ActorAutocompleteQuery,
  ActorAutocompleteQueryVariables
>;
export const GetAvailableMcpServersDocument = gql`
  query getAvailableMcpServers(
    $q: String
    $offset: Int
    $limit: Int
    $availableForTypes: [MCPServerAccessAvailableFor!]
    $agentId: ObjectID
  ) {
    mcpServers(
      q: $q
      offset: $offset
      limit: $limit
      availableForTypes: $availableForTypes
      isAvailableQuery: true
      agentId: $agentId
    ) {
      _id
      name
      accessConfig {
        availableFor
        isPersonalConnectionEnabled
      }
      availableInstalls(showInstalls: true, agentId: $agentId) {
        _id
        displayName
        accessConfig {
          installType
        }
        installed(agentId: $agentId)
      }
      canConnect
    }
  }
`;

/**
 * __useGetAvailableMcpServersQuery__
 *
 * To run a query within a React component, call `useGetAvailableMcpServersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableMcpServersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableMcpServersQuery({
 *   variables: {
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      availableForTypes: // value for 'availableForTypes'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useGetAvailableMcpServersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAvailableMcpServersQuery,
    GetAvailableMcpServersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAvailableMcpServersQuery,
    GetAvailableMcpServersQueryVariables
  >(GetAvailableMcpServersDocument, options);
}
export function useGetAvailableMcpServersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAvailableMcpServersQuery,
    GetAvailableMcpServersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAvailableMcpServersQuery,
    GetAvailableMcpServersQueryVariables
  >(GetAvailableMcpServersDocument, options);
}
// @ts-ignore
export function useGetAvailableMcpServersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAvailableMcpServersQuery,
    GetAvailableMcpServersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetAvailableMcpServersQuery,
  GetAvailableMcpServersQueryVariables
>;
export function useGetAvailableMcpServersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAvailableMcpServersQuery,
        GetAvailableMcpServersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetAvailableMcpServersQuery | undefined,
  GetAvailableMcpServersQueryVariables
>;
export function useGetAvailableMcpServersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAvailableMcpServersQuery,
        GetAvailableMcpServersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAvailableMcpServersQuery,
    GetAvailableMcpServersQueryVariables
  >(GetAvailableMcpServersDocument, options);
}
export type GetAvailableMcpServersQueryHookResult = ReturnType<
  typeof useGetAvailableMcpServersQuery
>;
export type GetAvailableMcpServersLazyQueryHookResult = ReturnType<
  typeof useGetAvailableMcpServersLazyQuery
>;
export type GetAvailableMcpServersSuspenseQueryHookResult = ReturnType<
  typeof useGetAvailableMcpServersSuspenseQuery
>;
export type GetAvailableMcpServersQueryResult = Apollo.QueryResult<
  GetAvailableMcpServersQuery,
  GetAvailableMcpServersQueryVariables
>;
export const GetAgentMcpServerInstallsDocument = gql`
  query getAgentMcpServerInstalls(
    $agentId: ObjectID!
    $server: ObjectID
    $offset: Int
    $limit: Int
  ) {
    agentMcpServerInstalls(
      agentId: $agentId
      server: $server
      offset: $offset
      limit: $limit
    ) {
      _id
      displayName
      status
      mcpUrl(agentId: $agentId)
      server {
        _id
        name
        status
        serverInfo {
          __typename
          ... on MCPServerInfo {
            source {
              __typename
            }
          }
          ... on CustomMCPServerInfo {
            source {
              __typename
              ... on CustomRemoteUrlSource {
                isOnPrem
              }
              ... on CustomDynamicRemoteUrlSource {
                isOnPrem
              }
            }
          }
        }
        accessConfig {
          availableFor
          isPersonalConnectionEnabled
        }
        availableInstalls(showInstalls: true, agentId: $agentId) {
          _id
          displayName
          accessConfig {
            installType
          }
          installed(agentId: $agentId)
        }
      }
      accessConfig {
        installType
      }
      tools(agentId: $agentId) {
        name
        description
      }
      canEdit
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useGetAgentMcpServerInstallsQuery__
 *
 * To run a query within a React component, call `useGetAgentMcpServerInstallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentMcpServerInstallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentMcpServerInstallsQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      server: // value for 'server'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAgentMcpServerInstallsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAgentMcpServerInstallsQuery,
    GetAgentMcpServerInstallsQueryVariables
  > &
    (
      | { variables: GetAgentMcpServerInstallsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAgentMcpServerInstallsQuery,
    GetAgentMcpServerInstallsQueryVariables
  >(GetAgentMcpServerInstallsDocument, options);
}
export function useGetAgentMcpServerInstallsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAgentMcpServerInstallsQuery,
    GetAgentMcpServerInstallsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAgentMcpServerInstallsQuery,
    GetAgentMcpServerInstallsQueryVariables
  >(GetAgentMcpServerInstallsDocument, options);
}
// @ts-ignore
export function useGetAgentMcpServerInstallsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAgentMcpServerInstallsQuery,
    GetAgentMcpServerInstallsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetAgentMcpServerInstallsQuery,
  GetAgentMcpServerInstallsQueryVariables
>;
export function useGetAgentMcpServerInstallsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAgentMcpServerInstallsQuery,
        GetAgentMcpServerInstallsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetAgentMcpServerInstallsQuery | undefined,
  GetAgentMcpServerInstallsQueryVariables
>;
export function useGetAgentMcpServerInstallsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAgentMcpServerInstallsQuery,
        GetAgentMcpServerInstallsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAgentMcpServerInstallsQuery,
    GetAgentMcpServerInstallsQueryVariables
  >(GetAgentMcpServerInstallsDocument, options);
}
export type GetAgentMcpServerInstallsQueryHookResult = ReturnType<
  typeof useGetAgentMcpServerInstallsQuery
>;
export type GetAgentMcpServerInstallsLazyQueryHookResult = ReturnType<
  typeof useGetAgentMcpServerInstallsLazyQuery
>;
export type GetAgentMcpServerInstallsSuspenseQueryHookResult = ReturnType<
  typeof useGetAgentMcpServerInstallsSuspenseQuery
>;
export type GetAgentMcpServerInstallsQueryResult = Apollo.QueryResult<
  GetAgentMcpServerInstallsQuery,
  GetAgentMcpServerInstallsQueryVariables
>;
export const GetAdminAppCatalogDocument = gql`
  query getAdminAppCatalog(
    $appType: AppType
    $q: String
    $offset: Int
    $limit: Int
  ) {
    adminAppCatalog(appType: $appType, q: $q, offset: $offset, limit: $limit) {
      name
      slug
      appType
    }
  }
`;

/**
 * __useGetAdminAppCatalogQuery__
 *
 * To run a query within a React component, call `useGetAdminAppCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminAppCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminAppCatalogQuery({
 *   variables: {
 *      appType: // value for 'appType'
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAdminAppCatalogQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAdminAppCatalogQuery,
    GetAdminAppCatalogQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAdminAppCatalogQuery,
    GetAdminAppCatalogQueryVariables
  >(GetAdminAppCatalogDocument, options);
}
export function useGetAdminAppCatalogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdminAppCatalogQuery,
    GetAdminAppCatalogQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdminAppCatalogQuery,
    GetAdminAppCatalogQueryVariables
  >(GetAdminAppCatalogDocument, options);
}
// @ts-ignore
export function useGetAdminAppCatalogSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAdminAppCatalogQuery,
    GetAdminAppCatalogQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetAdminAppCatalogQuery,
  GetAdminAppCatalogQueryVariables
>;
export function useGetAdminAppCatalogSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAdminAppCatalogQuery,
        GetAdminAppCatalogQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetAdminAppCatalogQuery | undefined,
  GetAdminAppCatalogQueryVariables
>;
export function useGetAdminAppCatalogSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAdminAppCatalogQuery,
        GetAdminAppCatalogQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAdminAppCatalogQuery,
    GetAdminAppCatalogQueryVariables
  >(GetAdminAppCatalogDocument, options);
}
export type GetAdminAppCatalogQueryHookResult = ReturnType<
  typeof useGetAdminAppCatalogQuery
>;
export type GetAdminAppCatalogLazyQueryHookResult = ReturnType<
  typeof useGetAdminAppCatalogLazyQuery
>;
export type GetAdminAppCatalogSuspenseQueryHookResult = ReturnType<
  typeof useGetAdminAppCatalogSuspenseQuery
>;
export type GetAdminAppCatalogQueryResult = Apollo.QueryResult<
  GetAdminAppCatalogQuery,
  GetAdminAppCatalogQueryVariables
>;
export const AppsCardViewEnableMcpServerDocument = gql`
  mutation AppsCardViewEnableMcpServer($input: EnableMcpServerInput!) {
    enableMcpServer(input: $input) {
      _id
    }
  }
`;
export type AppsCardViewEnableMcpServerMutationFn = Apollo.MutationFunction<
  AppsCardViewEnableMcpServerMutation,
  AppsCardViewEnableMcpServerMutationVariables
>;

/**
 * __useAppsCardViewEnableMcpServerMutation__
 *
 * To run a mutation, you first call `useAppsCardViewEnableMcpServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppsCardViewEnableMcpServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appsCardViewEnableMcpServerMutation, { data, loading, error }] = useAppsCardViewEnableMcpServerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppsCardViewEnableMcpServerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AppsCardViewEnableMcpServerMutation,
    AppsCardViewEnableMcpServerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AppsCardViewEnableMcpServerMutation,
    AppsCardViewEnableMcpServerMutationVariables
  >(AppsCardViewEnableMcpServerDocument, options);
}
export type AppsCardViewEnableMcpServerMutationHookResult = ReturnType<
  typeof useAppsCardViewEnableMcpServerMutation
>;
export type AppsCardViewEnableMcpServerMutationResult =
  Apollo.MutationResult<AppsCardViewEnableMcpServerMutation>;
export type AppsCardViewEnableMcpServerMutationOptions =
  Apollo.BaseMutationOptions<
    AppsCardViewEnableMcpServerMutation,
    AppsCardViewEnableMcpServerMutationVariables
  >;
export const AppsCardViewEditMcpServerDocument = gql`
  mutation AppsCardViewEditMcpServer($input: EditMcpServerInput!) {
    editMcpServer(input: $input) {
      _id
      accessConfig {
        availableFor
        isPersonalConnectionEnabled
      }
      config
    }
  }
`;
export type AppsCardViewEditMcpServerMutationFn = Apollo.MutationFunction<
  AppsCardViewEditMcpServerMutation,
  AppsCardViewEditMcpServerMutationVariables
>;

/**
 * __useAppsCardViewEditMcpServerMutation__
 *
 * To run a mutation, you first call `useAppsCardViewEditMcpServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppsCardViewEditMcpServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appsCardViewEditMcpServerMutation, { data, loading, error }] = useAppsCardViewEditMcpServerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppsCardViewEditMcpServerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AppsCardViewEditMcpServerMutation,
    AppsCardViewEditMcpServerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AppsCardViewEditMcpServerMutation,
    AppsCardViewEditMcpServerMutationVariables
  >(AppsCardViewEditMcpServerDocument, options);
}
export type AppsCardViewEditMcpServerMutationHookResult = ReturnType<
  typeof useAppsCardViewEditMcpServerMutation
>;
export type AppsCardViewEditMcpServerMutationResult =
  Apollo.MutationResult<AppsCardViewEditMcpServerMutation>;
export type AppsCardViewEditMcpServerMutationOptions =
  Apollo.BaseMutationOptions<
    AppsCardViewEditMcpServerMutation,
    AppsCardViewEditMcpServerMutationVariables
  >;
export const AppsCardViewMcpServerInfosDocument = gql`
  query AppsCardViewMcpServerInfos($q: String, $offset: Int, $limit: Int) {
    mcpServerInfos(q: $q, offset: $offset, limit: $limit) {
      serverId
      slug
      name
      authenticationType
      installConfig {
        required
        properties
      }
      serverConfig {
        required
        properties
      }
      source {
        __typename
        ... on NatomaDynamicRemoteUrlSource {
          sourceType
        }
        ... on NatomaLocalPackageSource {
          sourceType
        }
        ... on NatomaLocalUrlSource {
          sourceType
        }
        ... on NatomaRemoteUrlSource {
          sourceType
        }
        ... on NatomaRepositorySource {
          sourceType
          type
        }
      }
      authConfig {
        supportedScopes
        requiredScopes
        scopeDelimiter
        hasDefaultClient
      }
      annotations {
        hintPreRegistered
      }
    }
  }
`;

/**
 * __useAppsCardViewMcpServerInfosQuery__
 *
 * To run a query within a React component, call `useAppsCardViewMcpServerInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppsCardViewMcpServerInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppsCardViewMcpServerInfosQuery({
 *   variables: {
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAppsCardViewMcpServerInfosQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AppsCardViewMcpServerInfosQuery,
    AppsCardViewMcpServerInfosQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AppsCardViewMcpServerInfosQuery,
    AppsCardViewMcpServerInfosQueryVariables
  >(AppsCardViewMcpServerInfosDocument, options);
}
export function useAppsCardViewMcpServerInfosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AppsCardViewMcpServerInfosQuery,
    AppsCardViewMcpServerInfosQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AppsCardViewMcpServerInfosQuery,
    AppsCardViewMcpServerInfosQueryVariables
  >(AppsCardViewMcpServerInfosDocument, options);
}
// @ts-ignore
export function useAppsCardViewMcpServerInfosSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AppsCardViewMcpServerInfosQuery,
    AppsCardViewMcpServerInfosQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  AppsCardViewMcpServerInfosQuery,
  AppsCardViewMcpServerInfosQueryVariables
>;
export function useAppsCardViewMcpServerInfosSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AppsCardViewMcpServerInfosQuery,
        AppsCardViewMcpServerInfosQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  AppsCardViewMcpServerInfosQuery | undefined,
  AppsCardViewMcpServerInfosQueryVariables
>;
export function useAppsCardViewMcpServerInfosSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AppsCardViewMcpServerInfosQuery,
        AppsCardViewMcpServerInfosQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AppsCardViewMcpServerInfosQuery,
    AppsCardViewMcpServerInfosQueryVariables
  >(AppsCardViewMcpServerInfosDocument, options);
}
export type AppsCardViewMcpServerInfosQueryHookResult = ReturnType<
  typeof useAppsCardViewMcpServerInfosQuery
>;
export type AppsCardViewMcpServerInfosLazyQueryHookResult = ReturnType<
  typeof useAppsCardViewMcpServerInfosLazyQuery
>;
export type AppsCardViewMcpServerInfosSuspenseQueryHookResult = ReturnType<
  typeof useAppsCardViewMcpServerInfosSuspenseQuery
>;
export type AppsCardViewMcpServerInfosQueryResult = Apollo.QueryResult<
  AppsCardViewMcpServerInfosQuery,
  AppsCardViewMcpServerInfosQueryVariables
>;
export const GetEnabledServersAppsViewDocument = gql`
  query getEnabledServersAppsView(
    $q: String
    $offset: Int
    $limit: Int
    $availableForTypes: [MCPServerAccessAvailableFor!]
  ) {
    mcpServers(
      q: $q
      offset: $offset
      limit: $limit
      availableForTypes: $availableForTypes
    ) {
      _id
      accessConfig {
        availableFor
      }
      serverInfo {
        __typename
        ... on MCPServerInfo {
          serverId
          name
          authenticationType
          installConfig {
            required
            properties
          }
          serverConfig {
            required
            properties
          }
          source {
            __typename
            ... on NatomaRepositorySource {
              type
            }
          }
          annotations {
            hintPreRegistered
          }
        }
        ... on CustomMCPServerInfo {
          name
          authenticationType
          installConfig {
            required
            properties
          }
          source {
            __typename
            ... on CustomDynamicRemoteUrlSource {
              isOnPrem
              mcpServerUrl
              useCustomAuthServer
              deployment {
                _id
                displayName
                origin
              }
            }
            ... on CustomRemoteUrlSource {
              isOnPrem
              mcpServerUrl
              useCustomAuthServer
              deployment {
                _id
                displayName
                origin
              }
            }
          }
        }
      }
      managedInstalls {
        id
        displayName
        canEdit
      }
      name
      description
      originType
      isRemoteServerScanned
      status
      config
      oauthClientId
      hasOauthClientSecret
      oauthScopes
    }
  }
`;

/**
 * __useGetEnabledServersAppsViewQuery__
 *
 * To run a query within a React component, call `useGetEnabledServersAppsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnabledServersAppsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnabledServersAppsViewQuery({
 *   variables: {
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      availableForTypes: // value for 'availableForTypes'
 *   },
 * });
 */
export function useGetEnabledServersAppsViewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEnabledServersAppsViewQuery,
    GetEnabledServersAppsViewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEnabledServersAppsViewQuery,
    GetEnabledServersAppsViewQueryVariables
  >(GetEnabledServersAppsViewDocument, options);
}
export function useGetEnabledServersAppsViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEnabledServersAppsViewQuery,
    GetEnabledServersAppsViewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEnabledServersAppsViewQuery,
    GetEnabledServersAppsViewQueryVariables
  >(GetEnabledServersAppsViewDocument, options);
}
// @ts-ignore
export function useGetEnabledServersAppsViewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEnabledServersAppsViewQuery,
    GetEnabledServersAppsViewQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetEnabledServersAppsViewQuery,
  GetEnabledServersAppsViewQueryVariables
>;
export function useGetEnabledServersAppsViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEnabledServersAppsViewQuery,
        GetEnabledServersAppsViewQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetEnabledServersAppsViewQuery | undefined,
  GetEnabledServersAppsViewQueryVariables
>;
export function useGetEnabledServersAppsViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEnabledServersAppsViewQuery,
        GetEnabledServersAppsViewQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEnabledServersAppsViewQuery,
    GetEnabledServersAppsViewQueryVariables
  >(GetEnabledServersAppsViewDocument, options);
}
export type GetEnabledServersAppsViewQueryHookResult = ReturnType<
  typeof useGetEnabledServersAppsViewQuery
>;
export type GetEnabledServersAppsViewLazyQueryHookResult = ReturnType<
  typeof useGetEnabledServersAppsViewLazyQuery
>;
export type GetEnabledServersAppsViewSuspenseQueryHookResult = ReturnType<
  typeof useGetEnabledServersAppsViewSuspenseQuery
>;
export type GetEnabledServersAppsViewQueryResult = Apollo.QueryResult<
  GetEnabledServersAppsViewQuery,
  GetEnabledServersAppsViewQueryVariables
>;
export const AppsCardViewFlagScanForServerDocument = gql`
  mutation AppsCardViewFlagScanForServer($input: GetByIdMCPServerInput!) {
    flagScanForServer(input: $input) {
      _id
    }
  }
`;
export type AppsCardViewFlagScanForServerMutationFn = Apollo.MutationFunction<
  AppsCardViewFlagScanForServerMutation,
  AppsCardViewFlagScanForServerMutationVariables
>;

/**
 * __useAppsCardViewFlagScanForServerMutation__
 *
 * To run a mutation, you first call `useAppsCardViewFlagScanForServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppsCardViewFlagScanForServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appsCardViewFlagScanForServerMutation, { data, loading, error }] = useAppsCardViewFlagScanForServerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppsCardViewFlagScanForServerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AppsCardViewFlagScanForServerMutation,
    AppsCardViewFlagScanForServerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AppsCardViewFlagScanForServerMutation,
    AppsCardViewFlagScanForServerMutationVariables
  >(AppsCardViewFlagScanForServerDocument, options);
}
export type AppsCardViewFlagScanForServerMutationHookResult = ReturnType<
  typeof useAppsCardViewFlagScanForServerMutation
>;
export type AppsCardViewFlagScanForServerMutationResult =
  Apollo.MutationResult<AppsCardViewFlagScanForServerMutation>;
export type AppsCardViewFlagScanForServerMutationOptions =
  Apollo.BaseMutationOptions<
    AppsCardViewFlagScanForServerMutation,
    AppsCardViewFlagScanForServerMutationVariables
  >;
export const AppsCardViewMcpServerPollingDocument = gql`
  query AppsCardViewMcpServerPolling($id: ObjectID!) {
    mcpServer(id: $id) {
      _id
      status
    }
  }
`;

/**
 * __useAppsCardViewMcpServerPollingQuery__
 *
 * To run a query within a React component, call `useAppsCardViewMcpServerPollingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppsCardViewMcpServerPollingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppsCardViewMcpServerPollingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppsCardViewMcpServerPollingQuery(
  baseOptions: Apollo.QueryHookOptions<
    AppsCardViewMcpServerPollingQuery,
    AppsCardViewMcpServerPollingQueryVariables
  > &
    (
      | {
          variables: AppsCardViewMcpServerPollingQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AppsCardViewMcpServerPollingQuery,
    AppsCardViewMcpServerPollingQueryVariables
  >(AppsCardViewMcpServerPollingDocument, options);
}
export function useAppsCardViewMcpServerPollingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AppsCardViewMcpServerPollingQuery,
    AppsCardViewMcpServerPollingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AppsCardViewMcpServerPollingQuery,
    AppsCardViewMcpServerPollingQueryVariables
  >(AppsCardViewMcpServerPollingDocument, options);
}
// @ts-ignore
export function useAppsCardViewMcpServerPollingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AppsCardViewMcpServerPollingQuery,
    AppsCardViewMcpServerPollingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  AppsCardViewMcpServerPollingQuery,
  AppsCardViewMcpServerPollingQueryVariables
>;
export function useAppsCardViewMcpServerPollingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AppsCardViewMcpServerPollingQuery,
        AppsCardViewMcpServerPollingQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  AppsCardViewMcpServerPollingQuery | undefined,
  AppsCardViewMcpServerPollingQueryVariables
>;
export function useAppsCardViewMcpServerPollingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AppsCardViewMcpServerPollingQuery,
        AppsCardViewMcpServerPollingQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AppsCardViewMcpServerPollingQuery,
    AppsCardViewMcpServerPollingQueryVariables
  >(AppsCardViewMcpServerPollingDocument, options);
}
export type AppsCardViewMcpServerPollingQueryHookResult = ReturnType<
  typeof useAppsCardViewMcpServerPollingQuery
>;
export type AppsCardViewMcpServerPollingLazyQueryHookResult = ReturnType<
  typeof useAppsCardViewMcpServerPollingLazyQuery
>;
export type AppsCardViewMcpServerPollingSuspenseQueryHookResult = ReturnType<
  typeof useAppsCardViewMcpServerPollingSuspenseQuery
>;
export type AppsCardViewMcpServerPollingQueryResult = Apollo.QueryResult<
  AppsCardViewMcpServerPollingQuery,
  AppsCardViewMcpServerPollingQueryVariables
>;
export const GetDoesByoServerExistDocument = gql`
  query getDoesByoServerExist {
    doesByoServerExist
  }
`;

/**
 * __useGetDoesByoServerExistQuery__
 *
 * To run a query within a React component, call `useGetDoesByoServerExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDoesByoServerExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDoesByoServerExistQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDoesByoServerExistQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDoesByoServerExistQuery,
    GetDoesByoServerExistQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDoesByoServerExistQuery,
    GetDoesByoServerExistQueryVariables
  >(GetDoesByoServerExistDocument, options);
}
export function useGetDoesByoServerExistLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDoesByoServerExistQuery,
    GetDoesByoServerExistQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDoesByoServerExistQuery,
    GetDoesByoServerExistQueryVariables
  >(GetDoesByoServerExistDocument, options);
}
// @ts-ignore
export function useGetDoesByoServerExistSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDoesByoServerExistQuery,
    GetDoesByoServerExistQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetDoesByoServerExistQuery,
  GetDoesByoServerExistQueryVariables
>;
export function useGetDoesByoServerExistSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDoesByoServerExistQuery,
        GetDoesByoServerExistQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetDoesByoServerExistQuery | undefined,
  GetDoesByoServerExistQueryVariables
>;
export function useGetDoesByoServerExistSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDoesByoServerExistQuery,
        GetDoesByoServerExistQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDoesByoServerExistQuery,
    GetDoesByoServerExistQueryVariables
  >(GetDoesByoServerExistDocument, options);
}
export type GetDoesByoServerExistQueryHookResult = ReturnType<
  typeof useGetDoesByoServerExistQuery
>;
export type GetDoesByoServerExistLazyQueryHookResult = ReturnType<
  typeof useGetDoesByoServerExistLazyQuery
>;
export type GetDoesByoServerExistSuspenseQueryHookResult = ReturnType<
  typeof useGetDoesByoServerExistSuspenseQuery
>;
export type GetDoesByoServerExistQueryResult = Apollo.QueryResult<
  GetDoesByoServerExistQuery,
  GetDoesByoServerExistQueryVariables
>;
export const GetMcpServerInstallDocument = gql`
  query getMcpServerInstall($id: ObjectID!) {
    mcpServerInstall(id: $id) {
      _id
      displayName
      server {
        _id
        serverInfo {
          __typename
          ... on MCPServerInfo {
            slug
          }
          ... on CustomMCPServerInfo {
            slug
          }
        }
      }
      accessConfig {
        installType
      }
      canEdit
    }
  }
`;

/**
 * __useGetMcpServerInstallQuery__
 *
 * To run a query within a React component, call `useGetMcpServerInstallQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMcpServerInstallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMcpServerInstallQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMcpServerInstallQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMcpServerInstallQuery,
    GetMcpServerInstallQueryVariables
  > &
    (
      | { variables: GetMcpServerInstallQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMcpServerInstallQuery,
    GetMcpServerInstallQueryVariables
  >(GetMcpServerInstallDocument, options);
}
export function useGetMcpServerInstallLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMcpServerInstallQuery,
    GetMcpServerInstallQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMcpServerInstallQuery,
    GetMcpServerInstallQueryVariables
  >(GetMcpServerInstallDocument, options);
}
// @ts-ignore
export function useGetMcpServerInstallSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMcpServerInstallQuery,
    GetMcpServerInstallQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetMcpServerInstallQuery,
  GetMcpServerInstallQueryVariables
>;
export function useGetMcpServerInstallSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMcpServerInstallQuery,
        GetMcpServerInstallQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetMcpServerInstallQuery | undefined,
  GetMcpServerInstallQueryVariables
>;
export function useGetMcpServerInstallSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMcpServerInstallQuery,
        GetMcpServerInstallQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMcpServerInstallQuery,
    GetMcpServerInstallQueryVariables
  >(GetMcpServerInstallDocument, options);
}
export type GetMcpServerInstallQueryHookResult = ReturnType<
  typeof useGetMcpServerInstallQuery
>;
export type GetMcpServerInstallLazyQueryHookResult = ReturnType<
  typeof useGetMcpServerInstallLazyQuery
>;
export type GetMcpServerInstallSuspenseQueryHookResult = ReturnType<
  typeof useGetMcpServerInstallSuspenseQuery
>;
export type GetMcpServerInstallQueryResult = Apollo.QueryResult<
  GetMcpServerInstallQuery,
  GetMcpServerInstallQueryVariables
>;
export const GetByoMcpServersDocument = gql`
  query getByoMcpServers(
    $q: String
    $offset: Int
    $limit: Int
    $showUnusedByoOnly: Boolean
  ) {
    mcpServers(
      q: $q
      offset: $offset
      limit: $limit
      showUnusedByoOnly: $showUnusedByoOnly
    ) {
      _id
      accessConfig {
        availableFor
      }
      serverInfo {
        __typename
        ... on CustomMCPServerInfo {
          name
          authenticationType
          installConfig {
            required
            properties
          }
          source {
            __typename
            ... on CustomRemoteUrlSource {
              isOnPrem
              mcpServerUrl
              useCustomAuthServer
              deployment {
                _id
                displayName
                origin
              }
            }
          }
        }
      }
      managedInstalls {
        id
        displayName
      }
      name
      description
      originType
      isRemoteServerScanned
      status
      oauthScopes
    }
  }
`;

/**
 * __useGetByoMcpServersQuery__
 *
 * To run a query within a React component, call `useGetByoMcpServersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetByoMcpServersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetByoMcpServersQuery({
 *   variables: {
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      showUnusedByoOnly: // value for 'showUnusedByoOnly'
 *   },
 * });
 */
export function useGetByoMcpServersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetByoMcpServersQuery,
    GetByoMcpServersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetByoMcpServersQuery, GetByoMcpServersQueryVariables>(
    GetByoMcpServersDocument,
    options
  );
}
export function useGetByoMcpServersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetByoMcpServersQuery,
    GetByoMcpServersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetByoMcpServersQuery,
    GetByoMcpServersQueryVariables
  >(GetByoMcpServersDocument, options);
}
// @ts-ignore
export function useGetByoMcpServersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetByoMcpServersQuery,
    GetByoMcpServersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetByoMcpServersQuery,
  GetByoMcpServersQueryVariables
>;
export function useGetByoMcpServersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetByoMcpServersQuery,
        GetByoMcpServersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetByoMcpServersQuery | undefined,
  GetByoMcpServersQueryVariables
>;
export function useGetByoMcpServersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetByoMcpServersQuery,
        GetByoMcpServersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetByoMcpServersQuery,
    GetByoMcpServersQueryVariables
  >(GetByoMcpServersDocument, options);
}
export type GetByoMcpServersQueryHookResult = ReturnType<
  typeof useGetByoMcpServersQuery
>;
export type GetByoMcpServersLazyQueryHookResult = ReturnType<
  typeof useGetByoMcpServersLazyQuery
>;
export type GetByoMcpServersSuspenseQueryHookResult = ReturnType<
  typeof useGetByoMcpServersSuspenseQuery
>;
export type GetByoMcpServersQueryResult = Apollo.QueryResult<
  GetByoMcpServersQuery,
  GetByoMcpServersQueryVariables
>;
export const AppPersonalDisableDocument = gql`
  mutation AppPersonalDisable($input: EditMcpServerInput!) {
    editMcpServer(input: $input) {
      _id
      accessConfig {
        availableFor
        isPersonalConnectionEnabled
      }
      config
    }
  }
`;
export type AppPersonalDisableMutationFn = Apollo.MutationFunction<
  AppPersonalDisableMutation,
  AppPersonalDisableMutationVariables
>;

/**
 * __useAppPersonalDisableMutation__
 *
 * To run a mutation, you first call `useAppPersonalDisableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppPersonalDisableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appPersonalDisableMutation, { data, loading, error }] = useAppPersonalDisableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppPersonalDisableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AppPersonalDisableMutation,
    AppPersonalDisableMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AppPersonalDisableMutation,
    AppPersonalDisableMutationVariables
  >(AppPersonalDisableDocument, options);
}
export type AppPersonalDisableMutationHookResult = ReturnType<
  typeof useAppPersonalDisableMutation
>;
export type AppPersonalDisableMutationResult =
  Apollo.MutationResult<AppPersonalDisableMutation>;
export type AppPersonalDisableMutationOptions = Apollo.BaseMutationOptions<
  AppPersonalDisableMutation,
  AppPersonalDisableMutationVariables
>;
export const ByoServerRemoveMcpServerDocument = gql`
  mutation ByoServerRemoveMcpServer($input: GetByIdMCPServerInput!) {
    removeMCPServer(input: $input) {
      _id
    }
  }
`;
export type ByoServerRemoveMcpServerMutationFn = Apollo.MutationFunction<
  ByoServerRemoveMcpServerMutation,
  ByoServerRemoveMcpServerMutationVariables
>;

/**
 * __useByoServerRemoveMcpServerMutation__
 *
 * To run a mutation, you first call `useByoServerRemoveMcpServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useByoServerRemoveMcpServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [byoServerRemoveMcpServerMutation, { data, loading, error }] = useByoServerRemoveMcpServerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useByoServerRemoveMcpServerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ByoServerRemoveMcpServerMutation,
    ByoServerRemoveMcpServerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ByoServerRemoveMcpServerMutation,
    ByoServerRemoveMcpServerMutationVariables
  >(ByoServerRemoveMcpServerDocument, options);
}
export type ByoServerRemoveMcpServerMutationHookResult = ReturnType<
  typeof useByoServerRemoveMcpServerMutation
>;
export type ByoServerRemoveMcpServerMutationResult =
  Apollo.MutationResult<ByoServerRemoveMcpServerMutation>;
export type ByoServerRemoveMcpServerMutationOptions =
  Apollo.BaseMutationOptions<
    ByoServerRemoveMcpServerMutation,
    ByoServerRemoveMcpServerMutationVariables
  >;
export const GetMcpServersDocument = gql`
  query getMcpServers(
    $q: String
    $offset: Int
    $limit: Int
    $availableForTypes: [MCPServerAccessAvailableFor!]
  ) {
    mcpServers(
      q: $q
      offset: $offset
      limit: $limit
      availableForTypes: $availableForTypes
    ) {
      _id
      org {
        _id
        slug
        featureSwitchOverrides
        status
      }
      accessConfig {
        availableFor
        isPersonalConnectionEnabled
      }
      name
      status
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useGetMcpServersQuery__
 *
 * To run a query within a React component, call `useGetMcpServersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMcpServersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMcpServersQuery({
 *   variables: {
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      availableForTypes: // value for 'availableForTypes'
 *   },
 * });
 */
export function useGetMcpServersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMcpServersQuery,
    GetMcpServersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMcpServersQuery, GetMcpServersQueryVariables>(
    GetMcpServersDocument,
    options
  );
}
export function useGetMcpServersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMcpServersQuery,
    GetMcpServersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMcpServersQuery, GetMcpServersQueryVariables>(
    GetMcpServersDocument,
    options
  );
}
// @ts-ignore
export function useGetMcpServersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMcpServersQuery,
    GetMcpServersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetMcpServersQuery,
  GetMcpServersQueryVariables
>;
export function useGetMcpServersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMcpServersQuery,
        GetMcpServersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetMcpServersQuery | undefined,
  GetMcpServersQueryVariables
>;
export function useGetMcpServersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMcpServersQuery,
        GetMcpServersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMcpServersQuery,
    GetMcpServersQueryVariables
  >(GetMcpServersDocument, options);
}
export type GetMcpServersQueryHookResult = ReturnType<
  typeof useGetMcpServersQuery
>;
export type GetMcpServersLazyQueryHookResult = ReturnType<
  typeof useGetMcpServersLazyQuery
>;
export type GetMcpServersSuspenseQueryHookResult = ReturnType<
  typeof useGetMcpServersSuspenseQuery
>;
export type GetMcpServersQueryResult = Apollo.QueryResult<
  GetMcpServersQuery,
  GetMcpServersQueryVariables
>;
export const GroupAutocompleteDocument = gql`
  query groupAutocomplete(
    $types: [MCPAccessPolicyPrincipalType!]!
    $q: String
    $ids: [ObjectID!]
    $limit: Int
    $offset: Int
  ) {
    accessPolicyPrincipals(
      types: $types
      q: $q
      ids: $ids
      limit: $limit
      offset: $offset
    ) {
      principals {
        __typename
        ... on Group {
          _id: _id
          displayName: displayName
        }
      }
    }
  }
`;

/**
 * __useGroupAutocompleteQuery__
 *
 * To run a query within a React component, call `useGroupAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupAutocompleteQuery({
 *   variables: {
 *      types: // value for 'types'
 *      q: // value for 'q'
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGroupAutocompleteQuery(
  baseOptions: Apollo.QueryHookOptions<
    GroupAutocompleteQuery,
    GroupAutocompleteQueryVariables
  > &
    (
      | { variables: GroupAutocompleteQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GroupAutocompleteQuery,
    GroupAutocompleteQueryVariables
  >(GroupAutocompleteDocument, options);
}
export function useGroupAutocompleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GroupAutocompleteQuery,
    GroupAutocompleteQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GroupAutocompleteQuery,
    GroupAutocompleteQueryVariables
  >(GroupAutocompleteDocument, options);
}
// @ts-ignore
export function useGroupAutocompleteSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GroupAutocompleteQuery,
    GroupAutocompleteQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GroupAutocompleteQuery,
  GroupAutocompleteQueryVariables
>;
export function useGroupAutocompleteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GroupAutocompleteQuery,
        GroupAutocompleteQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GroupAutocompleteQuery | undefined,
  GroupAutocompleteQueryVariables
>;
export function useGroupAutocompleteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GroupAutocompleteQuery,
        GroupAutocompleteQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GroupAutocompleteQuery,
    GroupAutocompleteQueryVariables
  >(GroupAutocompleteDocument, options);
}
export type GroupAutocompleteQueryHookResult = ReturnType<
  typeof useGroupAutocompleteQuery
>;
export type GroupAutocompleteLazyQueryHookResult = ReturnType<
  typeof useGroupAutocompleteLazyQuery
>;
export type GroupAutocompleteSuspenseQueryHookResult = ReturnType<
  typeof useGroupAutocompleteSuspenseQuery
>;
export type GroupAutocompleteQueryResult = Apollo.QueryResult<
  GroupAutocompleteQuery,
  GroupAutocompleteQueryVariables
>;
export const ByoEditDrawerDocument = gql`
  mutation ByoEditDrawer($input: EditMcpServerInput!) {
    editMcpServer(input: $input) {
      _id
      name
      description
      accessConfig {
        availableFor
        isPersonalConnectionEnabled
      }
      status
      config
    }
  }
`;
export type ByoEditDrawerMutationFn = Apollo.MutationFunction<
  ByoEditDrawerMutation,
  ByoEditDrawerMutationVariables
>;

/**
 * __useByoEditDrawerMutation__
 *
 * To run a mutation, you first call `useByoEditDrawerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useByoEditDrawerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [byoEditDrawerMutation, { data, loading, error }] = useByoEditDrawerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useByoEditDrawerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ByoEditDrawerMutation,
    ByoEditDrawerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ByoEditDrawerMutation,
    ByoEditDrawerMutationVariables
  >(ByoEditDrawerDocument, options);
}
export type ByoEditDrawerMutationHookResult = ReturnType<
  typeof useByoEditDrawerMutation
>;
export type ByoEditDrawerMutationResult =
  Apollo.MutationResult<ByoEditDrawerMutation>;
export type ByoEditDrawerMutationOptions = Apollo.BaseMutationOptions<
  ByoEditDrawerMutation,
  ByoEditDrawerMutationVariables
>;
export const ByoStandardAppFormEnableMcpServerDocument = gql`
  mutation ByoStandardAppFormEnableMcpServer($input: EnableMcpServerInput!) {
    enableMcpServer(input: $input) {
      _id
      name
      accessConfig {
        availableFor
        isPersonalConnectionEnabled
      }
      status
    }
  }
`;
export type ByoStandardAppFormEnableMcpServerMutationFn =
  Apollo.MutationFunction<
    ByoStandardAppFormEnableMcpServerMutation,
    ByoStandardAppFormEnableMcpServerMutationVariables
  >;

/**
 * __useByoStandardAppFormEnableMcpServerMutation__
 *
 * To run a mutation, you first call `useByoStandardAppFormEnableMcpServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useByoStandardAppFormEnableMcpServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [byoStandardAppFormEnableMcpServerMutation, { data, loading, error }] = useByoStandardAppFormEnableMcpServerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useByoStandardAppFormEnableMcpServerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ByoStandardAppFormEnableMcpServerMutation,
    ByoStandardAppFormEnableMcpServerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ByoStandardAppFormEnableMcpServerMutation,
    ByoStandardAppFormEnableMcpServerMutationVariables
  >(ByoStandardAppFormEnableMcpServerDocument, options);
}
export type ByoStandardAppFormEnableMcpServerMutationHookResult = ReturnType<
  typeof useByoStandardAppFormEnableMcpServerMutation
>;
export type ByoStandardAppFormEnableMcpServerMutationResult =
  Apollo.MutationResult<ByoStandardAppFormEnableMcpServerMutation>;
export type ByoStandardAppFormEnableMcpServerMutationOptions =
  Apollo.BaseMutationOptions<
    ByoStandardAppFormEnableMcpServerMutation,
    ByoStandardAppFormEnableMcpServerMutationVariables
  >;
export const PersonalConfigDrawerEnableMcpServerDocument = gql`
  mutation PersonalConfigDrawerEnableMcpServer($input: EnableMcpServerInput!) {
    enableMcpServer(input: $input) {
      _id
    }
  }
`;
export type PersonalConfigDrawerEnableMcpServerMutationFn =
  Apollo.MutationFunction<
    PersonalConfigDrawerEnableMcpServerMutation,
    PersonalConfigDrawerEnableMcpServerMutationVariables
  >;

/**
 * __usePersonalConfigDrawerEnableMcpServerMutation__
 *
 * To run a mutation, you first call `usePersonalConfigDrawerEnableMcpServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonalConfigDrawerEnableMcpServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personalConfigDrawerEnableMcpServerMutation, { data, loading, error }] = usePersonalConfigDrawerEnableMcpServerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePersonalConfigDrawerEnableMcpServerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PersonalConfigDrawerEnableMcpServerMutation,
    PersonalConfigDrawerEnableMcpServerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PersonalConfigDrawerEnableMcpServerMutation,
    PersonalConfigDrawerEnableMcpServerMutationVariables
  >(PersonalConfigDrawerEnableMcpServerDocument, options);
}
export type PersonalConfigDrawerEnableMcpServerMutationHookResult = ReturnType<
  typeof usePersonalConfigDrawerEnableMcpServerMutation
>;
export type PersonalConfigDrawerEnableMcpServerMutationResult =
  Apollo.MutationResult<PersonalConfigDrawerEnableMcpServerMutation>;
export type PersonalConfigDrawerEnableMcpServerMutationOptions =
  Apollo.BaseMutationOptions<
    PersonalConfigDrawerEnableMcpServerMutation,
    PersonalConfigDrawerEnableMcpServerMutationVariables
  >;
export const PersonalConfigDrawerEditMcpServerDocument = gql`
  mutation PersonalConfigDrawerEditMcpServer($input: EditMcpServerInput!) {
    editMcpServer(input: $input) {
      _id
    }
  }
`;
export type PersonalConfigDrawerEditMcpServerMutationFn =
  Apollo.MutationFunction<
    PersonalConfigDrawerEditMcpServerMutation,
    PersonalConfigDrawerEditMcpServerMutationVariables
  >;

/**
 * __usePersonalConfigDrawerEditMcpServerMutation__
 *
 * To run a mutation, you first call `usePersonalConfigDrawerEditMcpServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonalConfigDrawerEditMcpServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personalConfigDrawerEditMcpServerMutation, { data, loading, error }] = usePersonalConfigDrawerEditMcpServerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePersonalConfigDrawerEditMcpServerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PersonalConfigDrawerEditMcpServerMutation,
    PersonalConfigDrawerEditMcpServerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PersonalConfigDrawerEditMcpServerMutation,
    PersonalConfigDrawerEditMcpServerMutationVariables
  >(PersonalConfigDrawerEditMcpServerDocument, options);
}
export type PersonalConfigDrawerEditMcpServerMutationHookResult = ReturnType<
  typeof usePersonalConfigDrawerEditMcpServerMutation
>;
export type PersonalConfigDrawerEditMcpServerMutationResult =
  Apollo.MutationResult<PersonalConfigDrawerEditMcpServerMutation>;
export type PersonalConfigDrawerEditMcpServerMutationOptions =
  Apollo.BaseMutationOptions<
    PersonalConfigDrawerEditMcpServerMutation,
    PersonalConfigDrawerEditMcpServerMutationVariables
  >;
export const GetPersonalCreateDrawerMcpServerDocument = gql`
  query getPersonalCreateDrawerMcpServer($id: ObjectID!) {
    mcpServer(id: $id) {
      _id
      name
      serverInfo {
        __typename
        ... on MCPServerInfo {
          authenticationType
          serverId
          instructions {
            installSetupInstructions
          }
          installConfig {
            required
            properties
          }
          source {
            __typename
            ... on NatomaRemoteUrlSource {
              sourceType
            }
            ... on NatomaLocalPackageSource {
              sourceType
            }
            ... on NatomaLocalUrlSource {
              sourceType
            }
            ... on NatomaRepositorySource {
              sourceType
            }
          }
        }
        ... on CustomMCPServerInfo {
          authenticationType
          installConfig {
            required
            properties
          }
          source {
            __typename
            ... on CustomRemoteUrlSource {
              sourceType
              mcpServerUrl
              isOnPrem
              deployment {
                origin
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetPersonalCreateDrawerMcpServerQuery__
 *
 * To run a query within a React component, call `useGetPersonalCreateDrawerMcpServerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalCreateDrawerMcpServerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalCreateDrawerMcpServerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPersonalCreateDrawerMcpServerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPersonalCreateDrawerMcpServerQuery,
    GetPersonalCreateDrawerMcpServerQueryVariables
  > &
    (
      | {
          variables: GetPersonalCreateDrawerMcpServerQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPersonalCreateDrawerMcpServerQuery,
    GetPersonalCreateDrawerMcpServerQueryVariables
  >(GetPersonalCreateDrawerMcpServerDocument, options);
}
export function useGetPersonalCreateDrawerMcpServerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPersonalCreateDrawerMcpServerQuery,
    GetPersonalCreateDrawerMcpServerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPersonalCreateDrawerMcpServerQuery,
    GetPersonalCreateDrawerMcpServerQueryVariables
  >(GetPersonalCreateDrawerMcpServerDocument, options);
}
// @ts-ignore
export function useGetPersonalCreateDrawerMcpServerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPersonalCreateDrawerMcpServerQuery,
    GetPersonalCreateDrawerMcpServerQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetPersonalCreateDrawerMcpServerQuery,
  GetPersonalCreateDrawerMcpServerQueryVariables
>;
export function useGetPersonalCreateDrawerMcpServerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPersonalCreateDrawerMcpServerQuery,
        GetPersonalCreateDrawerMcpServerQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetPersonalCreateDrawerMcpServerQuery | undefined,
  GetPersonalCreateDrawerMcpServerQueryVariables
>;
export function useGetPersonalCreateDrawerMcpServerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPersonalCreateDrawerMcpServerQuery,
        GetPersonalCreateDrawerMcpServerQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPersonalCreateDrawerMcpServerQuery,
    GetPersonalCreateDrawerMcpServerQueryVariables
  >(GetPersonalCreateDrawerMcpServerDocument, options);
}
export type GetPersonalCreateDrawerMcpServerQueryHookResult = ReturnType<
  typeof useGetPersonalCreateDrawerMcpServerQuery
>;
export type GetPersonalCreateDrawerMcpServerLazyQueryHookResult = ReturnType<
  typeof useGetPersonalCreateDrawerMcpServerLazyQuery
>;
export type GetPersonalCreateDrawerMcpServerSuspenseQueryHookResult =
  ReturnType<typeof useGetPersonalCreateDrawerMcpServerSuspenseQuery>;
export type GetPersonalCreateDrawerMcpServerQueryResult = Apollo.QueryResult<
  GetPersonalCreateDrawerMcpServerQuery,
  GetPersonalCreateDrawerMcpServerQueryVariables
>;
export const GetPersonalCreateDrawerMcpServerInstallDocument = gql`
  query getPersonalCreateDrawerMcpServerInstall($id: ObjectID!) {
    mcpServerInstall(id: $id) {
      _id
      displayName
      server {
        _id
        name
        serverInfo {
          __typename
          ... on MCPServerInfo {
            authenticationType
            serverId
            instructions {
              installSetupInstructions
            }
            installConfig {
              required
              properties
            }
            source {
              __typename
              ... on NatomaRemoteUrlSource {
                sourceType
              }
              ... on NatomaLocalPackageSource {
                sourceType
              }
              ... on NatomaLocalUrlSource {
                sourceType
              }
              ... on NatomaRepositorySource {
                sourceType
              }
            }
          }
          ... on CustomMCPServerInfo {
            authenticationType
            installConfig {
              required
              properties
            }
            source {
              __typename
              ... on CustomRemoteUrlSource {
                sourceType
                mcpServerUrl
                isOnPrem
                deployment {
                  origin
                }
              }
            }
          }
        }
      }
      accessConfig {
        installType
      }
    }
  }
`;

/**
 * __useGetPersonalCreateDrawerMcpServerInstallQuery__
 *
 * To run a query within a React component, call `useGetPersonalCreateDrawerMcpServerInstallQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalCreateDrawerMcpServerInstallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalCreateDrawerMcpServerInstallQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPersonalCreateDrawerMcpServerInstallQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPersonalCreateDrawerMcpServerInstallQuery,
    GetPersonalCreateDrawerMcpServerInstallQueryVariables
  > &
    (
      | {
          variables: GetPersonalCreateDrawerMcpServerInstallQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPersonalCreateDrawerMcpServerInstallQuery,
    GetPersonalCreateDrawerMcpServerInstallQueryVariables
  >(GetPersonalCreateDrawerMcpServerInstallDocument, options);
}
export function useGetPersonalCreateDrawerMcpServerInstallLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPersonalCreateDrawerMcpServerInstallQuery,
    GetPersonalCreateDrawerMcpServerInstallQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPersonalCreateDrawerMcpServerInstallQuery,
    GetPersonalCreateDrawerMcpServerInstallQueryVariables
  >(GetPersonalCreateDrawerMcpServerInstallDocument, options);
}
// @ts-ignore
export function useGetPersonalCreateDrawerMcpServerInstallSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPersonalCreateDrawerMcpServerInstallQuery,
    GetPersonalCreateDrawerMcpServerInstallQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetPersonalCreateDrawerMcpServerInstallQuery,
  GetPersonalCreateDrawerMcpServerInstallQueryVariables
>;
export function useGetPersonalCreateDrawerMcpServerInstallSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPersonalCreateDrawerMcpServerInstallQuery,
        GetPersonalCreateDrawerMcpServerInstallQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetPersonalCreateDrawerMcpServerInstallQuery | undefined,
  GetPersonalCreateDrawerMcpServerInstallQueryVariables
>;
export function useGetPersonalCreateDrawerMcpServerInstallSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPersonalCreateDrawerMcpServerInstallQuery,
        GetPersonalCreateDrawerMcpServerInstallQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPersonalCreateDrawerMcpServerInstallQuery,
    GetPersonalCreateDrawerMcpServerInstallQueryVariables
  >(GetPersonalCreateDrawerMcpServerInstallDocument, options);
}
export type GetPersonalCreateDrawerMcpServerInstallQueryHookResult = ReturnType<
  typeof useGetPersonalCreateDrawerMcpServerInstallQuery
>;
export type GetPersonalCreateDrawerMcpServerInstallLazyQueryHookResult =
  ReturnType<typeof useGetPersonalCreateDrawerMcpServerInstallLazyQuery>;
export type GetPersonalCreateDrawerMcpServerInstallSuspenseQueryHookResult =
  ReturnType<typeof useGetPersonalCreateDrawerMcpServerInstallSuspenseQuery>;
export type GetPersonalCreateDrawerMcpServerInstallQueryResult =
  Apollo.QueryResult<
    GetPersonalCreateDrawerMcpServerInstallQuery,
    GetPersonalCreateDrawerMcpServerInstallQueryVariables
  >;
export const GetMcpServersForProfileDocument = gql`
  query GetMCPServersForProfile($q: String) {
    mcpServers(q: $q, limit: 200) {
      _id
      name
      accessConfig {
        availableFor
        isPersonalConnectionEnabled
      }
      availableTools {
        name
        description
      }
      managedInstalls {
        id
        displayName
        availableTools {
          name
          description
        }
      }
    }
  }
`;

/**
 * __useGetMcpServersForProfileQuery__
 *
 * To run a query within a React component, call `useGetMcpServersForProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMcpServersForProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMcpServersForProfileQuery({
 *   variables: {
 *      q: // value for 'q'
 *   },
 * });
 */
export function useGetMcpServersForProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMcpServersForProfileQuery,
    GetMcpServersForProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMcpServersForProfileQuery,
    GetMcpServersForProfileQueryVariables
  >(GetMcpServersForProfileDocument, options);
}
export function useGetMcpServersForProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMcpServersForProfileQuery,
    GetMcpServersForProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMcpServersForProfileQuery,
    GetMcpServersForProfileQueryVariables
  >(GetMcpServersForProfileDocument, options);
}
// @ts-ignore
export function useGetMcpServersForProfileSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMcpServersForProfileQuery,
    GetMcpServersForProfileQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetMcpServersForProfileQuery,
  GetMcpServersForProfileQueryVariables
>;
export function useGetMcpServersForProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMcpServersForProfileQuery,
        GetMcpServersForProfileQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetMcpServersForProfileQuery | undefined,
  GetMcpServersForProfileQueryVariables
>;
export function useGetMcpServersForProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMcpServersForProfileQuery,
        GetMcpServersForProfileQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMcpServersForProfileQuery,
    GetMcpServersForProfileQueryVariables
  >(GetMcpServersForProfileDocument, options);
}
export type GetMcpServersForProfileQueryHookResult = ReturnType<
  typeof useGetMcpServersForProfileQuery
>;
export type GetMcpServersForProfileLazyQueryHookResult = ReturnType<
  typeof useGetMcpServersForProfileLazyQuery
>;
export type GetMcpServersForProfileSuspenseQueryHookResult = ReturnType<
  typeof useGetMcpServersForProfileSuspenseQuery
>;
export type GetMcpServersForProfileQueryResult = Apollo.QueryResult<
  GetMcpServersForProfileQuery,
  GetMcpServersForProfileQueryVariables
>;
export const ChangeUserRoleDocument = gql`
  mutation changeUserRole($userId: ObjectID!, $role: UserRole!) {
    changeUserRole(input: { userId: $userId, newRole: $role }) {
      _id
      org {
        _id
      }
      displayName
      email
      status
      role
    }
  }
`;
export type ChangeUserRoleMutationFn = Apollo.MutationFunction<
  ChangeUserRoleMutation,
  ChangeUserRoleMutationVariables
>;

/**
 * __useChangeUserRoleMutation__
 *
 * To run a mutation, you first call `useChangeUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserRoleMutation, { data, loading, error }] = useChangeUserRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useChangeUserRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeUserRoleMutation,
    ChangeUserRoleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeUserRoleMutation,
    ChangeUserRoleMutationVariables
  >(ChangeUserRoleDocument, options);
}
export type ChangeUserRoleMutationHookResult = ReturnType<
  typeof useChangeUserRoleMutation
>;
export type ChangeUserRoleMutationResult =
  Apollo.MutationResult<ChangeUserRoleMutation>;
export type ChangeUserRoleMutationOptions = Apollo.BaseMutationOptions<
  ChangeUserRoleMutation,
  ChangeUserRoleMutationVariables
>;
export const CopyMcpProfileToPersonalDocument = gql`
  mutation CopyMCPProfileToPersonal(
    $profileId: ObjectID!
    $name: String
    $setSelectedProfile: Boolean
  ) {
    copyMCPProfileToPersonal(
      profileId: $profileId
      name: $name
      setSelectedProfile: $setSelectedProfile
    ) {
      _id
      name
      type
    }
  }
`;
export type CopyMcpProfileToPersonalMutationFn = Apollo.MutationFunction<
  CopyMcpProfileToPersonalMutation,
  CopyMcpProfileToPersonalMutationVariables
>;

/**
 * __useCopyMcpProfileToPersonalMutation__
 *
 * To run a mutation, you first call `useCopyMcpProfileToPersonalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyMcpProfileToPersonalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyMcpProfileToPersonalMutation, { data, loading, error }] = useCopyMcpProfileToPersonalMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      name: // value for 'name'
 *      setSelectedProfile: // value for 'setSelectedProfile'
 *   },
 * });
 */
export function useCopyMcpProfileToPersonalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CopyMcpProfileToPersonalMutation,
    CopyMcpProfileToPersonalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CopyMcpProfileToPersonalMutation,
    CopyMcpProfileToPersonalMutationVariables
  >(CopyMcpProfileToPersonalDocument, options);
}
export type CopyMcpProfileToPersonalMutationHookResult = ReturnType<
  typeof useCopyMcpProfileToPersonalMutation
>;
export type CopyMcpProfileToPersonalMutationResult =
  Apollo.MutationResult<CopyMcpProfileToPersonalMutation>;
export type CopyMcpProfileToPersonalMutationOptions =
  Apollo.BaseMutationOptions<
    CopyMcpProfileToPersonalMutation,
    CopyMcpProfileToPersonalMutationVariables
  >;
export const CreateAgentDocument = gql`
  mutation createAgent($input: CreateAgentInput!) {
    createAgent(input: $input) {
      _id
      displayName
      owner {
        _id
        email
        displayName
      }
      createdBy {
        _id
        email
        displayName
      }
      createdAt
      updatedAt
    }
  }
`;
export type CreateAgentMutationFn = Apollo.MutationFunction<
  CreateAgentMutation,
  CreateAgentMutationVariables
>;

/**
 * __useCreateAgentMutation__
 *
 * To run a mutation, you first call `useCreateAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgentMutation, { data, loading, error }] = useCreateAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAgentMutation,
    CreateAgentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAgentMutation, CreateAgentMutationVariables>(
    CreateAgentDocument,
    options
  );
}
export type CreateAgentMutationHookResult = ReturnType<
  typeof useCreateAgentMutation
>;
export type CreateAgentMutationResult =
  Apollo.MutationResult<CreateAgentMutation>;
export type CreateAgentMutationOptions = Apollo.BaseMutationOptions<
  CreateAgentMutation,
  CreateAgentMutationVariables
>;
export const CreateCoreDeploymentDocument = gql`
  mutation createCoreDeployment($origin: String!, $displayName: String) {
    createCoreDeployment(origin: $origin, displayName: $displayName) {
      credential {
        _id
        status
        secret
        credentialId
      }
      deployment {
        _id
        status
        displayName
        origin
        createdBy {
          _id
          displayName
          email
        }
        updatedBy {
          _id
          displayName
          email
        }
        createdAt
        updatedAt
        polledAt
        health
      }
    }
  }
`;
export type CreateCoreDeploymentMutationFn = Apollo.MutationFunction<
  CreateCoreDeploymentMutation,
  CreateCoreDeploymentMutationVariables
>;

/**
 * __useCreateCoreDeploymentMutation__
 *
 * To run a mutation, you first call `useCreateCoreDeploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoreDeploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoreDeploymentMutation, { data, loading, error }] = useCreateCoreDeploymentMutation({
 *   variables: {
 *      origin: // value for 'origin'
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useCreateCoreDeploymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCoreDeploymentMutation,
    CreateCoreDeploymentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCoreDeploymentMutation,
    CreateCoreDeploymentMutationVariables
  >(CreateCoreDeploymentDocument, options);
}
export type CreateCoreDeploymentMutationHookResult = ReturnType<
  typeof useCreateCoreDeploymentMutation
>;
export type CreateCoreDeploymentMutationResult =
  Apollo.MutationResult<CreateCoreDeploymentMutation>;
export type CreateCoreDeploymentMutationOptions = Apollo.BaseMutationOptions<
  CreateCoreDeploymentMutation,
  CreateCoreDeploymentMutationVariables
>;
export const CreateCredentialDocument = gql`
  mutation createCredential($input: CreateCredentialInput!) {
    createCredential(input: $input) {
      _id
      type
      preview
      credentialId
      secret
      displayName
      createdAt
      status
      lastUsed
    }
  }
`;
export type CreateCredentialMutationFn = Apollo.MutationFunction<
  CreateCredentialMutation,
  CreateCredentialMutationVariables
>;

/**
 * __useCreateCredentialMutation__
 *
 * To run a mutation, you first call `useCreateCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCredentialMutation, { data, loading, error }] = useCreateCredentialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCredentialMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCredentialMutation,
    CreateCredentialMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCredentialMutation,
    CreateCredentialMutationVariables
  >(CreateCredentialDocument, options);
}
export type CreateCredentialMutationHookResult = ReturnType<
  typeof useCreateCredentialMutation
>;
export type CreateCredentialMutationResult =
  Apollo.MutationResult<CreateCredentialMutation>;
export type CreateCredentialMutationOptions = Apollo.BaseMutationOptions<
  CreateCredentialMutation,
  CreateCredentialMutationVariables
>;
export const CreateIngestJobDocument = gql`
  mutation createIngestJob($input: CreateIngestJobInput!) {
    createIngestJob(input: $input) {
      _id
      completedAt
      queuedAt
      startedAt
      status
      triggeredBy {
        _id
      }
      type
    }
  }
`;
export type CreateIngestJobMutationFn = Apollo.MutationFunction<
  CreateIngestJobMutation,
  CreateIngestJobMutationVariables
>;

/**
 * __useCreateIngestJobMutation__
 *
 * To run a mutation, you first call `useCreateIngestJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIngestJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIngestJobMutation, { data, loading, error }] = useCreateIngestJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIngestJobMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateIngestJobMutation,
    CreateIngestJobMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateIngestJobMutation,
    CreateIngestJobMutationVariables
  >(CreateIngestJobDocument, options);
}
export type CreateIngestJobMutationHookResult = ReturnType<
  typeof useCreateIngestJobMutation
>;
export type CreateIngestJobMutationResult =
  Apollo.MutationResult<CreateIngestJobMutation>;
export type CreateIngestJobMutationOptions = Apollo.BaseMutationOptions<
  CreateIngestJobMutation,
  CreateIngestJobMutationVariables
>;
export const CreateJobChainDocument = gql`
  mutation createJobChain($input: CreateJobChainInput!) {
    createJobChain(input: $input) {
      _id
      completedAt
      queuedAt
      startedAt
      status
      triggeredBy {
        _id
      }
      type
    }
  }
`;
export type CreateJobChainMutationFn = Apollo.MutationFunction<
  CreateJobChainMutation,
  CreateJobChainMutationVariables
>;

/**
 * __useCreateJobChainMutation__
 *
 * To run a mutation, you first call `useCreateJobChainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobChainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobChainMutation, { data, loading, error }] = useCreateJobChainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobChainMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateJobChainMutation,
    CreateJobChainMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateJobChainMutation,
    CreateJobChainMutationVariables
  >(CreateJobChainDocument, options);
}
export type CreateJobChainMutationHookResult = ReturnType<
  typeof useCreateJobChainMutation
>;
export type CreateJobChainMutationResult =
  Apollo.MutationResult<CreateJobChainMutation>;
export type CreateJobChainMutationOptions = Apollo.BaseMutationOptions<
  CreateJobChainMutation,
  CreateJobChainMutationVariables
>;
export const CreateMcpProfileDocument = gql`
  mutation CreateMCPProfile(
    $name: String!
    $installationConfigs: [InstallationConfigInput!]!
    $setSelectedProfile: Boolean
  ) {
    createMCPProfile(
      name: $name
      installationConfigs: $installationConfigs
      setSelectedProfile: $setSelectedProfile
    ) {
      _id
      name
      type
    }
  }
`;
export type CreateMcpProfileMutationFn = Apollo.MutationFunction<
  CreateMcpProfileMutation,
  CreateMcpProfileMutationVariables
>;

/**
 * __useCreateMcpProfileMutation__
 *
 * To run a mutation, you first call `useCreateMcpProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMcpProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMcpProfileMutation, { data, loading, error }] = useCreateMcpProfileMutation({
 *   variables: {
 *      name: // value for 'name'
 *      installationConfigs: // value for 'installationConfigs'
 *      setSelectedProfile: // value for 'setSelectedProfile'
 *   },
 * });
 */
export function useCreateMcpProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMcpProfileMutation,
    CreateMcpProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMcpProfileMutation,
    CreateMcpProfileMutationVariables
  >(CreateMcpProfileDocument, options);
}
export type CreateMcpProfileMutationHookResult = ReturnType<
  typeof useCreateMcpProfileMutation
>;
export type CreateMcpProfileMutationResult =
  Apollo.MutationResult<CreateMcpProfileMutation>;
export type CreateMcpProfileMutationOptions = Apollo.BaseMutationOptions<
  CreateMcpProfileMutation,
  CreateMcpProfileMutationVariables
>;
export const CreateMcpProfileTemplateDocument = gql`
  mutation CreateMCPProfileTemplate(
    $displayName: String!
    $installationConfigs: [TemplateInstallationConfigInput!]!
  ) {
    createMCPProfileTemplate(
      displayName: $displayName
      installationConfigs: $installationConfigs
    ) {
      _id
      displayName
      installationConfigs {
        server {
          _id
          name
        }
        installation {
          _id
          displayName
        }
        enabledTools
        installType
      }
    }
  }
`;
export type CreateMcpProfileTemplateMutationFn = Apollo.MutationFunction<
  CreateMcpProfileTemplateMutation,
  CreateMcpProfileTemplateMutationVariables
>;

/**
 * __useCreateMcpProfileTemplateMutation__
 *
 * To run a mutation, you first call `useCreateMcpProfileTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMcpProfileTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMcpProfileTemplateMutation, { data, loading, error }] = useCreateMcpProfileTemplateMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      installationConfigs: // value for 'installationConfigs'
 *   },
 * });
 */
export function useCreateMcpProfileTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMcpProfileTemplateMutation,
    CreateMcpProfileTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMcpProfileTemplateMutation,
    CreateMcpProfileTemplateMutationVariables
  >(CreateMcpProfileTemplateDocument, options);
}
export type CreateMcpProfileTemplateMutationHookResult = ReturnType<
  typeof useCreateMcpProfileTemplateMutation
>;
export type CreateMcpProfileTemplateMutationResult =
  Apollo.MutationResult<CreateMcpProfileTemplateMutation>;
export type CreateMcpProfileTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    CreateMcpProfileTemplateMutation,
    CreateMcpProfileTemplateMutationVariables
  >;
export const CreateOAuthMcpServerInstallDocument = gql`
  mutation createOAuthMcpServerInstall(
    $input: CreateOAuthMcpServerInstallInput!
  ) {
    createOAuthMcpServerInstall(input: $input) {
      _id
    }
  }
`;
export type CreateOAuthMcpServerInstallMutationFn = Apollo.MutationFunction<
  CreateOAuthMcpServerInstallMutation,
  CreateOAuthMcpServerInstallMutationVariables
>;

/**
 * __useCreateOAuthMcpServerInstallMutation__
 *
 * To run a mutation, you first call `useCreateOAuthMcpServerInstallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOAuthMcpServerInstallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOAuthMcpServerInstallMutation, { data, loading, error }] = useCreateOAuthMcpServerInstallMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOAuthMcpServerInstallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOAuthMcpServerInstallMutation,
    CreateOAuthMcpServerInstallMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateOAuthMcpServerInstallMutation,
    CreateOAuthMcpServerInstallMutationVariables
  >(CreateOAuthMcpServerInstallDocument, options);
}
export type CreateOAuthMcpServerInstallMutationHookResult = ReturnType<
  typeof useCreateOAuthMcpServerInstallMutation
>;
export type CreateOAuthMcpServerInstallMutationResult =
  Apollo.MutationResult<CreateOAuthMcpServerInstallMutation>;
export type CreateOAuthMcpServerInstallMutationOptions =
  Apollo.BaseMutationOptions<
    CreateOAuthMcpServerInstallMutation,
    CreateOAuthMcpServerInstallMutationVariables
  >;
export const CreateOrUpdateAccessPolicyDocument = gql`
  mutation createOrUpdateAccessPolicy(
    $input: CreateOrUpdateAccessPolicyInput!
  ) {
    createOrUpdateAccessPolicy(input: $input) {
      _id
      name
      status
      actionType
      effect
      updatedAt
      createdAt
      isDeprecated
      targetConfigs {
        server {
          _id
          name
          availableTools {
            name
            description
          }
        }
        tools
        allTools
        totalInstalls
        installationScope
      }
    }
  }
`;
export type CreateOrUpdateAccessPolicyMutationFn = Apollo.MutationFunction<
  CreateOrUpdateAccessPolicyMutation,
  CreateOrUpdateAccessPolicyMutationVariables
>;

/**
 * __useCreateOrUpdateAccessPolicyMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateAccessPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateAccessPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateAccessPolicyMutation, { data, loading, error }] = useCreateOrUpdateAccessPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateAccessPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOrUpdateAccessPolicyMutation,
    CreateOrUpdateAccessPolicyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateOrUpdateAccessPolicyMutation,
    CreateOrUpdateAccessPolicyMutationVariables
  >(CreateOrUpdateAccessPolicyDocument, options);
}
export type CreateOrUpdateAccessPolicyMutationHookResult = ReturnType<
  typeof useCreateOrUpdateAccessPolicyMutation
>;
export type CreateOrUpdateAccessPolicyMutationResult =
  Apollo.MutationResult<CreateOrUpdateAccessPolicyMutation>;
export type CreateOrUpdateAccessPolicyMutationOptions =
  Apollo.BaseMutationOptions<
    CreateOrUpdateAccessPolicyMutation,
    CreateOrUpdateAccessPolicyMutationVariables
  >;
export const CreateOrUpdateMcpServerInstallDocument = gql`
  mutation createOrUpdateMCPServerInstall(
    $mcpServerId: ObjectID
    $serverId: MCPServerId
    $displayName: String!
    $installType: MCPServerInstallAccessInstallType!
    $authCredentials: ServerInstallationCredsMap
    $mcpServerInstallId: ObjectID
    $ownerId: ObjectID
    $actorType: InstalledForActorType
    $shouldEnable: Boolean
  ) {
    createOrUpdateServerInstall(
      mcpServerId: $mcpServerId
      serverId: $serverId
      displayName: $displayName
      installType: $installType
      authCredentials: $authCredentials
      mcpServerInstallId: $mcpServerInstallId
      ownerId: $ownerId
      actorType: $actorType
      shouldEnable: $shouldEnable
    ) {
      _id
      displayName
      server {
        _id
        name
      }
      accessConfig {
        installType
      }
    }
  }
`;
export type CreateOrUpdateMcpServerInstallMutationFn = Apollo.MutationFunction<
  CreateOrUpdateMcpServerInstallMutation,
  CreateOrUpdateMcpServerInstallMutationVariables
>;

/**
 * __useCreateOrUpdateMcpServerInstallMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateMcpServerInstallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateMcpServerInstallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateMcpServerInstallMutation, { data, loading, error }] = useCreateOrUpdateMcpServerInstallMutation({
 *   variables: {
 *      mcpServerId: // value for 'mcpServerId'
 *      serverId: // value for 'serverId'
 *      displayName: // value for 'displayName'
 *      installType: // value for 'installType'
 *      authCredentials: // value for 'authCredentials'
 *      mcpServerInstallId: // value for 'mcpServerInstallId'
 *      ownerId: // value for 'ownerId'
 *      actorType: // value for 'actorType'
 *      shouldEnable: // value for 'shouldEnable'
 *   },
 * });
 */
export function useCreateOrUpdateMcpServerInstallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOrUpdateMcpServerInstallMutation,
    CreateOrUpdateMcpServerInstallMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateOrUpdateMcpServerInstallMutation,
    CreateOrUpdateMcpServerInstallMutationVariables
  >(CreateOrUpdateMcpServerInstallDocument, options);
}
export type CreateOrUpdateMcpServerInstallMutationHookResult = ReturnType<
  typeof useCreateOrUpdateMcpServerInstallMutation
>;
export type CreateOrUpdateMcpServerInstallMutationResult =
  Apollo.MutationResult<CreateOrUpdateMcpServerInstallMutation>;
export type CreateOrUpdateMcpServerInstallMutationOptions =
  Apollo.BaseMutationOptions<
    CreateOrUpdateMcpServerInstallMutation,
    CreateOrUpdateMcpServerInstallMutationVariables
  >;
export const CreateServiceFromIntegrationDocument = gql`
  mutation createServiceFromIntegration($input: CreateIntegrationInput!) {
    createServiceFromIntegration(input: $input) {
      _id
      status
      integration {
        __typename
        status
      }
    }
  }
`;
export type CreateServiceFromIntegrationMutationFn = Apollo.MutationFunction<
  CreateServiceFromIntegrationMutation,
  CreateServiceFromIntegrationMutationVariables
>;

/**
 * __useCreateServiceFromIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateServiceFromIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceFromIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceFromIntegrationMutation, { data, loading, error }] = useCreateServiceFromIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateServiceFromIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateServiceFromIntegrationMutation,
    CreateServiceFromIntegrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateServiceFromIntegrationMutation,
    CreateServiceFromIntegrationMutationVariables
  >(CreateServiceFromIntegrationDocument, options);
}
export type CreateServiceFromIntegrationMutationHookResult = ReturnType<
  typeof useCreateServiceFromIntegrationMutation
>;
export type CreateServiceFromIntegrationMutationResult =
  Apollo.MutationResult<CreateServiceFromIntegrationMutation>;
export type CreateServiceFromIntegrationMutationOptions =
  Apollo.BaseMutationOptions<
    CreateServiceFromIntegrationMutation,
    CreateServiceFromIntegrationMutationVariables
  >;
export const CreateTunnelDocument = gql`
  mutation createTunnel($displayName: String!) {
    createTunnel(displayName: $displayName) {
      _id
      displayName
      status
      connectionStatus
      tunnelKey {
        _id
        secret
      }
      metadata {
        lastHeartbeatAt
        tunnelVersion
        tunnelAuthStrategy
      }
    }
  }
`;
export type CreateTunnelMutationFn = Apollo.MutationFunction<
  CreateTunnelMutation,
  CreateTunnelMutationVariables
>;

/**
 * __useCreateTunnelMutation__
 *
 * To run a mutation, you first call `useCreateTunnelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTunnelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTunnelMutation, { data, loading, error }] = useCreateTunnelMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useCreateTunnelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTunnelMutation,
    CreateTunnelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateTunnelMutation,
    CreateTunnelMutationVariables
  >(CreateTunnelDocument, options);
}
export type CreateTunnelMutationHookResult = ReturnType<
  typeof useCreateTunnelMutation
>;
export type CreateTunnelMutationResult =
  Apollo.MutationResult<CreateTunnelMutation>;
export type CreateTunnelMutationOptions = Apollo.BaseMutationOptions<
  CreateTunnelMutation,
  CreateTunnelMutationVariables
>;
export const DeleteAccessPolicyDocument = gql`
  mutation deleteAccessPolicy($input: DeleteAccessPolicyInput!) {
    deleteAccessPolicy(input: $input) {
      _id
    }
  }
`;
export type DeleteAccessPolicyMutationFn = Apollo.MutationFunction<
  DeleteAccessPolicyMutation,
  DeleteAccessPolicyMutationVariables
>;

/**
 * __useDeleteAccessPolicyMutation__
 *
 * To run a mutation, you first call `useDeleteAccessPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccessPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccessPolicyMutation, { data, loading, error }] = useDeleteAccessPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAccessPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAccessPolicyMutation,
    DeleteAccessPolicyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAccessPolicyMutation,
    DeleteAccessPolicyMutationVariables
  >(DeleteAccessPolicyDocument, options);
}
export type DeleteAccessPolicyMutationHookResult = ReturnType<
  typeof useDeleteAccessPolicyMutation
>;
export type DeleteAccessPolicyMutationResult =
  Apollo.MutationResult<DeleteAccessPolicyMutation>;
export type DeleteAccessPolicyMutationOptions = Apollo.BaseMutationOptions<
  DeleteAccessPolicyMutation,
  DeleteAccessPolicyMutationVariables
>;
export const DeleteAgentDocument = gql`
  mutation deleteAgent($id: ObjectID!) {
    deleteAgent(id: $id) {
      _id
      displayName
    }
  }
`;
export type DeleteAgentMutationFn = Apollo.MutationFunction<
  DeleteAgentMutation,
  DeleteAgentMutationVariables
>;

/**
 * __useDeleteAgentMutation__
 *
 * To run a mutation, you first call `useDeleteAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgentMutation, { data, loading, error }] = useDeleteAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAgentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAgentMutation,
    DeleteAgentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteAgentMutation, DeleteAgentMutationVariables>(
    DeleteAgentDocument,
    options
  );
}
export type DeleteAgentMutationHookResult = ReturnType<
  typeof useDeleteAgentMutation
>;
export type DeleteAgentMutationResult =
  Apollo.MutationResult<DeleteAgentMutation>;
export type DeleteAgentMutationOptions = Apollo.BaseMutationOptions<
  DeleteAgentMutation,
  DeleteAgentMutationVariables
>;
export const DeleteServiceIntegrationDocument = gql`
  mutation deleteServiceIntegration($_id: ObjectID!) {
    deleteServiceIntegration(_id: $_id) {
      _id
      type
    }
  }
`;
export type DeleteServiceIntegrationMutationFn = Apollo.MutationFunction<
  DeleteServiceIntegrationMutation,
  DeleteServiceIntegrationMutationVariables
>;

/**
 * __useDeleteServiceIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteServiceIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceIntegrationMutation, { data, loading, error }] = useDeleteServiceIntegrationMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteServiceIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteServiceIntegrationMutation,
    DeleteServiceIntegrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteServiceIntegrationMutation,
    DeleteServiceIntegrationMutationVariables
  >(DeleteServiceIntegrationDocument, options);
}
export type DeleteServiceIntegrationMutationHookResult = ReturnType<
  typeof useDeleteServiceIntegrationMutation
>;
export type DeleteServiceIntegrationMutationResult =
  Apollo.MutationResult<DeleteServiceIntegrationMutation>;
export type DeleteServiceIntegrationMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteServiceIntegrationMutation,
    DeleteServiceIntegrationMutationVariables
  >;
export const DeleteMcpProfileDocument = gql`
  mutation deleteMcpProfile($profileId: ObjectID!) {
    deleteMCPProfile(profileId: $profileId)
  }
`;
export type DeleteMcpProfileMutationFn = Apollo.MutationFunction<
  DeleteMcpProfileMutation,
  DeleteMcpProfileMutationVariables
>;

/**
 * __useDeleteMcpProfileMutation__
 *
 * To run a mutation, you first call `useDeleteMcpProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMcpProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMcpProfileMutation, { data, loading, error }] = useDeleteMcpProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useDeleteMcpProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMcpProfileMutation,
    DeleteMcpProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteMcpProfileMutation,
    DeleteMcpProfileMutationVariables
  >(DeleteMcpProfileDocument, options);
}
export type DeleteMcpProfileMutationHookResult = ReturnType<
  typeof useDeleteMcpProfileMutation
>;
export type DeleteMcpProfileMutationResult =
  Apollo.MutationResult<DeleteMcpProfileMutation>;
export type DeleteMcpProfileMutationOptions = Apollo.BaseMutationOptions<
  DeleteMcpProfileMutation,
  DeleteMcpProfileMutationVariables
>;
export const DeleteRateLimitDocument = gql`
  mutation deleteRateLimit($_id: ObjectID!) {
    deleteRateLimit(_id: $_id) {
      _id
    }
  }
`;
export type DeleteRateLimitMutationFn = Apollo.MutationFunction<
  DeleteRateLimitMutation,
  DeleteRateLimitMutationVariables
>;

/**
 * __useDeleteRateLimitMutation__
 *
 * To run a mutation, you first call `useDeleteRateLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRateLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRateLimitMutation, { data, loading, error }] = useDeleteRateLimitMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteRateLimitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRateLimitMutation,
    DeleteRateLimitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteRateLimitMutation,
    DeleteRateLimitMutationVariables
  >(DeleteRateLimitDocument, options);
}
export type DeleteRateLimitMutationHookResult = ReturnType<
  typeof useDeleteRateLimitMutation
>;
export type DeleteRateLimitMutationResult =
  Apollo.MutationResult<DeleteRateLimitMutation>;
export type DeleteRateLimitMutationOptions = Apollo.BaseMutationOptions<
  DeleteRateLimitMutation,
  DeleteRateLimitMutationVariables
>;
export const DeleteTunnelDocument = gql`
  mutation deleteTunnel($tunnelId: ObjectID!) {
    deleteTunnel(tunnelId: $tunnelId) {
      _id
      status
    }
  }
`;
export type DeleteTunnelMutationFn = Apollo.MutationFunction<
  DeleteTunnelMutation,
  DeleteTunnelMutationVariables
>;

/**
 * __useDeleteTunnelMutation__
 *
 * To run a mutation, you first call `useDeleteTunnelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTunnelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTunnelMutation, { data, loading, error }] = useDeleteTunnelMutation({
 *   variables: {
 *      tunnelId: // value for 'tunnelId'
 *   },
 * });
 */
export function useDeleteTunnelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTunnelMutation,
    DeleteTunnelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteTunnelMutation,
    DeleteTunnelMutationVariables
  >(DeleteTunnelDocument, options);
}
export type DeleteTunnelMutationHookResult = ReturnType<
  typeof useDeleteTunnelMutation
>;
export type DeleteTunnelMutationResult =
  Apollo.MutationResult<DeleteTunnelMutation>;
export type DeleteTunnelMutationOptions = Apollo.BaseMutationOptions<
  DeleteTunnelMutation,
  DeleteTunnelMutationVariables
>;
export const DeleteUserDocument = gql`
  mutation deleteUser($_id: ObjectID!) {
    deleteUser(_id: $_id) {
      _id
      org {
        _id
      }
      displayName
      email
      status
      role
    }
  }
`;
export type DeleteUserMutationFn = Apollo.MutationFunction<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUserMutation,
    DeleteUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(
    DeleteUserDocument,
    options
  );
}
export type DeleteUserMutationHookResult = ReturnType<
  typeof useDeleteUserMutation
>;
export type DeleteUserMutationResult =
  Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;
export const InviteUserDocument = gql`
  mutation inviteUser($input: InviteUserInput!) {
    inviteUser(input: $input) {
      _id
      email
      displayName
      status
      role
      org {
        _id
      }
    }
  }
`;
export type InviteUserMutationFn = Apollo.MutationFunction<
  InviteUserMutation,
  InviteUserMutationVariables
>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InviteUserMutation,
    InviteUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(
    InviteUserDocument,
    options
  );
}
export type InviteUserMutationHookResult = ReturnType<
  typeof useInviteUserMutation
>;
export type InviteUserMutationResult =
  Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<
  InviteUserMutation,
  InviteUserMutationVariables
>;
export const MarkUserConfigSeenDocument = gql`
  mutation markUserConfigSeen {
    markUserConfigSeen {
      _id
      shouldPingMcpConfig
    }
  }
`;
export type MarkUserConfigSeenMutationFn = Apollo.MutationFunction<
  MarkUserConfigSeenMutation,
  MarkUserConfigSeenMutationVariables
>;

/**
 * __useMarkUserConfigSeenMutation__
 *
 * To run a mutation, you first call `useMarkUserConfigSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUserConfigSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUserConfigSeenMutation, { data, loading, error }] = useMarkUserConfigSeenMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkUserConfigSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkUserConfigSeenMutation,
    MarkUserConfigSeenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkUserConfigSeenMutation,
    MarkUserConfigSeenMutationVariables
  >(MarkUserConfigSeenDocument, options);
}
export type MarkUserConfigSeenMutationHookResult = ReturnType<
  typeof useMarkUserConfigSeenMutation
>;
export type MarkUserConfigSeenMutationResult =
  Apollo.MutationResult<MarkUserConfigSeenMutation>;
export type MarkUserConfigSeenMutationOptions = Apollo.BaseMutationOptions<
  MarkUserConfigSeenMutation,
  MarkUserConfigSeenMutationVariables
>;
export const RegisterDocument = gql`
  mutation register(
    $displayName: String
    $orgDisplayName: String
    $registrationCode: String
  ) {
    register(
      displayName: $displayName
      orgDisplayName: $orgDisplayName
      registrationCode: $registrationCode
    ) {
      currentOrg {
        ...OrgRegistrationFields
      }
      currentUser {
        ...UserRegistrationFields
      }
    }
  }
  ${OrgRegistrationFieldsFragmentDoc}
  ${UserRegistrationFieldsFragmentDoc}
`;
export type RegisterMutationFn = Apollo.MutationFunction<
  RegisterMutation,
  RegisterMutationVariables
>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      orgDisplayName: // value for 'orgDisplayName'
 *      registrationCode: // value for 'registrationCode'
 *   },
 * });
 */
export function useRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterMutation,
    RegisterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(
    RegisterDocument,
    options
  );
}
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<
  RegisterMutation,
  RegisterMutationVariables
>;
export const DeleteMcpServerInstallDocument = gql`
  mutation deleteMCPServerInstall($input: GetByIdMCPServerInstallInput!) {
    deleteMCPServerInstall(input: $input) {
      _id
      accessConfig {
        installType
      }
    }
  }
`;
export type DeleteMcpServerInstallMutationFn = Apollo.MutationFunction<
  DeleteMcpServerInstallMutation,
  DeleteMcpServerInstallMutationVariables
>;

/**
 * __useDeleteMcpServerInstallMutation__
 *
 * To run a mutation, you first call `useDeleteMcpServerInstallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMcpServerInstallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMcpServerInstallMutation, { data, loading, error }] = useDeleteMcpServerInstallMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMcpServerInstallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMcpServerInstallMutation,
    DeleteMcpServerInstallMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteMcpServerInstallMutation,
    DeleteMcpServerInstallMutationVariables
  >(DeleteMcpServerInstallDocument, options);
}
export type DeleteMcpServerInstallMutationHookResult = ReturnType<
  typeof useDeleteMcpServerInstallMutation
>;
export type DeleteMcpServerInstallMutationResult =
  Apollo.MutationResult<DeleteMcpServerInstallMutation>;
export type DeleteMcpServerInstallMutationOptions = Apollo.BaseMutationOptions<
  DeleteMcpServerInstallMutation,
  DeleteMcpServerInstallMutationVariables
>;
export const RemoveSelectedMcpProfileForUserDocument = gql`
  mutation removeSelectedMCPProfileForUser {
    removeSelectedMCPProfileForUser
  }
`;
export type RemoveSelectedMcpProfileForUserMutationFn = Apollo.MutationFunction<
  RemoveSelectedMcpProfileForUserMutation,
  RemoveSelectedMcpProfileForUserMutationVariables
>;

/**
 * __useRemoveSelectedMcpProfileForUserMutation__
 *
 * To run a mutation, you first call `useRemoveSelectedMcpProfileForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSelectedMcpProfileForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSelectedMcpProfileForUserMutation, { data, loading, error }] = useRemoveSelectedMcpProfileForUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveSelectedMcpProfileForUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveSelectedMcpProfileForUserMutation,
    RemoveSelectedMcpProfileForUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveSelectedMcpProfileForUserMutation,
    RemoveSelectedMcpProfileForUserMutationVariables
  >(RemoveSelectedMcpProfileForUserDocument, options);
}
export type RemoveSelectedMcpProfileForUserMutationHookResult = ReturnType<
  typeof useRemoveSelectedMcpProfileForUserMutation
>;
export type RemoveSelectedMcpProfileForUserMutationResult =
  Apollo.MutationResult<RemoveSelectedMcpProfileForUserMutation>;
export type RemoveSelectedMcpProfileForUserMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveSelectedMcpProfileForUserMutation,
    RemoveSelectedMcpProfileForUserMutationVariables
  >;
export const RequestMcpServerTemplateDocument = gql`
  mutation requestMCPServerTemplate(
    $appName: String!
    $additionalContext: String
  ) {
    requestMCPServerTemplate(
      appName: $appName
      additionalContext: $additionalContext
    ) {
      _id
      status
    }
  }
`;
export type RequestMcpServerTemplateMutationFn = Apollo.MutationFunction<
  RequestMcpServerTemplateMutation,
  RequestMcpServerTemplateMutationVariables
>;

/**
 * __useRequestMcpServerTemplateMutation__
 *
 * To run a mutation, you first call `useRequestMcpServerTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMcpServerTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMcpServerTemplateMutation, { data, loading, error }] = useRequestMcpServerTemplateMutation({
 *   variables: {
 *      appName: // value for 'appName'
 *      additionalContext: // value for 'additionalContext'
 *   },
 * });
 */
export function useRequestMcpServerTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestMcpServerTemplateMutation,
    RequestMcpServerTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestMcpServerTemplateMutation,
    RequestMcpServerTemplateMutationVariables
  >(RequestMcpServerTemplateDocument, options);
}
export type RequestMcpServerTemplateMutationHookResult = ReturnType<
  typeof useRequestMcpServerTemplateMutation
>;
export type RequestMcpServerTemplateMutationResult =
  Apollo.MutationResult<RequestMcpServerTemplateMutation>;
export type RequestMcpServerTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    RequestMcpServerTemplateMutation,
    RequestMcpServerTemplateMutationVariables
  >;
export const SetSelectedMcpProfileForUserDocument = gql`
  mutation SetSelectedMCPProfileForUser($profileId: ObjectID!) {
    setSelectedMCPProfileForUser(profileId: $profileId)
  }
`;
export type SetSelectedMcpProfileForUserMutationFn = Apollo.MutationFunction<
  SetSelectedMcpProfileForUserMutation,
  SetSelectedMcpProfileForUserMutationVariables
>;

/**
 * __useSetSelectedMcpProfileForUserMutation__
 *
 * To run a mutation, you first call `useSetSelectedMcpProfileForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSelectedMcpProfileForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSelectedMcpProfileForUserMutation, { data, loading, error }] = useSetSelectedMcpProfileForUserMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useSetSelectedMcpProfileForUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetSelectedMcpProfileForUserMutation,
    SetSelectedMcpProfileForUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetSelectedMcpProfileForUserMutation,
    SetSelectedMcpProfileForUserMutationVariables
  >(SetSelectedMcpProfileForUserDocument, options);
}
export type SetSelectedMcpProfileForUserMutationHookResult = ReturnType<
  typeof useSetSelectedMcpProfileForUserMutation
>;
export type SetSelectedMcpProfileForUserMutationResult =
  Apollo.MutationResult<SetSelectedMcpProfileForUserMutation>;
export type SetSelectedMcpProfileForUserMutationOptions =
  Apollo.BaseMutationOptions<
    SetSelectedMcpProfileForUserMutation,
    SetSelectedMcpProfileForUserMutationVariables
  >;
export const UpdateAccessPolicyDocument = gql`
  mutation updateAccessPolicy($input: UpdateAccessPolicyInput!) {
    updateAccessPolicy(input: $input) {
      _id
      status
    }
  }
`;
export type UpdateAccessPolicyMutationFn = Apollo.MutationFunction<
  UpdateAccessPolicyMutation,
  UpdateAccessPolicyMutationVariables
>;

/**
 * __useUpdateAccessPolicyMutation__
 *
 * To run a mutation, you first call `useUpdateAccessPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccessPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccessPolicyMutation, { data, loading, error }] = useUpdateAccessPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccessPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAccessPolicyMutation,
    UpdateAccessPolicyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAccessPolicyMutation,
    UpdateAccessPolicyMutationVariables
  >(UpdateAccessPolicyDocument, options);
}
export type UpdateAccessPolicyMutationHookResult = ReturnType<
  typeof useUpdateAccessPolicyMutation
>;
export type UpdateAccessPolicyMutationResult =
  Apollo.MutationResult<UpdateAccessPolicyMutation>;
export type UpdateAccessPolicyMutationOptions = Apollo.BaseMutationOptions<
  UpdateAccessPolicyMutation,
  UpdateAccessPolicyMutationVariables
>;
export const UpdateAgentDocument = gql`
  mutation updateAgent($input: UpdateAgentInput!) {
    updateAgent(input: $input) {
      _id
      displayName
      owner {
        _id
        email
        displayName
      }
      createdBy {
        _id
        email
        displayName
      }
      createdAt
      updatedAt
    }
  }
`;
export type UpdateAgentMutationFn = Apollo.MutationFunction<
  UpdateAgentMutation,
  UpdateAgentMutationVariables
>;

/**
 * __useUpdateAgentMutation__
 *
 * To run a mutation, you first call `useUpdateAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentMutation, { data, loading, error }] = useUpdateAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAgentMutation,
    UpdateAgentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAgentMutation, UpdateAgentMutationVariables>(
    UpdateAgentDocument,
    options
  );
}
export type UpdateAgentMutationHookResult = ReturnType<
  typeof useUpdateAgentMutation
>;
export type UpdateAgentMutationResult =
  Apollo.MutationResult<UpdateAgentMutation>;
export type UpdateAgentMutationOptions = Apollo.BaseMutationOptions<
  UpdateAgentMutation,
  UpdateAgentMutationVariables
>;
export const UpdateCredentialStatusDocument = gql`
  mutation updateCredentialStatus($input: UpdateCredentialStatusInput!) {
    updateCredentialStatus(input: $input) {
      _id
      status
    }
  }
`;
export type UpdateCredentialStatusMutationFn = Apollo.MutationFunction<
  UpdateCredentialStatusMutation,
  UpdateCredentialStatusMutationVariables
>;

/**
 * __useUpdateCredentialStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCredentialStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCredentialStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCredentialStatusMutation, { data, loading, error }] = useUpdateCredentialStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCredentialStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCredentialStatusMutation,
    UpdateCredentialStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCredentialStatusMutation,
    UpdateCredentialStatusMutationVariables
  >(UpdateCredentialStatusDocument, options);
}
export type UpdateCredentialStatusMutationHookResult = ReturnType<
  typeof useUpdateCredentialStatusMutation
>;
export type UpdateCredentialStatusMutationResult =
  Apollo.MutationResult<UpdateCredentialStatusMutation>;
export type UpdateCredentialStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateCredentialStatusMutation,
  UpdateCredentialStatusMutationVariables
>;
export const UpdateDeploymentDocument = gql`
  mutation updateDeployment($input: UpdateDeploymentInput!) {
    updateDeployment(input: $input) {
      _id
      status
      displayName
      origin
      updatedAt
      updatedBy {
        _id
        displayName
        email
      }
    }
  }
`;
export type UpdateDeploymentMutationFn = Apollo.MutationFunction<
  UpdateDeploymentMutation,
  UpdateDeploymentMutationVariables
>;

/**
 * __useUpdateDeploymentMutation__
 *
 * To run a mutation, you first call `useUpdateDeploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeploymentMutation, { data, loading, error }] = useUpdateDeploymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeploymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDeploymentMutation,
    UpdateDeploymentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDeploymentMutation,
    UpdateDeploymentMutationVariables
  >(UpdateDeploymentDocument, options);
}
export type UpdateDeploymentMutationHookResult = ReturnType<
  typeof useUpdateDeploymentMutation
>;
export type UpdateDeploymentMutationResult =
  Apollo.MutationResult<UpdateDeploymentMutation>;
export type UpdateDeploymentMutationOptions = Apollo.BaseMutationOptions<
  UpdateDeploymentMutation,
  UpdateDeploymentMutationVariables
>;
export const UpdateMcpProfileTemplateDocument = gql`
  mutation UpdateMCPProfileTemplate(
    $templateId: ObjectID!
    $displayName: String
    $installationConfigs: [TemplateInstallationConfigInput!]
  ) {
    updateMCPProfileTemplate(
      templateId: $templateId
      displayName: $displayName
      installationConfigs: $installationConfigs
    ) {
      _id
      displayName
      installationConfigs {
        server {
          _id
          name
        }
        installation {
          _id
          displayName
        }
        enabledTools
        installType
        allToolsEnabled
      }
    }
  }
`;
export type UpdateMcpProfileTemplateMutationFn = Apollo.MutationFunction<
  UpdateMcpProfileTemplateMutation,
  UpdateMcpProfileTemplateMutationVariables
>;

/**
 * __useUpdateMcpProfileTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateMcpProfileTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMcpProfileTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMcpProfileTemplateMutation, { data, loading, error }] = useUpdateMcpProfileTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      displayName: // value for 'displayName'
 *      installationConfigs: // value for 'installationConfigs'
 *   },
 * });
 */
export function useUpdateMcpProfileTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMcpProfileTemplateMutation,
    UpdateMcpProfileTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMcpProfileTemplateMutation,
    UpdateMcpProfileTemplateMutationVariables
  >(UpdateMcpProfileTemplateDocument, options);
}
export type UpdateMcpProfileTemplateMutationHookResult = ReturnType<
  typeof useUpdateMcpProfileTemplateMutation
>;
export type UpdateMcpProfileTemplateMutationResult =
  Apollo.MutationResult<UpdateMcpProfileTemplateMutation>;
export type UpdateMcpProfileTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateMcpProfileTemplateMutation,
    UpdateMcpProfileTemplateMutationVariables
  >;
export const UpdateMcpServerInstallDocument = gql`
  mutation updateMcpServerInstall($input: UpdateMCPServerInstallInput!) {
    updateMCPServerInstall(input: $input) {
      _id
      displayName
    }
  }
`;
export type UpdateMcpServerInstallMutationFn = Apollo.MutationFunction<
  UpdateMcpServerInstallMutation,
  UpdateMcpServerInstallMutationVariables
>;

/**
 * __useUpdateMcpServerInstallMutation__
 *
 * To run a mutation, you first call `useUpdateMcpServerInstallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMcpServerInstallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMcpServerInstallMutation, { data, loading, error }] = useUpdateMcpServerInstallMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMcpServerInstallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMcpServerInstallMutation,
    UpdateMcpServerInstallMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMcpServerInstallMutation,
    UpdateMcpServerInstallMutationVariables
  >(UpdateMcpServerInstallDocument, options);
}
export type UpdateMcpServerInstallMutationHookResult = ReturnType<
  typeof useUpdateMcpServerInstallMutation
>;
export type UpdateMcpServerInstallMutationResult =
  Apollo.MutationResult<UpdateMcpServerInstallMutation>;
export type UpdateMcpServerInstallMutationOptions = Apollo.BaseMutationOptions<
  UpdateMcpServerInstallMutation,
  UpdateMcpServerInstallMutationVariables
>;
export const UpdateOAuthMcpServerInstallDocument = gql`
  mutation updateOAuthMcpServerInstall(
    $input: UpdateOAuthMcpServerInstallInput!
  ) {
    updateOAuthMcpServerInstall(input: $input) {
      _id
    }
  }
`;
export type UpdateOAuthMcpServerInstallMutationFn = Apollo.MutationFunction<
  UpdateOAuthMcpServerInstallMutation,
  UpdateOAuthMcpServerInstallMutationVariables
>;

/**
 * __useUpdateOAuthMcpServerInstallMutation__
 *
 * To run a mutation, you first call `useUpdateOAuthMcpServerInstallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOAuthMcpServerInstallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOAuthMcpServerInstallMutation, { data, loading, error }] = useUpdateOAuthMcpServerInstallMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOAuthMcpServerInstallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOAuthMcpServerInstallMutation,
    UpdateOAuthMcpServerInstallMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOAuthMcpServerInstallMutation,
    UpdateOAuthMcpServerInstallMutationVariables
  >(UpdateOAuthMcpServerInstallDocument, options);
}
export type UpdateOAuthMcpServerInstallMutationHookResult = ReturnType<
  typeof useUpdateOAuthMcpServerInstallMutation
>;
export type UpdateOAuthMcpServerInstallMutationResult =
  Apollo.MutationResult<UpdateOAuthMcpServerInstallMutation>;
export type UpdateOAuthMcpServerInstallMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateOAuthMcpServerInstallMutation,
    UpdateOAuthMcpServerInstallMutationVariables
  >;
export const UpdateOrgDocument = gql`
  mutation updateOrg($input: OrgUpdateBody!) {
    updateOrg(input: $input) {
      _id
      displayName
      slug
      status
      onboarding {
        connectedIDP
      }
      authServer {
        enabled
        url
        audiences
      }
    }
  }
`;
export type UpdateOrgMutationFn = Apollo.MutationFunction<
  UpdateOrgMutation,
  UpdateOrgMutationVariables
>;

/**
 * __useUpdateOrgMutation__
 *
 * To run a mutation, you first call `useUpdateOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgMutation, { data, loading, error }] = useUpdateOrgMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrgMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrgMutation,
    UpdateOrgMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateOrgMutation, UpdateOrgMutationVariables>(
    UpdateOrgDocument,
    options
  );
}
export type UpdateOrgMutationHookResult = ReturnType<
  typeof useUpdateOrgMutation
>;
export type UpdateOrgMutationResult = Apollo.MutationResult<UpdateOrgMutation>;
export type UpdateOrgMutationOptions = Apollo.BaseMutationOptions<
  UpdateOrgMutation,
  UpdateOrgMutationVariables
>;
export const UpdateOrgNotificationsSettingsDocument = gql`
  mutation updateOrgNotificationsSettings(
    $input: OrgNotificationsSettingsBody
  ) {
    updateOrgNotificationsSettings(input: $input) {
      _id
      notifications {
        sender
        smtpHost
        smtpPort
      }
    }
  }
`;
export type UpdateOrgNotificationsSettingsMutationFn = Apollo.MutationFunction<
  UpdateOrgNotificationsSettingsMutation,
  UpdateOrgNotificationsSettingsMutationVariables
>;

/**
 * __useUpdateOrgNotificationsSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrgNotificationsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgNotificationsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgNotificationsSettingsMutation, { data, loading, error }] = useUpdateOrgNotificationsSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrgNotificationsSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrgNotificationsSettingsMutation,
    UpdateOrgNotificationsSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOrgNotificationsSettingsMutation,
    UpdateOrgNotificationsSettingsMutationVariables
  >(UpdateOrgNotificationsSettingsDocument, options);
}
export type UpdateOrgNotificationsSettingsMutationHookResult = ReturnType<
  typeof useUpdateOrgNotificationsSettingsMutation
>;
export type UpdateOrgNotificationsSettingsMutationResult =
  Apollo.MutationResult<UpdateOrgNotificationsSettingsMutation>;
export type UpdateOrgNotificationsSettingsMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateOrgNotificationsSettingsMutation,
    UpdateOrgNotificationsSettingsMutationVariables
  >;
export const UpdateOrgSamlConfigDocument = gql`
  mutation updateOrgSamlConfig($input: OrgUpdateSamlConfigInput!) {
    updateOrgSamlConfig(input: $input) {
      enabled
      idpMetadata {
        metadataUrl
        entityId
        ssoUrl
        idpSigningCertificate
      }
      spMetadata {
        entityId
        acsUrl
        wantAssertionsSigned
        wantAuthnResponseSigned
      }
    }
  }
`;
export type UpdateOrgSamlConfigMutationFn = Apollo.MutationFunction<
  UpdateOrgSamlConfigMutation,
  UpdateOrgSamlConfigMutationVariables
>;

/**
 * __useUpdateOrgSamlConfigMutation__
 *
 * To run a mutation, you first call `useUpdateOrgSamlConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgSamlConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgSamlConfigMutation, { data, loading, error }] = useUpdateOrgSamlConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrgSamlConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrgSamlConfigMutation,
    UpdateOrgSamlConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOrgSamlConfigMutation,
    UpdateOrgSamlConfigMutationVariables
  >(UpdateOrgSamlConfigDocument, options);
}
export type UpdateOrgSamlConfigMutationHookResult = ReturnType<
  typeof useUpdateOrgSamlConfigMutation
>;
export type UpdateOrgSamlConfigMutationResult =
  Apollo.MutationResult<UpdateOrgSamlConfigMutation>;
export type UpdateOrgSamlConfigMutationOptions = Apollo.BaseMutationOptions<
  UpdateOrgSamlConfigMutation,
  UpdateOrgSamlConfigMutationVariables
>;
export const UpdateOrgScimConfigDocument = gql`
  mutation updateOrgScimConfig($input: OrgUpdateScimConfigInput!) {
    updateOrgScimConfig(input: $input) {
      enabled
      scimProvisioningToken(includeUnencryptedSecret: true) {
        ... on CredentialCreatedResponse {
          preview
          secret
          status
          type
        }
      }
    }
  }
`;
export type UpdateOrgScimConfigMutationFn = Apollo.MutationFunction<
  UpdateOrgScimConfigMutation,
  UpdateOrgScimConfigMutationVariables
>;

/**
 * __useUpdateOrgScimConfigMutation__
 *
 * To run a mutation, you first call `useUpdateOrgScimConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgScimConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgScimConfigMutation, { data, loading, error }] = useUpdateOrgScimConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrgScimConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrgScimConfigMutation,
    UpdateOrgScimConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOrgScimConfigMutation,
    UpdateOrgScimConfigMutationVariables
  >(UpdateOrgScimConfigDocument, options);
}
export type UpdateOrgScimConfigMutationHookResult = ReturnType<
  typeof useUpdateOrgScimConfigMutation
>;
export type UpdateOrgScimConfigMutationResult =
  Apollo.MutationResult<UpdateOrgScimConfigMutation>;
export type UpdateOrgScimConfigMutationOptions = Apollo.BaseMutationOptions<
  UpdateOrgScimConfigMutation,
  UpdateOrgScimConfigMutationVariables
>;
export const UpdateOrgSettingsDocument = gql`
  mutation updateOrgSettings($input: OrgSettingsInput!) {
    updateOrgSettings(input: $input) {
      _id
      slug
      displayName
      settings {
        disableApiKeyUsage
        disableAllowAllPolicy
      }
    }
  }
`;
export type UpdateOrgSettingsMutationFn = Apollo.MutationFunction<
  UpdateOrgSettingsMutation,
  UpdateOrgSettingsMutationVariables
>;

/**
 * __useUpdateOrgSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrgSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgSettingsMutation, { data, loading, error }] = useUpdateOrgSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrgSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrgSettingsMutation,
    UpdateOrgSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOrgSettingsMutation,
    UpdateOrgSettingsMutationVariables
  >(UpdateOrgSettingsDocument, options);
}
export type UpdateOrgSettingsMutationHookResult = ReturnType<
  typeof useUpdateOrgSettingsMutation
>;
export type UpdateOrgSettingsMutationResult =
  Apollo.MutationResult<UpdateOrgSettingsMutation>;
export type UpdateOrgSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateOrgSettingsMutation,
  UpdateOrgSettingsMutationVariables
>;
export const UpdateShadowMcpServersDocument = gql`
  mutation updateShadowMCPServers($input: UpdateShadowMCPServersInput!) {
    updateShadowMCPServers(input: $input)
  }
`;
export type UpdateShadowMcpServersMutationFn = Apollo.MutationFunction<
  UpdateShadowMcpServersMutation,
  UpdateShadowMcpServersMutationVariables
>;

/**
 * __useUpdateShadowMcpServersMutation__
 *
 * To run a mutation, you first call `useUpdateShadowMcpServersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShadowMcpServersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShadowMcpServersMutation, { data, loading, error }] = useUpdateShadowMcpServersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShadowMcpServersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateShadowMcpServersMutation,
    UpdateShadowMcpServersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateShadowMcpServersMutation,
    UpdateShadowMcpServersMutationVariables
  >(UpdateShadowMcpServersDocument, options);
}
export type UpdateShadowMcpServersMutationHookResult = ReturnType<
  typeof useUpdateShadowMcpServersMutation
>;
export type UpdateShadowMcpServersMutationResult =
  Apollo.MutationResult<UpdateShadowMcpServersMutation>;
export type UpdateShadowMcpServersMutationOptions = Apollo.BaseMutationOptions<
  UpdateShadowMcpServersMutation,
  UpdateShadowMcpServersMutationVariables
>;
export const UpdateTunnelStatusDocument = gql`
  mutation updateTunnelStatus($tunnelId: ObjectID!, $status: TunnelStatus!) {
    setTunnelStatus(tunnelId: $tunnelId, status: $status) {
      _id
      status
    }
  }
`;
export type UpdateTunnelStatusMutationFn = Apollo.MutationFunction<
  UpdateTunnelStatusMutation,
  UpdateTunnelStatusMutationVariables
>;

/**
 * __useUpdateTunnelStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTunnelStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTunnelStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTunnelStatusMutation, { data, loading, error }] = useUpdateTunnelStatusMutation({
 *   variables: {
 *      tunnelId: // value for 'tunnelId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateTunnelStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTunnelStatusMutation,
    UpdateTunnelStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTunnelStatusMutation,
    UpdateTunnelStatusMutationVariables
  >(UpdateTunnelStatusDocument, options);
}
export type UpdateTunnelStatusMutationHookResult = ReturnType<
  typeof useUpdateTunnelStatusMutation
>;
export type UpdateTunnelStatusMutationResult =
  Apollo.MutationResult<UpdateTunnelStatusMutation>;
export type UpdateTunnelStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateTunnelStatusMutation,
  UpdateTunnelStatusMutationVariables
>;
export const UpsertRateLimitDocument = gql`
  mutation upsertRateLimit($input: UpsertRateLimitInput!) {
    upsertRateLimit(input: $input) {
      _id
      name
      status
      target {
        type
        details {
          ... on MCPServer {
            _id
            name
          }
        }
      }
      window {
        unit
        amount
      }
      action
      updatedAt
      createdAt
    }
  }
`;
export type UpsertRateLimitMutationFn = Apollo.MutationFunction<
  UpsertRateLimitMutation,
  UpsertRateLimitMutationVariables
>;

/**
 * __useUpsertRateLimitMutation__
 *
 * To run a mutation, you first call `useUpsertRateLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRateLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRateLimitMutation, { data, loading, error }] = useUpsertRateLimitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertRateLimitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertRateLimitMutation,
    UpsertRateLimitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertRateLimitMutation,
    UpsertRateLimitMutationVariables
  >(UpsertRateLimitDocument, options);
}
export type UpsertRateLimitMutationHookResult = ReturnType<
  typeof useUpsertRateLimitMutation
>;
export type UpsertRateLimitMutationResult =
  Apollo.MutationResult<UpsertRateLimitMutation>;
export type UpsertRateLimitMutationOptions = Apollo.BaseMutationOptions<
  UpsertRateLimitMutation,
  UpsertRateLimitMutationVariables
>;
export const GetAccessControlsDocument = gql`
  query getAccessControls(
    $q: String
    $types: [AccessControlType!]
    $sort: AccessControlSort
    $offset: Int
    $limit: Int
  ) {
    accessControls(
      q: $q
      types: $types
      sort: $sort
      offset: $offset
      limit: $limit
    ) {
      _id
      type
      name
      status
      updatedAt
      createdAt
      ... on AccessControlPolicy {
        policy {
          effect
          isDeprecated
          targetConfigs {
            allTools
            installationScope
            totalInstalls
            tools
          }
        }
      }
      ... on AccessControlRateLimit {
        rateLimit {
          target {
            type
            details {
              ... on MCPServer {
                _id
                name
              }
            }
          }
          window {
            unit
            amount
          }
        }
      }
    }
  }
`;

/**
 * __useGetAccessControlsQuery__
 *
 * To run a query within a React component, call `useGetAccessControlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessControlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessControlsQuery({
 *   variables: {
 *      q: // value for 'q'
 *      types: // value for 'types'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAccessControlsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccessControlsQuery,
    GetAccessControlsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccessControlsQuery,
    GetAccessControlsQueryVariables
  >(GetAccessControlsDocument, options);
}
export function useGetAccessControlsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccessControlsQuery,
    GetAccessControlsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccessControlsQuery,
    GetAccessControlsQueryVariables
  >(GetAccessControlsDocument, options);
}
// @ts-ignore
export function useGetAccessControlsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAccessControlsQuery,
    GetAccessControlsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetAccessControlsQuery,
  GetAccessControlsQueryVariables
>;
export function useGetAccessControlsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAccessControlsQuery,
        GetAccessControlsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetAccessControlsQuery | undefined,
  GetAccessControlsQueryVariables
>;
export function useGetAccessControlsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAccessControlsQuery,
        GetAccessControlsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAccessControlsQuery,
    GetAccessControlsQueryVariables
  >(GetAccessControlsDocument, options);
}
export type GetAccessControlsQueryHookResult = ReturnType<
  typeof useGetAccessControlsQuery
>;
export type GetAccessControlsLazyQueryHookResult = ReturnType<
  typeof useGetAccessControlsLazyQuery
>;
export type GetAccessControlsSuspenseQueryHookResult = ReturnType<
  typeof useGetAccessControlsSuspenseQuery
>;
export type GetAccessControlsQueryResult = Apollo.QueryResult<
  GetAccessControlsQuery,
  GetAccessControlsQueryVariables
>;
export const GetAccessPoliciesDocument = gql`
  query getAccessPolicies(
    $q: String
    $sort: AccessPolicySort
    $offset: Int
    $limit: Int
  ) {
    accessPolicies(q: $q, sort: $sort, offset: $offset, limit: $limit) {
      _id
      name
      status
      actionType
      effect
      isDeprecated
      targetConfigs {
        allTools
        tools
        totalInstalls
        installationScope
      }
    }
  }
`;

/**
 * __useGetAccessPoliciesQuery__
 *
 * To run a query within a React component, call `useGetAccessPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessPoliciesQuery({
 *   variables: {
 *      q: // value for 'q'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAccessPoliciesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccessPoliciesQuery,
    GetAccessPoliciesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccessPoliciesQuery,
    GetAccessPoliciesQueryVariables
  >(GetAccessPoliciesDocument, options);
}
export function useGetAccessPoliciesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccessPoliciesQuery,
    GetAccessPoliciesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccessPoliciesQuery,
    GetAccessPoliciesQueryVariables
  >(GetAccessPoliciesDocument, options);
}
// @ts-ignore
export function useGetAccessPoliciesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAccessPoliciesQuery,
    GetAccessPoliciesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetAccessPoliciesQuery,
  GetAccessPoliciesQueryVariables
>;
export function useGetAccessPoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAccessPoliciesQuery,
        GetAccessPoliciesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetAccessPoliciesQuery | undefined,
  GetAccessPoliciesQueryVariables
>;
export function useGetAccessPoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAccessPoliciesQuery,
        GetAccessPoliciesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAccessPoliciesQuery,
    GetAccessPoliciesQueryVariables
  >(GetAccessPoliciesDocument, options);
}
export type GetAccessPoliciesQueryHookResult = ReturnType<
  typeof useGetAccessPoliciesQuery
>;
export type GetAccessPoliciesLazyQueryHookResult = ReturnType<
  typeof useGetAccessPoliciesLazyQuery
>;
export type GetAccessPoliciesSuspenseQueryHookResult = ReturnType<
  typeof useGetAccessPoliciesSuspenseQuery
>;
export type GetAccessPoliciesQueryResult = Apollo.QueryResult<
  GetAccessPoliciesQuery,
  GetAccessPoliciesQueryVariables
>;
export const GetAccessPolicyDocument = gql`
  query getAccessPolicy($id: ObjectID!) {
    accessPolicy(id: $id) {
      _id
      name
      policy
      status
      actionType
      effect
      isDeprecated
      contentValidationRules {
        pattern
        contentType
        caseSensitive
        description
      }
      contextConditions
      principalTree {
        ...PrincipalTreeFieldsL1
      }
      targetConfigs {
        server {
          _id
          name
          availableTools {
            name
            description
          }
        }
        serverInstalls {
          _id
        }
        allTools
        tools
        installationScope
        totalInstalls
      }
    }
  }
  ${PrincipalTreeFieldsL1FragmentDoc}
`;

/**
 * __useGetAccessPolicyQuery__
 *
 * To run a query within a React component, call `useGetAccessPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessPolicyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccessPolicyQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAccessPolicyQuery,
    GetAccessPolicyQueryVariables
  > &
    (
      | { variables: GetAccessPolicyQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAccessPolicyQuery, GetAccessPolicyQueryVariables>(
    GetAccessPolicyDocument,
    options
  );
}
export function useGetAccessPolicyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccessPolicyQuery,
    GetAccessPolicyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccessPolicyQuery,
    GetAccessPolicyQueryVariables
  >(GetAccessPolicyDocument, options);
}
// @ts-ignore
export function useGetAccessPolicySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAccessPolicyQuery,
    GetAccessPolicyQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetAccessPolicyQuery,
  GetAccessPolicyQueryVariables
>;
export function useGetAccessPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAccessPolicyQuery,
        GetAccessPolicyQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetAccessPolicyQuery | undefined,
  GetAccessPolicyQueryVariables
>;
export function useGetAccessPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAccessPolicyQuery,
        GetAccessPolicyQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAccessPolicyQuery,
    GetAccessPolicyQueryVariables
  >(GetAccessPolicyDocument, options);
}
export type GetAccessPolicyQueryHookResult = ReturnType<
  typeof useGetAccessPolicyQuery
>;
export type GetAccessPolicyLazyQueryHookResult = ReturnType<
  typeof useGetAccessPolicyLazyQuery
>;
export type GetAccessPolicySuspenseQueryHookResult = ReturnType<
  typeof useGetAccessPolicySuspenseQuery
>;
export type GetAccessPolicyQueryResult = Apollo.QueryResult<
  GetAccessPolicyQuery,
  GetAccessPolicyQueryVariables
>;
export const GetAgentDocument = gql`
  query getAgent($id: ObjectID!) {
    agent(id: $id) {
      _id
      displayName
      owner {
        _id
        email
        displayName
      }
      createdBy {
        _id
        email
        displayName
      }
      createdAt
      updatedAt
      connections
      connectionsCount
    }
  }
`;

/**
 * __useGetAgentQuery__
 *
 * To run a query within a React component, call `useGetAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgentQuery(
  baseOptions: Apollo.QueryHookOptions<GetAgentQuery, GetAgentQueryVariables> &
    ({ variables: GetAgentQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAgentQuery, GetAgentQueryVariables>(
    GetAgentDocument,
    options
  );
}
export function useGetAgentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAgentQuery,
    GetAgentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAgentQuery, GetAgentQueryVariables>(
    GetAgentDocument,
    options
  );
}
// @ts-ignore
export function useGetAgentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAgentQuery,
    GetAgentQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetAgentQuery, GetAgentQueryVariables>;
export function useGetAgentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAgentQuery, GetAgentQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetAgentQuery | undefined,
  GetAgentQueryVariables
>;
export function useGetAgentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAgentQuery, GetAgentQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAgentQuery, GetAgentQueryVariables>(
    GetAgentDocument,
    options
  );
}
export type GetAgentQueryHookResult = ReturnType<typeof useGetAgentQuery>;
export type GetAgentLazyQueryHookResult = ReturnType<
  typeof useGetAgentLazyQuery
>;
export type GetAgentSuspenseQueryHookResult = ReturnType<
  typeof useGetAgentSuspenseQuery
>;
export type GetAgentQueryResult = Apollo.QueryResult<
  GetAgentQuery,
  GetAgentQueryVariables
>;
export const GetAgentsDocument = gql`
  query getAgents(
    $q: String
    $offset: Int
    $limit: Int
    $myAgentsOnly: Boolean
  ) {
    agents(q: $q, offset: $offset, limit: $limit, myAgentsOnly: $myAgentsOnly) {
      _id
      displayName
      owner {
        _id
        email
        displayName
      }
      createdAt
      connections
      connectionsCount
      lastActive
    }
  }
`;

/**
 * __useGetAgentsQuery__
 *
 * To run a query within a React component, call `useGetAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentsQuery({
 *   variables: {
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      myAgentsOnly: // value for 'myAgentsOnly'
 *   },
 * });
 */
export function useGetAgentsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAgentsQuery, GetAgentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAgentsQuery, GetAgentsQueryVariables>(
    GetAgentsDocument,
    options
  );
}
export function useGetAgentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAgentsQuery,
    GetAgentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAgentsQuery, GetAgentsQueryVariables>(
    GetAgentsDocument,
    options
  );
}
// @ts-ignore
export function useGetAgentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAgentsQuery,
    GetAgentsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetAgentsQuery, GetAgentsQueryVariables>;
export function useGetAgentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAgentsQuery, GetAgentsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetAgentsQuery | undefined,
  GetAgentsQueryVariables
>;
export function useGetAgentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAgentsQuery, GetAgentsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAgentsQuery, GetAgentsQueryVariables>(
    GetAgentsDocument,
    options
  );
}
export type GetAgentsQueryHookResult = ReturnType<typeof useGetAgentsQuery>;
export type GetAgentsLazyQueryHookResult = ReturnType<
  typeof useGetAgentsLazyQuery
>;
export type GetAgentsSuspenseQueryHookResult = ReturnType<
  typeof useGetAgentsSuspenseQuery
>;
export type GetAgentsQueryResult = Apollo.QueryResult<
  GetAgentsQuery,
  GetAgentsQueryVariables
>;
export const GetAuditLogsDocument = gql`
  query getAuditLogs(
    $eventTypes: [AuditEvent!]
    $actorType: AuditActorType
    $fromDate: String
    $toDate: String
    $groupBy: AuditLogGroupBy
    $sort: AuditLogSort
    $offset: Int
    $limit: Int
  ) {
    auditLogs(
      eventTypes: $eventTypes
      actorType: $actorType
      fromDate: $fromDate
      toDate: $toDate
      groupBy: $groupBy
      sort: $sort
      offset: $offset
      limit: $limit
    ) {
      _id
      timestamp
      event
      metadata
      actor {
        type
        details {
          __typename
          ... on User {
            email
            userDisplayName: displayName
          }
          ... on Agent {
            _id
            agentDisplayName: displayName
          }
        }
      }
      targets {
        type
        details {
          ... on User {
            email
            userDisplayName: displayName
          }
          ... on MCPServerInstall {
            displayName
            _id
            accessConfig {
              installType
            }
          }
          ... on MCPServer {
            _id
            name
          }
          ... on Agent {
            agentId: _id
            displayName
          }
        }
        ref
      }
    }
  }
`;

/**
 * __useGetAuditLogsQuery__
 *
 * To run a query within a React component, call `useGetAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditLogsQuery({
 *   variables: {
 *      eventTypes: // value for 'eventTypes'
 *      actorType: // value for 'actorType'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      groupBy: // value for 'groupBy'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAuditLogsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAuditLogsQuery,
    GetAuditLogsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>(
    GetAuditLogsDocument,
    options
  );
}
export function useGetAuditLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAuditLogsQuery,
    GetAuditLogsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>(
    GetAuditLogsDocument,
    options
  );
}
// @ts-ignore
export function useGetAuditLogsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAuditLogsQuery,
    GetAuditLogsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetAuditLogsQuery, GetAuditLogsQueryVariables>;
export function useGetAuditLogsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAuditLogsQuery,
        GetAuditLogsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetAuditLogsQuery | undefined,
  GetAuditLogsQueryVariables
>;
export function useGetAuditLogsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAuditLogsQuery,
        GetAuditLogsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>(
    GetAuditLogsDocument,
    options
  );
}
export type GetAuditLogsQueryHookResult = ReturnType<
  typeof useGetAuditLogsQuery
>;
export type GetAuditLogsLazyQueryHookResult = ReturnType<
  typeof useGetAuditLogsLazyQuery
>;
export type GetAuditLogsSuspenseQueryHookResult = ReturnType<
  typeof useGetAuditLogsSuspenseQuery
>;
export type GetAuditLogsQueryResult = Apollo.QueryResult<
  GetAuditLogsQuery,
  GetAuditLogsQueryVariables
>;
export const GetByoRemoteUrlServerDocument = gql`
  query getByoRemoteUrlServer($id: ObjectID!) {
    mcpServer(id: $id) {
      _id
      name
      serverInfo {
        ... on CustomMCPServerInfo {
          name
          description
          authenticationType
          source {
            ... on CustomRemoteUrlSource {
              mcpServerUrl
              isOnPrem
              useCustomAuthServer
              deployment {
                _id
                displayName
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetByoRemoteUrlServerQuery__
 *
 * To run a query within a React component, call `useGetByoRemoteUrlServerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetByoRemoteUrlServerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetByoRemoteUrlServerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetByoRemoteUrlServerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetByoRemoteUrlServerQuery,
    GetByoRemoteUrlServerQueryVariables
  > &
    (
      | { variables: GetByoRemoteUrlServerQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetByoRemoteUrlServerQuery,
    GetByoRemoteUrlServerQueryVariables
  >(GetByoRemoteUrlServerDocument, options);
}
export function useGetByoRemoteUrlServerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetByoRemoteUrlServerQuery,
    GetByoRemoteUrlServerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetByoRemoteUrlServerQuery,
    GetByoRemoteUrlServerQueryVariables
  >(GetByoRemoteUrlServerDocument, options);
}
// @ts-ignore
export function useGetByoRemoteUrlServerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetByoRemoteUrlServerQuery,
    GetByoRemoteUrlServerQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetByoRemoteUrlServerQuery,
  GetByoRemoteUrlServerQueryVariables
>;
export function useGetByoRemoteUrlServerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetByoRemoteUrlServerQuery,
        GetByoRemoteUrlServerQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetByoRemoteUrlServerQuery | undefined,
  GetByoRemoteUrlServerQueryVariables
>;
export function useGetByoRemoteUrlServerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetByoRemoteUrlServerQuery,
        GetByoRemoteUrlServerQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetByoRemoteUrlServerQuery,
    GetByoRemoteUrlServerQueryVariables
  >(GetByoRemoteUrlServerDocument, options);
}
export type GetByoRemoteUrlServerQueryHookResult = ReturnType<
  typeof useGetByoRemoteUrlServerQuery
>;
export type GetByoRemoteUrlServerLazyQueryHookResult = ReturnType<
  typeof useGetByoRemoteUrlServerLazyQuery
>;
export type GetByoRemoteUrlServerSuspenseQueryHookResult = ReturnType<
  typeof useGetByoRemoteUrlServerSuspenseQuery
>;
export type GetByoRemoteUrlServerQueryResult = Apollo.QueryResult<
  GetByoRemoteUrlServerQuery,
  GetByoRemoteUrlServerQueryVariables
>;
export const GetCredentialsDocument = gql`
  query getCredentials($offset: Int, $limit: Int, $type: CredentialTypes!) {
    credentials(offset: $offset, limit: $limit, type: $type) {
      _id
      displayName
      lastUsed
      createdAt
      preview
      credentialId
      status
    }
  }
`;

/**
 * __useGetCredentialsQuery__
 *
 * To run a query within a React component, call `useGetCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCredentialsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetCredentialsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCredentialsQuery,
    GetCredentialsQueryVariables
  > &
    (
      | { variables: GetCredentialsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCredentialsQuery, GetCredentialsQueryVariables>(
    GetCredentialsDocument,
    options
  );
}
export function useGetCredentialsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCredentialsQuery,
    GetCredentialsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCredentialsQuery, GetCredentialsQueryVariables>(
    GetCredentialsDocument,
    options
  );
}
// @ts-ignore
export function useGetCredentialsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCredentialsQuery,
    GetCredentialsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetCredentialsQuery,
  GetCredentialsQueryVariables
>;
export function useGetCredentialsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCredentialsQuery,
        GetCredentialsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetCredentialsQuery | undefined,
  GetCredentialsQueryVariables
>;
export function useGetCredentialsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCredentialsQuery,
        GetCredentialsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCredentialsQuery,
    GetCredentialsQueryVariables
  >(GetCredentialsDocument, options);
}
export type GetCredentialsQueryHookResult = ReturnType<
  typeof useGetCredentialsQuery
>;
export type GetCredentialsLazyQueryHookResult = ReturnType<
  typeof useGetCredentialsLazyQuery
>;
export type GetCredentialsSuspenseQueryHookResult = ReturnType<
  typeof useGetCredentialsSuspenseQuery
>;
export type GetCredentialsQueryResult = Apollo.QueryResult<
  GetCredentialsQuery,
  GetCredentialsQueryVariables
>;
export const GetDashboardInstallationsByMcpServerDocument = gql`
  query getDashboardInstallationsByMCPServer {
    getDashboardInstallationsByMCPServer {
      serverName
      personalConnections
      managedConnections
      shadowConnections
    }
  }
`;

/**
 * __useGetDashboardInstallationsByMcpServerQuery__
 *
 * To run a query within a React component, call `useGetDashboardInstallationsByMcpServerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardInstallationsByMcpServerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardInstallationsByMcpServerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardInstallationsByMcpServerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDashboardInstallationsByMcpServerQuery,
    GetDashboardInstallationsByMcpServerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardInstallationsByMcpServerQuery,
    GetDashboardInstallationsByMcpServerQueryVariables
  >(GetDashboardInstallationsByMcpServerDocument, options);
}
export function useGetDashboardInstallationsByMcpServerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardInstallationsByMcpServerQuery,
    GetDashboardInstallationsByMcpServerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardInstallationsByMcpServerQuery,
    GetDashboardInstallationsByMcpServerQueryVariables
  >(GetDashboardInstallationsByMcpServerDocument, options);
}
// @ts-ignore
export function useGetDashboardInstallationsByMcpServerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardInstallationsByMcpServerQuery,
    GetDashboardInstallationsByMcpServerQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetDashboardInstallationsByMcpServerQuery,
  GetDashboardInstallationsByMcpServerQueryVariables
>;
export function useGetDashboardInstallationsByMcpServerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardInstallationsByMcpServerQuery,
        GetDashboardInstallationsByMcpServerQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetDashboardInstallationsByMcpServerQuery | undefined,
  GetDashboardInstallationsByMcpServerQueryVariables
>;
export function useGetDashboardInstallationsByMcpServerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardInstallationsByMcpServerQuery,
        GetDashboardInstallationsByMcpServerQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardInstallationsByMcpServerQuery,
    GetDashboardInstallationsByMcpServerQueryVariables
  >(GetDashboardInstallationsByMcpServerDocument, options);
}
export type GetDashboardInstallationsByMcpServerQueryHookResult = ReturnType<
  typeof useGetDashboardInstallationsByMcpServerQuery
>;
export type GetDashboardInstallationsByMcpServerLazyQueryHookResult =
  ReturnType<typeof useGetDashboardInstallationsByMcpServerLazyQuery>;
export type GetDashboardInstallationsByMcpServerSuspenseQueryHookResult =
  ReturnType<typeof useGetDashboardInstallationsByMcpServerSuspenseQuery>;
export type GetDashboardInstallationsByMcpServerQueryResult =
  Apollo.QueryResult<
    GetDashboardInstallationsByMcpServerQuery,
    GetDashboardInstallationsByMcpServerQueryVariables
  >;
export const GetDashboardMcpServersByToolCallsDocument = gql`
  query getDashboardMCPServersByToolCalls {
    getDashboardMCPServersByToolCalls {
      serverName
      toolCallCount
    }
  }
`;

/**
 * __useGetDashboardMcpServersByToolCallsQuery__
 *
 * To run a query within a React component, call `useGetDashboardMcpServersByToolCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardMcpServersByToolCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardMcpServersByToolCallsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardMcpServersByToolCallsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDashboardMcpServersByToolCallsQuery,
    GetDashboardMcpServersByToolCallsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardMcpServersByToolCallsQuery,
    GetDashboardMcpServersByToolCallsQueryVariables
  >(GetDashboardMcpServersByToolCallsDocument, options);
}
export function useGetDashboardMcpServersByToolCallsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardMcpServersByToolCallsQuery,
    GetDashboardMcpServersByToolCallsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardMcpServersByToolCallsQuery,
    GetDashboardMcpServersByToolCallsQueryVariables
  >(GetDashboardMcpServersByToolCallsDocument, options);
}
// @ts-ignore
export function useGetDashboardMcpServersByToolCallsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardMcpServersByToolCallsQuery,
    GetDashboardMcpServersByToolCallsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetDashboardMcpServersByToolCallsQuery,
  GetDashboardMcpServersByToolCallsQueryVariables
>;
export function useGetDashboardMcpServersByToolCallsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardMcpServersByToolCallsQuery,
        GetDashboardMcpServersByToolCallsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetDashboardMcpServersByToolCallsQuery | undefined,
  GetDashboardMcpServersByToolCallsQueryVariables
>;
export function useGetDashboardMcpServersByToolCallsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardMcpServersByToolCallsQuery,
        GetDashboardMcpServersByToolCallsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardMcpServersByToolCallsQuery,
    GetDashboardMcpServersByToolCallsQueryVariables
  >(GetDashboardMcpServersByToolCallsDocument, options);
}
export type GetDashboardMcpServersByToolCallsQueryHookResult = ReturnType<
  typeof useGetDashboardMcpServersByToolCallsQuery
>;
export type GetDashboardMcpServersByToolCallsLazyQueryHookResult = ReturnType<
  typeof useGetDashboardMcpServersByToolCallsLazyQuery
>;
export type GetDashboardMcpServersByToolCallsSuspenseQueryHookResult =
  ReturnType<typeof useGetDashboardMcpServersByToolCallsSuspenseQuery>;
export type GetDashboardMcpServersByToolCallsQueryResult = Apollo.QueryResult<
  GetDashboardMcpServersByToolCallsQuery,
  GetDashboardMcpServersByToolCallsQueryVariables
>;
export const GetDashboardToolCallsOverTimeDocument = gql`
  query getDashboardToolCallsOverTime {
    getDashboardToolCallsOverTime {
      weekStart
      weekEnd
      successfulCalls
      failedCalls
      totalCalls
    }
  }
`;

/**
 * __useGetDashboardToolCallsOverTimeQuery__
 *
 * To run a query within a React component, call `useGetDashboardToolCallsOverTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardToolCallsOverTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardToolCallsOverTimeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardToolCallsOverTimeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDashboardToolCallsOverTimeQuery,
    GetDashboardToolCallsOverTimeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardToolCallsOverTimeQuery,
    GetDashboardToolCallsOverTimeQueryVariables
  >(GetDashboardToolCallsOverTimeDocument, options);
}
export function useGetDashboardToolCallsOverTimeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardToolCallsOverTimeQuery,
    GetDashboardToolCallsOverTimeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardToolCallsOverTimeQuery,
    GetDashboardToolCallsOverTimeQueryVariables
  >(GetDashboardToolCallsOverTimeDocument, options);
}
// @ts-ignore
export function useGetDashboardToolCallsOverTimeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardToolCallsOverTimeQuery,
    GetDashboardToolCallsOverTimeQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetDashboardToolCallsOverTimeQuery,
  GetDashboardToolCallsOverTimeQueryVariables
>;
export function useGetDashboardToolCallsOverTimeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardToolCallsOverTimeQuery,
        GetDashboardToolCallsOverTimeQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetDashboardToolCallsOverTimeQuery | undefined,
  GetDashboardToolCallsOverTimeQueryVariables
>;
export function useGetDashboardToolCallsOverTimeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardToolCallsOverTimeQuery,
        GetDashboardToolCallsOverTimeQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardToolCallsOverTimeQuery,
    GetDashboardToolCallsOverTimeQueryVariables
  >(GetDashboardToolCallsOverTimeDocument, options);
}
export type GetDashboardToolCallsOverTimeQueryHookResult = ReturnType<
  typeof useGetDashboardToolCallsOverTimeQuery
>;
export type GetDashboardToolCallsOverTimeLazyQueryHookResult = ReturnType<
  typeof useGetDashboardToolCallsOverTimeLazyQuery
>;
export type GetDashboardToolCallsOverTimeSuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardToolCallsOverTimeSuspenseQuery
>;
export type GetDashboardToolCallsOverTimeQueryResult = Apollo.QueryResult<
  GetDashboardToolCallsOverTimeQuery,
  GetDashboardToolCallsOverTimeQueryVariables
>;
export const GetDashboardUsersByToolCallsDocument = gql`
  query getDashboardUsersByToolCalls {
    getDashboardUsersByToolCalls {
      user {
        displayName
        email
      }
      toolCallCount
    }
  }
`;

/**
 * __useGetDashboardUsersByToolCallsQuery__
 *
 * To run a query within a React component, call `useGetDashboardUsersByToolCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardUsersByToolCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardUsersByToolCallsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardUsersByToolCallsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDashboardUsersByToolCallsQuery,
    GetDashboardUsersByToolCallsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardUsersByToolCallsQuery,
    GetDashboardUsersByToolCallsQueryVariables
  >(GetDashboardUsersByToolCallsDocument, options);
}
export function useGetDashboardUsersByToolCallsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardUsersByToolCallsQuery,
    GetDashboardUsersByToolCallsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardUsersByToolCallsQuery,
    GetDashboardUsersByToolCallsQueryVariables
  >(GetDashboardUsersByToolCallsDocument, options);
}
// @ts-ignore
export function useGetDashboardUsersByToolCallsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardUsersByToolCallsQuery,
    GetDashboardUsersByToolCallsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetDashboardUsersByToolCallsQuery,
  GetDashboardUsersByToolCallsQueryVariables
>;
export function useGetDashboardUsersByToolCallsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardUsersByToolCallsQuery,
        GetDashboardUsersByToolCallsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetDashboardUsersByToolCallsQuery | undefined,
  GetDashboardUsersByToolCallsQueryVariables
>;
export function useGetDashboardUsersByToolCallsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDashboardUsersByToolCallsQuery,
        GetDashboardUsersByToolCallsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardUsersByToolCallsQuery,
    GetDashboardUsersByToolCallsQueryVariables
  >(GetDashboardUsersByToolCallsDocument, options);
}
export type GetDashboardUsersByToolCallsQueryHookResult = ReturnType<
  typeof useGetDashboardUsersByToolCallsQuery
>;
export type GetDashboardUsersByToolCallsLazyQueryHookResult = ReturnType<
  typeof useGetDashboardUsersByToolCallsLazyQuery
>;
export type GetDashboardUsersByToolCallsSuspenseQueryHookResult = ReturnType<
  typeof useGetDashboardUsersByToolCallsSuspenseQuery
>;
export type GetDashboardUsersByToolCallsQueryResult = Apollo.QueryResult<
  GetDashboardUsersByToolCallsQuery,
  GetDashboardUsersByToolCallsQueryVariables
>;
export const GetDeploymentsDocument = gql`
  query getDeployments($offset: Int, $limit: Int) {
    deployments(offset: $offset, limit: $limit) {
      _id
      status
      displayName
      origin
      credentials {
        _id
        status
        credentialId
      }
      createdBy {
        _id
        displayName
        email
      }
      updatedBy {
        _id
        displayName
        email
      }
      createdAt
      updatedAt
      polledAt
      health
    }
  }
`;

/**
 * __useGetDeploymentsQuery__
 *
 * To run a query within a React component, call `useGetDeploymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeploymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeploymentsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDeploymentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDeploymentsQuery,
    GetDeploymentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDeploymentsQuery, GetDeploymentsQueryVariables>(
    GetDeploymentsDocument,
    options
  );
}
export function useGetDeploymentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeploymentsQuery,
    GetDeploymentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDeploymentsQuery, GetDeploymentsQueryVariables>(
    GetDeploymentsDocument,
    options
  );
}
// @ts-ignore
export function useGetDeploymentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDeploymentsQuery,
    GetDeploymentsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetDeploymentsQuery,
  GetDeploymentsQueryVariables
>;
export function useGetDeploymentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDeploymentsQuery,
        GetDeploymentsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetDeploymentsQuery | undefined,
  GetDeploymentsQueryVariables
>;
export function useGetDeploymentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDeploymentsQuery,
        GetDeploymentsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDeploymentsQuery,
    GetDeploymentsQueryVariables
  >(GetDeploymentsDocument, options);
}
export type GetDeploymentsQueryHookResult = ReturnType<
  typeof useGetDeploymentsQuery
>;
export type GetDeploymentsLazyQueryHookResult = ReturnType<
  typeof useGetDeploymentsLazyQuery
>;
export type GetDeploymentsSuspenseQueryHookResult = ReturnType<
  typeof useGetDeploymentsSuspenseQuery
>;
export type GetDeploymentsQueryResult = Apollo.QueryResult<
  GetDeploymentsQuery,
  GetDeploymentsQueryVariables
>;
export const GetDeploymentsForSelectDocument = gql`
  query getDeploymentsForSelect($offset: Int, $limit: Int) {
    deployments(offset: $offset, limit: $limit) {
      _id
      displayName
      origin
    }
  }
`;

/**
 * __useGetDeploymentsForSelectQuery__
 *
 * To run a query within a React component, call `useGetDeploymentsForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeploymentsForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeploymentsForSelectQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDeploymentsForSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDeploymentsForSelectQuery,
    GetDeploymentsForSelectQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDeploymentsForSelectQuery,
    GetDeploymentsForSelectQueryVariables
  >(GetDeploymentsForSelectDocument, options);
}
export function useGetDeploymentsForSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeploymentsForSelectQuery,
    GetDeploymentsForSelectQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDeploymentsForSelectQuery,
    GetDeploymentsForSelectQueryVariables
  >(GetDeploymentsForSelectDocument, options);
}
// @ts-ignore
export function useGetDeploymentsForSelectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDeploymentsForSelectQuery,
    GetDeploymentsForSelectQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetDeploymentsForSelectQuery,
  GetDeploymentsForSelectQueryVariables
>;
export function useGetDeploymentsForSelectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDeploymentsForSelectQuery,
        GetDeploymentsForSelectQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetDeploymentsForSelectQuery | undefined,
  GetDeploymentsForSelectQueryVariables
>;
export function useGetDeploymentsForSelectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDeploymentsForSelectQuery,
        GetDeploymentsForSelectQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDeploymentsForSelectQuery,
    GetDeploymentsForSelectQueryVariables
  >(GetDeploymentsForSelectDocument, options);
}
export type GetDeploymentsForSelectQueryHookResult = ReturnType<
  typeof useGetDeploymentsForSelectQuery
>;
export type GetDeploymentsForSelectLazyQueryHookResult = ReturnType<
  typeof useGetDeploymentsForSelectLazyQuery
>;
export type GetDeploymentsForSelectSuspenseQueryHookResult = ReturnType<
  typeof useGetDeploymentsForSelectSuspenseQuery
>;
export type GetDeploymentsForSelectQueryResult = Apollo.QueryResult<
  GetDeploymentsForSelectQuery,
  GetDeploymentsForSelectQueryVariables
>;
export const GetEnabledAppsDocument = gql`
  query getEnabledApps(
    $personalConnectionStatus: PersonalConnectionStatus!
    $q: String
    $limit: Int
    $offset: Int
  ) {
    enabledApps(
      personalConnectionStatus: $personalConnectionStatus
      q: $q
      limit: $limit
      offset: $offset
    ) {
      _id
      name
      accessConfig {
        availableFor
        isPersonalConnectionEnabled
      }
    }
  }
`;

/**
 * __useGetEnabledAppsQuery__
 *
 * To run a query within a React component, call `useGetEnabledAppsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnabledAppsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnabledAppsQuery({
 *   variables: {
 *      personalConnectionStatus: // value for 'personalConnectionStatus'
 *      q: // value for 'q'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetEnabledAppsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEnabledAppsQuery,
    GetEnabledAppsQueryVariables
  > &
    (
      | { variables: GetEnabledAppsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEnabledAppsQuery, GetEnabledAppsQueryVariables>(
    GetEnabledAppsDocument,
    options
  );
}
export function useGetEnabledAppsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEnabledAppsQuery,
    GetEnabledAppsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEnabledAppsQuery, GetEnabledAppsQueryVariables>(
    GetEnabledAppsDocument,
    options
  );
}
// @ts-ignore
export function useGetEnabledAppsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEnabledAppsQuery,
    GetEnabledAppsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetEnabledAppsQuery,
  GetEnabledAppsQueryVariables
>;
export function useGetEnabledAppsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEnabledAppsQuery,
        GetEnabledAppsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetEnabledAppsQuery | undefined,
  GetEnabledAppsQueryVariables
>;
export function useGetEnabledAppsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEnabledAppsQuery,
        GetEnabledAppsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEnabledAppsQuery,
    GetEnabledAppsQueryVariables
  >(GetEnabledAppsDocument, options);
}
export type GetEnabledAppsQueryHookResult = ReturnType<
  typeof useGetEnabledAppsQuery
>;
export type GetEnabledAppsLazyQueryHookResult = ReturnType<
  typeof useGetEnabledAppsLazyQuery
>;
export type GetEnabledAppsSuspenseQueryHookResult = ReturnType<
  typeof useGetEnabledAppsSuspenseQuery
>;
export type GetEnabledAppsQueryResult = Apollo.QueryResult<
  GetEnabledAppsQuery,
  GetEnabledAppsQueryVariables
>;
export const GetEnabledInstallsForServerDocument = gql`
  query getEnabledInstallsForServer(
    $offset: Int
    $limit: Int
    $installTypes: [MCPServerInstallAccessInstallType!]
    $server: ObjectID
  ) {
    myMcpServerInstalls(
      offset: $offset
      limit: $limit
      installTypes: $installTypes
      server: $server
    ) {
      _id
      displayName
      accessConfig {
        installType
      }
    }
  }
`;

/**
 * __useGetEnabledInstallsForServerQuery__
 *
 * To run a query within a React component, call `useGetEnabledInstallsForServerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnabledInstallsForServerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnabledInstallsForServerQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      installTypes: // value for 'installTypes'
 *      server: // value for 'server'
 *   },
 * });
 */
export function useGetEnabledInstallsForServerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEnabledInstallsForServerQuery,
    GetEnabledInstallsForServerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEnabledInstallsForServerQuery,
    GetEnabledInstallsForServerQueryVariables
  >(GetEnabledInstallsForServerDocument, options);
}
export function useGetEnabledInstallsForServerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEnabledInstallsForServerQuery,
    GetEnabledInstallsForServerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEnabledInstallsForServerQuery,
    GetEnabledInstallsForServerQueryVariables
  >(GetEnabledInstallsForServerDocument, options);
}
// @ts-ignore
export function useGetEnabledInstallsForServerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEnabledInstallsForServerQuery,
    GetEnabledInstallsForServerQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetEnabledInstallsForServerQuery,
  GetEnabledInstallsForServerQueryVariables
>;
export function useGetEnabledInstallsForServerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEnabledInstallsForServerQuery,
        GetEnabledInstallsForServerQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetEnabledInstallsForServerQuery | undefined,
  GetEnabledInstallsForServerQueryVariables
>;
export function useGetEnabledInstallsForServerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEnabledInstallsForServerQuery,
        GetEnabledInstallsForServerQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEnabledInstallsForServerQuery,
    GetEnabledInstallsForServerQueryVariables
  >(GetEnabledInstallsForServerDocument, options);
}
export type GetEnabledInstallsForServerQueryHookResult = ReturnType<
  typeof useGetEnabledInstallsForServerQuery
>;
export type GetEnabledInstallsForServerLazyQueryHookResult = ReturnType<
  typeof useGetEnabledInstallsForServerLazyQuery
>;
export type GetEnabledInstallsForServerSuspenseQueryHookResult = ReturnType<
  typeof useGetEnabledInstallsForServerSuspenseQuery
>;
export type GetEnabledInstallsForServerQueryResult = Apollo.QueryResult<
  GetEnabledInstallsForServerQuery,
  GetEnabledInstallsForServerQueryVariables
>;
export const GetEnabledMcpServersForSelectDocument = gql`
  query getEnabledMcpServersForSelect(
    $q: String
    $offset: Int
    $limit: Int
    $availableForTypes: [MCPServerAccessAvailableFor!]
  ) {
    mcpServers(
      q: $q
      offset: $offset
      limit: $limit
      availableForTypes: $availableForTypes
    ) {
      _id
      name
    }
  }
`;

/**
 * __useGetEnabledMcpServersForSelectQuery__
 *
 * To run a query within a React component, call `useGetEnabledMcpServersForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnabledMcpServersForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnabledMcpServersForSelectQuery({
 *   variables: {
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      availableForTypes: // value for 'availableForTypes'
 *   },
 * });
 */
export function useGetEnabledMcpServersForSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEnabledMcpServersForSelectQuery,
    GetEnabledMcpServersForSelectQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEnabledMcpServersForSelectQuery,
    GetEnabledMcpServersForSelectQueryVariables
  >(GetEnabledMcpServersForSelectDocument, options);
}
export function useGetEnabledMcpServersForSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEnabledMcpServersForSelectQuery,
    GetEnabledMcpServersForSelectQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEnabledMcpServersForSelectQuery,
    GetEnabledMcpServersForSelectQueryVariables
  >(GetEnabledMcpServersForSelectDocument, options);
}
// @ts-ignore
export function useGetEnabledMcpServersForSelectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEnabledMcpServersForSelectQuery,
    GetEnabledMcpServersForSelectQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetEnabledMcpServersForSelectQuery,
  GetEnabledMcpServersForSelectQueryVariables
>;
export function useGetEnabledMcpServersForSelectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEnabledMcpServersForSelectQuery,
        GetEnabledMcpServersForSelectQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetEnabledMcpServersForSelectQuery | undefined,
  GetEnabledMcpServersForSelectQueryVariables
>;
export function useGetEnabledMcpServersForSelectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEnabledMcpServersForSelectQuery,
        GetEnabledMcpServersForSelectQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEnabledMcpServersForSelectQuery,
    GetEnabledMcpServersForSelectQueryVariables
  >(GetEnabledMcpServersForSelectDocument, options);
}
export type GetEnabledMcpServersForSelectQueryHookResult = ReturnType<
  typeof useGetEnabledMcpServersForSelectQuery
>;
export type GetEnabledMcpServersForSelectLazyQueryHookResult = ReturnType<
  typeof useGetEnabledMcpServersForSelectLazyQuery
>;
export type GetEnabledMcpServersForSelectSuspenseQueryHookResult = ReturnType<
  typeof useGetEnabledMcpServersForSelectSuspenseQuery
>;
export type GetEnabledMcpServersForSelectQueryResult = Apollo.QueryResult<
  GetEnabledMcpServersForSelectQuery,
  GetEnabledMcpServersForSelectQueryVariables
>;
export const GetGroupDocument = gql`
  query getGroup($id: ObjectID!) {
    group(id: $id) {
      _id
      displayName
    }
  }
`;

/**
 * __useGetGroupQuery__
 *
 * To run a query within a React component, call `useGetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupQuery(
  baseOptions: Apollo.QueryHookOptions<GetGroupQuery, GetGroupQueryVariables> &
    ({ variables: GetGroupQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGroupQuery, GetGroupQueryVariables>(
    GetGroupDocument,
    options
  );
}
export function useGetGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupQuery,
    GetGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGroupQuery, GetGroupQueryVariables>(
    GetGroupDocument,
    options
  );
}
// @ts-ignore
export function useGetGroupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetGroupQuery,
    GetGroupQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetGroupQuery, GetGroupQueryVariables>;
export function useGetGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetGroupQuery | undefined,
  GetGroupQueryVariables
>;
export function useGetGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetGroupQuery, GetGroupQueryVariables>(
    GetGroupDocument,
    options
  );
}
export type GetGroupQueryHookResult = ReturnType<typeof useGetGroupQuery>;
export type GetGroupLazyQueryHookResult = ReturnType<
  typeof useGetGroupLazyQuery
>;
export type GetGroupSuspenseQueryHookResult = ReturnType<
  typeof useGetGroupSuspenseQuery
>;
export type GetGroupQueryResult = Apollo.QueryResult<
  GetGroupQuery,
  GetGroupQueryVariables
>;
export const GetGroupsDocument = gql`
  query getGroups($q: String, $offset: Int, $limit: Int) {
    groups(q: $q, offset: $offset, limit: $limit) {
      _id
      displayName
    }
  }
`;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(
    GetGroupsDocument,
    options
  );
}
export function useGetGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupsQuery,
    GetGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(
    GetGroupsDocument,
    options
  );
}
// @ts-ignore
export function useGetGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetGroupsQuery,
    GetGroupsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export function useGetGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetGroupsQuery | undefined,
  GetGroupsQueryVariables
>;
export function useGetGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetGroupsQuery, GetGroupsQueryVariables>(
    GetGroupsDocument,
    options
  );
}
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<
  typeof useGetGroupsLazyQuery
>;
export type GetGroupsSuspenseQueryHookResult = ReturnType<
  typeof useGetGroupsSuspenseQuery
>;
export type GetGroupsQueryResult = Apollo.QueryResult<
  GetGroupsQuery,
  GetGroupsQueryVariables
>;
export const GetIdNameMcpServerInstallsDocument = gql`
  query getIdNameMcpServerInstalls(
    $servers: [ObjectID!]
    $offset: Int
    $limit: Int
    $installTypes: [MCPServerInstallAccessInstallType!]
    $q: String
    $owners: [ObjectID!]
  ) {
    mcpServerInstalls(
      servers: $servers
      offset: $offset
      limit: $limit
      installTypes: $installTypes
      q: $q
      owners: $owners
    ) {
      _id
      displayName
      server {
        _id
      }
    }
  }
`;

/**
 * __useGetIdNameMcpServerInstallsQuery__
 *
 * To run a query within a React component, call `useGetIdNameMcpServerInstallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdNameMcpServerInstallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdNameMcpServerInstallsQuery({
 *   variables: {
 *      servers: // value for 'servers'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      installTypes: // value for 'installTypes'
 *      q: // value for 'q'
 *      owners: // value for 'owners'
 *   },
 * });
 */
export function useGetIdNameMcpServerInstallsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetIdNameMcpServerInstallsQuery,
    GetIdNameMcpServerInstallsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIdNameMcpServerInstallsQuery,
    GetIdNameMcpServerInstallsQueryVariables
  >(GetIdNameMcpServerInstallsDocument, options);
}
export function useGetIdNameMcpServerInstallsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIdNameMcpServerInstallsQuery,
    GetIdNameMcpServerInstallsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIdNameMcpServerInstallsQuery,
    GetIdNameMcpServerInstallsQueryVariables
  >(GetIdNameMcpServerInstallsDocument, options);
}
// @ts-ignore
export function useGetIdNameMcpServerInstallsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIdNameMcpServerInstallsQuery,
    GetIdNameMcpServerInstallsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetIdNameMcpServerInstallsQuery,
  GetIdNameMcpServerInstallsQueryVariables
>;
export function useGetIdNameMcpServerInstallsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIdNameMcpServerInstallsQuery,
        GetIdNameMcpServerInstallsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetIdNameMcpServerInstallsQuery | undefined,
  GetIdNameMcpServerInstallsQueryVariables
>;
export function useGetIdNameMcpServerInstallsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIdNameMcpServerInstallsQuery,
        GetIdNameMcpServerInstallsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIdNameMcpServerInstallsQuery,
    GetIdNameMcpServerInstallsQueryVariables
  >(GetIdNameMcpServerInstallsDocument, options);
}
export type GetIdNameMcpServerInstallsQueryHookResult = ReturnType<
  typeof useGetIdNameMcpServerInstallsQuery
>;
export type GetIdNameMcpServerInstallsLazyQueryHookResult = ReturnType<
  typeof useGetIdNameMcpServerInstallsLazyQuery
>;
export type GetIdNameMcpServerInstallsSuspenseQueryHookResult = ReturnType<
  typeof useGetIdNameMcpServerInstallsSuspenseQuery
>;
export type GetIdNameMcpServerInstallsQueryResult = Apollo.QueryResult<
  GetIdNameMcpServerInstallsQuery,
  GetIdNameMcpServerInstallsQueryVariables
>;
export const GetInstallationConfigPropertiesDocument = gql`
  query GetInstallationConfigProperties($templateOrServerInfoSlug: String!) {
    installationConfigProperties(
      templateOrServerInfoSlug: $templateOrServerInfoSlug
    ) {
      serverId
      server {
        _id
      }
      configSchema {
        required
        properties
      }
    }
  }
`;

/**
 * __useGetInstallationConfigPropertiesQuery__
 *
 * To run a query within a React component, call `useGetInstallationConfigPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallationConfigPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallationConfigPropertiesQuery({
 *   variables: {
 *      templateOrServerInfoSlug: // value for 'templateOrServerInfoSlug'
 *   },
 * });
 */
export function useGetInstallationConfigPropertiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInstallationConfigPropertiesQuery,
    GetInstallationConfigPropertiesQueryVariables
  > &
    (
      | {
          variables: GetInstallationConfigPropertiesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInstallationConfigPropertiesQuery,
    GetInstallationConfigPropertiesQueryVariables
  >(GetInstallationConfigPropertiesDocument, options);
}
export function useGetInstallationConfigPropertiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInstallationConfigPropertiesQuery,
    GetInstallationConfigPropertiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInstallationConfigPropertiesQuery,
    GetInstallationConfigPropertiesQueryVariables
  >(GetInstallationConfigPropertiesDocument, options);
}
// @ts-ignore
export function useGetInstallationConfigPropertiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetInstallationConfigPropertiesQuery,
    GetInstallationConfigPropertiesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetInstallationConfigPropertiesQuery,
  GetInstallationConfigPropertiesQueryVariables
>;
export function useGetInstallationConfigPropertiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetInstallationConfigPropertiesQuery,
        GetInstallationConfigPropertiesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetInstallationConfigPropertiesQuery | undefined,
  GetInstallationConfigPropertiesQueryVariables
>;
export function useGetInstallationConfigPropertiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetInstallationConfigPropertiesQuery,
        GetInstallationConfigPropertiesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetInstallationConfigPropertiesQuery,
    GetInstallationConfigPropertiesQueryVariables
  >(GetInstallationConfigPropertiesDocument, options);
}
export type GetInstallationConfigPropertiesQueryHookResult = ReturnType<
  typeof useGetInstallationConfigPropertiesQuery
>;
export type GetInstallationConfigPropertiesLazyQueryHookResult = ReturnType<
  typeof useGetInstallationConfigPropertiesLazyQuery
>;
export type GetInstallationConfigPropertiesSuspenseQueryHookResult = ReturnType<
  typeof useGetInstallationConfigPropertiesSuspenseQuery
>;
export type GetInstallationConfigPropertiesQueryResult = Apollo.QueryResult<
  GetInstallationConfigPropertiesQuery,
  GetInstallationConfigPropertiesQueryVariables
>;
export const GetIntegrationCountsDocument = gql`
  query getIntegrationCounts($integrationId: IntegrationId) {
    getIntegrationCounts(integrationId: $integrationId) {
      integrationId
      count
    }
  }
`;

/**
 * __useGetIntegrationCountsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationCountsQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useGetIntegrationCountsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetIntegrationCountsQuery,
    GetIntegrationCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIntegrationCountsQuery,
    GetIntegrationCountsQueryVariables
  >(GetIntegrationCountsDocument, options);
}
export function useGetIntegrationCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIntegrationCountsQuery,
    GetIntegrationCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIntegrationCountsQuery,
    GetIntegrationCountsQueryVariables
  >(GetIntegrationCountsDocument, options);
}
// @ts-ignore
export function useGetIntegrationCountsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIntegrationCountsQuery,
    GetIntegrationCountsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetIntegrationCountsQuery,
  GetIntegrationCountsQueryVariables
>;
export function useGetIntegrationCountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIntegrationCountsQuery,
        GetIntegrationCountsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetIntegrationCountsQuery | undefined,
  GetIntegrationCountsQueryVariables
>;
export function useGetIntegrationCountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIntegrationCountsQuery,
        GetIntegrationCountsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIntegrationCountsQuery,
    GetIntegrationCountsQueryVariables
  >(GetIntegrationCountsDocument, options);
}
export type GetIntegrationCountsQueryHookResult = ReturnType<
  typeof useGetIntegrationCountsQuery
>;
export type GetIntegrationCountsLazyQueryHookResult = ReturnType<
  typeof useGetIntegrationCountsLazyQuery
>;
export type GetIntegrationCountsSuspenseQueryHookResult = ReturnType<
  typeof useGetIntegrationCountsSuspenseQuery
>;
export type GetIntegrationCountsQueryResult = Apollo.QueryResult<
  GetIntegrationCountsQuery,
  GetIntegrationCountsQueryVariables
>;
export const LatestJobChainDocument = gql`
  query LatestJobChain($serviceId: ObjectID!, $type: JobChainType!) {
    latestJobChain(serviceId: $serviceId, type: $type) {
      _id
      startedAt
      completedAt
      status
      error
      missingScopes
    }
  }
`;

/**
 * __useLatestJobChainQuery__
 *
 * To run a query within a React component, call `useLatestJobChainQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestJobChainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestJobChainQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useLatestJobChainQuery(
  baseOptions: Apollo.QueryHookOptions<
    LatestJobChainQuery,
    LatestJobChainQueryVariables
  > &
    (
      | { variables: LatestJobChainQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LatestJobChainQuery, LatestJobChainQueryVariables>(
    LatestJobChainDocument,
    options
  );
}
export function useLatestJobChainLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LatestJobChainQuery,
    LatestJobChainQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LatestJobChainQuery, LatestJobChainQueryVariables>(
    LatestJobChainDocument,
    options
  );
}
// @ts-ignore
export function useLatestJobChainSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LatestJobChainQuery,
    LatestJobChainQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  LatestJobChainQuery,
  LatestJobChainQueryVariables
>;
export function useLatestJobChainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LatestJobChainQuery,
        LatestJobChainQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  LatestJobChainQuery | undefined,
  LatestJobChainQueryVariables
>;
export function useLatestJobChainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LatestJobChainQuery,
        LatestJobChainQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    LatestJobChainQuery,
    LatestJobChainQueryVariables
  >(LatestJobChainDocument, options);
}
export type LatestJobChainQueryHookResult = ReturnType<
  typeof useLatestJobChainQuery
>;
export type LatestJobChainLazyQueryHookResult = ReturnType<
  typeof useLatestJobChainLazyQuery
>;
export type LatestJobChainSuspenseQueryHookResult = ReturnType<
  typeof useLatestJobChainSuspenseQuery
>;
export type LatestJobChainQueryResult = Apollo.QueryResult<
  LatestJobChainQuery,
  LatestJobChainQueryVariables
>;
export const GetMcpProfilesDocument = gql`
  query getMcpProfiles($q: String) {
    mcpProfiles(q: $q) {
      _id
      type
      name
      isSystemDefault
    }
  }
`;

/**
 * __useGetMcpProfilesQuery__
 *
 * To run a query within a React component, call `useGetMcpProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMcpProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMcpProfilesQuery({
 *   variables: {
 *      q: // value for 'q'
 *   },
 * });
 */
export function useGetMcpProfilesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMcpProfilesQuery,
    GetMcpProfilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMcpProfilesQuery, GetMcpProfilesQueryVariables>(
    GetMcpProfilesDocument,
    options
  );
}
export function useGetMcpProfilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMcpProfilesQuery,
    GetMcpProfilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMcpProfilesQuery, GetMcpProfilesQueryVariables>(
    GetMcpProfilesDocument,
    options
  );
}
// @ts-ignore
export function useGetMcpProfilesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMcpProfilesQuery,
    GetMcpProfilesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetMcpProfilesQuery,
  GetMcpProfilesQueryVariables
>;
export function useGetMcpProfilesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMcpProfilesQuery,
        GetMcpProfilesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetMcpProfilesQuery | undefined,
  GetMcpProfilesQueryVariables
>;
export function useGetMcpProfilesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMcpProfilesQuery,
        GetMcpProfilesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMcpProfilesQuery,
    GetMcpProfilesQueryVariables
  >(GetMcpProfilesDocument, options);
}
export type GetMcpProfilesQueryHookResult = ReturnType<
  typeof useGetMcpProfilesQuery
>;
export type GetMcpProfilesLazyQueryHookResult = ReturnType<
  typeof useGetMcpProfilesLazyQuery
>;
export type GetMcpProfilesSuspenseQueryHookResult = ReturnType<
  typeof useGetMcpProfilesSuspenseQuery
>;
export type GetMcpProfilesQueryResult = Apollo.QueryResult<
  GetMcpProfilesQuery,
  GetMcpProfilesQueryVariables
>;
export const GetMcpProfileDocument = gql`
  query getMCPProfile($profileId: ObjectID!) {
    mcpProfile(profileId: $profileId) {
      _id
      type
      name
      installationConfigs {
        server {
          _id
          name
        }
        installation {
          _id
          displayName
          tools {
            name
            description
          }
        }
        enabledTools
        installType
      }
    }
  }
`;

/**
 * __useGetMcpProfileQuery__
 *
 * To run a query within a React component, call `useGetMcpProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMcpProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMcpProfileQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetMcpProfileQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMcpProfileQuery,
    GetMcpProfileQueryVariables
  > &
    (
      | { variables: GetMcpProfileQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMcpProfileQuery, GetMcpProfileQueryVariables>(
    GetMcpProfileDocument,
    options
  );
}
export function useGetMcpProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMcpProfileQuery,
    GetMcpProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMcpProfileQuery, GetMcpProfileQueryVariables>(
    GetMcpProfileDocument,
    options
  );
}
// @ts-ignore
export function useGetMcpProfileSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMcpProfileQuery,
    GetMcpProfileQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetMcpProfileQuery,
  GetMcpProfileQueryVariables
>;
export function useGetMcpProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMcpProfileQuery,
        GetMcpProfileQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetMcpProfileQuery | undefined,
  GetMcpProfileQueryVariables
>;
export function useGetMcpProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMcpProfileQuery,
        GetMcpProfileQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMcpProfileQuery,
    GetMcpProfileQueryVariables
  >(GetMcpProfileDocument, options);
}
export type GetMcpProfileQueryHookResult = ReturnType<
  typeof useGetMcpProfileQuery
>;
export type GetMcpProfileLazyQueryHookResult = ReturnType<
  typeof useGetMcpProfileLazyQuery
>;
export type GetMcpProfileSuspenseQueryHookResult = ReturnType<
  typeof useGetMcpProfileSuspenseQuery
>;
export type GetMcpProfileQueryResult = Apollo.QueryResult<
  GetMcpProfileQuery,
  GetMcpProfileQueryVariables
>;
export const GetMcpProfileTemplateDocument = gql`
  query GetMCPProfileTemplate {
    mcpProfileTemplate {
      _id
      displayName
      installationConfigs {
        server {
          _id
          name
        }
        installation {
          _id
          displayName
        }
        enabledTools
        installType
        allToolsEnabled
      }
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useGetMcpProfileTemplateQuery__
 *
 * To run a query within a React component, call `useGetMcpProfileTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMcpProfileTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMcpProfileTemplateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMcpProfileTemplateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMcpProfileTemplateQuery,
    GetMcpProfileTemplateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMcpProfileTemplateQuery,
    GetMcpProfileTemplateQueryVariables
  >(GetMcpProfileTemplateDocument, options);
}
export function useGetMcpProfileTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMcpProfileTemplateQuery,
    GetMcpProfileTemplateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMcpProfileTemplateQuery,
    GetMcpProfileTemplateQueryVariables
  >(GetMcpProfileTemplateDocument, options);
}
// @ts-ignore
export function useGetMcpProfileTemplateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMcpProfileTemplateQuery,
    GetMcpProfileTemplateQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetMcpProfileTemplateQuery,
  GetMcpProfileTemplateQueryVariables
>;
export function useGetMcpProfileTemplateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMcpProfileTemplateQuery,
        GetMcpProfileTemplateQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetMcpProfileTemplateQuery | undefined,
  GetMcpProfileTemplateQueryVariables
>;
export function useGetMcpProfileTemplateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMcpProfileTemplateQuery,
        GetMcpProfileTemplateQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMcpProfileTemplateQuery,
    GetMcpProfileTemplateQueryVariables
  >(GetMcpProfileTemplateDocument, options);
}
export type GetMcpProfileTemplateQueryHookResult = ReturnType<
  typeof useGetMcpProfileTemplateQuery
>;
export type GetMcpProfileTemplateLazyQueryHookResult = ReturnType<
  typeof useGetMcpProfileTemplateLazyQuery
>;
export type GetMcpProfileTemplateSuspenseQueryHookResult = ReturnType<
  typeof useGetMcpProfileTemplateSuspenseQuery
>;
export type GetMcpProfileTemplateQueryResult = Apollo.QueryResult<
  GetMcpProfileTemplateQuery,
  GetMcpProfileTemplateQueryVariables
>;
export const GetMcpServerInstallsDocument = gql`
  query getMcpServerInstalls(
    $offset: Int
    $limit: Int
    $installTypes: [MCPServerInstallAccessInstallType!]
    $q: String
    $owners: [ObjectID!]
    $includeOrgManagedInstalls: Boolean
  ) {
    mcpServerInstalls(
      offset: $offset
      limit: $limit
      installTypes: $installTypes
      q: $q
      owners: $owners
      includeOrgManagedInstalls: $includeOrgManagedInstalls
    ) {
      _id
      displayName
      status
      availableTools {
        name
      }
      server {
        _id
        name
        status
      }
      ownedBy {
        type
        ref {
          ... on User {
            userId: _id
            userDisplayName: displayName
          }
          ... on Agent {
            agentId: _id
            agentDisplayName: displayName
          }
        }
      }
      accessConfig {
        installType
      }
    }
  }
`;

/**
 * __useGetMcpServerInstallsQuery__
 *
 * To run a query within a React component, call `useGetMcpServerInstallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMcpServerInstallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMcpServerInstallsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      installTypes: // value for 'installTypes'
 *      q: // value for 'q'
 *      owners: // value for 'owners'
 *      includeOrgManagedInstalls: // value for 'includeOrgManagedInstalls'
 *   },
 * });
 */
export function useGetMcpServerInstallsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMcpServerInstallsQuery,
    GetMcpServerInstallsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMcpServerInstallsQuery,
    GetMcpServerInstallsQueryVariables
  >(GetMcpServerInstallsDocument, options);
}
export function useGetMcpServerInstallsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMcpServerInstallsQuery,
    GetMcpServerInstallsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMcpServerInstallsQuery,
    GetMcpServerInstallsQueryVariables
  >(GetMcpServerInstallsDocument, options);
}
// @ts-ignore
export function useGetMcpServerInstallsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMcpServerInstallsQuery,
    GetMcpServerInstallsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetMcpServerInstallsQuery,
  GetMcpServerInstallsQueryVariables
>;
export function useGetMcpServerInstallsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMcpServerInstallsQuery,
        GetMcpServerInstallsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetMcpServerInstallsQuery | undefined,
  GetMcpServerInstallsQueryVariables
>;
export function useGetMcpServerInstallsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMcpServerInstallsQuery,
        GetMcpServerInstallsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMcpServerInstallsQuery,
    GetMcpServerInstallsQueryVariables
  >(GetMcpServerInstallsDocument, options);
}
export type GetMcpServerInstallsQueryHookResult = ReturnType<
  typeof useGetMcpServerInstallsQuery
>;
export type GetMcpServerInstallsLazyQueryHookResult = ReturnType<
  typeof useGetMcpServerInstallsLazyQuery
>;
export type GetMcpServerInstallsSuspenseQueryHookResult = ReturnType<
  typeof useGetMcpServerInstallsSuspenseQuery
>;
export type GetMcpServerInstallsQueryResult = Apollo.QueryResult<
  GetMcpServerInstallsQuery,
  GetMcpServerInstallsQueryVariables
>;
export const GetMeDocument = gql`
  query getMe {
    me {
      currentOrg {
        ...CurrentOrgFields
      }
      currentUser {
        ...CurrentUserFields
      }
    }
  }
  ${CurrentOrgFieldsFragmentDoc}
  ${CurrentUserFieldsFragmentDoc}
`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(
    GetMeDocument,
    options
  );
}
export function useGetMeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(
    GetMeDocument,
    options
  );
}
// @ts-ignore
export function useGetMeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>
): Apollo.UseSuspenseQueryResult<GetMeQuery, GetMeQueryVariables>;
export function useGetMeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>
): Apollo.UseSuspenseQueryResult<GetMeQuery | undefined, GetMeQueryVariables>;
export function useGetMeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMeQuery, GetMeQueryVariables>(
    GetMeDocument,
    options
  );
}
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeSuspenseQueryHookResult = ReturnType<
  typeof useGetMeSuspenseQuery
>;
export type GetMeQueryResult = Apollo.QueryResult<
  GetMeQuery,
  GetMeQueryVariables
>;
export const GetMyOrgSamlAuthorizeUrlDocument = gql`
  query getMyOrgSamlAuthorizeUrl($input: OrgSamlAuthorizeUrlInput!) {
    myOrgSamlAuthorizeUrl(input: $input) {
      authorizeUrl
      success
    }
  }
`;

/**
 * __useGetMyOrgSamlAuthorizeUrlQuery__
 *
 * To run a query within a React component, call `useGetMyOrgSamlAuthorizeUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOrgSamlAuthorizeUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOrgSamlAuthorizeUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMyOrgSamlAuthorizeUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMyOrgSamlAuthorizeUrlQuery,
    GetMyOrgSamlAuthorizeUrlQueryVariables
  > &
    (
      | { variables: GetMyOrgSamlAuthorizeUrlQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMyOrgSamlAuthorizeUrlQuery,
    GetMyOrgSamlAuthorizeUrlQueryVariables
  >(GetMyOrgSamlAuthorizeUrlDocument, options);
}
export function useGetMyOrgSamlAuthorizeUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyOrgSamlAuthorizeUrlQuery,
    GetMyOrgSamlAuthorizeUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMyOrgSamlAuthorizeUrlQuery,
    GetMyOrgSamlAuthorizeUrlQueryVariables
  >(GetMyOrgSamlAuthorizeUrlDocument, options);
}
// @ts-ignore
export function useGetMyOrgSamlAuthorizeUrlSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMyOrgSamlAuthorizeUrlQuery,
    GetMyOrgSamlAuthorizeUrlQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetMyOrgSamlAuthorizeUrlQuery,
  GetMyOrgSamlAuthorizeUrlQueryVariables
>;
export function useGetMyOrgSamlAuthorizeUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMyOrgSamlAuthorizeUrlQuery,
        GetMyOrgSamlAuthorizeUrlQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetMyOrgSamlAuthorizeUrlQuery | undefined,
  GetMyOrgSamlAuthorizeUrlQueryVariables
>;
export function useGetMyOrgSamlAuthorizeUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMyOrgSamlAuthorizeUrlQuery,
        GetMyOrgSamlAuthorizeUrlQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMyOrgSamlAuthorizeUrlQuery,
    GetMyOrgSamlAuthorizeUrlQueryVariables
  >(GetMyOrgSamlAuthorizeUrlDocument, options);
}
export type GetMyOrgSamlAuthorizeUrlQueryHookResult = ReturnType<
  typeof useGetMyOrgSamlAuthorizeUrlQuery
>;
export type GetMyOrgSamlAuthorizeUrlLazyQueryHookResult = ReturnType<
  typeof useGetMyOrgSamlAuthorizeUrlLazyQuery
>;
export type GetMyOrgSamlAuthorizeUrlSuspenseQueryHookResult = ReturnType<
  typeof useGetMyOrgSamlAuthorizeUrlSuspenseQuery
>;
export type GetMyOrgSamlAuthorizeUrlQueryResult = Apollo.QueryResult<
  GetMyOrgSamlAuthorizeUrlQuery,
  GetMyOrgSamlAuthorizeUrlQueryVariables
>;
export const GetMyOrgSamlConfigDocument = gql`
  query getMyOrgSamlConfig {
    myOrgSamlConfig {
      enabled
      idpMetadata {
        metadataUrl
        entityId
        ssoUrl
        idpSigningCertificate
      }
      spMetadata {
        entityId
        acsUrl
        wantAssertionsSigned
        wantAuthnResponseSigned
      }
    }
  }
`;

/**
 * __useGetMyOrgSamlConfigQuery__
 *
 * To run a query within a React component, call `useGetMyOrgSamlConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOrgSamlConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOrgSamlConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyOrgSamlConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMyOrgSamlConfigQuery,
    GetMyOrgSamlConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMyOrgSamlConfigQuery,
    GetMyOrgSamlConfigQueryVariables
  >(GetMyOrgSamlConfigDocument, options);
}
export function useGetMyOrgSamlConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyOrgSamlConfigQuery,
    GetMyOrgSamlConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMyOrgSamlConfigQuery,
    GetMyOrgSamlConfigQueryVariables
  >(GetMyOrgSamlConfigDocument, options);
}
// @ts-ignore
export function useGetMyOrgSamlConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMyOrgSamlConfigQuery,
    GetMyOrgSamlConfigQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetMyOrgSamlConfigQuery,
  GetMyOrgSamlConfigQueryVariables
>;
export function useGetMyOrgSamlConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMyOrgSamlConfigQuery,
        GetMyOrgSamlConfigQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetMyOrgSamlConfigQuery | undefined,
  GetMyOrgSamlConfigQueryVariables
>;
export function useGetMyOrgSamlConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMyOrgSamlConfigQuery,
        GetMyOrgSamlConfigQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMyOrgSamlConfigQuery,
    GetMyOrgSamlConfigQueryVariables
  >(GetMyOrgSamlConfigDocument, options);
}
export type GetMyOrgSamlConfigQueryHookResult = ReturnType<
  typeof useGetMyOrgSamlConfigQuery
>;
export type GetMyOrgSamlConfigLazyQueryHookResult = ReturnType<
  typeof useGetMyOrgSamlConfigLazyQuery
>;
export type GetMyOrgSamlConfigSuspenseQueryHookResult = ReturnType<
  typeof useGetMyOrgSamlConfigSuspenseQuery
>;
export type GetMyOrgSamlConfigQueryResult = Apollo.QueryResult<
  GetMyOrgSamlConfigQuery,
  GetMyOrgSamlConfigQueryVariables
>;
export const GetMyOrgScimConfigDocument = gql`
  query getMyOrgScimConfig {
    myOrgScimConfig {
      enabled
      baseURL
      scimProvisioningToken(includeUnencryptedSecret: false) {
        ... on Credential {
          preview
          status
          type
        }
      }
    }
  }
`;

/**
 * __useGetMyOrgScimConfigQuery__
 *
 * To run a query within a React component, call `useGetMyOrgScimConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOrgScimConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOrgScimConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyOrgScimConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMyOrgScimConfigQuery,
    GetMyOrgScimConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMyOrgScimConfigQuery,
    GetMyOrgScimConfigQueryVariables
  >(GetMyOrgScimConfigDocument, options);
}
export function useGetMyOrgScimConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyOrgScimConfigQuery,
    GetMyOrgScimConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMyOrgScimConfigQuery,
    GetMyOrgScimConfigQueryVariables
  >(GetMyOrgScimConfigDocument, options);
}
// @ts-ignore
export function useGetMyOrgScimConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMyOrgScimConfigQuery,
    GetMyOrgScimConfigQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetMyOrgScimConfigQuery,
  GetMyOrgScimConfigQueryVariables
>;
export function useGetMyOrgScimConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMyOrgScimConfigQuery,
        GetMyOrgScimConfigQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetMyOrgScimConfigQuery | undefined,
  GetMyOrgScimConfigQueryVariables
>;
export function useGetMyOrgScimConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMyOrgScimConfigQuery,
        GetMyOrgScimConfigQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMyOrgScimConfigQuery,
    GetMyOrgScimConfigQueryVariables
  >(GetMyOrgScimConfigDocument, options);
}
export type GetMyOrgScimConfigQueryHookResult = ReturnType<
  typeof useGetMyOrgScimConfigQuery
>;
export type GetMyOrgScimConfigLazyQueryHookResult = ReturnType<
  typeof useGetMyOrgScimConfigLazyQuery
>;
export type GetMyOrgScimConfigSuspenseQueryHookResult = ReturnType<
  typeof useGetMyOrgScimConfigSuspenseQuery
>;
export type GetMyOrgScimConfigQueryResult = Apollo.QueryResult<
  GetMyOrgScimConfigQuery,
  GetMyOrgScimConfigQueryVariables
>;
export const GetMyOrgsDocument = gql`
  query getMyOrgs {
    myOrgs {
      ...CurrentOrgFields
    }
  }
  ${CurrentOrgFieldsFragmentDoc}
`;

/**
 * __useGetMyOrgsQuery__
 *
 * To run a query within a React component, call `useGetMyOrgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOrgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOrgsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyOrgsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMyOrgsQuery, GetMyOrgsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMyOrgsQuery, GetMyOrgsQueryVariables>(
    GetMyOrgsDocument,
    options
  );
}
export function useGetMyOrgsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyOrgsQuery,
    GetMyOrgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMyOrgsQuery, GetMyOrgsQueryVariables>(
    GetMyOrgsDocument,
    options
  );
}
// @ts-ignore
export function useGetMyOrgsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMyOrgsQuery,
    GetMyOrgsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetMyOrgsQuery, GetMyOrgsQueryVariables>;
export function useGetMyOrgsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMyOrgsQuery, GetMyOrgsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetMyOrgsQuery | undefined,
  GetMyOrgsQueryVariables
>;
export function useGetMyOrgsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMyOrgsQuery, GetMyOrgsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMyOrgsQuery, GetMyOrgsQueryVariables>(
    GetMyOrgsDocument,
    options
  );
}
export type GetMyOrgsQueryHookResult = ReturnType<typeof useGetMyOrgsQuery>;
export type GetMyOrgsLazyQueryHookResult = ReturnType<
  typeof useGetMyOrgsLazyQuery
>;
export type GetMyOrgsSuspenseQueryHookResult = ReturnType<
  typeof useGetMyOrgsSuspenseQuery
>;
export type GetMyOrgsQueryResult = Apollo.QueryResult<
  GetMyOrgsQuery,
  GetMyOrgsQueryVariables
>;
export const GetNeedsShadowAiSetupDocument = gql`
  query getNeedsShadowAISetup {
    needsShadowAISetup
  }
`;

/**
 * __useGetNeedsShadowAiSetupQuery__
 *
 * To run a query within a React component, call `useGetNeedsShadowAiSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNeedsShadowAiSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNeedsShadowAiSetupQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNeedsShadowAiSetupQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetNeedsShadowAiSetupQuery,
    GetNeedsShadowAiSetupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetNeedsShadowAiSetupQuery,
    GetNeedsShadowAiSetupQueryVariables
  >(GetNeedsShadowAiSetupDocument, options);
}
export function useGetNeedsShadowAiSetupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNeedsShadowAiSetupQuery,
    GetNeedsShadowAiSetupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNeedsShadowAiSetupQuery,
    GetNeedsShadowAiSetupQueryVariables
  >(GetNeedsShadowAiSetupDocument, options);
}
// @ts-ignore
export function useGetNeedsShadowAiSetupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetNeedsShadowAiSetupQuery,
    GetNeedsShadowAiSetupQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetNeedsShadowAiSetupQuery,
  GetNeedsShadowAiSetupQueryVariables
>;
export function useGetNeedsShadowAiSetupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetNeedsShadowAiSetupQuery,
        GetNeedsShadowAiSetupQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetNeedsShadowAiSetupQuery | undefined,
  GetNeedsShadowAiSetupQueryVariables
>;
export function useGetNeedsShadowAiSetupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetNeedsShadowAiSetupQuery,
        GetNeedsShadowAiSetupQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetNeedsShadowAiSetupQuery,
    GetNeedsShadowAiSetupQueryVariables
  >(GetNeedsShadowAiSetupDocument, options);
}
export type GetNeedsShadowAiSetupQueryHookResult = ReturnType<
  typeof useGetNeedsShadowAiSetupQuery
>;
export type GetNeedsShadowAiSetupLazyQueryHookResult = ReturnType<
  typeof useGetNeedsShadowAiSetupLazyQuery
>;
export type GetNeedsShadowAiSetupSuspenseQueryHookResult = ReturnType<
  typeof useGetNeedsShadowAiSetupSuspenseQuery
>;
export type GetNeedsShadowAiSetupQueryResult = Apollo.QueryResult<
  GetNeedsShadowAiSetupQuery,
  GetNeedsShadowAiSetupQueryVariables
>;
export const GetRateLimitDocument = gql`
  query getRateLimit($id: ObjectID!) {
    rateLimit(id: $id) {
      _id
      name
      target {
        details {
          ... on MCPServer {
            _id
            name
          }
        }
      }
      window {
        unit
        amount
      }
    }
  }
`;

/**
 * __useGetRateLimitQuery__
 *
 * To run a query within a React component, call `useGetRateLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRateLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRateLimitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRateLimitQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRateLimitQuery,
    GetRateLimitQueryVariables
  > &
    (
      | { variables: GetRateLimitQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRateLimitQuery, GetRateLimitQueryVariables>(
    GetRateLimitDocument,
    options
  );
}
export function useGetRateLimitLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRateLimitQuery,
    GetRateLimitQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRateLimitQuery, GetRateLimitQueryVariables>(
    GetRateLimitDocument,
    options
  );
}
// @ts-ignore
export function useGetRateLimitSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRateLimitQuery,
    GetRateLimitQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetRateLimitQuery, GetRateLimitQueryVariables>;
export function useGetRateLimitSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRateLimitQuery,
        GetRateLimitQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetRateLimitQuery | undefined,
  GetRateLimitQueryVariables
>;
export function useGetRateLimitSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRateLimitQuery,
        GetRateLimitQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRateLimitQuery, GetRateLimitQueryVariables>(
    GetRateLimitDocument,
    options
  );
}
export type GetRateLimitQueryHookResult = ReturnType<
  typeof useGetRateLimitQuery
>;
export type GetRateLimitLazyQueryHookResult = ReturnType<
  typeof useGetRateLimitLazyQuery
>;
export type GetRateLimitSuspenseQueryHookResult = ReturnType<
  typeof useGetRateLimitSuspenseQuery
>;
export type GetRateLimitQueryResult = Apollo.QueryResult<
  GetRateLimitQuery,
  GetRateLimitQueryVariables
>;
export const GetServiceInstancesDocument = gql`
  query getServiceInstances {
    serviceInstances
  }
`;

/**
 * __useGetServiceInstancesQuery__
 *
 * To run a query within a React component, call `useGetServiceInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceInstancesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetServiceInstancesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetServiceInstancesQuery,
    GetServiceInstancesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetServiceInstancesQuery,
    GetServiceInstancesQueryVariables
  >(GetServiceInstancesDocument, options);
}
export function useGetServiceInstancesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetServiceInstancesQuery,
    GetServiceInstancesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetServiceInstancesQuery,
    GetServiceInstancesQueryVariables
  >(GetServiceInstancesDocument, options);
}
// @ts-ignore
export function useGetServiceInstancesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetServiceInstancesQuery,
    GetServiceInstancesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetServiceInstancesQuery,
  GetServiceInstancesQueryVariables
>;
export function useGetServiceInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetServiceInstancesQuery,
        GetServiceInstancesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetServiceInstancesQuery | undefined,
  GetServiceInstancesQueryVariables
>;
export function useGetServiceInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetServiceInstancesQuery,
        GetServiceInstancesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetServiceInstancesQuery,
    GetServiceInstancesQueryVariables
  >(GetServiceInstancesDocument, options);
}
export type GetServiceInstancesQueryHookResult = ReturnType<
  typeof useGetServiceInstancesQuery
>;
export type GetServiceInstancesLazyQueryHookResult = ReturnType<
  typeof useGetServiceInstancesLazyQuery
>;
export type GetServiceInstancesSuspenseQueryHookResult = ReturnType<
  typeof useGetServiceInstancesSuspenseQuery
>;
export type GetServiceInstancesQueryResult = Apollo.QueryResult<
  GetServiceInstancesQuery,
  GetServiceInstancesQueryVariables
>;
export const GetServicesDocument = gql`
  query getServices(
    $identityId: [ObjectID!]
    $integrationId: [IntegrationId!]
    $offset: Int
    $limit: Int
    $q: String
    $isIntegration: Boolean
    $status: [ServiceStatus!]
  ) {
    services(
      identityId: $identityId
      integrationId: $integrationId
      offset: $offset
      limit: $limit
      q: $q
      isIntegration: $isIntegration
      status: $status
    ) {
      _id
      displayName
      instanceName
      status
      integration {
        integrationId
        description
        activeAuthType
        authFields
      }
    }
  }
`;

/**
 * __useGetServicesQuery__
 *
 * To run a query within a React component, call `useGetServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServicesQuery({
 *   variables: {
 *      identityId: // value for 'identityId'
 *      integrationId: // value for 'integrationId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      q: // value for 'q'
 *      isIntegration: // value for 'isIntegration'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetServicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetServicesQuery,
    GetServicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetServicesQuery, GetServicesQueryVariables>(
    GetServicesDocument,
    options
  );
}
export function useGetServicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetServicesQuery,
    GetServicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetServicesQuery, GetServicesQueryVariables>(
    GetServicesDocument,
    options
  );
}
// @ts-ignore
export function useGetServicesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetServicesQuery,
    GetServicesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetServicesQuery, GetServicesQueryVariables>;
export function useGetServicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetServicesQuery,
        GetServicesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetServicesQuery | undefined,
  GetServicesQueryVariables
>;
export function useGetServicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetServicesQuery,
        GetServicesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetServicesQuery, GetServicesQueryVariables>(
    GetServicesDocument,
    options
  );
}
export type GetServicesQueryHookResult = ReturnType<typeof useGetServicesQuery>;
export type GetServicesLazyQueryHookResult = ReturnType<
  typeof useGetServicesLazyQuery
>;
export type GetServicesSuspenseQueryHookResult = ReturnType<
  typeof useGetServicesSuspenseQuery
>;
export type GetServicesQueryResult = Apollo.QueryResult<
  GetServicesQuery,
  GetServicesQueryVariables
>;
export const GetSessionAuditLogsDocument = gql`
  query getSessionAuditLogs(
    $actors: [ActorFilterInput!]
    $fromDate: String
    $toDate: String
    $toolName: String
    $status: String
    $sort: AuditLogSort
    $offset: Int
    $limit: Int
  ) {
    sessionAuditLogs(
      actors: $actors
      fromDate: $fromDate
      toDate: $toDate
      toolName: $toolName
      status: $status
      sort: $sort
      offset: $offset
      limit: $limit
    ) {
      totalCount
      sessions {
        sessionId
        count
        latestTimestamp
        earliestTimestamp
        events {
          _id
          timestamp
          event
          actor {
            type
            details {
              __typename
              ... on User {
                email
                userDisplayName: displayName
              }
              ... on Agent {
                _id
                agentDisplayName: displayName
              }
            }
          }
          metadata
          targets {
            type
            details {
              __typename
              ... on MCPServerInstall {
                displayName
                _id
                accessConfig {
                  installType
                }
                server {
                  name
                }
              }
            }
          }
        }
        metadata {
          toolNames
          statuses
          actorCount
        }
      }
    }
  }
`;

/**
 * __useGetSessionAuditLogsQuery__
 *
 * To run a query within a React component, call `useGetSessionAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionAuditLogsQuery({
 *   variables: {
 *      actors: // value for 'actors'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      toolName: // value for 'toolName'
 *      status: // value for 'status'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSessionAuditLogsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSessionAuditLogsQuery,
    GetSessionAuditLogsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSessionAuditLogsQuery,
    GetSessionAuditLogsQueryVariables
  >(GetSessionAuditLogsDocument, options);
}
export function useGetSessionAuditLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSessionAuditLogsQuery,
    GetSessionAuditLogsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSessionAuditLogsQuery,
    GetSessionAuditLogsQueryVariables
  >(GetSessionAuditLogsDocument, options);
}
// @ts-ignore
export function useGetSessionAuditLogsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSessionAuditLogsQuery,
    GetSessionAuditLogsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetSessionAuditLogsQuery,
  GetSessionAuditLogsQueryVariables
>;
export function useGetSessionAuditLogsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSessionAuditLogsQuery,
        GetSessionAuditLogsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetSessionAuditLogsQuery | undefined,
  GetSessionAuditLogsQueryVariables
>;
export function useGetSessionAuditLogsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSessionAuditLogsQuery,
        GetSessionAuditLogsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSessionAuditLogsQuery,
    GetSessionAuditLogsQueryVariables
  >(GetSessionAuditLogsDocument, options);
}
export type GetSessionAuditLogsQueryHookResult = ReturnType<
  typeof useGetSessionAuditLogsQuery
>;
export type GetSessionAuditLogsLazyQueryHookResult = ReturnType<
  typeof useGetSessionAuditLogsLazyQuery
>;
export type GetSessionAuditLogsSuspenseQueryHookResult = ReturnType<
  typeof useGetSessionAuditLogsSuspenseQuery
>;
export type GetSessionAuditLogsQueryResult = Apollo.QueryResult<
  GetSessionAuditLogsQuery,
  GetSessionAuditLogsQueryVariables
>;
export const GetShadowMcpServerOwnerOptionsDocument = gql`
  query GetShadowMCPServerOwnerOptions($q: String) {
    shadowMCPServerOwners(q: $q) {
      user {
        _id
        displayName
        email
      }
      hostname
    }
  }
`;

/**
 * __useGetShadowMcpServerOwnerOptionsQuery__
 *
 * To run a query within a React component, call `useGetShadowMcpServerOwnerOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShadowMcpServerOwnerOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShadowMcpServerOwnerOptionsQuery({
 *   variables: {
 *      q: // value for 'q'
 *   },
 * });
 */
export function useGetShadowMcpServerOwnerOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetShadowMcpServerOwnerOptionsQuery,
    GetShadowMcpServerOwnerOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetShadowMcpServerOwnerOptionsQuery,
    GetShadowMcpServerOwnerOptionsQueryVariables
  >(GetShadowMcpServerOwnerOptionsDocument, options);
}
export function useGetShadowMcpServerOwnerOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetShadowMcpServerOwnerOptionsQuery,
    GetShadowMcpServerOwnerOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetShadowMcpServerOwnerOptionsQuery,
    GetShadowMcpServerOwnerOptionsQueryVariables
  >(GetShadowMcpServerOwnerOptionsDocument, options);
}
// @ts-ignore
export function useGetShadowMcpServerOwnerOptionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetShadowMcpServerOwnerOptionsQuery,
    GetShadowMcpServerOwnerOptionsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetShadowMcpServerOwnerOptionsQuery,
  GetShadowMcpServerOwnerOptionsQueryVariables
>;
export function useGetShadowMcpServerOwnerOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetShadowMcpServerOwnerOptionsQuery,
        GetShadowMcpServerOwnerOptionsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetShadowMcpServerOwnerOptionsQuery | undefined,
  GetShadowMcpServerOwnerOptionsQueryVariables
>;
export function useGetShadowMcpServerOwnerOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetShadowMcpServerOwnerOptionsQuery,
        GetShadowMcpServerOwnerOptionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetShadowMcpServerOwnerOptionsQuery,
    GetShadowMcpServerOwnerOptionsQueryVariables
  >(GetShadowMcpServerOwnerOptionsDocument, options);
}
export type GetShadowMcpServerOwnerOptionsQueryHookResult = ReturnType<
  typeof useGetShadowMcpServerOwnerOptionsQuery
>;
export type GetShadowMcpServerOwnerOptionsLazyQueryHookResult = ReturnType<
  typeof useGetShadowMcpServerOwnerOptionsLazyQuery
>;
export type GetShadowMcpServerOwnerOptionsSuspenseQueryHookResult = ReturnType<
  typeof useGetShadowMcpServerOwnerOptionsSuspenseQuery
>;
export type GetShadowMcpServerOwnerOptionsQueryResult = Apollo.QueryResult<
  GetShadowMcpServerOwnerOptionsQuery,
  GetShadowMcpServerOwnerOptionsQueryVariables
>;
export const GetShadowMcpServersGroupedByNormalizedServerNameDocument = gql`
  query getShadowMCPServersGroupedByNormalizedServerName(
    $q: String
    $offset: Int!
    $limit: Int!
    $owners: [ShadowServerOwnerInput!]
    $sortBy: ShadowServerSortBy
    $statuses: [ShadowMCPServerStatus!]
  ) {
    shadowMCPServersGroupedByNormalizedServerName(
      q: $q
      offset: $offset
      limit: $limit
      owners: $owners
      sortBy: $sortBy
      statuses: $statuses
    ) {
      normalizedServerName
      users {
        deviceId
        hostname
        primaryUserEmail
        userId
      }
      lastSeenAt
      firstDetectedAt
      integrationId
    }
  }
`;

/**
 * __useGetShadowMcpServersGroupedByNormalizedServerNameQuery__
 *
 * To run a query within a React component, call `useGetShadowMcpServersGroupedByNormalizedServerNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShadowMcpServersGroupedByNormalizedServerNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShadowMcpServersGroupedByNormalizedServerNameQuery({
 *   variables: {
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      owners: // value for 'owners'
 *      sortBy: // value for 'sortBy'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetShadowMcpServersGroupedByNormalizedServerNameQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetShadowMcpServersGroupedByNormalizedServerNameQuery,
    GetShadowMcpServersGroupedByNormalizedServerNameQueryVariables
  > &
    (
      | {
          variables: GetShadowMcpServersGroupedByNormalizedServerNameQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetShadowMcpServersGroupedByNormalizedServerNameQuery,
    GetShadowMcpServersGroupedByNormalizedServerNameQueryVariables
  >(GetShadowMcpServersGroupedByNormalizedServerNameDocument, options);
}
export function useGetShadowMcpServersGroupedByNormalizedServerNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetShadowMcpServersGroupedByNormalizedServerNameQuery,
    GetShadowMcpServersGroupedByNormalizedServerNameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetShadowMcpServersGroupedByNormalizedServerNameQuery,
    GetShadowMcpServersGroupedByNormalizedServerNameQueryVariables
  >(GetShadowMcpServersGroupedByNormalizedServerNameDocument, options);
}
// @ts-ignore
export function useGetShadowMcpServersGroupedByNormalizedServerNameSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetShadowMcpServersGroupedByNormalizedServerNameQuery,
    GetShadowMcpServersGroupedByNormalizedServerNameQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetShadowMcpServersGroupedByNormalizedServerNameQuery,
  GetShadowMcpServersGroupedByNormalizedServerNameQueryVariables
>;
export function useGetShadowMcpServersGroupedByNormalizedServerNameSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetShadowMcpServersGroupedByNormalizedServerNameQuery,
        GetShadowMcpServersGroupedByNormalizedServerNameQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetShadowMcpServersGroupedByNormalizedServerNameQuery | undefined,
  GetShadowMcpServersGroupedByNormalizedServerNameQueryVariables
>;
export function useGetShadowMcpServersGroupedByNormalizedServerNameSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetShadowMcpServersGroupedByNormalizedServerNameQuery,
        GetShadowMcpServersGroupedByNormalizedServerNameQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetShadowMcpServersGroupedByNormalizedServerNameQuery,
    GetShadowMcpServersGroupedByNormalizedServerNameQueryVariables
  >(GetShadowMcpServersGroupedByNormalizedServerNameDocument, options);
}
export type GetShadowMcpServersGroupedByNormalizedServerNameQueryHookResult =
  ReturnType<typeof useGetShadowMcpServersGroupedByNormalizedServerNameQuery>;
export type GetShadowMcpServersGroupedByNormalizedServerNameLazyQueryHookResult =
  ReturnType<
    typeof useGetShadowMcpServersGroupedByNormalizedServerNameLazyQuery
  >;
export type GetShadowMcpServersGroupedByNormalizedServerNameSuspenseQueryHookResult =
  ReturnType<
    typeof useGetShadowMcpServersGroupedByNormalizedServerNameSuspenseQuery
  >;
export type GetShadowMcpServersGroupedByNormalizedServerNameQueryResult =
  Apollo.QueryResult<
    GetShadowMcpServersGroupedByNormalizedServerNameQuery,
    GetShadowMcpServersGroupedByNormalizedServerNameQueryVariables
  >;
export const GetTunnelsDocument = gql`
  query getTunnels(
    $q: String
    $status: [TunnelStatus!]
    $connectionStatus: TunnelConnectionStatus
    $offset: Int
    $limit: Int
  ) {
    tunnels(
      q: $q
      status: $status
      connectionStatus: $connectionStatus
      offset: $offset
      limit: $limit
    ) {
      _id
      displayName
      status
      connectionStatus
      url
      metadata {
        lastHeartbeatAt
        tunnelVersion
        tunnelAuthStrategy
      }
    }
  }
`;

/**
 * __useGetTunnelsQuery__
 *
 * To run a query within a React component, call `useGetTunnelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTunnelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTunnelsQuery({
 *   variables: {
 *      q: // value for 'q'
 *      status: // value for 'status'
 *      connectionStatus: // value for 'connectionStatus'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTunnelsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTunnelsQuery,
    GetTunnelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTunnelsQuery, GetTunnelsQueryVariables>(
    GetTunnelsDocument,
    options
  );
}
export function useGetTunnelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTunnelsQuery,
    GetTunnelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTunnelsQuery, GetTunnelsQueryVariables>(
    GetTunnelsDocument,
    options
  );
}
// @ts-ignore
export function useGetTunnelsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTunnelsQuery,
    GetTunnelsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetTunnelsQuery, GetTunnelsQueryVariables>;
export function useGetTunnelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTunnelsQuery, GetTunnelsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetTunnelsQuery | undefined,
  GetTunnelsQueryVariables
>;
export function useGetTunnelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTunnelsQuery, GetTunnelsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTunnelsQuery, GetTunnelsQueryVariables>(
    GetTunnelsDocument,
    options
  );
}
export type GetTunnelsQueryHookResult = ReturnType<typeof useGetTunnelsQuery>;
export type GetTunnelsLazyQueryHookResult = ReturnType<
  typeof useGetTunnelsLazyQuery
>;
export type GetTunnelsSuspenseQueryHookResult = ReturnType<
  typeof useGetTunnelsSuspenseQuery
>;
export type GetTunnelsQueryResult = Apollo.QueryResult<
  GetTunnelsQuery,
  GetTunnelsQueryVariables
>;
export const GetUsersDocument = gql`
  query getUsers(
    $offset: Int
    $limit: Int
    $q: String
    $sort: GetUsersSort
    $status: [UserStatus!]
    $role: [UserRole!]
  ) {
    getUsers(
      offset: $offset
      limit: $limit
      q: $q
      sort: $sort
      status: $status
      role: $role
    ) {
      total
      users {
        _id
        org {
          _id
        }
        displayName
        email
        status
        role
      }
    }
  }
`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      q: // value for 'q'
 *      sort: // value for 'sort'
 *      status: // value for 'status'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useGetUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options
  );
}
export function useGetUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUsersQuery,
    GetUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options
  );
}
// @ts-ignore
export function useGetUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUsersQuery,
    GetUsersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetUsersQuery | undefined,
  GetUsersQueryVariables
>;
export function useGetUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options
  );
}
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<
  typeof useGetUsersLazyQuery
>;
export type GetUsersSuspenseQueryHookResult = ReturnType<
  typeof useGetUsersSuspenseQuery
>;
export type GetUsersQueryResult = Apollo.QueryResult<
  GetUsersQuery,
  GetUsersQueryVariables
>;
export const GetUsersCountOnMcpServersDocument = gql`
  query getUsersCountOnMcpServers($id: ObjectID!) {
    mcpServer(id: $id) {
      _id
      usersCount
    }
  }
`;

/**
 * __useGetUsersCountOnMcpServersQuery__
 *
 * To run a query within a React component, call `useGetUsersCountOnMcpServersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersCountOnMcpServersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersCountOnMcpServersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUsersCountOnMcpServersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUsersCountOnMcpServersQuery,
    GetUsersCountOnMcpServersQueryVariables
  > &
    (
      | { variables: GetUsersCountOnMcpServersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUsersCountOnMcpServersQuery,
    GetUsersCountOnMcpServersQueryVariables
  >(GetUsersCountOnMcpServersDocument, options);
}
export function useGetUsersCountOnMcpServersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUsersCountOnMcpServersQuery,
    GetUsersCountOnMcpServersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUsersCountOnMcpServersQuery,
    GetUsersCountOnMcpServersQueryVariables
  >(GetUsersCountOnMcpServersDocument, options);
}
// @ts-ignore
export function useGetUsersCountOnMcpServersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUsersCountOnMcpServersQuery,
    GetUsersCountOnMcpServersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  GetUsersCountOnMcpServersQuery,
  GetUsersCountOnMcpServersQueryVariables
>;
export function useGetUsersCountOnMcpServersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUsersCountOnMcpServersQuery,
        GetUsersCountOnMcpServersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  GetUsersCountOnMcpServersQuery | undefined,
  GetUsersCountOnMcpServersQueryVariables
>;
export function useGetUsersCountOnMcpServersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUsersCountOnMcpServersQuery,
        GetUsersCountOnMcpServersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetUsersCountOnMcpServersQuery,
    GetUsersCountOnMcpServersQueryVariables
  >(GetUsersCountOnMcpServersDocument, options);
}
export type GetUsersCountOnMcpServersQueryHookResult = ReturnType<
  typeof useGetUsersCountOnMcpServersQuery
>;
export type GetUsersCountOnMcpServersLazyQueryHookResult = ReturnType<
  typeof useGetUsersCountOnMcpServersLazyQuery
>;
export type GetUsersCountOnMcpServersSuspenseQueryHookResult = ReturnType<
  typeof useGetUsersCountOnMcpServersSuspenseQuery
>;
export type GetUsersCountOnMcpServersQueryResult = Apollo.QueryResult<
  GetUsersCountOnMcpServersQuery,
  GetUsersCountOnMcpServersQueryVariables
>;
export const SimulatePolicyToolCallDocument = gql`
  query simulatePolicyToolCall($input: SimulatePolicyToolCallInput!) {
    simulatePolicyToolCall(input: $input)
  }
`;

/**
 * __useSimulatePolicyToolCallQuery__
 *
 * To run a query within a React component, call `useSimulatePolicyToolCallQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimulatePolicyToolCallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimulatePolicyToolCallQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSimulatePolicyToolCallQuery(
  baseOptions: Apollo.QueryHookOptions<
    SimulatePolicyToolCallQuery,
    SimulatePolicyToolCallQueryVariables
  > &
    (
      | { variables: SimulatePolicyToolCallQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SimulatePolicyToolCallQuery,
    SimulatePolicyToolCallQueryVariables
  >(SimulatePolicyToolCallDocument, options);
}
export function useSimulatePolicyToolCallLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SimulatePolicyToolCallQuery,
    SimulatePolicyToolCallQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SimulatePolicyToolCallQuery,
    SimulatePolicyToolCallQueryVariables
  >(SimulatePolicyToolCallDocument, options);
}
// @ts-ignore
export function useSimulatePolicyToolCallSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SimulatePolicyToolCallQuery,
    SimulatePolicyToolCallQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  SimulatePolicyToolCallQuery,
  SimulatePolicyToolCallQueryVariables
>;
export function useSimulatePolicyToolCallSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SimulatePolicyToolCallQuery,
        SimulatePolicyToolCallQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  SimulatePolicyToolCallQuery | undefined,
  SimulatePolicyToolCallQueryVariables
>;
export function useSimulatePolicyToolCallSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SimulatePolicyToolCallQuery,
        SimulatePolicyToolCallQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SimulatePolicyToolCallQuery,
    SimulatePolicyToolCallQueryVariables
  >(SimulatePolicyToolCallDocument, options);
}
export type SimulatePolicyToolCallQueryHookResult = ReturnType<
  typeof useSimulatePolicyToolCallQuery
>;
export type SimulatePolicyToolCallLazyQueryHookResult = ReturnType<
  typeof useSimulatePolicyToolCallLazyQuery
>;
export type SimulatePolicyToolCallSuspenseQueryHookResult = ReturnType<
  typeof useSimulatePolicyToolCallSuspenseQuery
>;
export type SimulatePolicyToolCallQueryResult = Apollo.QueryResult<
  SimulatePolicyToolCallQuery,
  SimulatePolicyToolCallQueryVariables
>;
export const TestMcpConnectionDocument = gql`
  query TestMCPConnection(
    $authCredentials: ServerInstallationCredsMap
    $mcpServerId: ObjectID
    $mcpServerInstallId: ObjectID
    $agentId: ObjectID
  ) {
    testMCPConnection(
      authCredentials: $authCredentials
      mcpServerId: $mcpServerId
      mcpServerInstallId: $mcpServerInstallId
      agentId: $agentId
    ) {
      success
      error
      toolCount
      toolNames
    }
  }
`;

/**
 * __useTestMcpConnectionQuery__
 *
 * To run a query within a React component, call `useTestMcpConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestMcpConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestMcpConnectionQuery({
 *   variables: {
 *      authCredentials: // value for 'authCredentials'
 *      mcpServerId: // value for 'mcpServerId'
 *      mcpServerInstallId: // value for 'mcpServerInstallId'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useTestMcpConnectionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TestMcpConnectionQuery,
    TestMcpConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TestMcpConnectionQuery,
    TestMcpConnectionQueryVariables
  >(TestMcpConnectionDocument, options);
}
export function useTestMcpConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TestMcpConnectionQuery,
    TestMcpConnectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TestMcpConnectionQuery,
    TestMcpConnectionQueryVariables
  >(TestMcpConnectionDocument, options);
}
// @ts-ignore
export function useTestMcpConnectionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TestMcpConnectionQuery,
    TestMcpConnectionQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  TestMcpConnectionQuery,
  TestMcpConnectionQueryVariables
>;
export function useTestMcpConnectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TestMcpConnectionQuery,
        TestMcpConnectionQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  TestMcpConnectionQuery | undefined,
  TestMcpConnectionQueryVariables
>;
export function useTestMcpConnectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TestMcpConnectionQuery,
        TestMcpConnectionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TestMcpConnectionQuery,
    TestMcpConnectionQueryVariables
  >(TestMcpConnectionDocument, options);
}
export type TestMcpConnectionQueryHookResult = ReturnType<
  typeof useTestMcpConnectionQuery
>;
export type TestMcpConnectionLazyQueryHookResult = ReturnType<
  typeof useTestMcpConnectionLazyQuery
>;
export type TestMcpConnectionSuspenseQueryHookResult = ReturnType<
  typeof useTestMcpConnectionSuspenseQuery
>;
export type TestMcpConnectionQueryResult = Apollo.QueryResult<
  TestMcpConnectionQuery,
  TestMcpConnectionQueryVariables
>;
